webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var DiccionarioCookiesAGuardar = ['usuariosexo', 'usuarioemail', 'usuarioanio', 'usuarioDetalleClubNacion', 'UsuarioDetalleGuid', 'UsuarioDetalleNick', 'UsuarioId', 'UsuarioUsuario', 'usuario%5Fusuario', 'usuarioLogTkn', 'cookieLogin', 'syncLfLN', 'tieneClub', 'Provinciaid', 'Paisid', 'LNPreferencias', 'Crm_id', 'ProductoPremiumId', 'token', 'xvalue', 'TokenJWT'];

var LeerCookie = exports.LeerCookie = function LeerCookie(nombrecookie) {
    return leer(nombrecookie);
};

var CreateCookie = exports.CreateCookie = function CreateCookie(name, value) {
    var seconds = parseInt(window.config.Statics.CookieExpiration);
    var expires;
    if (seconds) {
        var date = new Date();
        date.setTime(date.getTime() + seconds);
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }

    if (document.domain === 'localhost') {
        document.cookie = name + "=" + value + expires + "; path=/";
    } else {
        document.cookie = name + "=" + value + expires + ";domain=" + window.config.Statics.DominioCookie + "; path=/";
    }
};

var SetToken = exports.SetToken = function SetToken(token) {
    if (IsEmpty(token)) return;
    CreateCookie('token', token);
};

var SetXValue = exports.SetXValue = function SetXValue(xvalue) {
    if (IsEmpty(xvalue)) return;
    CreateCookie('xvalue', xvalue);
};

var IsEmpty = exports.IsEmpty = function IsEmpty(obj) {
    if (obj == null) return true;
    if (obj.length > 0) return false;
    if (obj.length === 0) return true;
    for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) return false;
    }
    return true;
};

var SetupCookies = exports.SetupCookies = function SetupCookies(obj) {
    for (var key in obj) {
        var aux;
        var cookie;
        // Busco si la key se encuentra en el diccionario de cookies para ver si la grabo o no . 
        if (DiccionarioCookiesAGuardar.indexOf(key) > -1 && typeof obj[key] == "string") {
            switch (key) {
                case 'UsuarioDetalleGuid':
                    aux = "usuario%5Fdetalle%5Fguid";
                    cookie = '{' + leer("token") + '}';
                    break;
                case 'UsuarioDetalleNick':
                    aux = "usuario%5Fdetalle%5Fnick";
                    cookie = obj[key];
                    break;
                case 'UsuarioId':
                    aux = "usuario%5Fid";
                    cookie = obj[key];
                    break;
                case 'UsuarioUsuario':
                    aux = "usuario%5Fusuario";
                    cookie = obj[key];
                    break;
                case 'usuarioLogTkn':
                    aux = "usuario%5Flogtkn";
                    cookie = obj[key];
                    break;
                case 'TokenJWT':
                    aux = "PersoTKN";
                    cookie = obj[key];
                    break;
                default:
                    aux = key;
                    cookie = obj[key];
            }

            CreateCookie(aux, cookie);
        }
    }
};

function leer(nombrecookie) {
    var laCookie = '' + document.cookie;
    var indice = laCookie.indexOf(nombrecookie);

    if (indice == -1 || nombrecookie == '') {
        return '';
    }

    var indiceUno = laCookie.indexOf(';', indice);
    var indiceDos = laCookie.indexOf('&', indice);

    if (indiceUno > indiceDos && indiceDos != -1 || indiceUno == -1 && indiceDos != -1) {
        indiceUno = indiceDos;
    }

    if (indiceUno == -1) {
        indiceUno = laCookie.length;
    }

    return unescape(laCookie.substring(indice + nombrecookie.length + 1, indiceUno));
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// @ts-check

/**
 * Request - Generic method
 * @param {string} method
 * @param {string} url
 * @param {any} params
 * @param {any} headers
 * @return {Promise<string>}
 */
var ajax = exports.ajax = function ajax(method, url, params) {
    var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    return new Promise(function (resolve, reject) {
        var request = new XMLHttpRequest();

        request.open(method, url, true);
        if (headers) {
            var names = Object.keys(headers);
            names.forEach(function (name) {
                var value = headers[name];

                request.setRequestHeader(name, value);
            });
        }

        request.onload = function () {
            if (request.status >= 200 && request.status < 400) {
                var resp = request.responseText;
                resolve(resp);
            } else {
                reject();
            }
        };
        request.onerror = function () {
            return reject();
        };
        request.send(JSON.stringify(params));
    });
};

/**
 * Request - Post
 * @param {string} url
 * @param {any} params
 * @param {any} headers
 * @return {Promise<string>}
 */
var post = exports.post = function post(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return ajax('POST', url, params, headers);
};

/**
 * Request - Get
 * @param {string} url
 * @param {any} params
 * @param {any} headers
 * @return {Promise<string>}
 */
var get = exports.get = function get(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return ajax('GET', url, params, headers);
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//todo: refactorizar.
var urlBucketBalance = exports.urlBucketBalance = function urlBucketBalance(bucketUrl, pathImage) {
    var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    var width = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
    var extension = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "png";

    var id = "";
    var ext = "";
    if (pathImage.toString().indexOf("fotos") !== -1) {
        var startIndex = pathImage.indexOf("fotos") + 9; // (fotos/23/) = 9
        var finalIndex = pathImage.length - 4;
        id = pathImage.substr(startIndex, finalIndex - startIndex);
        ext = pathImage.substr(pathImage.length - 3);
    } else {
        id = pathImage.toString();
        ext = extension;
    }
    var bucketSrv = "1";
    height = height === "" ? "" : "h" + height;
    width = width === "" ? "" : "w" + width;
    var ultdos = id.substr(id.length - 2);
    var ultdig = ultdos.substr(ultdos.length - 1);
    switch (ultdig) {
        case "0":
        case "1":
        case "2":
            bucketSrv = "1";
            break;
        case "3":
        case "4":
        case "5":
            bucketSrv = "2";
            break;
        default:
            bucketSrv = "3";
            break;
    }

    var url = bucketUrl.replace("{nro}", bucketSrv) + "/anexos/fotos/" + ultdos + "/" + id + width + height + "." + ext;

    return url;
};

var urlBucketClubLn = exports.urlBucketClubLn = function urlBucketClubLn(bucketUrl, pathImage) {
    var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    var width = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
    var extension = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "png";

    var id = "";
    var ext = "";
    if (pathImage.toString().indexOf("fotos") !== -1) {
        var startIndex = pathImage.indexOf("fotos") + 9; // (fotos/23/) = 9
        var finalIndex = pathImage.length - 4;
        id = pathImage.substr(startIndex, finalIndex - startIndex);
        ext = pathImage.substr(pathImage.length - 3);
    } else {
        id = pathImage.toString();
        ext = extension;
    }

    height = height === "" ? "" : "h" + height;
    width = width === "" ? "" : "w" + width;
    var ultdos = id.substr(id.length - 2);

    var url = bucketUrl + "/" + ultdos + "/I" + id + width + height + "." + ext;

    return url;
};

// type, classSize
var getImageSrcPath = exports.getImageSrcPath = function getImageSrcPath(img, type, classSize) {
    var classFinal = classSize.substr(0, 2).trim();
    var height = "";

    //Se define la resolución depende del tipo(img, galeria, etc..) y class(L, XL).
    type === "galeria" ? classFinal === "L" ? //si no es L..  es XL
    height = "484" : height = "688" : type === "imagen" ? classFinal === "L" ? //si no es L..  es XL 
    height = "640" : height = "540" : type === "Encolumnada" ? height = "280" : type === "modal" ? height = "765" : "";

    //const carpeta = "\\anexos\\fotos\\" + img.id.toString().slice(-2);
    return height;
};

var changeSizeWithFullPath = exports.changeSizeWithFullPath = function changeSizeWithFullPath(srcImage, size) {
    srcImage.substr(srcImage.length - 1) === "/" ? srcImage = srcImage.slice(0, -1) : "";
    var startIndex = srcImage.indexOf("fotos/") + 9;
    var finalIndex = srcImage.length - 4;

    var ext = srcImage.substr(srcImage.length - 3);
    var bucketUrl = srcImage.substr(0, startIndex);
    var imageWithSize = srcImage.substr(startIndex, finalIndex - startIndex);
    var imageHeight = imageWithSize.indexOf("h");
    var imageWidth = imageWithSize.indexOf("w");

    var imageFinal = "";
    imageHeight > imageWidth ? imageFinal = imageWithSize.slice(0, imageHeight) : imageFinal = imageWithSize.slice(0, imageWidth);

    return "" + bucketUrl + imageFinal + size + "." + ext;
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // @ts-check


var _ajax = __webpack_require__(23);

var _ajax2 = _interopRequireDefault(_ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_HEADERS = {
  'Content-Type': 'application/json; charset=UTF-8'
};

var ApiBase = function () {
  function ApiBase(name, config) {
    var _this = this;

    var apiTarget = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

    _classCallCheck(this, ApiBase);

    var settings = typeof config === 'function' ? config() : config;

    this.target = apiTarget || {};
    this.reset();
    this.name = name;
    this.version = settings.version || 'v1';
    this.domain = settings.domain;
    this.defaultHeaders = DEFAULT_HEADERS;
    this.session = settings.session;
    var headers = settings.headers || {};
    if (!settings.token) throw new Error('config.token is undefined');else this.getToken = function () {
      return settings.token;
    };

    if (!settings.session) throw new Error('config.session is undefined');

    Object.keys(headers).forEach(function (header) {
      if (headers[header] === undefined) delete headers[header];else _this.defaultHeaders[header] = headers[header];
    });
  }

  _createClass(ApiBase, [{
    key: 'init',
    value: function init() {
      this.reset();
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.tasks = { urls: [] };
    }
  }, {
    key: 'getURL',
    value: function getURL() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.name;
      var chunk = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var url = '' + this.domain;
      if (name) url += '/' + name;
      if (chunk) url += '/' + chunk;

      return url;
    }
  }, {
    key: 'getHeaders',
    value: function getHeaders() {
      var _this2 = this;

      var headersBase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.defaultHeaders;

      var headers = headersBase || {};

      return new Promise(function (resolve, reject) {
        try {
          headers['x-ln-token'] = _this2.getToken();
          headers['x-ln-session'] = _this2.session;
          headers['x-ln-api-version'] = _this2.version;

          resolve(headers);
        } catch (errorGetHeaders) {
          reject(errorGetHeaders);
        }
      });
    }
  }, {
    key: 'addTask',
    value: function addTask(name, chunkUrl, parameters) {
      var _tasks$url$params,
          _this3 = this;

      var params = parameters === undefined ? chunkUrl : parameters;
      var chunk = parameters === undefined ? undefined : chunkUrl;

      var url = this.getURL(name, chunk);
      if (!this.tasks[url]) this.tasks.urls.push(url);
      this.tasks[url] = this.tasks[url] || { url: url, params: [], promise: [] };
      this.tasks[url].length = (_tasks$url$params = this.tasks[url].params).push.apply(_tasks$url$params, _toConsumableArray(params));

      var p = new Promise(function (resolve, reject) {
        return _this3.tasks[url].promise.push({ resolve: resolve, reject: reject });
      });

      return p;
    }
  }, {
    key: 'execute',
    value: function execute() {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        _this4.getHeaders().then(function (headers) {
          var tasksToRun = _this4.tasks;
          _this4.reset();

          if (tasksToRun.urls.length > 0) {
            tasksToRun.urls.forEach(function (url) {
              var info = tasksToRun[url];
              _ajax2.default.post(info.url, info.params, headers).then(function (textResult) {
                try {
                  var result = JSON.parse(textResult);

                  if (result instanceof Array) {
                    result.forEach(function (r, i) {
                      return info.promise[i].resolve(r);
                    });

                    resolve(result);
                  } else if ((typeof result === 'undefined' ? 'undefined' : _typeof(result)) === 'object') {
                    reject(result ? result.errorMessage : textResult);
                  } else {
                    reject(result);
                  }
                } catch (err) {
                  reject(err);
                }
              }).catch(reject);
            });
          } else {
            resolve(null);
          }
        }).catch(reject);
      });
    }
  }, {
    key: 'tasks',
    get: function get() {
      return this.target.tasks;
    },
    set: function set(value) {
      this.target.tasks = value;
    }
  }]);

  return ApiBase;
}();

exports.default = ApiBase;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.metaRefresh = exports.scrolledIntoView = exports.getRandom = exports.getRandomInteger = exports.formatoUrlAcuAutor = exports.formatoUrlAcuFotoTag = exports.formatoUrlAcuTag = exports.FormatearUrl = undefined;

var _cookie = __webpack_require__(0);

var Cookie = _interopRequireWildcard(_cookie);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var FormatearUrl = exports.FormatearUrl = function FormatearUrl(nombre) {
    var res = nombre.trim().toLowerCase().replace(/,/g, '').replace(/\./g, '').replace(/:/g, '-').replace(/ /g, '-').replace(/\)/g, '').replace(/\(/g, '').replace(/´/g, '').replace(/"/g, '').replace(/#/g, '').replace(/&/g, '').replace(/\//g, '').replace(/\\/g, '').replace(/\?/g, '').replace(/!/g, '').replace(/\*/g, '').replace(/\[/g, '').replace(/\]/g, '').replace(/\{/g, '').replace(/\}/g, '').replace(/~/g, '').replace(/'/g, '').replace(/¨/g, '').replace(/`/g, '').replace(/\^/g, '').replace(/_/g, '').replace(/\+/g, '').replace(/“/g, '').replace(/%/g, '').replace(/”/g, '');

    var replacement = ['a', 'a', 'a', 'a', 'a', 'a', 'c', 'e', 'e', 'e', 'e', 'i', 'i', 'i', 'i', 'n', 'o', 'o', 'o', 'o', 'o', 'u', 'u', 'u', 'u', 'y', 'y'];
    var accents = ['à', 'á', 'â', 'ã', 'ä', 'å', 'ç', 'é', 'è', 'ê', 'ë', 'ì', 'í', 'î', 'ï', 'ñ', 'ò', 'ó', 'ô', 'ö', 'õ', 'ù', 'ú', 'û', 'ü', 'ý', 'ÿ'];

    for (var i = 0; i < accents.length; i++) {
        res = res.replace(accents[i], replacement[i]);
    }

    return res;
};

var formatoUrlAcuTag = exports.formatoUrlAcuTag = function formatoUrlAcuTag(descripcion, id) {

    return '/' + FormatearUrl(descripcion) + '-t' + id;
};

var formatoUrlAcuFotoTag = exports.formatoUrlAcuFotoTag = function formatoUrlAcuFotoTag(descripcion, id) {

    return '/fotos-de-' + FormatearUrl(descripcion) + '-f' + id;
};
var formatoUrlAcuAutor = exports.formatoUrlAcuAutor = function formatoUrlAcuAutor(nombre, id) {

    return '/autor/' + FormatearUrl(nombre) + '-' + id;
};

var getRandomInteger = exports.getRandomInteger = function getRandomInteger(min, max) {
    var _min = Math.ceil(min);
    var _max = Math.floor(max + 1);
    return Math.floor(Math.random() * (_max - _min)) + _min;
};

var getRandom = exports.getRandom = function getRandom(data, hasta) {
    {
        var arrayNotasRandom = [];
        var arraycount = data.length;
        var startIndex = 0;
        var endIndex = arraycount - 1;
        var loopTo = hasta;
        var dataRandom = [];

        if (endIndex < loopTo) loopTo = arraycount;

        for (var i = startIndex; i < loopTo; i++) {
            //Obtenego el primer numero random
            var _randomNumIndex = getRandomInteger(0, endIndex);

            //Cargo el numero random en el array
            arrayNotasRandom.push(_randomNumIndex);

            //Si no es el 1er numero y si esta en el array buscar otro numero
            if (arrayNotasRandom.length > 1 && jQuery.inArray(_randomNumIndex, arrayNotasRandom) > -1) {
                var exitwhile = 0;
                _randomNumIndex = getRandomInteger(0, endIndex);
                while (jQuery.inArray(_randomNumIndex, arrayNotasRandom) > -1 && exitwhile < 400) {
                    exitwhile++;
                    _randomNumIndex = getRandomInteger(0, endIndex);
                }
                arrayNotasRandom[i] = _randomNumIndex;
            }
        }

        for (var ir = 0; ir < arrayNotasRandom.length; ir++) {
            dataRandom.push(data[arrayNotasRandom[ir]]);
        }

        return dataRandom;
    }
};

var scrolledIntoView = exports.scrolledIntoView = function scrolledIntoView(elem) {
    var element = $(elem);

    if (element.length > 0) {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();

        var elemTop = element.offset().top;
        var elemBottom = elemTop + element.height();

        return elemBottom <= docViewBottom && elemTop >= docViewTop;
    }
    return false;
};

var metaRefresh = exports.metaRefresh = function metaRefresh(time) {
    var productoPremiumId = Cookie.LeerCookie("ProductoPremiumId");
    if (productoPremiumId !== "") {
        productoPremiumId = productoPremiumId.replace(/ /g, "").split(",");
    }
    var objPlayers = document.getElementsByClassName("jwplayer");
    if (productoPremiumId.indexOf("5") < 0) {
        setInterval(function () {
            if (objPlayers.length > 0) {
                var isPlaying = false;
                for (var i = 0; i < objPlayers.length; i++) {
                    if (jwplayer(i).getState() === "playing") {
                        isPlaying = true;
                        break;
                    }
                }
                if (!isPlaying) {
                    localStorage.setItem("CDmetaRefresh", true);
                    window.location.reload();
                }
            } else {
                localStorage.setItem("CDmetaRefresh", true);
                window.location.reload();
            }
        }, time);
    }
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Logout = exports.Initialize = undefined;

var _usuario = __webpack_require__(6);

var Usuario = _interopRequireWildcard(_usuario);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var Initialize = exports.Initialize = function Initialize() {
    $('.salir').click(function () {
        return Logout();
    });
};

var Logout = exports.Logout = function Logout() {
    return Usuario.Salir();
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Salir = exports.VerificarUsuario = undefined;

var _cookie = __webpack_require__(0);

var Cookie = _interopRequireWildcard(_cookie);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var VerificarUsuario = exports.VerificarUsuario = function VerificarUsuario() {
    if (Cookie.LeerCookie('cookieLogin') != '') {
        MostrarUsuario();
    }
};

var Salir = exports.Salir = function Salir() {
    $('#cabezal').removeClass('logueado');
    $('#cabezal').removeClass('suscripto');
    return OcultarUsuario();
};

function MostrarUsuario() {

    var nick = Cookie.LeerCookie('usuario%5Fdetalle%5Fnick');

    $('.usuario').text(nick + ' ' + $('.usuario').text());

    $('.ingresar').css('display', 'none');
    //$('.usuario').css('display', 'initial');

    if (Cookie.LeerCookie('ProductoPremiumId') != "") {
        $('#cabezal').addClass('suscripto');
    } else {
        $('#cabezal').addClass('logueado');
    }
}

function OcultarUsuario() {
    $('.ingresar').css('display', 'initial');
    $('.usuario').css('display', 'none');

    $('.usuario').text('&#9660;');

    localStorage.removeItem("token");

    window.top.frames['iLogout'].location.href = window.config.Statics.SitioSeguroRegistracion + '/logout/logout.html?pagina=' + window.location.origin + window.config.Statics.LogoutUrl;

    if (typeof fyre != "undefined") {
        fyre.conv.logout();
    }

    return false;
}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initPerso = exports.init = undefined;

var _cookie = __webpack_require__(0);

var Cookie = _interopRequireWildcard(_cookie);

var _api = __webpack_require__(21);

var _api2 = _interopRequireDefault(_api);

var _laNacionProvider = __webpack_require__(22);

var _laNacionProvider2 = _interopRequireDefault(_laNacionProvider);

var _ClearLoQueSigo = __webpack_require__(9);

var ClearLoQueSigo = _interopRequireWildcard(_ClearLoQueSigo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var init = exports.init = function init() {
    var cookieToken = Cookie.LeerCookie("token");

    if (cookieToken !== "") {
        var lsToken = localStorage.getItem("token");
        if (cookieToken === lsToken) {
            //Pregunta si la cookie tiene el mismo token que el localstorage
            if (!isSessionDateExpired()) {
                //Devuelve si la sesion sigue siendo valida
                return true;
            } else {
                clearLocalstorage();
                localStorage.setItem("token", cookieToken);
                localStorage.setItem("sessionCreated", Date.now());
                return true;
            }
        } else {
            clearLocalstorage();
            //Se llama al clearCustomDImension porque unicamente se limpia al cambiarse el token y no al deslogearse
            clearCustomDimension();
            localStorage.setItem("token", cookieToken);
            localStorage.setItem("sessionCreated", Date.now());
            return true;
        }
    } else {
        clearLocalstorage();
        return false;
    }
};
var isSessionDateExpired = function isSessionDateExpired() {
    var sessionCreatedDate = localStorage.getItem("sessionCreated");
    var sessionCacheMiliseconds = 60000; ///TODO:pasar a configuracion
    var dif = 0;

    if (sessionCreatedDate === null) {
        return true;
    } else {
        dif = Date.now() - sessionCreatedDate;
        if (dif < sessionCacheMiliseconds) {
            return false;
        } else {
            return true;
        }
    }
};

var clearLocalstorage = function clearLocalstorage() {

    localStorage.removeItem("token");
    localStorage.removeItem("sugerenciasTitulares");
    localStorage.removeItem("fechaSugerenciaTitulares");
    localStorage.removeItem("CDusuarioLogeado");
    ClearLoQueSigo.clearLS();
    //remove items
};

var clearCustomDimension = function clearCustomDimension() {
    //Solo tiene que llamarse al clearCustomDimension cuando cambio el token y no cuando se deslogeo
    localStorage.removeItem("CDcacheCommon");
    localStorage.removeItem("CDusuarioLogeado");
    localStorage.removeItem("CDusuarioRegistrado");
    localStorage.removeItem("CDpayUser");
    localStorage.removeItem("CDsuscriptorType");
    localStorage.removeItem("CDcredentialType");
    localStorage.removeItem("CDuserId");
};

var initPerso = exports.initPerso = function initPerso() {
    var configProvider = _laNacionProvider2.default.ConfigProvider;
    return (0, _api2.default)(configProvider());

    //FOR TEST ONLY
    //******************************
    //const usuario = {
    //    token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiMDYyNjY1MzkyRkVENDRBNjg3Mzc3NENFMUQ5NDcwM0EiLCJpZF92ZXJpZmllciI6IkY4Nzc4M0YxIiwiZXhwIjoxNTE0MjExNjUyfQ.WbMh_4ZmPlWLXmECoRfZWtOyCtVNAtVOIe0Frg-qIyM",
    //    //token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiODA2RDM5QjFCRDUwNERBOUFFN0Y3RjYwRTExMjEzRUQiLCJpZF92ZXJpZmllciI6IkFFQUQxMDhBIiwiZXhwIjoxNTEyODQ1NzIwfQ.3apuiTeTkcnRsJ7P_JgInnVN2kpAv3kSrgSJ2kEUYCk",
    //    //session: "AEAD108A"
    //    session: "F87783F1"
    //}
    //const APIDOMAIN = "https://personalizacion.lanacion.com.ar/v3";
    //return ApiBuilder(configProvider(APIDOMAIN, usuario));  
};

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = {"metaTitle":"{title}","metaDescription":"{title} - {bajada} - {arrayTags} - LA NACION","metaKeywords":"{title} - {bajada} - {arrayTags} - LA NACION","LiveFyre":{"activo":true,"mensaje":"Debido a la veda electoral estas notas estarán cerradas a comentarios hasta el domingo a las 18hs. Muchas gracias.","token":""},"sitiosPermitidos":[1],"categoriasEliminadas":[7195],"prioridadTag":[{"descripcion":"content-lab","tagtipo":10,"prioridad":1},{"descripcion":"espacio-patrocinado","tagtipo":9,"prioridad":2},{"descripcion":"topico","tagtipo":1,"prioridad":3},{"descripcion":"show","tagtipo":8,"prioridad":4},{"descripcion":"seccion","tagtipo":6,"prioridad":5}],"Template":[{"Nombre":"Htmllibre","Apertura":["Titulo"],"Destacado":["Encuentro","Video","Galeria","Imagen","Infografia","ImagenEmbebida"]},{"Nombre":"Historia","Apertura":["Historia"],"Destacado":["Encuentro","Galeria","Video","Imagen","Infografia","ImagenEmbebida"]},{"Nombre":"Opinion","Apertura":["Titulo"],"Destacado":["Encuentro","Video","Galeria","Imagen","Infografia","ImagenEmbebida"]},{"Nombre":"Infografia","Apertura":["Infografia","Titulo"],"Destacado":["ImagenEmbebida"]},{"Nombre":"Noticia","Apertura":["Titulo"],"Destacado":["Encuentro","Video","Galeria","Imagen","Infografia","ImagenEmbebida"]}],"tercera":["BannerCaja1","BannerCaja2","ListadoTemasBloque2","PromoContent","Ranking","PromoClub"],"site":[{"categoriaId":1,"nombre":"LA NACION"},{"categoriaId":9,"nombre":"ROLLING STONE"},{"categoriaId":19,"nombre":"LIVING"},{"categoriaId":20,"nombre":"Club LANACION"},{"categoriaId":21,"nombre":"REVISTA OHLALA"},{"categoriaId":22,"nombre":"Revista BRANDO"},{"categoriaId":28,"nombre":"Revista HOLA"},{"categoriaId":32,"nombre":"Revista Susana"},{"categoriaId":35,"nombre":"Recetas"},{"categoriaId":37,"nombre":"Master LN"},{"categoriaId":40,"nombre":"Revista Lugares"}],"class":{"bloque1":[{"nombre":"Noticia","descripcion":"normal"},{"nombre":"Historia","descripcion":"storytelling"},{"nombre":"Infografia","descripcion":"normal infografia"},{"nombre":"Opinion","descripcion":"opinion"}],"bloque2":[{"descripcion":"revista brando","categoriaId":7993,"tagIgnoradoId":61735,"tagUrlDescripcion":"revista brando"},{"descripcion":"revista living","categoriaId":7998,"tagIgnoradoId":50022,"tagUrlDescripcion":"revista living"},{"descripcion":"revista ohlala","categoriaId":7049,"tagIgnoradoId":99999,"tagUrlDescripcion":"revista ohlala"},{"descripcion":"revista rolling","categoriaId":7048,"tagIgnoradoId":99999,"tagUrlDescripcion":"revista rolling"},{"descripcion":"revista lugares","categoriaId":7994,"tagIgnoradoId":62072,"tagUrlDescripcion":"revista lugares"},{"descripcion":"revista jardin","categoriaId":7995,"tagIgnoradoId":61799,"tagUrlDescripcion":"revista jardin"},{"descripcion":"revista hola","categoriaId":7996,"tagIgnoradoId":62132,"tagUrlDescripcion":"revista hola"},{"descripcion":"revista living","categoriaId":7998,"tagIgnoradoId":50022,"tagUrlDescripcion":"revista living"}],"bloque3":[{"descripcion":"ovrik","tipo":"tag","id":59142,"url":"http://www.ovrik.com/"},{"descripcion":"bbc","tipo":"categoria","id":6250,"url":"http://www.bbc.co.uk/mundo/"},{"descripcion":"bbc","tipo":"tag","id":6250,"url":"http://www.bbc.co.uk/mundo/"},{"descripcion":"wall-street","tipo":"tag","id":6373,"url":"http://www.wsj.com/"},{"descripcion":"wall-street","tipo":"categoria","id":6373,"url":"http://www.wsj.com/"}],"bloque4":[{"descripcion":"content-lab","tagTipo":10},{"descripcion":"espacio-patrocinado","tagTipo":9}]},"autoresMostrarEnCabecera":3,"reglaNodoContenidoExtendido":[{"nodoType":"NodoBanner","template":["Noticia","Opinion","Infografia"],"espacio":"Middle 1","cssClass":"middle-1","bannerId":"middle","bannerType":"middle","dispositivo":"desktop","dibujarEnPosicionInicial":3,"dibujarSiElementosEnNotaAlMenos":3,"nombre":"Regla[Template:{0}|NodoType:{1}|Espacio:{2}|Posicion:{3}|dibujarSiElementosEnNotaAlMenos:{4}|Prioridad:{5}|ElementosEnLaNota:{6}]","prioridad":1,"nodoNoContabilizar":["Subtitulo","Subtitulo2"]},{"nodoType":"NodoBanner","template":["Noticia","Opinion","Infografia"],"espacio":"Middle 2","cssClass":"middle-2","bannerId":"middle_2","bannerType":"middle","dispositivo":"desktop","dibujarEnPosicionInicial":6,"dibujarSiElementosEnNotaAlMenos":9,"nombre":"Regla[Template:{0}|NodoType:{1}|Espacio:{2}|Posicion:{3}|dibujarSiElementosEnNotaAlMenos:{4}|Prioridad:{5}|ElementosEnLaNota:{6}]","prioridad":3,"nodoNoContabilizar":["Subtitulo","Subtitulo2"]},{"nodoType":"NodoBanner","template":["Noticia","Opinion","Infografia","Historia"],"espacio":"Caja 1","cssClass":"caja","bannerId":"caja_1","bannerType":"bigbox","dispositivo":"mobile","dibujarEnPosicionInicial":1,"dibujarSiElementosEnNotaAlMenos":1,"nombre":"Regla[Template:{0}|NodoType:{1}|Espacio:{2}|Posicion:{3}|dibujarSiElementosEnNotaAlMenos:{4}|Prioridad:{5}|ElementosEnLaNota:{6}]","prioridad":4,"nodoNoContabilizar":["Subtitulo","Subtitulo2"]},{"nodoType":"NodoBanner","template":["Noticia","Opinion","Infografia","Historia"],"espacio":"Middle","cssClass":"middle-1","bannerId":"middle","bannerType":"middle","dispositivo":"mobile","dibujarEnPosicionInicial":4,"dibujarSiElementosEnNotaAlMenos":4,"nombre":"Regla[Template:{0}|NodoType:{1}|Espacio:{2}|Posicion:{3}|dibujarSiElementosEnNotaAlMenos:{4}|Prioridad:{5}|ElementosEnLaNota:{6}]","prioridad":5,"nodoNoContabilizar":["Subtitulo","Subtitulo2"]},{"nodoType":"NodoBanner","template":["Noticia","Opinion","Infografia","Historia"],"espacio":"Caja 2","cssClass":"caja","bannerId":"caja_2","bannerType":"bigbox2","dispositivo":"mobile","dibujarEnPosicionInicial":7,"dibujarSiElementosEnNotaAlMenos":7,"nombre":"Regla[Template:{0}|NodoType:{1}|Espacio:{2}|Posicion:{3}|dibujarSiElementosEnNotaAlMenos:{4}|Prioridad:{5}|ElementosEnLaNota:{6}]","prioridad":6,"nodoNoContabilizar":["Subtitulo","Subtitulo2"]},{"nodoType":"NodoBanner","template":["Noticia","Opinion","Infografia","Historia"],"espacio":"Caja 3","cssClass":"caja","bannerId":"caja_3","bannerType":"box","dispositivo":"mobile","dibujarEnPosicionInicial":9,"dibujarSiElementosEnNotaAlMenos":9,"nombre":"Regla[Template:{0}|NodoType:{1}|Espacio:{2}|Posicion:{3}|dibujarSiElementosEnNotaAlMenos:{4}|Prioridad:{5}|ElementosEnLaNota:{6}]","prioridad":7,"nodoNoContabilizar":["Subtitulo","Subtitulo2"]},{"nodoType":"NodoBanner","template":["Noticia","Opinion","Infografia","Historia"],"espacio":"Caja 1","cssClass":"caja","bannerId":"caja_1","bannerType":"bigbox","dispositivo":"tablet","dibujarEnPosicionInicial":1,"dibujarSiElementosEnNotaAlMenos":1,"nombre":"Regla[Template:{0}|NodoType:{1}|Espacio:{2}|Posicion:{3}|dibujarSiElementosEnNotaAlMenos:{4}|Prioridad:{5}|ElementosEnLaNota:{6}]","prioridad":8,"nodoNoContabilizar":["Subtitulo","Subtitulo2"]},{"nodoType":"NodoBanner","template":["Noticia","Opinion","Infografia","Historia"],"espacio":"Caja 2","cssClass":"caja","bannerId":"caja_2","bannerType":"bigbox2","dispositivo":"tablet","dibujarEnPosicionInicial":4,"dibujarSiElementosEnNotaAlMenos":4,"nombre":"Regla[Template:{0}|NodoType:{1}|Espacio:{2}|Posicion:{3}|dibujarSiElementosEnNotaAlMenos:{4}|Prioridad:{5}|ElementosEnLaNota:{6}]","prioridad":9,"nodoNoContabilizar":["Subtitulo","Subtitulo2"]},{"nodoType":"NodoNotaDinamica","template":["Noticia","Opinion","Infografia"],"espacio":"Listado Ademas Notas Automaticas Dinamicas","cssClass":"ademas","bannerId":"","bannerType":"","dispositivo":"","dibujarEnPosicionInicial":3,"dibujarSiElementosEnNotaAlMenos":3,"nombre":"Regla[Template:{0}|NodoType:{1}|Espacio:{2}|Posicion:{3}|dibujarSiElementosEnNotaAlMenos:{4}|Prioridad:{5}|ElementosEnLaNota:{6}]","prioridad":2,"nodoNoContabilizar":["Subtitulo","Subtitulo2"]}],"reglaColumnaTercera":[{"prioridad":1,"viewName":"BannerCaja1","template":["Noticia","Opinion","Infografia","Historia"],"dibujarSiElementosEnNotaAlMenos":0},{"prioridad":2,"viewName":"ListadoTemasBloque2","template":["Noticia","Opinion","Infografia","Historia"],"dibujarSiElementosEnNotaAlMenos":3},{"prioridad":3,"viewName":"BannerCaja2","template":["Noticia","Opinion","Infografia","Historia"],"dibujarSiElementosEnNotaAlMenos":6},{"prioridad":4,"viewName":"PromoContent","template":["Noticia","Opinion","Infografia","Historia"],"dibujarSiElementosEnNotaAlMenos":6},{"prioridad":5,"viewName":"Ranking","template":["Noticia","Opinion","Infografia","Historia"],"dibujarSiElementosEnNotaAlMenos":9},{"prioridad":6,"viewName":"PromoClub","template":["Noticia","Opinion","Infografia","Historia"],"dibujarSiElementosEnNotaAlMenos":10}],"sugerenciasPie":[{"categoriasPosibles":[30,131,120,272,7773],"cantidad":4}],"HeaderVarnish":[{"key":"X-APW-ACCESS-CONTROL","value":"anonymous,subscribers"},{"key":"X-APW-AAC-PIDS","value":"0"},{"key":"X-APW-SAC-PIDS","value":"PAYWALL"},{"key":"X-APW-AUTHENTICATION-FAILED","value":"https://ingresar.lanacion.com.ar/ingresar/S/1/?{url}"},{"key":"X-APW-AUTHORIZATION-DENIED","value":"https://ingresar.lanacion.com.ar/suscripcion/V/1/1/?{url}"},{"key":"X-APW-CID","value":"n_{notaId}"},{"key":"X-APW-SOCIAL","value":"{social}"}]}

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var clearLS = exports.clearLS = function clearLS() {

    localStorage.removeItem("apiPerso.preferencias.obtener");
    localStorage.removeItem("apiPerso.preferencias.obtenerNovedades");
    localStorage.removeItem("apiPerso.preferencias.obtenerPreferibles");

    localStorage.removeItem("apiPerso.ranking.obtenerMasSeguidos");

    localStorage.removeItem("obtenerPorPrioridad");
    localStorage.removeItem("obtenerNovedades");
    localStorage.removeItem("recomendarTemas");
    localStorage.removeItem("obtenerAccesos");
    localStorage.removeItem("obtenerSugerencias");
    localStorage.removeItem("obtenerHashSuscripciones");
    localStorage.removeItem("obtenerPreferibles");
};

/***/ }),
/* 10 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function() {

/*!
 * jQuery JavaScript Library v3.3.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2018-01-20T17:24Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		noModule: true
	};

	function DOMEval( code, doc, node ) {
		doc = doc || document;

		var i,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {
				if ( node[ i ] ) {
					script[ i ] = node[ i ];
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.3.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		div.style.position = "absolute";
		scrollboxSizeVal = div.offsetWidth === 36 || "absolute";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5
		) );
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),
		val = curCSS( elem, dimension, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox;

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = valueIsBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ dimension ] );

	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	if ( val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {

		val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];

		// offsetWidth/offsetHeight provide border-box values
		valueIsBorderBox = true;
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),
				isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra && boxModelAdjustment(
					elem,
					dimension,
					extra,
					isBorderBox,
					styles
				);

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && support.scrollboxSize() === styles.position ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( typeof define === "function" && define.amd ) {
	define( "jquery", [], function() {
		return jQuery;
	} );
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );

}.call(window));

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = {"sitioId":1,"viewport":"width=device-width,initial-scale=1,minimum-scale=1","copyright":"LA NACION","facebookId":"246891475813003","head":{"meta":[{"name":"viewport","content":"width=device-width,initial-scale=1,minimum-scale=1"}]},"termicas":{"comentarios":{"activo":true,"mensaje":"Esta nota se encuentra cerrada a comentarios"}},"banners":[{"categoriaId":7774,"descripcion":"ln_buenos_aires"},{"categoriaId":131,"descripcion":"ln_deportes"},{"categoriaId":272,"descripcion":"ln_economia"},{"categoriaId":562,"descripcion":"ln_editoriales"},{"categoriaId":7,"descripcion":"ln_el_mundo"},{"categoriaId":7950,"descripcion":"ln_espectaculos"},{"categoriaId":7949,"descripcion":"ln_ideas"},{"categoriaId":28,"descripcion":"ln_opinion"},{"categoriaId":30,"descripcion":"ln_politica"},{"categoriaId":7775,"descripcion":"ln_seguridad"},{"categoriaId":7773,"descripcion":"ln_sociedad"},{"categoriaId":432,"descripcion":"ln_tecnologia"},{"categoriaId":6585,"descripcion":"ln_vida_y_ocio"}],"banner":{"tags":[{"tipo":1,"mostrar":1,"key":"te_","tipoDescripcion":"Topico"},{"tipo":2,"mostrar":1,"key":"pe_","tipoDescripcion":"Persona"},{"tipo":3,"mostrar":1,"key":"org_","tipoDescripcion":"Organizacion"},{"tipo":4,"mostrar":0,"key":"lu_","tipoDescripcion":"Lugar"},{"tipo":5,"mostrar":0,"key":"ing_","tipoDescripcion":"Ingredientes"},{"tipo":6,"mostrar":1,"key":"se_","tipoDescripcion":"Seccion"},{"tipo":9,"mostrar":1,"key":"pa_","tipoDescripcion":"Espacio Patrocinado"},{"tipo":10,"mostrar":1,"key":"cl_","tipoDescripcion":"Content Lab"}]},"ocultarBanners":{"desktop":{"nota":[{"userType":2,"banners":["middle_2","middle_teads"]},{"userType":4,"banners":["megacabezal","middle"]},{"userType":6,"banners":["megacabezal","middle"]}],"acumulado":[{"userType":2,"banners":[]},{"userType":4,"banners":["megacabezal"]},{"userType":6,"banners":["megacabezal"]}],"home":[{"userType":2,"banners":[]},{"userType":4,"banners":["megacabezal"]},{"userType":6,"banners":[]}]},"tablet":{"nota":[{"userType":2,"banners":[]},{"userType":4,"banners":["megacabezal"]},{"userType":6,"banners":["megacabezal"]}],"acumulado":[{"userType":2,"banners":[]},{"userType":4,"banners":["megacabezal"]},{"userType":6,"banners":["megacabezal"]}],"home":[{"userType":2,"banners":[]},{"userType":4,"banners":["megacabezal"]},{"userType":6,"banners":[]}]},"mobile":{"nota":[{"userType":2,"banners":[]},{"userType":4,"banners":["sticky","sticky_2"]},{"userType":6,"banners":["sticky","sticky_2"]}],"acumulado":[{"userType":2,"banners":[]},{"userType":4,"banners":["sticky","sticky_2"]},{"userType":6,"banners":["sticky","sticky_2"]}],"home":[{"userType":2,"banners":[]},{"userType":4,"banners":["sticky","sticky_2"]},{"userType":6,"banners":[]}]}},"header":{"tematicas":[{"nombre":"Política","url":"/politica"},{"nombre":"Economía","url":"/economia"},{"nombre":"Sociedad","url":"/sociedad"},{"nombre":"Mundo","url":"/el-mundo "},{"nombre":"Opinión","url":"/opinion"},{"nombre":"Editoriales","url":"/editorial-t54796 "},{"nombre":"Deportes","url":"/deportes"},{"nombre":"Espectáculos","url":"/espectaculos"},{"nombre":"Tecnología","url":"/tecnologia-t47502"},{"nombre":"Arte y Cultura","url":"/arte-cultura"},{"nombre":"Lifestyle","url":"/lifestyle"}],"servicios":[{"nombre":"Horóscopo","url":"//servicios.lanacion.com.ar/horoscopo"},{"nombre":"Pronóstico","url":"//servicios.lanacion.com.ar/pronostico-del-tiempo "},{"nombre":"Tránsito","url":"//servicios.lanacion.com.ar/transito"},{"nombre":"Dólar hoy","url":"/dolar-hoy-t1369 "},{"nombre":"Feriados","url":"//servicios.lanacion.com.ar/feriados"},{"nombre":"Fúnebres","url":"//servicios.lanacion.com.ar/edicion-impresa/avisos-funebres"},{"nombre":"Loterías y quinielas","url":"//servicios.lanacion.com.ar/loterias"},{"nombre":"Cartelera de cine","url":"//guia.lanacion.com.ar/cine"},{"nombre":"Cartelera de teatro","url":"//guia.lanacion.com.ar/teatro "},{"nombre":"Cocina y Recetas","url":"//recetas.lanacion.com.ar/"},{"nombre":"Sudoku","url":"//servicios.lanacion.com.ar/sudoku-online"},{"nombre":"Sólo texto","url":"//servicios.lanacion.com.ar/solo-texto"}],"club":[{"nombre":"GASTRONOMÍA","url":"//club.lanacion.com.ar/beneficios-de-Gastronom%C3%ADa "},{"nombre":"ENTRETENIMIENTO","url":"//club.lanacion.com.ar/beneficios-de-Entretenimiento"},{"nombre":"TURISMO","url":"//club.lanacion.com.ar/beneficios-de-Turismo"},{"nombre":"MODA","url":"//club.lanacion.com.ar/beneficios-de-Moda"},{"nombre":"BELLEZA","url":"//club.lanacion.com.ar/beneficios-de-Belleza"},{"nombre":"DECO Y HOGAR","url":"//club.lanacion.com.ar/beneficios-de-Deco%20y%20Hogar"}],"revistas":[{"nombre":"ohlalá!","url":"http://www.revistaohlala.com/"},{"nombre":"¡hola!","url":"/revista-hola-t62132"},{"nombre":"rollingstone","url":"http://www.rollingstone.com.ar/"},{"nombre":"lugares","url":"/revista-lugares-t62072"},{"nombre":"living","url":"/revista-living-t50022"},{"nombre":"brando","url":"/revista-brando-t61735"},{"nombre":"jardín","url":"/revista-jardin-t61799"},{"nombre":"susana","url":"http://www.revistasusana.com/"}],"ultimasNoticias":"/ultimas-noticias","lnPlus":"http://lnmas.lanacion.com.ar/","edicionImpresa":"/edicion-impresa"}}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadData = loadData;
exports.signwall = signwall;
exports.paywall = paywall;

var _ajax = __webpack_require__(1);

var _nota = __webpack_require__(8);

function getDefaultDataUrl() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    if (url.indexOf('?') >= 0) {
        return url + '&utm_source=navigation';
    }
    return url + '?utm_source=navigation';
}

function loadData(url) {
    var getDataUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getDefaultDataUrl;

    var dataUrl = getDataUrl(url);
    return new Promise(function (resolve, reject) {
        (0, _ajax.get)(dataUrl).then(function (rs) {
            var data = JSON.parse(rs);
            var elements = [];
            for (var i = 0; i < data.Modules.length; i++) {
                var m = data.Modules[i];
                var el = document.querySelector('[data-module="' + m.Key + '"]');
                el.innerHTML = m.Value;
                elements.push(el);
            }
            document.title = data.Title;
            resolve(elements);
        }).catch(function () {
            return reject();
        });
    });
}

function signwall() {
    var signwall = _nota.HeaderVarnish.filter(function (x) {
        return x.key == "X-APW-AUTHENTICATION-FAILED";
    });
    return signwall.value.replace("{url}", "");
}

function paywall() {
    var signwall = _nota.HeaderVarnish.filter(function (x) {
        return x.key == "X-APW-AUTHORIZATION-DENIED";
    });
    return signwall.value.replace("{url}", "");
}

window.prueba11 = function () {
    console.log("entre a PRUEBA11111111");
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.start = start;

var _jquery = __webpack_require__(10);

var _jquery2 = _interopRequireDefault(_jquery);

var _page = __webpack_require__(12);

var page = _interopRequireWildcard(_page);

var _spinner = __webpack_require__(16);

var Spinner = _interopRequireWildcard(_spinner);

var _EplAd = __webpack_require__(14);

var _EplAd2 = _interopRequireDefault(_EplAd);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.spinner = Spinner;

window.jQuery = _jquery2.default;
window.$ = _jquery2.default;

//window.eplArgs = window.eplArgs || {};
//window.eplArgs.callback = (arg) => {
//    if (arg.k === "megaLateral") {
//        const div = document.getElementById('eplAdDivmegaLateral');
//        if (div.childNodes.length) {
//            document.body.classList.remove('con-mega');
//            document.body.classList.add('con-mega');    
//        }
//    }
//}

function start() {
    return new Promise(function (resolve, reject) {
        (0, _jquery2.default)(function () {
            if (window.banner && window.banner.sites) {
                var ad = new _EplAd2.default(window.banner.sites, window.keywords);
                ad.initSpaces();
            }
            if (!window.render) {
                resolve();
            } else {
                Spinner.show();
                page.loadData(window.location.href).then(function (rs) {
                    Spinner.hide();
                    resolve(rs);
                }).catch(function (err) {
                    Spinner.hide();
                    reject(err);
                });
            }
        });
    });
}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GLOBAL_URL = 'us.img.e-planning.net';
var DATA_ATTR = 'data-adpos';

var createIframe = function createIframe() {
    var el = document.createElement('IFRAME');
    el.src = 'about:blank';
    el.id = 'epl4iframe';
    el.name = 'epl4iframe';
    el.width = 0;
    el.height = 0;
    el.style.width = '0px';
    el.style.height = '0px';
    el.style.display = 'none';
    return el;
};

var findSite = function findSite(sites) {
    var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body.offsetWidth;

    var selectedSites = sites.filter(function (s) {
        return s.maxWidth >= width;
    }).sort(function (a, b) {
        return a.maxWidth - b.maxWidth;
    });

    if (selectedSites.length < 1) throw new Error('No se encuentra un sitio para el ancho: ' + width);

    return selectedSites[0];
};

var EplAd = function () {
    function EplAd(sites) {
        var keywords = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        _classCallCheck(this, EplAd);

        var protocol = document.location.protocol || window.top.location.protocol;
        this.scheme = protocol.substr(0, protocol.length - 1);
        this.sites = sites;
        this.args = args;
        this.keywords = keywords;

        this.site = findSite(sites);
        this.eplArgs = this._getArgs(this.site, args);

        this._loaded = false;
    }

    _createClass(EplAd, [{
        key: 'updateAds',
        value: function updateAds() {
            var forced = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (!document.epl) return;
            var site = findSite(this.sites);
            if (forced || site !== this.site) {
                this.site = site;
                this.eplArgs = this._getArgs(this.site, this.args);
                this.removeSpaces();
                document.epl.eplInit(this.eplArgs);
                this.initSpaces();
            }
        }
    }, {
        key: '_getArgs',
        value: function _getArgs(site) {
            var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return Object.assign({
                iIF: 1,
                sV: this.scheme + '://ads.e-planning.net/',
                vV: "4",
                sOpts: {},
                sI: site.id,
                sec: site.section,
                eIs: site.positions,
                kVs: { busqueda: this.keywords }
            }, args);
        }
    }, {
        key: 'initSpace',
        value: function initSpace(id) {
            var container = document.querySelector('[' + DATA_ATTR + '="' + id + '"]');
            this._initSpace(container);
        }
    }, {
        key: 'initSpaces',
        value: function initSpaces() {
            var ads = document.querySelectorAll('[' + DATA_ATTR + ']');
            for (var i = 0; i < ads.length; i++) {
                var container = ads[i];
                this._initSpace(container);
            }
        }
    }, {
        key: 'removeSpace',
        value: function removeSpace(id) {
            if (!document.epl) return;

            id = this._findPosition(id);
            var space = document.epl.getSpace(id);
            try {
                space.clearAds();
                space.getDiv().remove();
            } catch (_) {}
        }
    }, {
        key: 'removeSpaces',
        value: function removeSpaces() {
            if (!document.epl) return;

            for (var name in document.epl.spaces) {
                var space = document.epl.spaces[name];
                try {
                    space.clearAds();
                    space.getDiv().remove();
                } catch (_) {}
            }
            var ads = document.querySelectorAll('[' + DATA_ATTR + ']');
            for (var i = 0; i < ads.length; i++) {
                var container = ads[i];
                container.childNodes.forEach(function (n) {
                    return n.remove();
                });
            }
        }
    }, {
        key: 'reloadSpaces',
        value: function reloadSpaces() {
            document.epl.refreshAds();
        }
    }, {
        key: '_findPosition',
        value: function _findPosition(pos) {
            if (this.site.rename) {
                for (var i = 0; i < this.site.rename.length; i++) {
                    var rn = this.site.rename[i];
                    if (rn.from === pos) {
                        return rn.to;
                    }
                }
            }
            return pos;
        }
    }, {
        key: '_initialized',
        value: function _initialized() {
            if (document.epl) return this._setupAd();
            if (this._loaded) return false;
            this._loaded = true;

            var cookie = document.cookie;
            var cookieName = ('https' === this.scheme ? 'EPLSERVER_S' : 'EPLSERVER') + '=';
            var regex = new RegExp(cookieName + '[\\w.-]+');

            var baseUrl = null;
            var res = regex.exec(cookie);
            if (res) {
                baseUrl = res[0].substr(cookieName.length);
            }

            var iframe = createIframe();
            document.body.appendChild(iframe);
            var iframeDoc = iframe.contentDocument ? iframe.contentDocument : iframe.document;

            iframeDoc.open();
            iframeDoc.write('<html><head><title>e-planning</title></head><body></body></html>');
            iframeDoc.close();

            var script = iframeDoc.createElement('SCRIPT');
            script.src = this.scheme + '://' + (baseUrl ? baseUrl : GLOBAL_URL) + '/layers/epl-41.min.js';
            iframeDoc.body.appendChild(script);

            if (!baseUrl) {
                script = iframeDoc.createElement('SCRIPT');
                script.src = this.scheme + '://ads.e-planning.net/egc/4/39a8';
                iframeDoc.body.appendChild(script);
            }

            return false;
        }
    }, {
        key: '_initSpace',
        value: function _initSpace(container) {
            var idAttr = container.getAttribute(DATA_ATTR);
            var id = this._findPosition(idAttr);
            this._createSpace(container, id);
        }
    }, {
        key: '_createSpace',
        value: function _createSpace(container, id) {
            var eplId = 'eplAdDiv' + id;
            if (container.querySelector('#' + eplId) == null) {
                var el = document.createElement('div');
                el.id = eplId;
                container.appendChild(el);
                var opts = { t: 1 };
                this.eplArgs.sOpts[id] = opts;
                this._showSpace(id);
            }
        }
    }, {
        key: '_showSpace',
        value: function _showSpace(id, custom) {
            var _this = this;

            if (this._initialized()) {
                var epl = document.epl;
                if (custom) {
                    epl.setCustomAdShow(id, this.eplArgs.custom[id]);
                }
                epl.showSpace(id);
            } else {
                setTimeout(function () {
                    _this._showSpace(id, custom);
                }, 250);
            }
        }
    }, {
        key: '_setupAd',
        value: function _setupAd() {
            if (document.epl.eplReady()) return true;
            document.epl.eplInit(this.eplArgs);
            if (this.eplArgs.custom) {
                for (var s in this.eplArgs.custom) {
                    document.epl.setCustomAdShow(s, this.eplArgs.custom[s]);
                }
            }
            return document.epl.eplReady();
        }
    }]);

    return EplAd;
}();

exports.default = EplAd;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Login = exports.Initialize = undefined;

var _usuario = __webpack_require__(6);

var Usuario = _interopRequireWildcard(_usuario);

var _cookie = __webpack_require__(0);

var Cookie = _interopRequireWildcard(_cookie);

var _logout = __webpack_require__(5);

var Logout = _interopRequireWildcard(_logout);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var Initialize = exports.Initialize = function Initialize() {
    $('.ingresar').click(function () {
        Login();
    });

    if (Cookie.LeerCookie('cookieLogin') != "") {
        Relogin();
    }

    Usuario.VerificarUsuario();
};

var Login = exports.Login = function Login() {
    location.href = window.config.Statics.LoginUrl + window.btoa(location.href);
};

function Relogin() {
    var toRelogin = mustRelogin();
    console.log(toRelogin);

    if (toRelogin) {
        var headers = { 'X-Token': Cookie.LeerCookie("token") || '', 'X-Value': Cookie.LeerCookie("xvalue") || '' };
        var data = {
            OrigenLoginTipoId: 1,
            AutenticacionTipoId: 1,
            IsRelogin: 1
        };
        jQuery.ajax({
            url: window.config.Statics.APILoginUrl + "/Usuario/ReLogin",
            type: 'post',
            dataType: "json",
            data: data,
            headers: headers,
            async: true,
            success: function success(res, status, xhr) {
                if (res.code == "0000") {
                    var token = xhr.getResponseHeader("X-Token");
                    var xvalue = xhr.getResponseHeader("X-Value");
                    Cookie.SetToken(token);
                    Cookie.SetXValue(xvalue);
                    reMe();
                    top.frames['iLogout'].location.href = "http://passport.lanacion.com.ar/cifrador.aspx?pagina=" + window.location.origin + window.config.Statics.ReloginUrl;
                } else {
                    Logout.Logout();
                }
            },
            error: function error(e) {
                console.log("error: " + e.toString());
            }
        });
    }
}

function mustRelogin() {
    var result = true;
    var millisecBeforeRelogin = window.config.Statics.ReloginValidation;
    try {
        var syncValue = Cookie.LeerCookie('syncLfLN');
        var cookieSalt = Cookie.LeerCookie('token');

        // Parseo cookie syncLfLN para que no tenga am/pm . 
        // Tengo que convertir la hora en formato de 24hrs y no de 12hrs . 
        // Cookie de ejemplo : 09/06/2017 06:52:46 p.m.
        if (syncValue.indexOf("/") > -1 && (syncValue.indexOf('a.m.') > -1 || syncValue.indexOf('p.m.') > -1)) {
            var arr_full_date = syncValue.split(" "); // [0] : 09/06/2017 - [1] : 06:52:46 - [2] : p.m.

            // La fecha está en DD/MM/YYYY . La convierto a MM/DD/YYYY ; 
            var daysDate = arr_full_date[0];
            var arr_days = daysDate.split('/');
            var daysDate = arr_days[1] + '/' + arr_days[0] + "/" + arr_days[2];

            var time = convertTo24Hour(arr_full_date[1] + arr_full_date[2]);
            arr_full_date[1] = time;
            syncValue = daysDate + " " + arr_full_date[1]; // Vuelvo a armar la cookie con el date actualizado. 
        }
        // Fin 

        if (cookieSalt == '') {
            return false;
        }

        if (syncValue != '') {
            var syncDate = new Date(syncValue);
            if (new Date() < new Date(syncDate.getTime() - millisecBeforeRelogin)) {
                result = false;
            }
        }
    } catch (e) {
        return false;
    }

    return result;
}

function convertTo24Hour(time) {
    var hours = time.substr(0, 2);
    if (time.indexOf('a.m.') != -1 && hours == 12) {
        time = time.replace('12', '00');
    }
    if (time.indexOf('p.m.') != -1 && hours < 12) {
        time = time.replace(hours, parseInt(hours) + 12);
    }
    return time.replace(/(a.m.|p.m.)/, '');
}

function reMe() {
    var headers = { 'X-Token': Cookie.LeerCookie("token") || '', 'X-Value': Cookie.LeerCookie("xvalue") || '' };
    jQuery.ajax({
        url: window.config.Statics.APILoginUrl + "/Usuario/Me",
        type: 'post',
        dataType: "json",
        headers: headers,
        async: true,
        success: function success(res, status, xhr) {
            if (res.code == "0000") {
                var usuario = JSON.parse(res.response);
                Cookie.SetupCookies(usuario.Usuario);
            }
            if (res.code != "0000") {
                Logout.Logout();
            }
        },
        error: function error(e) {
            console.log("error: " + e.toString());
        }
    });
}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var html = '<div class="spinner">\n        <div class="bounce1"></div>\n        <div class="bounce2"></div>\n        <div class="bounce3"></div>\n    </div>';

var box = document.createElement('div');
box.className = 'spinner-box';
box.innerHTML = html;

var show = exports.show = function show() {
    return document.body.appendChild(box);
};
var hide = exports.hide = function hide() {
    return box.remove();
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.functions = undefined;
exports.buscador = buscador;

__webpack_require__(18);

var _bucket = __webpack_require__(2);

var BucketTools = _interopRequireWildcard(_bucket);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function buscador() {
    $('button[data-id="btnBuscador"]').on('click', function () {
        window.location.href = window.config.Statics.BuscadorUrl + $('input[data-id="buscador"]').val();
    });
    $('input[data-id="buscador"]').on('keypress', function (e) {
        if (e.keyCode == 13) {
            $('button[data-id="btnBuscador"]').click();
        }
    });
}

var functions = exports.functions = function functions() {

    var $window = $(window);
    modal();
    encuesta();
    //colorMobile();
    headerFijo();
    arriba();
    //animated(); //TODO: Revisar el comportamiento de los efectos de transicion. No estan funcionando en el proyecto con WebPack
    menu();
    menuBusqueda();
    modalOut();
    fotoXL();
    audioPlayer();
    //slider(); //TODO: esto solo se usa para HTMLs de integracion
    headerFijoHome();
    comentarioScroll();
    videoFixed();

    function encuesta() {
        var opcion = $('#item-nota #nota #cuerpo .encuesta button');
        var encuesta = $('#item-nota #nota #cuerpo .encuesta');

        opcion.click(function () {

            if (encuesta.hasClass('resultados')) {} else {
                $(this).addClass('elegido');
                encuesta.addClass('resultados');

                opcion.each(function () {
                    var opcionAfter = $(this).find('span');
                    var porcentaje = opcionAfter.html();
                    opcionAfter.css('width', porcentaje);
                });
            }
        });
    }

    function headerFijo() {
        if ($(window).width() > 767) {
            if ($('h1.titulo') && $('h1.titulo').length > 0) {
                var titulo = $('h1.titulo')[0].textContent;
                document.querySelector('.titulo-fijo').innerHTML = titulo;
            }
        } else {
            if (document.querySelector('.titulo-fijo')) {
                document.querySelector('.titulo-fijo').innerHTML = '';
            }
        }

        $(window).scroll(function () {
            if (checkVisible($('.titulo'))) {
                $("header").removeClass("headerFijo");
            } else {
                $("header").addClass("headerFijo");
            }
        });

        function checkVisible(elm, evalparam) {
            var evalparam = evalparam || "visible";
            var vpH = $(window).height(),
                // Viewport Height
            st = $(window).scrollTop(),
                // Scroll Top
            y = $(elm).offset().top,
                elementHeight = $(elm).height();

            if (evalparam === "visible") return y < vpH + st && y > st - elementHeight;
            if (evalparam === "above") return y < vpH + st;
        }
    }

    function headerFijoHome() {
        // Oculta header cuando el usuario scrollea hacia abajo y lo muestra cuando scrollea hacia arriba
        var didScroll = void 0;
        var lastScrollTop = 0;
        var delta = 5;
        var navbarHeight = $('header').outerHeight();

        $(window).scroll(function (event) {
            didScroll = true;
        });

        setInterval(function () {
            if (didScroll) {
                hasScrolled();
                didScroll = false;
            }
        }, 250);

        function hasScrolled() {
            var st = $(window).scrollTop();

            // Make sure they scroll more than delta
            if (Math.abs(lastScrollTop - st) <= delta) return;

            // If they scrolled down and are past the navbar, add class .nav-up.
            // This is necessary so you never see what is "behind" the navbar.
            if (st > lastScrollTop && st > navbarHeight) {
                // Scroll Down
                $('header').removeClass('nav-down').addClass('nav-up');
            } else {
                // Scroll Up
                if (st + $(window).height() < $(document).height()) {
                    $('header').removeClass('nav-up').addClass('nav-down');
                }
            }

            if ($(window).width() < 1024 && $("#item-nota").length) {
                var cuerpo = $('#nota').offset().top + 70;
                if (st > lastScrollTop || $(window).scrollTop() < cuerpo) {
                    $('.scroll-links').slideUp(200);
                } else {
                    // Scroll Up
                    if (st + $(window).height() < $(document).height()) {
                        $('.scroll-links').slideDown(200);
                    }
                }
            }
            if (st > 180) {

                if ($('header').hasClass('nav-down')) {
                    $('.banner-mobile.sticky2, .banner.sticky2').removeClass('up');
                } else {
                    $('.banner-mobile.sticky2, .banner.sticky2').addClass('up');
                }
            }

            lastScrollTop = st;
        }

        /*$(".scroll-links a").on('click', function(event) {
            if (this.hash !== "") {
                event.preventDefault();
                let hash = this.hash;
                $('html, body').animate({
                    scrollTop: $(hash).offset().top
                }, 800, function() {
                    window.location.hash = hash;
                });
            }
        });*/
    }

    function arriba() {
        $(".volver").click(function (event) {
            event.preventDefault();
            $("html, body").animate({ scrollTop: 0 }, 600);
            return false;
        });
    };

    function comentarioScroll() {
        if ($("#livefyre").length > 0) {
            $('[data-id="comentarios"]').click(function (event) {
                event.preventDefault();
                $("html, body").animate({ scrollTop: $("#livefyre").offset().top }, 600);
                return false;
            });
        }
    }

    function modal() {
        var modal = $('#modalImagen');
        var ampliar = $('.galeria img, figure img');
        var cerrar = $('#cuerpo .icon-cerrar');

        //Abre Modal
        ampliar.click(function () {
            var sliderContainer = $('body').find('#sliderContainer');

            if ($(this).parent().parent().parent().is('#sliderContainer')) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = sliderContainer.find('ul li img')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var img = _step.value;

                        img.src = BucketTools.changeSizeWithFullPath(img.src, 'h1080');
                        $('#sliderContainer').find('ul').addClass('elementoModal');
                        $('#slider').addClass('top');
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                ;
            } else {
                $(this).parent().find("img").attr("src", BucketTools.changeSizeWithFullPath($(this).parent().find("img").attr("src"), 'h1080'));
                $(this).parent().addClass('elementoModal');
            }

            if ($("body").hasClass('modal-on')) {} else {
                modal.fadeIn();
                $('body').addClass('modal-on');
                setTimeout(function () {
                    var elem = document.body; // Make the body go full screen.
                    requestFullScreen(elem);
                }, 0);

                $('.modal-on figcaption').fadeOut(0);
                $('.modal-on .elementoModal + figcaption, .modal-on .elementoModal > figcaption').fadeIn(0);
            }
        });

        cerrar.click(function () {
            if ($("body").hasClass('modal-on')) {
                exitFullScreen(elem);
                setTimeout(function () {
                    modal.fadeOut();
                    $('body').removeClass('modal-on');
                    $('body').find('.elementoModal').removeClass('elementoModal');
                    $('#slider').removeClass('top');
                }, 0);
                var elem = document.body; // Make the body go full screen.

                $('.modal-on figcaption').fadeIn(0);
            } else {}
        });
    }

    // Fullscreen on
    function requestFullScreen(element) {
        // Supports most browsers and their versions.
        var requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen;

        if (requestMethod) {
            // Native full screen.
            requestMethod.call(element);
        } else if (typeof window.ActiveXObject !== "undefined") {
            // Older IE.
            var wscript = new ActiveXObject("WScript.Shell");
            if (wscript !== null) {
                wscript.SendKeys("{F11}");
            }
        }
    }

    // Fullscreen off
    function exitFullScreen(element) {
        if (document.exitFullscreen) {
            document.exitFullscreen();
            setTimeout(function () {
                modal.fadeOut();
                $('body').removeClass('modal-on');
                $('body').find('.elementoModal').removeClass('elementoModal');
                $('#slider').removeClass('top');
            }, 300);
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        }
    }

    function modalOut() {

        var modal = $('#modalImagen');

        $(document).keyup(function (e) {
            if (e.which == 27) setTimeout(function () {
                modal.fadeOut();
                $('body').removeClass('modal-on');
                $('body').find('.elementoModal').removeClass('elementoModal');
                $('#slider').removeClass('top');
            }, 300);
        });

        //Mousewheel abajo
        $(window).on('mousewheel', function (turn, delta) {

            if ($("figure").hasClass('elementoModal')) {
                if (delta == 1) ;else setTimeout(function () {
                    modal.fadeOut();
                    $('body').removeClass('modal-on');
                    $('body').find('.elementoModal').removeClass('elementoModal');
                    $('#slider').removeClass('top');
                }, 300);

                var elem = document.body; // Make the body go full screen.
                exitFullScreen(elem);

                return true;
            } else {}
        });
    }

    /* Revisar */
    function animated() {
        /* Elemento ATL, anima */
        $(".sugeridas .nota").each(function (i, el) {
            var el = $(el);
            (function (that, i) {
                var t = setTimeout(function () {
                    if (el.visible(true)) {
                        el.addClass("fadeInRight");
                    }
                }, 500 * i);
            })(this, i);
        });

        /* Elemento ATL, anima */

        /* Elemento BTL, espera */
        (function ($) {
            $.fn.visible = function (partial) {
                var $t = $(this);
                var $w = $(window);
                var viewTop = $w.scrollTop();
                var viewBottom = viewTop + $w.height();
                var _top = $t.offset().top;
                var _bottom = _top + $t.height();
                var compareTop = partial === true ? _bottom : _top;
                var compareBottom = partial === true ? _top : _bottom;
                return compareBottom <= viewBottom && compareTop >= viewTop;
            };
        })($);

        $(window).scroll(function (event) {
            $(".ademas.listado").each(function (i, el) {
                var el = $(el);
                if (el.visible(true)) {
                    el.addClass("animated");
                }
            });
        });

        var win = $(window);
        var allMods = $(".ademas.listado");
        // Already visible animateds
        allMods.each(function (i, el) {
            var el = $(el);
            if (el.visible(true)) {
                el.addClass("elementoVisible");
            }
        });
        win.scroll(function (event) {
            allMods.each(function (i, el) {
                var el = $(el);
                if (el.visible(true)) {
                    el.addClass("fadeInUp");
                }
            });
        });

        /* Elemento BTL, espera */
    }

    function menu() {
        $(".icon-menu-desktop").unbind().click(function (event) {
            if ($('header').hasClass('desplegado')) {
                $('.icon-menu-desktop').html('MENÚ');
                $('header').removeClass('desplegado-busqueda');
                $('header').removeClass('desplegado');
            } else {
                $('header').addClass('desplegado');
                $('.icon-menu-desktop').html('CERRAR');
            }
            if ($('header').hasClass('desplegado-busqueda') && $('.icon-menu-desktop').html('CERRAR')) {
                $('.icon-menu-desktop').html('MENÚ');
                $('header').removeClass('desplegado-busqueda');
                $('header').removeClass('desplegado');
            }

            if ($(window).width() < 1024) {
                if ($('body').hasClass('sinScroll')) {
                    $('body').removeClass('sinScroll');
                } else {
                    $('body').addClass('sinScroll');
                }
            }
        });

        //Cierre del menú

        $('html').click(function (e) {
            if (e.target.id != 'header' && $(e.target).parents('header').length == 0) {
                $('.icon-menu-desktop').html('MENÚ');
                $('header').removeClass('desplegado-busqueda');
                $('header').removeClass('desplegado');
            }
        });
    }

    function menuBusqueda() {
        $('.busqueda input').focus(function () {
            /*$('header').addClass('desplegado-busqueda');
            $('header').removeClass('desplegado');
            $('.icon-menu-desktop').html('CERRAR');*/
        });
    }

    function fotoXL() {
        if ($(window).width() < 768) {
            $(".scroll").each(function () {
                var contenedor = $(this).children("img").width();
                var scroll = $(this).width();
                var diferencia = (contenedor - scroll) / 2;
                if ($(this).hasClass("centrado")) {
                    $(this).scrollLeft(diferencia);
                }
                /*if ($(this).hasClass("derecha")) {
                    $(this).scrollLeft(0);
                }
                if ($(this).hasClass("izquierda")) {
                    $(this).scrollLeft(scroll);
                }*/
            });
        }
    }

    function audioPlayer() {
        $('.audio-player').mediaPlayer();
    }

    function colorNotaMobile(hex) {
        //Paso de HEX a RGB
        var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function (m, r, g, b) {
            return r + r + g + g + b + b;
        });

        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        var r = parseInt(result[1], 16);
        var g = parseInt(result[2], 16);
        var b = parseInt(result[3], 16);

        //Convierto de RGB a YIQ 
        var yiq = (r * 299 + g * 587 + b * 114) / 1000;
        var colorRGB = "rgb(" + r + "," + g + "," + b + ")";
        var foto = $("#cuerpo figure.XL img");
        var extra = 200;

        var alto = foto.offset().top + foto.height() + extra; //hardcode: por el banner sticky

        //Si el color es muy claro lo dejo blanco
        if (yiq < 190) {
            $("body").addClass("predomina-oscuro");
            if (!$(".background").length) {
                $("body").prepend("<div class='background'></div>");
            }
            $(".background").css({ "height": alto });
            $(".background").css({ "margin-top": "-" + extra + "px" });
            $(".background").css({ backgroundColor: colorRGB });
            $(".predomina-oscuro #cabezal").css({ backgroundColor: colorRGB });
        };
    }

    function borrarColorNotaMobile() {
        $("body").removeClass("predomina-oscuro");
        $(".background").remove();
    }

    //ESTO SOLO VA EN NOTA
    //COLORES EJEMPLOS oscuro 878E9A y claro D9D1CE:
    var colorPredominante = document.querySelector("div[data-colorPredominante]");
    colorPredominante = colorPredominante != null ? colorPredominante.getAttribute("data-colorPredominante") : null;

    $(document).ready(function () {
        if (!$('.storytelling').length && colorPredominante != null && colorPredominante != "") {
            if (window.innerWidth < 640) {
                colorNotaMobile(colorPredominante);
            }
        }
    });

    $(window).resize(function () {
        if (!$('.storytelling').length && colorPredominante != null && colorPredominante != "") {
            if (window.innerWidth < 640) {
                colorNotaMobile(colorPredominante);
            } else {
                borrarColorNotaMobile();
            }
        }
    });

    //Start - INHABILITA :HOVER en MOBILE
    function hasTouch() {
        return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }

    if (hasTouch()) {
        // remove all :hover stylesheets
        try {
            // prevent exception on browsers not supporting DOM styleSheets properly
            for (var si in document.styleSheets) {
                var styleSheet = document.styleSheets[si];
                if (!styleSheet.rules) continue;

                for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
                    if (!styleSheet.rules[ri].selectorText) continue;

                    if (styleSheet.rules[ri].selectorText.match(':hover')) {
                        styleSheet.deleteRule(ri);
                    }
                }
            }
        } catch (ex) {}
    }
    //End - INHABILITA :HOVER en MOBILE
};

function videoFixed() {

    if ($(window).width() >= 1024) {
        var videoid = 0;
        //toma el evento click y graba el id cuando es clickeado en la lista de videos (<a>)
        $(document).on('click', '.playlist-generico a', function (e) {
            e.preventDefault();
            if ($(".jwplayer.jw-flag-ads.jw-state-playing").length > 0) {
                jwplayer(videoid).pause();
            } else {
                jwplayer(videoid).stop();
            }
            $("#" + videoid).removeClass("fixedVideo");
            $(".contenedor-video-fixed").css("display", "none");
            $("#" + videoid).addClass("defaultVideo");

            $("#" + videoid + " .jw-skip").removeClass("omitirShow");
            $("#" + videoid + " .jw-skip").addClass("omitirHide");

            videoid = $(this).parent().prev().attr('id');

            $("#" + videoid + " .jw-skip").removeClass("omitirHide");
            $("#" + videoid + " .jw-skip").addClass("omitirShow");
        });

        //Prevalece el efecto fixed cuando se clickea en los controladores (play)
        $(document).on('click', '.jw-flag-ads.fixedVideo.jw-state-playing', function () {
            videoid = $(this).attr('id');
            jwplayer(videoid).pause();
        });

        //Prevalece el efecto fixed cuando se clickea en los controladores (pause)
        $(document).on('click', '.jw-flag-ads.fixedVideo.jw-state-paused', function () {
            videoid = $(this).attr('id');
            jwplayer(videoid).stop();
        });

        //toma el evento click y graba el id cuando el video esta en ads, con todas sus variables probables
        $(document).on('click', '.jw-flag-ads.defaultVideo', function () {

            if ($("#" + videoid + ".jw-flag-ads").length > 0) {

                $("#" + videoid + " .jw-skip").removeClass("omitirShow");
                $("#" + videoid + " .jw-skip").addClass("omitirHide");

                if ($("#" + videoid + ".fixedVideo.jwplayer.jw-state-paused").length > 0) {
                    jwplayer(videoid).stop();
                    $("#" + videoid).removeClass("fixedVideo");
                    $(".contenedor-video-fixed").css("display", "none");
                    $("#" + videoid).addClass("defaultVideo");
                } else if ($("#" + videoid + ".fixedVideo.jwplayer.jw-state-playing").length > 0) {
                    jwplayer(videoid).pause();
                    $("#" + videoid).removeClass("fixedVideo");
                    $(".contenedor-video-fixed").css("display", "none");
                    $("#" + videoid).addClass("defaultVideo");
                } else if ($("#" + videoid + ".jwplayer.jw-state-playing").length > 0) {
                    jwplayer(videoid).pause();
                } else if ($("#" + videoid + ".jwplayer.jw-state-paused").length > 0) {
                    jwplayer(videoid).stop();
                }
            } else if ($("#" + videoid + ".jw-state-playing").length > 0 || $(".jwplayer.jw-state-paused").length > 0) {
                jwplayer(videoid).stop();
                $("#" + videoid).removeClass("fixedVideo");
                $(".contenedor-video-fixed").css("display", "none");
                $("#" + videoid).addClass("defaultVideo");
            }
            $("#" + videoid + " .jw-skip").removeClass("omitirShow");
            $("#" + videoid + " .jw-skip").addClass("omitirHide");

            videoid = $(this).attr('id');

            $("#" + videoid + " .jw-skip").removeClass("omitirHide");
            $("#" + videoid + " .jw-skip").addClass("omitirShow");
        });

        //toma el evento click y graba el id del video (sin ads)
        $(document).on('click', '.jw-state-buffering', '.jw-state-playing', function () {

            $("#" + videoid + " .jw-skip").removeClass("omitirShow");
            $("#" + videoid + " .jw-skip").addClass("omitirHide");

            if ($("#" + videoid + ".jw-flag-ads.jw-state-playing").length > 0) {
                jwplayer(videoid).pause();
                $("#" + videoid).removeClass("fixedVideo");
                $(".contenedor-video-fixed").css("display", "none");
                $("#" + videoid).addClass("defaultVideo");
                videoid = $(this).attr('id');
            } else if ($("#" + videoid + ".jwplayer.jw-state-playing").length > 0 || $(".jwplayer.jw-state-paused").length > 0 || $(".jwplayer.jw-state-complete").length > 0 || $(".jwplayer.jw-flag-ads.jw-state-paused").length > 0 || $(".jwplayer.jw-state-buffering").length > 1) {
                jwplayer(videoid).stop();
                $("#" + videoid).removeClass("fixedVideo");
                $(".contenedor-video-fixed").css("display", "none");
                $("#" + videoid).addClass("defaultVideo");
                videoid = $(this).attr('id');
            } else if ($(".jwplayer.jw-flag-ads.jw-state-buffering").length > 1) {
                jwplayer(videoid).pause();
                $("#" + videoid).removeClass("fixedVideo");
                $(".contenedor-video-fixed").css("display", "none");
                $("#" + videoid).addClass("defaultVideo");
                videoid = $(this).attr('id');
            } else {
                videoid = $(this).attr('id');
            }
        });

        //animacion con el scroll ya tomado el id
        $(window).scroll(function () {
            function VideoDefault() {
                $("#" + videoid).removeClass("fixedVideo");
                $(".contenedor-video-fixed").css("display", "none");
                $("#" + videoid).addClass("defaultVideo");
            };

            function VideoFixed() {
                $("#" + videoid).addClass("fixedVideo");
                $(".contenedor-video-fixed").css("display", "block");
                $("#" + videoid).removeClass("defaultVideo");
            };

            //segun estado del video
            if ($("#" + videoid + ".jwplayer.jw-state-playing").length > 0 || $("#" + videoid + ".jwplayer.jw-state-paused").length > 0 || $("#" + videoid + ".jwplayer.jw-flag-ads.jw-state-playing").length > 0 || $(".jwplayer.jw-state-buffering").length > 0) {

                var limiteTop = $("#" + videoid).parent().offset().top;
                var limiteBottom = limiteTop + $("#" + videoid).height();
                var documento = $(document).scrollTop();
                var pantalla = $(window).height();
                var altoAside = $("#" + videoid).parent().height();
                $("#" + videoid).parent().css({ "min-height": altoAside, "background-color": "#ddd" });

                //Si se visualiza o no en el WindowsScreen
                if (documento + pantalla < limiteTop || documento > limiteBottom) {
                    VideoFixed();
                } else {
                    VideoDefault();
                }

                //Termina el video y finaliza la funcion Fixed
                jwplayer(videoid).on('complete', function () {
                    VideoDefault();
                    videoid = 0;
                });
            }
        });
        //Boton cerrar FixedVideo
        $(".contenedor-video-fixed span:last-child").on("click", function () {
            var cerrarVideo = $(".jwplayer.fixedVideo").attr("id");
            if ($(".jwplayer.jw-flag-ads.jw-state-playing").length > 0) {
                jwplayer(cerrarVideo).pause();
            } else {
                jwplayer(cerrarVideo).stop();
            }
            $("#" + cerrarVideo + " .jw-skip").removeClass("omitirShow");
            $("#" + cerrarVideo + " .jw-skip").addClass("omitirHide");
            $("#" + cerrarVideo).addClass("animated slideOutDown");
            $(".contenedor-video-fixed").addClass("animated slideOutDown");

            function slideCerrar() {
                $("#" + cerrarVideo).removeClass("fixedVideo");
                $("#" + cerrarVideo).removeClass("animated slideOutDown");
                $(".contenedor-video-fixed").removeClass("animated slideOutDown");
                $(".contenedor-video-fixed").css("display", "none");
                $("#" + cerrarVideo).addClass("defaultVideo");
                cerrarVideo = 0;
            }
            setTimeout(slideCerrar, 500);
            videoid = 0;
        });
    }
}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (root, factory) {

    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
        module.exports = factory;
    } else {
        root.lunar = factory();
    }
})(undefined, function () {

    var lunar = {};

    lunar.hasClass = function (elem, name) {
        return new RegExp('(\\s|^)' + name + '(\\s|$)').test(elem.attr('class'));
    };

    lunar.addClass = function (elem, name) {
        !lunar.hasClass(elem, name) && elem.attr('class', (!!elem.getAttribute('class') ? elem.getAttribute('class') + ' ' : '') + name);
    };

    lunar.removeClass = function (elem, name) {
        var remove = elem.attr('class').replace(new RegExp('(\\s|^)' + name + '(\\s|$)', 'g'), '$2');
        lunar.hasClass(elem, name) && elem.attr('class', remove);
    };

    lunar.toggleClass = function (elem, name) {
        lunar[lunar.hasClass(elem, name) ? 'removeClass' : 'addClass'](elem, name);
    };

    lunar.className = function (elem, name) {
        elem.attr('class', name);
        console.log('className', elem);
    };

    return lunar;
});

(function ($) {

    var _ = {

        cursorPoint: function cursorPoint(evt, el) {
            _.settings.pt.x = evt.clientX;
            _.settings.pt.y = evt.clientY;
            var playObject = el.find('svg').attr('id');
            playObject = document.getElementById(playObject);
            return _.settings.pt.matrixTransform(playObject.getScreenCTM().inverse());
        },

        angle: function angle(ex, ey) {
            var dy = ey - 50; // 100;
            var dx = ex - 50; // 100;
            var theta = Math.atan2(dy, dx); // range (-PI, PI]
            theta *= 180 / Math.PI; // rads to degs, range (-180, 180]
            theta = theta + 90; // in our case we are animating from the top, so we offset by the rotation value;
            if (theta < 0) theta = 360 + theta; // range [0, 360)
            return theta;
        },

        setGraphValue: function setGraphValue(obj, val, el) {

            var audioObj = el.find(_.settings.audioObj),
                pc = _.settings.pc,
                dash = pc - parseFloat(val / audioObj[0].duration * pc, 10);

            $(obj).css('strokeDashoffset', dash);

            if (val === 0) {
                $(obj).addClass(obj, 'done');
                //if (obj === $(_.settings.progress)) {
                //$(obj).closest("svg").attr('class', 'ended');
                $(obj).closest("svg").attr('class', 'not-started playable');
                //}
            }
        },

        reportPosition: function reportPosition(el, audioId) {
            var progress = el.find(_.settings.progress),
                audio = el.find(_.settings.audioObj);
            if (audioId.currentTime == audio[0].duration) {
                audioId.currentTime = 0;
            }
            _.setGraphValue(progress, audioId.currentTime, el);
        },

        stopAllSounds: function stopAllSounds() {

            document.addEventListener('play', function (e) {
                var audios = document.getElementsByTagName('audio');
                for (var i = 0, len = audios.length; i < len; i++) {
                    if (audios[i] != e.target) {
                        audios[i].pause();
                    }
                    if (audios[i] != e.target) $(audios[i]).parent('div').find('.playing').attr('class', 'paused');
                }
            }, true);
        },

        settings: {},

        /**
         * Main Function for plugin
         * @param options
         */
        init: function init(options) {

            var template = ['<svg viewBox="0 0 100 100" id="playable" version="1.1" xmlns="http://www.w3.org/2000/svg" width="34" height="34" data-play="playable" class="not-started playable">', '<g class="shape">', '<circle class="progress-track" cx="50" cy="50" r="47.45" stroke="#ffffff" stroke-opacity="0.25" stroke-linecap="square" fill="none" stroke-width="4"/>', '<circle class="precache-bar" cx="50" cy="50" r="47.45" stroke="#cccccc" stroke-opacity="0.25" stroke-linecap="square" fill="none" stroke-width="4" transform="rotate(-90 50 50)"/>', '<circle class="progress-bar" cx="50" cy="50" r="47.45" stroke="#009EF8" stroke-opacity="1" stroke-linecap="square" fill="none" stroke-width="5" transform="rotate(-90 50 50)"/>', '</g>', '<circle class="controls" cx="50" cy="50" r="36" stroke="none" stroke-width="2" fill="#ffffff" opacity="0.0" pointer-events="all"/>', '<g class="control pause">', '<line x1="40" y1="35" x2="40" y2="65" stroke="#ffffff" fill="none" stroke-width="8" stroke-linecap="butt"/>', '<line x1="60" y1="35" x2="60" y2="65" stroke="#ffffff" fill="none" stroke-width="8" stroke-linecap="butt"/>', '</g>', '<g class="control play">', '<polygon points="45,35 65,50 45,65" fill="#000000" stroke-width="0"></polygon>', '</g>', '<g class="control stop">', '<rect x="35" y="35" width="30" height="30" stroke="#000000" fill="none" stroke-width="1"/>', '</g>', '</svg>'];

            template = template.join(' ');

            $.each(this, function (a, b) {

                var audio = $(this).find('audio');
                audio.attr('id', 'audio' + a);
                template = template.replace('width="34"', 'width="' + audio.data('size') + '"');
                template = template.replace('height="34"', 'height="' + audio.data('size') + '"');
                template = template.replace('id="playable"', 'id="playable' + a + '"');
                $(this).append(template);
            });

            var svgId = $(this).find('svg').attr('id');
            if (svgId == null) {
                return false;
            }
            svgId = document.getElementById(svgId);

            _.defaults = {
                this: this,
                thisSelector: $(this).parent(),
                playObj: 'playable',
                progress: '.progress-bar',
                precache: '.precache-bar',
                audioObj: 'audio',
                controlsObj: '.controls',
                pt: svgId.createSVGPoint(),
                pc: 298.1371428256714 // 2 pi r                                
            };

            var lunar = {};

            _.settings = $.extend({}, _.defaults, options);

            $(_.settings.controlsObj).on('click', function (e) {

                var el = $(e.currentTarget).closest($(_.settings.thisSelector));

                var obj = {
                    el: el,
                    activeAudio: el.find(_.settings.audioObj),
                    playObj: el.find('[data-play]'),
                    precache: el.find(_.settings.precache)
                };

                obj.class = obj.playObj.attr('class');
                switch (obj.class.replace('playable', '').trim()) {

                    case 'not-started':
                        _.stopAllSounds();
                        obj.activeAudio[0].play();
                        var audioId = document.getElementById(obj.activeAudio.attr('id'));
                        audioId.addEventListener('timeupdate', function (e) {
                            _.reportPosition(el, audioId);
                        });
                        obj.playObj.attr('class', 'playing');
                        break;
                    case 'playing':
                        obj.playObj.attr('class', 'playable paused');
                        obj.activeAudio[0].pause();
                        $(audioId).off('timeupdate');
                        break;
                    case 'paused':
                        obj.playObj.attr('class', 'playable playing');
                        obj.activeAudio[0].play();
                        break;
                    case 'ended':
                        obj.playObj.attr('class', 'not-started playable');
                        obj.activeAudio.off('timeupdate', _.reportPosition);
                        break;
                }
            });

            $(_.defaults.audioObj).on('progress', function (e) {
                if (this.buffered.length > 0) {
                    var end = this.buffered.end(this.buffered.length - 1);
                    var cache = $(e.currentTarget).parent().find(_.settings.precache),
                        el = $(this).closest($(_.settings.thisSelector));
                    _.setGraphValue(cache, end, el);
                }
            });
        }

    };

    // Add Plugin to Jquery
    $.fn.mediaPlayer = function (methodOrOptions) {
        if (_[methodOrOptions]) {
            return _[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if ((typeof methodOrOptions === 'undefined' ? 'undefined' : _typeof(methodOrOptions)) === 'object' || !methodOrOptions) {
            // Default to "init"
            return _.init.apply(this, arguments);
        } else {
            $.error('Method ' + methodOrOptions + ' does not exist on jQuery.mediaPlayer');
        }
    };
})(jQuery);

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadBanners = exports.hideBannersDesktopMobile = exports.loadScriptBanners = undefined;

var _global = __webpack_require__(11);

var _cookie = __webpack_require__(0);

var Cookie = _interopRequireWildcard(_cookie);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var loadScriptBanners = exports.loadScriptBanners = function loadScriptBanners() {
    var script = document.createElement("script");
    script.async = true;
    script.src = "//static.glanacion.com/v2/dfp/dfp_v3.js"; //PROD
    //script.src = "/statics/scripts/common/banner/dfp.js";       //DEV
    //script.src = window.config.Statics.BasePath + "/js/dfp.js";
    document.head.appendChild(script);
};

var hideBannersDesktopMobile = exports.hideBannersDesktopMobile = function hideBannersDesktopMobile(section) {
    var check = false;
    (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)) || /Tablet|iPad/i.test(a)) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    var tablet = false;
    if (screen.width >= 768) {
        tablet = true;
    }
    if (screen.height >= 768) {
        tablet = true;
    }
    if (check) {
        if (tablet) {
            hideDivs(document.querySelectorAll('div[data-dispositivo="mobile"]'));
            hideDivs(document.querySelectorAll('div[data-dispositivo="desktop"]'));
            getBannersConfig("tablet", section);
        } else {
            hideDivs(document.querySelectorAll('div[data-dispositivo="tablet"]'));
            hideDivs(document.querySelectorAll('div[data-dispositivo="desktop"]'));
            getBannersConfig("mobile", section);
        }
    } else {
        hideDivs(document.querySelectorAll('div[data-dispositivo="mobile"]'));
        hideDivs(document.querySelectorAll('div[data-dispositivo="tablet"]'));
        getBannersConfig("desktop", section);
    }
};

var getBannersConfig = function getBannersConfig(dispositivo, section) {
    var userSuscriptorType = Cookie.LeerCookie("ProductoPremiumId").split(",");
    if (section == undefined) return;
    userSuscriptorType.forEach(function (element, index) {
        if (element == "") userSuscriptorType.splice(index, 1);
    });

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = userSuscriptorType[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var suscriptorId = _step.value;

            switch (dispositivo) {
                case "desktop":
                    hideBannerByUserAndSection(suscriptorId.trim(), section, dispositivo);
                    break;
                case "tablet":
                    hideBannerByUserAndSection(suscriptorId.trim(), section, dispositivo);
                    break;
                case "mobile":
                    hideBannerByUserAndSection(suscriptorId.trim(), section, dispositivo);
                    break;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};

var hideBannerByUserAndSection = function hideBannerByUserAndSection(userId, section, dispositivo) {
    var configBanner = _global.ocultarBanners[dispositivo][section];
    var banners = void 0;
    configBanner.forEach(function (data) {
        if (data.userType == userId) {
            banners = data.banners;
        }
    });
    //Si no hay configuracion para el userId especificado
    if (banners == undefined || banners == null) return;

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = banners[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var typeBanner = _step2.value;

            var banner = document.querySelector('#' + typeBanner + '[data-dispositivo="' + dispositivo + '"]');
            if (banner != null) {
                banner.classList.remove('ad-slot');
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
};

var hideDivs = function hideDivs(elements) {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = Array.from(elements)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var div = _step3.value;

            div.classList.remove("ad-slot");
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }
};

var loadBanners = exports.loadBanners = function loadBanners(section) {
    hideBannersDesktopMobile(section);
    loadScriptBanners();
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sugerencias = exports.preferenciasCambioBotonSiguiendo = exports.initPreferencias = exports.dejarSeguirLoQueSigo = exports.preferenciasPendientes = exports.seguirDejarSeguir = undefined;

var _ajax = __webpack_require__(1);

var _cookie = __webpack_require__(0);

var Cookie = _interopRequireWildcard(_cookie);

var _bucket = __webpack_require__(2);

var BucketTools = _interopRequireWildcard(_bucket);

var _utilities = __webpack_require__(4);

var Utilities = _interopRequireWildcard(_utilities);

var _session = __webpack_require__(7);

var SessionLogin = _interopRequireWildcard(_session);

var _ClearLoQueSigo = __webpack_require__(9);

var ClearLoQueSigo = _interopRequireWildcard(_ClearLoQueSigo);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var urlBucket = window.config.Statics.BucketUrl;
var urlNavAnonimo = window.config.Statics.ApiNavAnonimaHome;
var urlNavAnonimoExt = window.config.Statics.ApiNavAnonimaExt;

var showErr = console.error.bind(console, "perso ");
var showLog = console.log.bind(console, "perso ");

//TODO: HACER REFACTOR DE ESTE JS, QUEDANDO EN EL MISMO TODO LO DE APIPERSO Y LO DE LOCALSTORAGE, SACAR LO DE PERSO DE LOS OTROS ARCHIVOS, LOQUESIGO, HOME, NOTA, ETC....
//TODO: PODEMOS HACER QUE DESDE SESSION.JS SE LLAME A PERSONALIZACION Y EN EL INICIO YA TENER TODO CARGADO

var seguirDejarSeguir = exports.seguirDejarSeguir = function seguirDejarSeguir(element) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {

        for (var _iterator = Array.from(element)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var btn = _step.value;

            btn.addEventListener('click', function (event) {

                if (!SessionLogin.init()) {
                    var dataPreferible = "{dataPreferibleId}|{dataPreferibleTipoId}".replace("{dataPreferibleId}", event.currentTarget.getAttribute('data-preferibleId')).replace("{dataPreferibleTipoId}", event.currentTarget.getAttribute('data-preferibleTipoId'));

                    localStorage.setItem("apiPerso.Pendientes.Preferencias", dataPreferible);

                    location.href = window.config.Statics.LoginUrl + window.btoa(location.href);
                    return;
                }

                var apiPerso = SessionLogin.initPerso();

                if (event.currentTarget.classList.contains("activo")) {
                    event.currentTarget.classList.remove("activo");
                    event.currentTarget.innerText = "SEGUIR";
                    apiPerso.preferencias.dejarDeSeguirPreferible(event.currentTarget.getAttribute('data-preferibleId'), event.currentTarget.getAttribute('data-preferibleTipoId'));
                    apiPerso.execute().then(function (resp) {
                        dejarSeguirOrSeguir();
                    }).catch(console.log.bind(console, 'error'));
                } else {
                    event.currentTarget.classList.add("activo");
                    event.currentTarget.innerText = "SIGUIENDO";
                    apiPerso.preferencias.seguirPreferible(event.currentTarget.getAttribute('data-preferibleId'), event.currentTarget.getAttribute('data-preferibleTipoId'));
                    apiPerso.execute().then(function (resp) {
                        dejarSeguirOrSeguir();
                    }).catch(console.log.bind(console, 'error'));
                }
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};

var dejarSeguirOrSeguir = function dejarSeguirOrSeguir() {

    var apiPerso = SessionLogin.initPerso();

    if (!SessionLogin.init()) {
        location.href = window.config.Statics.LoginUrl + window.btoa(location.href);
        return;
    }

    //apiPerso.preferencias.obtenerPreferibles()
    //            .then(resp => {
    //                localStorage.setItem("obtenerPreferibles", JSON.stringify(resp));
    //            })
    //            .catch(showErr.bind(console, "Obtener preferibles"));

    apiPerso.execute().then(function (resp) {
        ClearLoQueSigo.clearLS();
    }).catch(console.log.bind(console, 'error'));
};

var preferenciasPendientes = exports.preferenciasPendientes = function preferenciasPendientes() {

    var apiPerso = SessionLogin.initPerso();

    var preferenciasPendientes = localStorage.getItem("apiPerso.Pendientes.Preferencias");

    if (preferenciasPendientes != null) {
        var datosPreferencias = preferenciasPendientes.split("|");

        apiPerso.preferencias.seguirPreferible(parseInt(datosPreferencias[0]), parseInt(datosPreferencias[1]));

        apiPerso.execute().then(function (resp) {
            localStorage.removeItem("apiPerso.Pendientes.Preferencias");
        }).catch(showErr.bind(console, "execute"));
    }
};

var dejarSeguirLoQueSigo = exports.dejarSeguirLoQueSigo = function dejarSeguirLoQueSigo(element) {

    var apiPerso = SessionLogin.initPerso();

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = Array.from(element)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var btn = _step2.value;

            btn.addEventListener('click', function (event) {

                if (!SessionLogin.init()) {
                    location.href = window.config.Statics.LoginUrl + window.btoa(location.href);
                    return;
                }

                apiPerso.preferencias.dejarDeSeguirPreferible(event.currentTarget.getAttribute('data-preferibleId'), event.currentTarget.getAttribute('data-preferibleTipoId'));
                apiPerso.execute().then(function (resp) {
                    ClearLoQueSigo.clearLS();
                }).catch(console.log.bind(console, 'error'));

                event.currentTarget.parentNode.remove();
            });
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
};

//////////////////
//  LO QUE SIGO //
//////////////////
var initPreferencias = exports.initPreferencias = function initPreferencias() {
    var ctx = null;
    var obtenerNotaId = document.querySelector('div[data-notaId]').getAttribute("data-notaId");
    var obtenerTemas = document.querySelector('div[data-preferibles]').getAttribute('data-preferibles').split(',');

    var obtenerSugerencias = localStorage.getItem("obtenerSugerencias");
    var obtenerHashSuscripciones = localStorage.getItem("obtenerHashSuscripciones");
    var obtenerPreferibles = localStorage.getItem("obtenerPreferibles");

    if (SessionLogin.init()) {

        preferenciasPendientes();

        var apiPerso = SessionLogin.initPerso();

        apiPerso.sugerencias.lecturaNota(obtenerNotaId).then(showLog.bind(console, 'lecturaNota')).catch(showErr.bind(console, 'lecturaNota'));

        apiPerso.sugerencias.registrarTemas(obtenerTemas, ctx).then(showLog.bind(console, 'registrarTemas')).catch(showErr.bind(console, 'registrarTemas'));

        if (obtenerSugerencias === null) {
            apiPerso.sugerencias.obtener("", 25).then(function (resp) {
                localStorage.setItem("obtenerSugerencias", JSON.stringify(resp));
                obtenerSugerencias = localStorage.getItem("obtenerSugerencias");;
            }).catch(showErr.bind(console, 'obtener sugerencias'));
        }

        if (obtenerHashSuscripciones === null) {
            apiPerso.preferencias.obtenerHashSuscripciones().then(function (resp) {
                localStorage.setItem("obtenerHashSuscripciones", resp);
                obtenerHashSuscripciones = localStorage.getItem("obtenerHashSuscripciones");
            }).catch(showErr.bind(console, "Obtener hash suscripciones"));
        }

        if (obtenerPreferibles === null) {
            apiPerso.preferencias.obtenerPreferibles().then(function (resp) {
                localStorage.setItem("obtenerPreferibles", JSON.stringify(resp));
                obtenerPreferibles = localStorage.getItem("obtenerPreferibles");
            }).catch(showErr.bind(console, "Obtener preferibles"));
        }

        apiPerso.execute().then(function (resp) {
            preferencias(obtenerHashSuscripciones, apiPerso);
            ejecutarSugerenciasPreferencias(JSON.parse(obtenerSugerencias));
            preferenciasCambioBotonSiguiendo();
        }).catch(showErr.bind(console, "execute"));
    } else {
        //NO LOGUEADO 
        getDataNoLogueado();

        if (isSessionDateExpired()) {
            reLoadSugerenciasAnonimas();
        }
    }
};

var isSessionDateExpired = function isSessionDateExpired() {
    var createdDate = localStorage.getItem("sugerenciasNoLoginCreated");
    var cacheMiliseconds = 300000; ///TODO:pasar a configuracion
    var dif = 0;

    if (createdDate === null) {
        return true;
    } else {
        dif = Date.now() - createdDate;
        if (dif < cacheMiliseconds) {
            return false;
        } else {
            return true;
        }
    }
};

var reLoadSugerenciasAnonimas = function reLoadSugerenciasAnonimas() {

    localStorage.removeItem("sugerenciasNoLogin");
    getDataNoLogueado();
};

var preferenciasCambioBotonSiguiendo = exports.preferenciasCambioBotonSiguiendo = function preferenciasCambioBotonSiguiendo() {
    var LSPreferible = localStorage.getItem("obtenerPreferibles");
    if (LSPreferible == null) return;

    var dataPreferibles = JSON.parse(LSPreferible);
    var idsPreferibles = [];
    document.querySelectorAll('button.seguir').forEach(function (elem) {
        idsPreferibles.push(elem.getAttribute('data-preferibleid'));
    });

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = dataPreferibles[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var preferible = _step3.value;

            if (idsPreferibles.indexOf(preferible.id.toString()) != -1) {
                var nodo = document.querySelector('button.seguir[data-preferibleid="' + preferible.id + '"]');
                nodo.textContent = 'SIGUIENDO';
                nodo.classList.add('activo');
            }
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }
};

var preferencias = function preferencias(hash, apiPerso) {
    if (hash !== null) {
        //Obtener las Preferencias y competando con sugerencias llegado el caso.
        obtenerDatosPreferencias(true, renderPreferencias, apiPerso);
    } else {
        //SIN PREFERENCIAS
        //Obtener sugerencias pero NO completar con preferencias llegado el caso.
        obtenerDatosSugerencias(false, renderSugerenciasTemas, apiPerso);
    }
};

//Prefgerencias
var obtenerDatosPreferencias = function obtenerDatosPreferencias(rellenar, callback, apiPerso) {
    //Solo temas, NO notas
    var obtenerPorPrioridad = localStorage.getItem("obtenerPorPrioridad");
    var obtenerNovedades = localStorage.getItem("obtenerNovedades");
    var recomendarTemas = localStorage.getItem("recomendarTemas");

    if (obtenerPorPrioridad === null) {
        apiPerso.comunes.obtenerPorPrioridad(rellenar, 8, "Preferencia").then(function (resp) {
            localStorage.setItem("obtenerPorPrioridad", JSON.stringify(resp));
            obtenerPorPrioridad = localStorage.getItem("obtenerPorPrioridad");
        });
    }

    if (obtenerNovedades === null) {
        apiPerso.preferencias.obtenerNovedades().then(function (resp) {
            localStorage.setItem("obtenerNovedades", resp[0].cantidad);
            obtenerNovedades = localStorage.getItem("obtenerNovedades");
        });
    }

    if (recomendarTemas === null) {
        //Para temas y autores mas sugeridos
        apiPerso.sugerencias.recomendarTemas(5).then(function (resp) {
            localStorage.setItem("recomendarTemas", JSON.stringify(resp));
            recomendarTemas = localStorage.getItem("recomendarTemas");
        });
    }

    apiPerso.execute().then(function (resp) {
        callback(JSON.parse(obtenerPorPrioridad), obtenerNovedades, JSON.parse(recomendarTemas));
    }).catch(showErr.bind(console, "execute"));
};
//Sugerencias
var obtenerDatosSugerencias = function obtenerDatosSugerencias(rellenar, callback, apiPerso) {
    //Solo temas, NO notas
    var recomendarTemas = localStorage.getItem("recomendarTemas");

    if (recomendarTemas === null) {
        //Para temas y autores mas sugeridos
        apiPerso.sugerencias.recomendarTemas(5).then(function (resp) {
            localStorage.setItem("recomendarTemas", JSON.stringify(resp));
            recomendarTemas = localStorage.getItem("recomendarTemas");
        });
    }

    apiPerso.execute().then(function (resp) {
        callback(JSON.parse(recomendarTemas));
    }).catch(showErr.bind(console, "execute"));
};

var renderPreferencias = function renderPreferencias(preferencias, cantNotasNoLeidas, temasRecomendados) {
    var html = "";
    var css = void 0;

    //CON notas a leer. (si hay pocas, completa con Sugerencias)
    if (cantNotasNoLeidas > 0) {
        css = "nuevas";
        html = "<div class=\"techo floatFix\">\n                    <span class=\"subtitulo\">Tus temas y autores </span>\n                    <h4><span>" + cantNotasNoLeidas + "</span> nuevas notas </h4>\n                    <a href=\"/lo-que-sigo\"> Configurar </a>\n                </div>";
        //Articles
        html += loopArticles(preferencias, 8);
        //Botones
        html += "<div class=\"ver-mas\">\n                    <a href=\"/lo-que-sigo\">VER M\xC1S NOTAS</a>\n                 </div>";
    } else if (preferencias.length === 0) {
        //SIN Preferencias NI Sugerencias.
        css = "sin-seguir";
        html = "<div class=\"techo floatFix\">\n                    <h4>SEGU\xCD LOS TEMAS Y AUTORES QUE <b>M\xC1S TE INTERESAN</b></h4>\n                </div>\n                <p> Busc\xE1 el bot\xF3n: <span class=\"seguir\">SEGUIR</span> para guardarlos en tus favoritos y enterate, al instante, cada vez que haya nuevas notas.</p>\n                <section class=\"mas-seguidos\">\n                <h5> MIENTRAS PODES SEGUIR ESTOS TEMAS:</h5>";

        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
            for (var _iterator4 = temasRecomendados[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var tema = _step4.value;

                var id = tema[0],
                    idTipo = tema[3];

                html += "<div class=\"tema floatFix\"><p>" + tema[5] + "</p>\n                 <button class=\"seguir\" data-preferibleId=\"" + id + "\" data-preferibleTipoId=\"" + idTipo + "\">SEGUIR</button></div>";
            }
        } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                }
            } finally {
                if (_didIteratorError4) {
                    throw _iteratorError4;
                }
            }
        }

        html += "</section>";
    } else {
        //SIN nota a leer (Llenar con sugerencias)
        css = "recomendadas";
        html += "<div class=\"techo floatFix\">\n                    <span class=\"subtitulo\">Tus temas y autores </span>\n                    <h4>RECOMENDADOS</h4>\n                    <a href=\"/lo-que-sigo\"> Configurar </a>\n                </div>";
        //Articles
        html += loopArticles(preferencias, 8);
        //Botones
        html += "<div class=\"ver-mas\">\n                    <a href=\"/lo-que-sigo\">VER M\xC1S NOTAS</a>\n                </div>";
    }

    var asideBloque2 = document.querySelector("#bloque-2");
    asideBloque2.classList.add(css);
    asideBloque2.innerHTML = html;
    seguirDejarSeguir(document.querySelectorAll('button[class="seguir"]'));
};

var renderSugerenciasTemas = function renderSugerenciasTemas(temasRecomendados) {
    var css = "sin-seguir";
    var html = "<div class=\"techo floatFix\">\n                    <h4>SEGU\xCD LOS TEMAS Y AUTORES QUE <b>M\xC1S TE INTERESAN</b></h4>\n                </div>\n                <p> Busc\xE1 el bot\xF3n: <span class=\"seguir\">SEGUIR</span> para guardarlos en tus favoritos y enterate, al instante, cada vez que haya nuevas notas.</p>\n                <section class=\"mas-seguidos\">\n                <h5> MIENTRAS PODES SEGUIR ESTOS TEMAS:</h5>";

    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
        for (var _iterator5 = temasRecomendados[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var tema = _step5.value;

            var id = tema[0],
                idTipo = tema[3];

            html += "<p>" + tema[5] + "</p>\n                 <button class=\"seguir\" data-preferibleId=\"" + id + "\" data-preferibleTipoId=\"" + idTipo + "\">SEGUIR</button>";
        }
    } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
            }
        } finally {
            if (_didIteratorError5) {
                throw _iteratorError5;
            }
        }
    }

    html += "</section>";

    var asideBloque2 = document.querySelector("#bloque-2");
    asideBloque2.classList.add(css);
    asideBloque2.innerHTML = html;
    seguirDejarSeguir(document.querySelectorAll('button[class="seguir"]'));
};

var getDataNoLogueado = function getDataNoLogueado() {

    var resp = void 0;

    var sugerenciasNoLoginLS = localStorage.getItem("sugerenciasNoLogin");

    if (sugerenciasNoLoginLS != null) {
        renderNoLogueado(JSON.parse(sugerenciasNoLoginLS));
        sugerenciasNoLogin(JSON.parse(sugerenciasNoLoginLS));
    } else {
        if (randomFn() > 5) {
            (0, _ajax.get)(urlNavAnonimo).then(function (rs) {
                localStorage.setItem("sugerenciasNoLogin", rs);
                localStorage.setItem("sugerenciasNoLoginCreated", Date.now());
                resp = JSON.parse(rs);
                renderNoLogueado(resp);
                sugerenciasNoLogin(resp);
            });
        } else {
            (0, _ajax.get)(urlNavAnonimoExt).then(function (rs) {
                localStorage.setItem("sugerenciasNoLogin", rs);
                localStorage.setItem("sugerenciasNoLoginCreated", Date.now());
                resp = JSON.parse(rs);
                renderNoLogueado(resp);
                sugerenciasNoLogin(resp);
            });
        }
    }
};

var randomFn = function randomFn() {
    return Math.floor(Math.random() * 10 + 1);
};

var renderNoLogueado = function renderNoLogueado(notas) {
    if (document.querySelector("#bloque-2")) {
        var notasTemasRecomendados = notas.items.filter(function (nota) {
            return nota.tagDestacado;
        });
        var css = "sin-loguear";
        var html = "";

        if (notasTemasRecomendados !== null && notasTemasRecomendados !== undefined && notasTemasRecomendados.length > 0) {
            var valueToSlice = notasTemasRecomendados.length < 3 ? notasTemasRecomendados.length : 3;

            html += "<div class=\"techo floatFix\">\n                    <h4>REGISTRATE EN LA NACION Y </h4>\n                    <h4><b>MEJOR\xC1 TU EXPERIENCIA</b></h4>\n                    <button class=\"ingresar\"> INGRES\xC1 </button>\n                </div>\n                <p>Segu\xED los temas y autores que m\xE1s te interesan y enterate, al instante, cada vez que haya nuevas notas</p>\n                <section class=\"mas-seguidos\">";

            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
                for (var _iterator6 = notasTemasRecomendados.slice(0, valueToSlice)[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var nota = _step6.value;

                    var id = nota.tagDestacado.id;

                    html += "<div class=\"tema floatFix\"><p>" + nota.tagDestacado.valor + "</p>\n                     <button class=\"seguir\" data-preferibleId=\"" + id + "\" data-preferibleTipoId=\"7\">SEGUIR</button></div>";
                }
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                        _iterator6.return();
                    }
                } finally {
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }

            html += "</section>";
        }

        var asideBloque2 = document.querySelector("#bloque-2");
        asideBloque2.classList.add(css);
        asideBloque2.innerHTML = html;
    }
    seguirDejarSeguir(document.querySelectorAll('button[class="seguir"]'));
};

var loopArticles = function loopArticles(notas, cantidadATomar) {
    var valueToSlice = notas.length < cantidadATomar ? notas.length : cantidadATomar;
    notas = notas.filter(function (n) {
        return n.datos != undefined;
    });

    //Para test de render nota opinion
    //notas = notas.filter(n => n.datos.template.id === 3);

    var html = "";

    var _iteratorNormalCompletion7 = true;
    var _didIteratorError7 = false;
    var _iteratorError7 = undefined;

    try {
        for (var _iterator7 = notas.slice(0, valueToSlice)[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
            var nota = _step7.value;

            var notaDato = nota.datos;
            var esNotaOpinion = notaDato.template.id === 3;

            var isNotaRecomendada = nota.origen === "Sugerencia" ? "recomendadas" : "";
            var imagenSrc = "";
            var autorUrl = "";

            if (esNotaOpinion) {
                if (notaDato.autores !== undefined && notaDato.autores !== null && notaDato.autores[0].imagen !== undefined && notaDato.autores[0].imagen != null) {
                    imagenSrc = "<img src=\"" + BucketTools.urlBucketBalance(urlBucket, notaDato.autores[0].imagen.id, "", 90, notaDato.autores[0].imagen.extension) + "\"/>";
                    var url = Utilities.formatoUrlAcuAutor(notaDato.autores[0].nombre, notaDato.autores[0].id);
                    autorUrl = "<a href=\"" + url + "\" class=\"autor\">" + notaDato.autores[0].nombre + "</a>";
                }
            } else {
                imagenSrc = notaDato.imagen && notaDato.imagen !== undefined && notaDato.imagen != null ? "<img src=\"" + BucketTools.urlBucketBalance(urlBucket, notaDato.imagen.id, 140, "", notaDato.imagen.extension) + "\"/>" : "";
            }

            var notaUrl = nota.contenido_id + "-" + Utilities.FormatearUrl(nota.titulo),
                tags = notaDato.temas;
            var tag = void 0;
            var tagHtml = "";

            if (tags && tags.length > 0) {
                tag = tags[0];
                tagHtml = "<h3 class=\"tag\"><a href=\"" + Utilities.formatoUrlAcuTag(tag.descripcion, tag.id) + "\">" + tag.descripcion + "</a></h3>";
            }

            html += "<article title=\"\" class=\"nota m " + (esNotaOpinion ? " autor" : " foto") + " floatFix " + isNotaRecomendada + "\">\n                    <a href=\"" + notaUrl + "\" class=\"figure\">\n                        " + imagenSrc + "\n                    </a>";

            if (!esNotaOpinion) {
                html += tagHtml;
                html += "<h2>\n                        <a href=\"" + notaUrl + "\">" + nota.titulo + "</a>\n                        </h2>";
            } else {
                html += "<h2>\n                        <a href=\"" + notaUrl + "\">" + nota.titulo + "</a>\n                        </h2>\n                        " + autorUrl;
            }
            html += "</article>";
        }
    } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
            }
        } finally {
            if (_didIteratorError7) {
                throw _iteratorError7;
            }
        }
    }

    return html;
};

/////////////////////////////////////TE PUEDE INTERESAR - NOTA///////////////////////////////////////////////////////////////////

var ejecutarSugerenciasPreferencias = function ejecutarSugerenciasPreferencias(contenidosSuge) {
    sugerencias(contenidosSuge);
};

var sugerencias = exports.sugerencias = function sugerencias(notas) {
    if (notas != null && notas.length > 0) {

        notas = notas.filter(function (item) {
            return item.datos != null && item.datos.imagen !== null && item.datos.imagen !== undefined;
        });

        var notasBloque1 = notas.slice(0, 7);
        var notasBloque2 = notas.slice(7, 15);
        var notasBloque3 = notas.slice(15, 20);
        var contador = 0;

        var html = "<aside class=\"puede-interesar\" id=\"bloque-3\">\n                    <div class=\"fila-1 floatFix\" id=\"sugeridasBloque3F1\">\n                    <h4>Te puede interesar</h4>\n                    <div class=\"columna-doble\">" + getArticleSugerido(notas[0], 514) + "</div>";

        var article = "";
        notasBloque1.shift();
        var _iteratorNormalCompletion8 = true;
        var _didIteratorError8 = false;
        var _iteratorError8 = undefined;

        try {
            for (var _iterator8 = notasBloque1[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                var nota = _step8.value;

                article += getArticleSugerido(nota, 216);
                contador++;

                if (contador % 2 === 0) {
                    html += "<div class=\"columna\">" + article + "</div>";
                    article = "";
                }
            }
        } catch (err) {
            _didIteratorError8 = true;
            _iteratorError8 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                    _iterator8.return();
                }
            } finally {
                if (_didIteratorError8) {
                    throw _iteratorError8;
                }
            }
        }

        html += "</div>";
        //todo: ESto deberia contemplar cuando es "Promocion???"
        //<div class="columna">
        //    <a title="" href="" class="nota">
        //        <figure style="background-image:url('/Statics/img/messi.png')">
        //            <div class="transparente">
        //                <h5>Messi
        //                    <b>Estadísticas</b>
        //                </h5>
        //                <label>todas las <b>tablas</b> y <b> comparativos</b><span>&#8594;</span></label>
        //            </div>
        //        </figure>
        //    </a>
        //</div>
        html += "<div class=\"fila-2 floatFix\" id=\"sugeridasBloque3F2\">";
        article = "";
        contador = 0;
        var _iteratorNormalCompletion9 = true;
        var _didIteratorError9 = false;
        var _iteratorError9 = undefined;

        try {
            for (var _iterator9 = notasBloque2[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                var nota = _step9.value;

                article += getArticleSugerido(nota, 216);
                contador++;
                if (contador % 2 === 0) {
                    html += "<div class=\"columna\">" + article + "</div>";
                    article = "";
                }
                if (contador === 5) {
                    article = getArticleSugerido(nota, 514);
                    html += "<div class=\"columna-doble\">" + article + "</div>";
                    article = "";
                    contador++;
                }
            }
        } catch (err) {
            _didIteratorError9 = true;
            _iteratorError9 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion9 && _iterator9.return) {
                    _iterator9.return();
                }
            } finally {
                if (_didIteratorError9) {
                    throw _iteratorError9;
                }
            }
        }

        html += "</div><div class=\"fila-3 floatFix\" id=\"sugeridasBloque3F3\">";

        var _iteratorNormalCompletion10 = true;
        var _didIteratorError10 = false;
        var _iteratorError10 = undefined;

        try {
            for (var _iterator10 = notasBloque3[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                var nota = _step10.value;

                html += getArticleSugerido(nota, 216);
            }
        } catch (err) {
            _didIteratorError10 = true;
            _iteratorError10 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion10 && _iterator10.return) {
                    _iterator10.return();
                }
            } finally {
                if (_didIteratorError10) {
                    throw _iteratorError10;
                }
            }
        }

        html += "</div></aside>";
        document.querySelector('div[data-module="nota-sugeridas"]').innerHTML = html;
    }
};

var sugerenciasNoLogin = function sugerenciasNoLogin(notas) {
    if (notas != null && notas.items.length > 0) {

        notas = notas.items.filter(function (item) {
            return item != null && item.imagenes !== null && item.imagenes !== undefined && item.imagenes.length > 0;
        });

        var notasBloque1 = notas.slice(0, 7);
        var notasBloque2 = notas.slice(7, 15);
        var notasBloque3 = notas.slice(15, 20);
        var contador = 0;

        var html = "<aside class=\"puede-interesar\" id=\"bloque-3\">\n                    <div class=\"fila-1 floatFix\" id=\"sugeridasBloque3F1\">\n                    <h4>Te puede interesar</h4>\n                    <div class=\"columna-doble\">" + getArticleSugeridoSinLogin(notas[0], 514) + "</div>";

        var article = "";
        notasBloque1.shift();
        var _iteratorNormalCompletion11 = true;
        var _didIteratorError11 = false;
        var _iteratorError11 = undefined;

        try {
            for (var _iterator11 = notasBloque1[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                var nota = _step11.value;

                article += getArticleSugeridoSinLogin(nota, 216);
                contador++;

                if (contador % 2 === 0) {
                    html += "<div class=\"columna\">" + article + "</div>";
                    article = "";
                }
            }
        } catch (err) {
            _didIteratorError11 = true;
            _iteratorError11 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion11 && _iterator11.return) {
                    _iterator11.return();
                }
            } finally {
                if (_didIteratorError11) {
                    throw _iteratorError11;
                }
            }
        }

        html += "</div>";
        //todo: ESto deberia contemplar cuando es "Promocion???"
        //<div class="columna">
        //    <a title="" href="" class="nota">
        //        <figure style="background-image:url('/Statics/img/messi.png')">
        //            <div class="transparente">
        //                <h5>Messi
        //                    <b>Estadísticas</b>
        //                </h5>
        //                <label>todas las <b>tablas</b> y <b> comparativos</b><span>&#8594;</span></label>
        //            </div>
        //        </figure>
        //    </a>
        //</div>
        html += "<div class=\"fila-2 floatFix\" id=\"sugeridasBloque3F2\">";
        article = "";
        contador = 0;
        var _iteratorNormalCompletion12 = true;
        var _didIteratorError12 = false;
        var _iteratorError12 = undefined;

        try {
            for (var _iterator12 = notasBloque2[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                var nota = _step12.value;

                article += getArticleSugeridoSinLogin(nota, 216);
                contador++;
                if (contador % 2 === 0) {
                    html += "<div class=\"columna\">" + article + "</div>";
                    article = "";
                }
                if (contador === 5) {
                    article = getArticleSugeridoSinLogin(nota, 514);
                    html += "<div class=\"columna-doble\">" + article + "</div>";
                    article = "";
                    contador++;
                }
            }
        } catch (err) {
            _didIteratorError12 = true;
            _iteratorError12 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion12 && _iterator12.return) {
                    _iterator12.return();
                }
            } finally {
                if (_didIteratorError12) {
                    throw _iteratorError12;
                }
            }
        }

        html += "</div><div class=\"fila-3 floatFix\" id=\"sugeridasBloque3F3\">";

        var _iteratorNormalCompletion13 = true;
        var _didIteratorError13 = false;
        var _iteratorError13 = undefined;

        try {
            for (var _iterator13 = notasBloque3[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                var nota = _step13.value;

                html += getArticleSugeridoSinLogin(nota, 216);
            }
        } catch (err) {
            _didIteratorError13 = true;
            _iteratorError13 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion13 && _iterator13.return) {
                    _iterator13.return();
                }
            } finally {
                if (_didIteratorError13) {
                    throw _iteratorError13;
                }
            }
        }

        html += "</div></aside>";
        document.querySelector('div[data-module="nota-sugeridas"]').innerHTML = html;
    }
};

var getArticleSugerido = function getArticleSugerido(nota, width) {
    return "<article title=\"\" class=\"nota\">\n              <a class=\"figure\" href=\"" + nota.contenido_id + "-" + Utilities.FormatearUrl(nota.titulo) + "\">                                                                \n                  <img src=\"" + BucketTools.urlBucketBalance(urlBucket, nota.datos.imagen.id, "", width, nota.datos.imagen.extension) + "\"/>\n              </a>\n              <h2><a href=\"" + nota.contenido_id + "-" + Utilities.FormatearUrl(nota.titulo) + "\">" + nota.titulo + "</a></h2>\n          </article>";
};

var getArticleSugeridoSinLogin = function getArticleSugeridoSinLogin(nota, width) {
    return "<article title=\"\" class=\"nota\">\n              <a class=\"figure\" href=\"" + Utilities.FormatearUrl(nota.url) + "\">                                                                \n                  <img src=\"" + BucketTools.urlBucketBalance(urlBucket, nota.imagenes[0].src, "", width) + "\"/>\n              </a>\n              <h2><a href=\"" + Utilities.FormatearUrl(nota.url) + "\">" + nota.titulo + "</a></h2>\n          </article>";
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApiBuilder = undefined;

var _preferencias = __webpack_require__(26);

var _preferencias2 = _interopRequireDefault(_preferencias);

var _sugerencias = __webpack_require__(28);

var _sugerencias2 = _interopRequireDefault(_sugerencias);

var _comunes = __webpack_require__(25);

var _comunes2 = _interopRequireDefault(_comunes);

var _ranking = __webpack_require__(27);

var _ranking2 = _interopRequireDefault(_ranking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ApiBuilder = exports.ApiBuilder = function ApiBuilder(config) {
  var api = { byBuilder: true };

  var preferencias = new _preferencias2.default(config.preferencias || config, api);
  var sugerencias = new _sugerencias2.default(config.sugerencias || config, api);
  var comunes = new _comunes2.default(config.comunes || config, api);
  var ranking = new _ranking2.default(config.ranking || config, api);

  return {
    preferencias: preferencias,
    sugerencias: sugerencias,
    comunes: comunes,
    ranking: ranking,
    execute: function execute() {
      return preferencias.execute();
    }
  };
};

exports.default = ApiBuilder;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TOKEN_COOKIE_NAME = 'PersoTKN';
var SESSION_COOKIE_NAME = 'token';
var DEFAULT_DOMAIN = 'https://personalizacion.lanacion.com.ar/v3';
var cookie = __webpack_require__(24);

var _window = window,
    LN = _window.LN;
var ConfigProvider = exports.ConfigProvider = function ConfigProvider() {
  var domain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_DOMAIN;
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var version = 2;
  var token = config.token || cookie.getValue(config.tokenCookieName || TOKEN_COOKIE_NAME);
  var session = config.session || (cookie.getValue(config.sessionCookieName || SESSION_COOKIE_NAME) || '').split('-', 1);

  return function () {
    return {
      domain: domain,
      token: token,
      session: session,
      version: version
    };
  };
};

var DataProvider = exports.DataProvider = function DataProvider() {
  return { obtenerTemas: function obtenerTemas() {
      return LN.Preferencias.Categories || [];
    }, obtenerNotaId: function obtenerNotaId() {
      return LN.current.notaId;
    } };
};

var Providers = exports.Providers = {
  ConfigProvider: ConfigProvider,
  DataProvider: DataProvider
};

exports.default = Providers;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// @ts-check

/**
 * Request - Generic method
 * @param {string} method
 * @param {string} url
 * @param {any} params
 * @param {any} headers
 * @return {Promise<string>}
 */
var ajax = exports.ajax = function ajax(method, url, params) {
  var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return new Promise(function (resolve, reject) {
    var request = new XMLHttpRequest();

    request.open(method, url, true);
    if (headers) {
      var names = Object.keys(headers);
      names.forEach(function (name) {
        var value = headers[name];

        request.setRequestHeader(name, value);
      });
    }

    request.onload = function () {
      if (request.status >= 200 && request.status < 400) {
        var resp = request.responseText;
        resolve(resp);
      } else {
        reject();
      }
    };
    request.onerror = function () {
      return reject();
    };
    request.send(JSON.stringify(params));
  });
};

/**
 * Request - Post
 * @param {string} method
 * @param {string} url
 * @param {any} params
 * @param {any} headers
 * @return {Promise<string>}
 */
var post = exports.post = function post(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return ajax('POST', url, params, headers);
};

/**
 * Request - Get
 * @param {string} method
 * @param {string} url
 * @param {any} params
 * @param {any} headers
 * @return {Promise<string>}
 */
var get = exports.get = function get(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return ajax('GET', url, params, headers);
};

exports.default = { get: get, post: post };

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var builder = function builder(domain) {
  var document = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.document;

  var doc = document;

  var getValue = function getValue(name) {
    var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : doc.cookie;

    var indice = source.indexOf(name);

    if (indice === -1 || !name) return '';

    var idxTo = source.indexOf(';', indice);

    var idxAmp = source.indexOf('&', indice);
    if (idxTo > idxAmp && idxAmp !== -1 || idxTo === -1 && idxAmp !== -1) idxTo = idxAmp;
    if (idxTo === -1) idxTo = source.length;

    var idFrom = indice + name.length + 1;

    return unescape(source.substring(idFrom, idxTo));
  };

  var createCookieString = function createCookieString(name, value, seconds, path) {
    var strExpires = seconds ? 'expires=' + new Date(Date.now() + seconds * 1000).toGMTString() + '; ' : '';
    var strDomain = domain === 'localhost' ? '' : 'domain=' + domain + '; ';
    var strPath = path ? 'path=' + path + '; ' : '';

    return (name + '=' + value + '; ' + strExpires + strDomain + strPath).trim();
  };

  var setValue = function setValue(name, value) {
    var seconds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 853200;
    var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '/';
    doc.cookie = createCookieString(name, value, seconds, path);
  };

  return { getValue: getValue, setValue: setValue };
};

module.exports = builder(window.document.domain.split(':', 1).pop(), window.document);
module.exports.builder = builder;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _apibase = __webpack_require__(3);

var _apibase2 = _interopRequireDefault(_apibase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Comunes = function (_ApiBase) {
  _inherits(Comunes, _ApiBase);

  function Comunes(config) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    _classCallCheck(this, Comunes);

    return _possibleConstructorReturn(this, (Comunes.__proto__ || Object.getPrototypeOf(Comunes)).call(this, 'personalizacion', config, target));
  }

  /**
   * Obtiene notas en base a la prioridad ('sugerencia' | 'preferencia')
   * @param {Bool} rellena - indica si rellena con la 2da prioridad si no alcanzan las notas con la prioridad indicada.
   * @param {Number} [cantidad] - hasta cuantos resultados devolver
   * @param {String} tipo - Tipo de prioridad ('sugerencia' o 'preferencia')
   * @param {Number[]} contenidosLeidos - array con los id's de notas que se quieren excluir de la busqueda
   * @param {Number[]} [hours] - en que horas buscar
   * @param {Number[]} [daysOfWeek] - en que dias de la semana buscar
   * @param {Bool} [user] - si busca solamente en el entrenamiento del usuario
   * @param {String[]} [tags]
   */


  _createClass(Comunes, [{
    key: 'obtenerPorPrioridad',
    value: function obtenerPorPrioridad(rellena) {
      var cantidad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
      var tipo = arguments[2];
      var contenidosLeidos = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      var hours = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
      var daysOfWeek = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
      var user = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
      var tags = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [];

      var params = {};

      params.quantity = cantidad <= 0 ? 10 : cantidad;
      params.contenidosLeidos = contenidosLeidos;
      params.priorityType = tipo;
      params.hours = hours;
      params.daysOfWeek = daysOfWeek;
      params.user = user;
      params.tags = tags;
      params.refill = rellena;

      return this.addTask('personalizacion', 'json', [{
        name: 'obtener_por_prioridad',
        params: params
      }]);
    }
  }]);

  return Comunes;
}(_apibase2.default);

exports.default = Comunes;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _apibase = __webpack_require__(3);

var _apibase2 = _interopRequireDefault(_apibase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Preferencias = function (_ApiBase) {
  _inherits(Preferencias, _ApiBase);

  function Preferencias(config) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    _classCallCheck(this, Preferencias);

    return _possibleConstructorReturn(this, (Preferencias.__proto__ || Object.getPrototypeOf(Preferencias)).call(this, 'personalizacion', config, target));
  }

  /**
   * Sigue un preferible
   * @param {Number} preferibleId - Id del preferible a seguir
   * @param {Number} preferibleTipoId - Id del tipo de preferible a seguir (6:autor, 7:tag, 20:categoria)
   */


  _createClass(Preferencias, [{
    key: 'seguirPreferible',
    value: function seguirPreferible(preferibleId, preferibleTipoId) {
      var params = {};
      params.preferibleId = preferibleId;
      params.preferibleTipoId = preferibleTipoId;
      return this.addTask('personalizacion', 'json', [{
        name: 'suscribir',
        params: params
      }]);
    }

    /**
     * Obtiene el hash de las suscripciones del usuario. devuelve null si el usuario no tiene suscripciones.
     */

  }, {
    key: 'obtenerHashSuscripciones',
    value: function obtenerHashSuscripciones() {
      var params = {};
      return this.addTask('personalizacion', 'json', [{
        name: 'obtener_hash_suscripciones',
        params: params
      }]);
    }

    /**
     * Deja de seguir un preferible
     * @param {Number} preferibleId - Id del preferible a dejar de seguir
     * @param {Number} preferibleTipoId - Id del tipo de preferible a seguir (6:autor, 7:tag, 20:categoria)
     */

  }, {
    key: 'dejarDeSeguirPreferible',
    value: function dejarDeSeguirPreferible(preferibleId, preferibleTipoId) {
      var params = {};
      params.preferibleId = preferibleId;
      params.preferibleTipoId = preferibleTipoId;
      return this.addTask('personalizacion', 'json', [{
        name: 'cancelar_suscripcion',
        params: params
      }]);
    }

    /**
     * Registrar accion sobre contenido
     * @param {Number} contenidoId - Id del contenido
     * @param {Number} contenidoTipoId - Id del tipo de contenido (1:nota)
     * @param {String} [accion] - acción a entrenar
     */

  }, {
    key: 'registrarAccion',
    value: function registrarAccion(contenidoId, contenidoTipoId) {
      var accion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'lectura';

      return this.addTask('personalizacion', 'json', [{
        name: 'registrar_accion',
        params: [contenidoId, contenidoTipoId, accion]
      }]);
    }

    /**
     * Obtiene la cantidad de novedades del usuario
     */

  }, {
    key: 'obtenerNovedades',
    value: function obtenerNovedades() {
      return this.addTask('personalizacion', 'json', [{
        name: 'obtener_cantidad_novedades'
      }]);
    }

    /**
     * Obtiene los preferibles del usuario
     * @param {Number} [preferibleTipoId] - tipo de preferible (6:autor, 7:tag, 20:categoria)
     */

  }, {
    key: 'obtenerPreferibles',
    value: function obtenerPreferibles() {
      var preferibleTipoId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var params = {};
      params.preferibleTipoId = preferibleTipoId;
      return this.addTask('personalizacion', 'json', [{
        name: 'obtener_preferibles',
        params: params
      }]);
    }

    /**
    * Obtiene notas en base a las preferencias del usuario
    * @param {Number} [cantidad=10] - Cantidad máxima de Notas a devolver
    * @param {Number} [page=1] - Página
    */

  }, {
    key: 'obtener',
    value: function obtener(cantidad) {
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      var params = {};

      params.quantity = cantidad <= 0 ? 10 : cantidad;
      params.page = page;

      return this.addTask('personalizacion', 'json', [{
        name: 'obtener_preferencias',
        params: params
      }]);
    }
  }]);

  return Preferencias;
}(_apibase2.default);

exports.default = Preferencias;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _apibase = __webpack_require__(3);

var _apibase2 = _interopRequireDefault(_apibase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Comunes = function (_ApiBase) {
  _inherits(Comunes, _ApiBase);

  function Comunes(config) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    _classCallCheck(this, Comunes);

    return _possibleConstructorReturn(this, (Comunes.__proto__ || Object.getPrototypeOf(Comunes)).call(this, 'personalizacion', config, target));
  }

  /**
   * Obtiene los autores y tags mas seguidos
   */


  _createClass(Comunes, [{
    key: 'obtenerMasSeguidos',
    value: function obtenerMasSeguidos() {
      var params = '';

      return this.addTask('personalizacion', 'json', [{
        name: 'obtener_mas_seguidos',
        params: params
      }]);
    }
  }]);

  return Comunes;
}(_apibase2.default);

exports.default = Comunes;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _apibase = __webpack_require__(3);

var _apibase2 = _interopRequireDefault(_apibase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CATEGORY_MAX_WEIGHT = 1000;

/**
 * Api sugerencias
 */

var Sugerencias = function (_ApiBase) {
  _inherits(Sugerencias, _ApiBase);

  /**
   * @param {object} config
   */
  function Sugerencias(config) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    _classCallCheck(this, Sugerencias);

    return _possibleConstructorReturn(this, (Sugerencias.__proto__ || Object.getPrototypeOf(Sugerencias)).call(this, 'personalizacion', config, target));
  }

  /**
   * Recomendar temas en base al entrenamiento del usuario
   * @param {Number} [quantity] - hasta cuantos resultados devolver
   * @param {Number[]} [hours] - en que horas buscar
   * @param {Number[]} [daysOfWeek] - en que dias de la semana buscar
   * @param {Bool} [user] - si busca solamente en el entrenamiento del usuario
   * @param {String[]} [tags]
   */


  _createClass(Sugerencias, [{
    key: 'recomendarTemas',
    value: function recomendarTemas() {
      var quantity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
      var hours = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var daysOfWeek = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var user = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var tags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

      var params = {};
      params.quantity = quantity || 10;
      params.hours = hours || [];
      params.daysOfWeek = daysOfWeek || [];
      params.user = user;
      params.tags = tags || [];

      return this.addTask('personalizacion', 'json', [// recomendar/temas
      {
        name: 'recomendar_temas',
        params: params
      }]);
    }

    /**
     * Registra los preferibles que se encuentran en la nota a la que accede el usuario.
     * @param {Any} categoriesParam - array de categorias (preferibles) a entrenar. formato esperado: idPreferible#tipoPreferibleId#SubTipoPreferibleId
     * @param {Array} context
     */

  }, {
    key: 'registrarTemas',
    value: function registrarTemas(categoriesParam) {
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      var params = {};
      params.categories = Sugerencias.getCategoriesFrom(categoriesParam);

      var now = new Date();
      var hour = now.getHours();
      var dayOfWeek = now.getDay();

      params.hour = hour;
      params.dayOfWeek = dayOfWeek;

      if (context) params.context = context;

      return this.addTask('personalizacion', 'json', [// registrar/temas
      {
        name: 'registrar_navegacion',
        params: params
      }]);
    }

    /**
     * Registra el acceso a una url
     * @param {Any} categoriesParam - array de accesos a entrenar. formato esperado: descripcion|url|tipo
     * @param {Array} context
     */

  }, {
    key: 'registrarAccesos',
    value: function registrarAccesos(categoriesParam) {
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      var params = {};
      params.categories = Sugerencias.getCategoriesFrom(categoriesParam);

      var now = new Date();
      var hour = now.getHours();
      var dayOfWeek = now.getDay();

      params.hour = hour;
      params.dayOfWeek = dayOfWeek;

      if (context) params.context = context;

      return this.addTask('personalizacion', 'json', [{
        name: 'registrar_acceso',
        params: params
      }]);
    }

    /**
     * Obtiene los accesos entrenados
     * @param {Number} [quantity] - hasta cuantos resultados devolver
     * @param {Number[]} [hours] - en que horas buscar
     * @param {Number[]} [daysOfWeek] - en que dias de la semana buscar
     * @param {Bool} [user] - si busca solamente en el entrenamiento del usuario
     * @param {String[]} [tags]
     */

  }, {
    key: 'obtenerAccesos',
    value: function obtenerAccesos() {
      var quantity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
      var hours = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var daysOfWeek = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var user = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var tags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

      var params = {};
      params.quantity = quantity || 10;
      params.hours = hours || [];
      params.daysOfWeek = daysOfWeek || [];
      params.user = user;
      params.tags = tags || [];

      return this.addTask('personalizacion', 'json', [{
        name: 'obtener_accesos',
        params: params
      }]);
    }

    /**
     * Registrar accion sobre contendio
     * @param {Number} contenidoId - Id del contenido 
     * @param {Number} contenidoTipoId - Id del tipo de contenido (1:nota)
     * @param {String} [accion] - acción a entrenar
     */

  }, {
    key: 'registrarAccion',
    value: function registrarAccion(contenidoId, contenidoTipoId) {
      var accion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'lectura';

      return this.addTask('personalizacion', 'json', [{
        name: 'registrar_accion',
        params: [contenidoId, contenidoTipoId, accion]
      }]);
    }

    /**
     * Registra lectura de nota
     * @param {Number} notaId - Id de la nota
     */

  }, {
    key: 'lecturaNota',
    value: function lecturaNota(notaId) {
      return this.addTask('personalizacion', 'json', [{
        name: 'registrar_lectura_nota',
        params: [notaId]
      }]);
    }

    /**
     * @param {Number[]} [contenidosLeidos] - array con los id's de notas que se quieren excluir de la busqueda
     * @param {Number} [quantity] - hasta cuantos resultados devolver
     * @param {Number[]} [hours] - en que horas buscar
     * @param {Number[]} [daysOfWeek] - en que dias de la semana buscar
     * @param {Bool} [user] - si busca solamente en el entrenamiento del usuario
     * @param {String[]} [tags]
     */

  }, {
    key: 'obtener',
    value: function obtener() {
      var contenidosLeidos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
      var hours = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var daysOfWeek = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      var user = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      var tags = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

      var params = {};

      params.quantity = quantity <= 0 ? 10 : quantity;
      params.contenidosLeidos = contenidosLeidos;
      params.hours = hours || [];
      params.daysOfWeek = daysOfWeek || [];
      params.user = user;
      params.tags = tags || [];

      return this.addTask('personalizacion', 'json', [{
        name: 'obtener_sugerencias',
        params: params
      }]);
    }
  }]);

  return Sugerencias;
}(_apibase2.default);

/**
   * Convert a single value to category object
   * @param  {Any} categoryParam
   * @return  {object} category
   **/


Sugerencias.getCategory = function (categoryParam) {
  if (typeof categoryParam === 'string') {
    return categoryParam;
  }

  var category = {};
  if ((typeof categoryParam === 'undefined' ? 'undefined' : _typeof(categoryParam)) === 'object') {
    category.value = categoryParam.value;
    if (categoryParam.type) category.type = categoryParam.type;else if (categoryParam.weight > CATEGORY_MAX_WEIGHT) category.weight = CATEGORY_MAX_WEIGHT;else if (categoryParam.weight) category.weight = categoryParam.weight;else category.weight = 1;
  } else {
    category.value = categoryParam;
    category.weight = 1;
  }

  return category;
};

/**
   * Convert values to array of categories
   * @param  {Any} categories
   * @return  {Array} categories
   **/
Sugerencias.getCategoriesFrom = function (categories) {
  if (categories instanceof Array) {
    return [].concat(_toConsumableArray(categories.map(Sugerencias.getCategory).filter(function (c) {
      return !!c;
    })));
  } else if ((typeof categories === 'undefined' ? 'undefined' : _typeof(categories)) === 'object') {
    return categories.categories || categories;
  }
  return [Sugerencias.getCategory(categories)];
};

exports.default = Sugerencias;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MakeCustomDimension = undefined;

var _cookie = __webpack_require__(0);

var Cookie = _interopRequireWildcard(_cookie);

var _ajax = __webpack_require__(1);

var Ajax = _interopRequireWildcard(_ajax);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var urlApiPaywall = window.config.Statics.ApiPaywall;
var urlApiSuscripcion = urlApiPaywall + window.config.Statics.ApiSuscripcion;

var MakeCustomDimension = exports.MakeCustomDimension = function MakeCustomDimension() {

    //let timeCache = localStorage.getItem("CDcacheCommon");
    // let dif = 0;  
    // let tiempoCacheMilisegundos = 300000; ///TODO:Cambiar a configuracion
    var cDlocalStorage = localStorage.getItem("CDusuarioLogeado");
    if (cDlocalStorage == null) {
        getAndSaveCustomDimension();
    }

    //if (timeCache) {
    //    dif = Date.now() - timeCache;
    //    if (dif > tiempoCacheMilisegundos) {
    //        cleanAndGetCustomDimensions();
    //    } else {
    //        let tokenActual = Cookie.LeerCookie('token');
    //        let cDtoken = localStorage.getItem("token");
    //        if (tokenActual && tokenActual !== cDtoken) {
    //            localStorage.removeItem("CDnotasLeidas");
    //            cleanAndGetCustomDimensions();
    //        }
    //    }
    //} else {
    //    getAndSaveCustomDimension();
    //}
};

var getAndSaveCustomDimension = function getAndSaveCustomDimension() {

    //let usuarioLogeado = Cookie.LeerCookie('token');
    var usuarioLogeado = localStorage.getItem("token");
    var productoId = Cookie.LeerCookie('ProductoPremiumId');
    var clubLn = Cookie.LeerCookie('usuarioDetalleClubNacion');
    var userId = Cookie.LeerCookie('usuario%5Fid');
    var usuarioRegistrado = Cookie.LeerCookie('usuarioemail');

    if (usuarioLogeado != null) {
        getSuscriptorType(usuarioLogeado);
    } else {
        localStorage.setItem("CDsuscriptorType", "N/A");
    }

    usuarioLogeado = usuarioLogeado != null ? true : false;
    productoId = productoId ? true : false;
    clubLn = clubLn ? clubLn : "N/A";
    userId = userId ? userId : "N/A";
    usuarioRegistrado = usuarioRegistrado ? true : false;

    localStorage.setItem("CDcacheCommon", Date.now());
    localStorage.setItem("CDusuarioLogeado", usuarioLogeado);
    localStorage.setItem("CDpayUser", productoId);
    localStorage.setItem("CDcredentialType", clubLn);
    localStorage.setItem("CDuserId", userId);
    localStorage.setItem("CDusuarioRegistrado", usuarioRegistrado);
};

var cleanAndGetCustomDimensions = function cleanAndGetCustomDimensions() {

    localStorage.removeItem("CDcacheCommon");
    localStorage.removeItem("CDusuarioLogeado");
    localStorage.removeItem("CDusuarioRegistrado");
    localStorage.removeItem("CDpayUser");
    localStorage.removeItem("CDsuscriptorType");
    localStorage.removeItem("CDcredentialType");
    localStorage.removeItem("CDuserId");
    getAndSaveCustomDimension();
};

var getSuscriptorType = function getSuscriptorType(token) {
    var objHeaders = {
        "X-Token": token
    };
    Ajax.post(urlApiSuscripcion, undefined, objHeaders).then(function (rs) {
        return saveSuscriptorType(JSON.parse(rs));
    });
};

var saveSuscriptorType = function saveSuscriptorType(data) {
    if (data && data.code && data.code === "0000") {
        var combo = data.response.nombre;
        localStorage.setItem("CDsuscriptorType", combo);
    } else {
        localStorage.setItem("CDsuscriptorType", "N/A");
    }
};

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.checkBomba = undefined;

var _ajax = __webpack_require__(1);

var Ajax = _interopRequireWildcard(_ajax);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var checkBomba = exports.checkBomba = function checkBomba() {
    var bombaIntrasitio = document.querySelector("#bombaIntrasitio");

    if (bombaIntrasitio === null || bombaIntrasitio === undefined) return;

    queryBomba();
    setInterval(queryBomba, 60000);
};

var queryBomba = function queryBomba() {
    Ajax.get(window.config.Statics.NotaBomba).then(function (result) {
        drawnBomba(JSON.parse(result));
    });
};

var drawnBomba = function drawnBomba(json) {
    var bombaIntrasitio = document.querySelector("#bombaIntrasitio");

    if (bombaIntrasitio === null || bombaIntrasitio === undefined) return;

    if (Object.getOwnPropertyNames(json).length > 0) {
        var bombaIntrasitioObj = json;
        var html = "<a href=\"{url}\" class=\"floatFix\"> <img src=\"{imagen}\" />\n                        <div>\n                                <div class=\"bullet\"><div class=\"circle\"></div></div>                                \n                                <strong>{tema}</strong>\n                                <h1>{titulo}</h1>                                \n                                <span>M\xE1s informaci\xF3n <b class=\"icon-ir\"></b></span>\n                        </div>\n                        </a>";

        bombaIntrasitio.classList.add("bomba-interna");
        bombaIntrasitio.classList.add("floatFix");
        bombaIntrasitio.innerHTML = html.replace("{imagen}", bombaIntrasitioObj.Imagen).replace("{tema}", bombaIntrasitioObj.Tema).replace("{titulo}", bombaIntrasitioObj.Titulo).replace("{url}", bombaIntrasitioObj.Url);
    } else {
        bombaIntrasitio.innerHTML = "";
        var classBombaIntransito = document.querySelector("#bombaIntrasitio").classList;

        if (classBombaIntransito.contains("bomba-interna")) {
            classBombaIntransito.remove("bomba-interna");
            classBombaIntransito.remove("floatFix");
        }
    }
};

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCotizacionDivisas = exports.getPromoContentLab = exports.getPromoClubLn = exports.getRanking = undefined;

var _ajax = __webpack_require__(1);

var _bucket = __webpack_require__(2);

var BucketTools = _interopRequireWildcard(_bucket);

var _utilities = __webpack_require__(4);

var Utilities = _interopRequireWildcard(_utilities);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var sitioId = window.config.Sitio.Id;
var urlRankingSitio = window.config.Statics.ApiContenidoUrlRoot + window.config.Statics.ApiRankingSitioUrl;
var urlRankingCategoria = window.config.Statics.ApiContenidoUrlRoot + window.config.Statics.ApiRankingCategoriaUrl;
var bucket = window.config.Statics.BucketUrl;
var bucketClubLn = window.config.Statics.BucketClubLnUrl.replace("dp-", "");
var urlPromoContentLab = window.config.Statics.ApiContenidoUrlRoot + window.config.Statics.ApiAcumuladoTipoTagUrl;
var urlPromoClubLn = window.config.Statics.ApiContenidoUrlRoot + window.config.Statics.ApiPromoClubLnUrl;
var cantidadNotasPromoContentLab = 10; //TODO: ver de obtenerla de la configuracion
var tagTipoContentLab = 10; //TODO: ver de obtenerla de la configuracion
var urlEconomiaCotizacionDivisas = window.config.Statics.ApiContenidoUrlRoot + window.config.Statics.ApiEconomiaCotizacionDivisasUrl;
//devuelve un numero random entre el rango establecido
var getRandomInteger = function getRandomInteger(min, max) {
    var _min = Math.ceil(min);
    var _max = Math.floor(max + 1);
    return Math.floor(Math.random() * (_max - _min)) + _min;
};

var renderRanking = function renderRanking(data) {
    var container = document.getElementById("ranking");
    if (!container) return;

    var ranking = '<div class="techo floatFix"><h4>Más <b>leídas ahora</b></h4></div>';
    var notas = data.items.slice(0, 5);
    ranking += "<ol>";
    for (var i = 0; i < notas.length; i++) {
        var nota = notas[i];

        var imageHtml = "";
        if (nota.imagenes != null && nota.imagenes.length > 0) {
            imageHtml = "<a class=\"figure\"  href=\"/" + nota.url + "\">       \n                            <img src=\"" + BucketTools.urlBucketBalance(bucket, nota.imagenes[0].src, "70") + "\"/>\n                        </a>";
        } else {
            imageHtml = "<a class=\"figure\"  href=\"/" + nota.url + "\">      \n                        </a>";
        }

        ranking += "<li>\n                        <article class=\"nota floatFix\">";
        ranking += imageHtml;
        ranking += "<h2>\n                        <a href=\"/" + nota.url + "\">\n                            " + nota.titulo + "\n                        </a>\n                    </h2>\n                </article>\n             </li>";
    }
    ranking += "</ol>";
    container.innerHTML = ranking;
};

var renderNotasHeader = function renderNotasHeader(data) {
    var acumulado = document.querySelector("div[data-notaHeader]");
    //console.log(document.referrer)
    if (acumulado !== null && (document.referrer === "" || document.referrer.split('/')[2].indexOf(location.hostname) === -1)) {
        var notas = data.items.slice(0, 4);

        var html = "<aside class=\"listado sugeridas floatFix\" id=\"bloque-1\"><div class=\"floatFix\">";
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = notas[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var nota = _step.value;

                var imageHtml = nota.imagenes != null && nota.imagenes.length > 0 ? "<a class=\"figure\"  href=\"/" + nota.url + "\">       \n                                <img src=\"" + BucketTools.urlBucketBalance(bucket, nota.imagenes[0].src, "69") + "\"/>                   \n                              </a>" : "<a class=\"figure\"  href=\"/" + nota.url + "\"></a>";

                html += "<article title=\"\" class=\"nota foto floatFix\">\n                " + imageHtml + "\n                <h2>\n                    <a href=\"/" + nota.url + "\">\n                        " + nota.titulo + "\n                    </a>\n                </h2>\n                </article>";
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        html += "</div></aside>";
        acumulado.innerHTML = html;
    }
};

var renderHeaderAndRanking = function renderHeaderAndRanking(data) {
    renderNotasHeader(data);
    renderRanking(data);
};

var getRanking = exports.getRanking = function getRanking() {
    if (!!document.getElementById("ranking")) {
        //todo: desacoplar esto.
        var rankyngByCategoria = document.querySelector("main[data-Acu-TagRelaCatId]");
        var rankyngByCategoriaId = "0";
        if (rankyngByCategoria) {
            rankyngByCategoriaId = rankyngByCategoria.getAttribute("data-Acu-TagRelaCatId");
        }

        var urlBy = urlRankingSitio;
        var getById = sitioId;

        if (rankyngByCategoriaId != "0") {
            urlBy = urlRankingCategoria;
            getById = rankyngByCategoriaId;
        }

        (0, _ajax.get)(urlBy + getById).then(function (rs) {
            return renderHeaderAndRanking(JSON.parse(rs));
        }).catch(errorUrl);
    }
};

var errorUrl = function errorUrl() {
    (0, _ajax.get)(urlRankingSitio + sitioId).then(function (rs) {
        return JSON.parse(rs);
    }).then(renderHeaderAndRanking);
};

var renderPromoContentLab = function renderPromoContentLab(data) {
    var container = document.getElementById("promoContenLab");
    if (!container) return;
    var notas = data.items;

    if (notas == null) {
        container.parentNode.removeChild(container);
        return;
    }

    var cantidadNotas = notas.length;
    if (cantidadNotas == 0) {
        container.parentNode.removeChild(container);
        return;
    }

    //getRandom
    var indexRandom = getRandomInteger(0, cantidadNotas - 1);

    var nota = notas[indexRandom];

    var promoContentLabHtml = '<h3> CONTENT LAB PARA </h3>';
    var urlTag = Utilities.FormatearUrl(nota.tagDestacado.valor) + "-t" + nota.tagDestacado.id;
    var taghtml = "<a href=\"/" + urlTag + "\">" + nota.tagDestacado.valor + "</a>";
    var imageHTML = "";
    var imageUrl = "";

    if (nota.imagenes != null && nota.imagenes.length > 0) {
        imageUrl = BucketTools.urlBucketBalance(bucket, nota.imagenes[0].src, "200", "300");
        imageHTML = "<img src=\"" + imageUrl + "\"/>";
    }
    var classFigure = "<a href=\"" + nota.url + "\" class=\"figure\">     \n                        " + imageHTML + "                            \n                      </a>";
    promoContentLabHtml += taghtml;
    promoContentLabHtml += classFigure;
    promoContentLabHtml += "<h2>\n                            <a href=\"" + nota.url + "\">\n                                " + nota.titulo + "\n                            </a>\n                            </h2>";

    container.innerHTML = promoContentLabHtml;
};

var renderPromoClubLn = function renderPromoClubLn(data) {
    var container = document.getElementById("promoClubLn");
    if (container) {
        var notas = data;

        if (notas == null) {
            container.parentNode.removeChild(container);
            return;
        }

        var cantidadNotas = notas.length;
        if (cantidadNotas == 0) {
            container.parentNode.removeChild(container);
            return;
        }

        //getRandom
        var indexRandom = Utilities.getRandomInteger(0, cantidadNotas - 1);

        var nota = notas[indexRandom];

        var promoPromoClubLnHtml = "<h3>BENEFICIOS</h3><a href=\"https://club.lanacion.com.ar/\" target=\"_blank\">Club LA NACION</a>\n                                    <div class=\"floatFix\">";

        var benefit = nota.benefits[0];
        var imageHTML = "";
        var imageUrl = "";
        if (benefit.images != null && benefit.images.length > 0) {
            imageUrl = BucketTools.urlBucketClubLn(bucketClubLn, benefit.images[0].id, "220", "300", benefit.images[0].extension);
            imageHTML = "<img src=\"" + imageUrl + "\"/>";
        }
        var classFigure = "<a href=\"" + nota.link + "\" class=\"figure\" target=\"_blank\">     \n                            " + imageHTML + "                \n                           </a>";

        promoPromoClubLnHtml += classFigure;
        promoPromoClubLnHtml += "<a href=\"" + nota.link + "\" class=\"beneficio\">\n                                    <span>" + benefit.benefitTypeName + "</span>\n                                    <h2>" + benefit.name + "</h2>\n                                </a>\n                                </div>";

        container.innerHTML = promoPromoClubLnHtml;
    }
};

var renderCotizacionDivisasDolar = function renderCotizacionDivisasDolar(data) {
    var container = document.getElementById("cotizacionDivisasDolar");
    if (container) {
        var cotizaciones = data;

        if (cotizaciones == null) return;

        if (cotizaciones.length == 0) return;

        var cotizacionDolar = cotizaciones.filter(function (d) {
            return d.papel == "DLRBILL";
        })[0];

        var compraValorEntero = cotizacionDolar.compra.split(",")[0];
        var compraValorCentavos = cotizacionDolar.compra.split(",")[1];
        var ventaValorEntero = cotizacionDolar.venta.split(",")[0];
        var ventaValorCentavos = cotizacionDolar.venta.split(",")[1];

        var cotizacionDolarHtml = "<div class=\"techo floatFix\">\n                                        <h4>Cotizaci\xF3n </br> <b>D\xF3lar Oficial</b></h4>\n                                    </div>\n                                    <div class=\"cotiza\">\n                                        <div>\n                                            <h5>Compra</h5>\n                                            <span>$" + compraValorEntero + ",</span>\n                                            <span>" + compraValorCentavos + "</span>\n                                        </div>\n                                        <div>\n                                            <h5>Venta</h5>\n                                            <span>$" + ventaValorEntero + ",</span>\n                                            <span>" + ventaValorCentavos + "</span>\n                                        </div>\n                                        <div class=\"auspiciante\">\n                                            Provisto por\n                                            <a href=\"http://www.invertironline.com/\" target=\"_blank\"><img src=\"" + window.config.Statics.BasePath + "/img/logo-invertir-online.png\" width=\"88\" height=\"18\" border=\"0\" alt=\"Invertir Online\" title=\"Invertir Online\"></a>\n                                        </div>\n                                    </div>";

        container.innerHTML = cotizacionDolarHtml;
    }
};

var getPromoClubLn = exports.getPromoClubLn = function getPromoClubLn() {
    if (document.getElementById("promoClubLn")) {
        (0, _ajax.get)(urlPromoClubLn).then(function (rs) {
            return JSON.parse(rs);
        }).then(renderPromoClubLn);
    }
};

var getPromoContentLab = exports.getPromoContentLab = function getPromoContentLab() {
    if (document.getElementById("promoContenLab")) {
        (0, _ajax.get)(urlPromoContentLab + tagTipoContentLab + "?c=" + cantidadNotasPromoContentLab + "&h=1").then(function (rs) {
            return JSON.parse(rs);
        }).then(renderPromoContentLab);
    }
};

var getCotizacionDivisas = exports.getCotizacionDivisas = function getCotizacionDivisas() {
    if (document.getElementById("cotizacionDivisasDolar")) {
        (0, _ajax.get)(urlEconomiaCotizacionDivisas).then(function (rs) {
            return JSON.parse(rs);
        }).then(renderCotizacionDivisasDolar);
    }
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.render = render;

var _video = __webpack_require__(39);

var _video2 = _interopRequireDefault(_video);

var _jwplayer = __webpack_require__(38);

var _jwplayer2 = _interopRequireDefault(_jwplayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_jwplayer2.default.key = "rgP22Py/jYzmXcg4SWRmPOsIvMZfZ8yx/nnong==";
window.jwplayer = _jwplayer2.default;

function render(nodo, video_id, multimediofileId, multimedioJWKey, multimediofileJWKey, videoDestacado, showAds, autoPlay, arrayTags, videoTag_Home, contenedor, titulo) {
    var nodoId = "jwVideo" + multimediofileId,
        playlistUrlBase = _video2.default.playlistUrlBase,
        settings = _video2.default.settings; //new LN.conf.video.settings();

    if (multimedioJWKey) {
        /* Es una playlist */
        settings.playlist = playlistUrlBase + multimedioJWKey + ".xml";
        //settings.skin = undefined;
    } else if (multimediofileJWKey) {
        /* Es un video */
        settings.playlist = playlistUrlBase + multimediofileJWKey + ".xml";
    }

    //TODO: SHARING FUNCTION (<iframe>)---------------------------------------------------------------------------------------------------
    //if (video_id != '' && settings.sharing.code ){ 
    //    settings.sharing.code = '<iframe src="' + document.location.origin + '/herramientas/modal-video/-multimedio_id=' + video_id + '" width="100%" height="650"/>'
    //}

    //if (settings.sharing.link && settings.sharing.link.indexOf('http://') != 0)
    //    settings.sharing.link = document.location.origin + settings.sharing.link;
    //-------------------------------------------------------------------------------------------------------------------------------------

    //TODO: VER EL TEMA DE LOS ADS EN LOS VIDEOS------------------------------------------------------------------------------------------
    if (showAds != undefined && showAds == 0) {
        settings.advertising = undefined;
    } else {
        var d = new Date();
        var timestamp = d.getTime();
        settings.advertising.schedule.myAds.tag = "https://pubads.g.doubleclick.net/gampad/ads?slotname=/133919216/lanacion/" + window.LN.tipoPaginaBanner + "/preroll&sz=640x480|400x300&ciu_szs=300x250&unviewed_position_start=1&output=vast&impl=s&env=vp&gdfp_req=1&ad_rule=0&vad_type=linear&vpos=preroll&pod=3&ppos=1&lip=true&min_ad_duration=0&max_ad_duration=30000&vrid=6256&cust_params=&url=null&video_doc_id=short_onecue&cmsid=496&kfa=0&tfcd=0&correlator=" + timestamp;
        //settings.advertising.schedule.postroll.tag = window.JW.ads.getVideoURL("vast","postroll");   
    }

    nodo.innerHTML += '<div id="' + nodoId + '"></div>';

    if (autoPlay === true) {
        settings.autostart = true;
    } else {
        settings.autostart = false;
    }

    var player = (0, _jwplayer2.default)(nodoId).setup(settings);

    //TODO: GOOGLE ANALYTICS---------------------------------------------------------------------------------------------------
    //let eventosParametro = video_id.toString();
    //contenedor.toString();

    player.on("play", function (data) {
        if (data.oldstate === "buffering" && player.getPosition() === 0 && dataLayer) {
            dataLayer.push({ 'event': 'videoPlay', 'videoName': titulo, 'videoTags': arrayTags });
        }
    });

    //player.on("complete", function () {
    //    ga("send", "event", "Video-Nativo", "complete", eventosParametro, { 'dimension10': contenedor });
    //});
    //-------------------------------------------------------------------------------------------------------------------


    //PLAYLIST-----------------------------------------------------------------------------------------------------------
    if (multimedioJWKey) {
        /* Dar formato a la playlist */
        player.on("ready", function () {
            var html = "";
            var playlist = player.getPlaylist();
            //console.log(playlist.length);
            //if (playlist.length > 1) {
            if (playlist.length > 1) {
                for (var index = 0; index < playlist.length; index++) {
                    html += "<a href='javascript:void(0)' onclick='javascript:playVideoPlayList(\"" + nodoId + "\", " + index + ")'>";
                    html += playlist[index].title;
                    html += "</a>";
                }

                var elemDiv = document.createElement("div");
                elemDiv.setAttribute("class", "playlist-generico");
                elemDiv.setAttribute("id", "PlayList-" + video_id);
                document.getElementById("videoContainerVideo-" + video_id).appendChild(elemDiv);

                document.getElementById("PlayList-" + video_id).innerHTML = html;
            }
            //}
        });
    }
    if (dataLayer) {
        dataLayer.push({ 'event': 'videoDisplay', 'videoName': titulo, 'videoTags': arrayTags });
    }

    //-------------------------------------------------------------------------------------------------------------------
    //  ga('send', 'event', 'Video-Nativo', 'Embed', eventosParametro, { 'dimension10': contenedor });
    return nodo;
}

//function areAdsShowed(settings, showAds) {
//    if (showAds != undefined && showAds == 0)
//    {
//        settings.advertising = undefined;
//    }
//    else
//    {
//        settings.advertising.schedule.myAds.tag = ads.getVideoURL("vast", "preroll");
//        settings.advertising.schedule.postroll.tag = ads.getVideoURL("vast","postroll");   
//    }

//    return settings;
//}

function playVideoPlayList(nodoId, index) {
    var player = (0, _jwplayer2.default)(nodoId);
    player.playlistItem(index);
}
window.playVideoPlayList = playVideoPlayList;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initialize = undefined;

var _jwplayerRender = __webpack_require__(36);

var Jwp = _interopRequireWildcard(_jwplayerRender);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialize = exports.initialize = function initialize() {
    var videos = Array.from(document.getElementsByClassName("videoAside"));
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = videos[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var video = _step.value;

            var videoId = video.getAttribute("data-video_id"),
                multimediofileId = video.getAttribute("data-multimediofile_id"),
                multimediofileJWKey = video.getAttribute("data-jwkey"),
                multimedioJWKey = video.getAttribute("data-multimediojwkey"),
                videoDestacado = video.getAttribute("data-destacado"),
                showAds = video.getAttribute("data-showads"),
                arrayTags = video.getAttribute("data-arraytags"),
                videoTagHome = video.getAttribute("data-videotag_home"),
                contenedor = video.getAttribute("data-contenedor"),
                titulo = video.getAttribute("data-titulo"),
                autoPlay = video.getAttribute("data-autoplay") === 1;

            if (videoId && multimediofileId) {
                Jwp.render(video, videoId, multimediofileId, multimedioJWKey, multimediofileJWKey, !!videoDestacado, showAds, autoPlay, arrayTags, videoTagHome, contenedor, titulo);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};

/***/ }),
/* 38 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function() {

"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.jwplayer = t() : e.jwplayer = t();
}(undefined, function () {
  return function (e) {
    function t(n) {
      if (i[n]) return i[n].exports;var o = i[n] = { exports: {}, id: n, loaded: !1 };return e[n].call(o.exports, o, o.exports, t), o.loaded = !0, o.exports;
    }var n = window.webpackJsonpjwplayer;window.webpackJsonpjwplayer = function (i, r) {
      for (var a, s, l = 0, c = []; l < i.length; l++) {
        s = i[l], o[s] && c.push.apply(c, o[s]), o[s] = 0;
      }for (a in r) {
        e[a] = r[a];
      }for (n && n(i, r); c.length;) {
        c.shift().call(null, t);
      }
    };var i = {},
        o = { 0: 0 };return t.e = function (e, n) {
      if (0 === o[e]) return n.call(null, t);if (void 0 !== o[e]) o[e].push(n);else {
        o[e] = [n];var i = document.getElementsByTagName("head")[0],
            r = document.createElement("script");r.type = "text/javascript", r.charset = "utf-8", r.async = !0, r.src = t.p + "" + ({ 1: "provider.caterpillar", 2: "provider.shaka", 3: "provider.cast", 4: "provider.html5", 5: "provider.flash", 6: "provider.youtube", 7: "polyfills.vttcue", 8: "polyfills.vttrenderer", 9: "polyfills.promise", 10: "polyfills.base64", 11: "vttparser" }[e] || e) + ".js", i.appendChild(r);
      }
    }, t.m = e, t.c = i, t.p = "", t(0);
  }([function (e, t, n) {
    e.exports = n(212);
  }, function (e, t, n) {
    var i, o;i = [], o = function () {
      var e = {},
          t = Array.prototype,
          n = Object.prototype,
          i = Function.prototype,
          o = t.slice,
          r = t.concat,
          a = n.toString,
          s = n.hasOwnProperty,
          l = t.map,
          c = t.reduce,
          u = t.forEach,
          d = t.filter,
          p = t.every,
          h = t.some,
          f = t.indexOf,
          g = Array.isArray,
          m = Object.keys,
          v = i.bind,
          w = function w(e) {
        return e instanceof w ? e : this instanceof w ? void 0 : new w(e);
      },
          y = w.each = w.forEach = function (t, n, i) {
        if (null == t) return t;if (u && t.forEach === u) t.forEach(n, i);else if (t.length === +t.length) {
          for (var o = 0, r = t.length; o < r; o++) {
            if (n.call(i, t[o], o, t) === e) return;
          }
        } else for (var a = w.keys(t), o = 0, r = a.length; o < r; o++) {
          if (n.call(i, t[a[o]], a[o], t) === e) return;
        }return t;
      };w.map = w.collect = function (e, t, n) {
        var i = [];return null == e ? i : l && e.map === l ? e.map(t, n) : (y(e, function (e, o, r) {
          i.push(t.call(n, e, o, r));
        }), i);
      };var j = "Reduce of empty array with no initial value";w.reduce = w.foldl = w.inject = function (e, t, n, i) {
        var o = arguments.length > 2;if (null == e && (e = []), c && e.reduce === c) return i && (t = w.bind(t, i)), o ? e.reduce(t, n) : e.reduce(t);if (y(e, function (e, r, a) {
          o ? n = t.call(i, n, e, r, a) : (n = e, o = !0);
        }), !o) throw new TypeError(j);return n;
      }, w.find = w.detect = function (e, t, n) {
        var i;return b(e, function (e, o, r) {
          if (t.call(n, e, o, r)) return i = e, !0;
        }), i;
      }, w.filter = w.select = function (e, t, n) {
        var i = [];return null == e ? i : d && e.filter === d ? e.filter(t, n) : (y(e, function (e, o, r) {
          t.call(n, e, o, r) && i.push(e);
        }), i);
      }, w.reject = function (e, t, n) {
        return w.filter(e, function (e, i, o) {
          return !t.call(n, e, i, o);
        }, n);
      }, w.compact = function (e) {
        return w.filter(e, w.identity);
      }, w.every = w.all = function (t, n, i) {
        n || (n = w.identity);var o = !0;return null == t ? o : p && t.every === p ? t.every(n, i) : (y(t, function (t, r, a) {
          if (!(o = o && n.call(i, t, r, a))) return e;
        }), !!o);
      };var b = w.some = w.any = function (t, n, i) {
        n || (n = w.identity);var o = !1;return null == t ? o : h && t.some === h ? t.some(n, i) : (y(t, function (t, r, a) {
          if (o || (o = n.call(i, t, r, a))) return e;
        }), !!o);
      };w.size = function (e) {
        return null == e ? 0 : e.length === +e.length ? e.length : w.keys(e).length;
      }, w.last = function (e, t, n) {
        if (null != e) return null == t || n ? e[e.length - 1] : o.call(e, Math.max(e.length - t, 0));
      }, w.after = function (e, t) {
        return function () {
          if (--e < 1) return t.apply(this, arguments);
        };
      }, w.before = function (e, t) {
        var n;return function () {
          return --e > 0 && (n = t.apply(this, arguments)), e <= 1 && (t = null), n;
        };
      };var E = function E(e) {
        return null == e ? w.identity : w.isFunction(e) ? e : w.property(e);
      },
          k = function k(e) {
        return function (t, n, i) {
          var o = {};return n = E(n), y(t, function (r, a) {
            var s = n.call(i, r, a, t);e(o, s, r);
          }), o;
        };
      };w.groupBy = k(function (e, t, n) {
        w.has(e, t) ? e[t].push(n) : e[t] = [n];
      }), w.indexBy = k(function (e, t, n) {
        e[t] = n;
      }), w.sortedIndex = function (e, t, n, i) {
        n = E(n);for (var o = n.call(i, t), r = 0, a = e.length; r < a;) {
          var s = r + a >>> 1;n.call(i, e[s]) < o ? r = s + 1 : a = s;
        }return r;
      };var b = w.some = w.any = function (t, n, i) {
        n || (n = w.identity);var o = !1;return null == t ? o : h && t.some === h ? t.some(n, i) : (y(t, function (t, r, a) {
          if (o || (o = n.call(i, t, r, a))) return e;
        }), !!o);
      };w.contains = w.include = function (e, t) {
        return null != e && (e.length !== +e.length && (e = w.values(e)), w.indexOf(e, t) >= 0);
      }, w.pluck = function (e, t) {
        return w.map(e, w.property(t));
      }, w.where = function (e, t) {
        return w.filter(e, w.matches(t));
      }, w.findWhere = function (e, t) {
        return w.find(e, w.matches(t));
      }, w.max = function (e, t, n) {
        if (!t && w.isArray(e) && e[0] === +e[0] && e.length < 65535) return Math.max.apply(Math, e);var i = -(1 / 0),
            o = -(1 / 0);return y(e, function (e, r, a) {
          var s = t ? t.call(n, e, r, a) : e;s > o && (i = e, o = s);
        }), i;
      }, w.difference = function (e) {
        var n = r.apply(t, o.call(arguments, 1));return w.filter(e, function (e) {
          return !w.contains(n, e);
        });
      }, w.without = function (e) {
        return w.difference(e, o.call(arguments, 1));
      }, w.indexOf = function (e, t, n) {
        if (null == e) return -1;var i = 0,
            o = e.length;if (n) {
          if ("number" != typeof n) return i = w.sortedIndex(e, t), e[i] === t ? i : -1;i = n < 0 ? Math.max(0, o + n) : n;
        }if (f && e.indexOf === f) return e.indexOf(t, n);for (; i < o; i++) {
          if (e[i] === t) return i;
        }return -1;
      };var L = function L() {};w.bind = function (e, t) {
        var n, _i;if (v && e.bind === v) return v.apply(e, o.call(arguments, 1));if (!w.isFunction(e)) throw new TypeError();return n = o.call(arguments, 2), _i = function i() {
          if (!(this instanceof _i)) return e.apply(t, n.concat(o.call(arguments)));L.prototype = e.prototype;var r = new L();L.prototype = null;var a = e.apply(r, n.concat(o.call(arguments)));return Object(a) === a ? a : r;
        };
      }, w.partial = function (e) {
        var t = o.call(arguments, 1);return function () {
          for (var n = 0, i = t.slice(), o = 0, r = i.length; o < r; o++) {
            i[o] === w && (i[o] = arguments[n++]);
          }for (; n < arguments.length;) {
            i.push(arguments[n++]);
          }return e.apply(this, i);
        };
      }, w.once = w.partial(w.before, 2), w.memoize = function (e, t) {
        var n = {};return t || (t = w.identity), function () {
          var i = t.apply(this, arguments);return w.has(n, i) ? n[i] : n[i] = e.apply(this, arguments);
        };
      }, w.delay = function (e, t) {
        var n = o.call(arguments, 2);return setTimeout(function () {
          return e.apply(null, n);
        }, t);
      }, w.defer = function (e) {
        return w.delay.apply(w, [e, 1].concat(o.call(arguments, 1)));
      }, w.throttle = function (e, t, n) {
        var i,
            o,
            r,
            a = null,
            s = 0;n || (n = {});var l = function l() {
          s = n.leading === !1 ? 0 : w.now(), a = null, r = e.apply(i, o), i = o = null;
        };return function () {
          var c = w.now();s || n.leading !== !1 || (s = c);var u = t - (c - s);return i = this, o = arguments, u <= 0 ? (clearTimeout(a), a = null, s = c, r = e.apply(i, o), i = o = null) : a || n.trailing === !1 || (a = setTimeout(l, u)), r;
        };
      }, w.keys = function (e) {
        if (!w.isObject(e)) return [];if (m) return m(e);var t = [];for (var n in e) {
          w.has(e, n) && t.push(n);
        }return t;
      }, w.invert = function (e) {
        for (var t = {}, n = w.keys(e), i = 0, o = n.length; i < o; i++) {
          t[e[n[i]]] = n[i];
        }return t;
      }, w.defaults = function (e) {
        return y(o.call(arguments, 1), function (t) {
          if (t) for (var n in t) {
            void 0 === e[n] && (e[n] = t[n]);
          }
        }), e;
      }, w.extend = function (e) {
        return y(o.call(arguments, 1), function (t) {
          if (t) for (var n in t) {
            e[n] = t[n];
          }
        }), e;
      }, w.pick = function (e) {
        var n = {},
            i = r.apply(t, o.call(arguments, 1));return y(i, function (t) {
          t in e && (n[t] = e[t]);
        }), n;
      }, w.omit = function (e) {
        var n = {},
            i = r.apply(t, o.call(arguments, 1));for (var a in e) {
          w.contains(i, a) || (n[a] = e[a]);
        }return n;
      }, w.clone = function (e) {
        return w.isObject(e) ? w.isArray(e) ? e.slice() : w.extend({}, e) : e;
      }, w.isArray = g || function (e) {
        return "[object Array]" == a.call(e);
      }, w.isObject = function (e) {
        return e === Object(e);
      }, y(["Arguments", "Function", "String", "Number", "Date", "RegExp"], function (e) {
        w["is" + e] = function (t) {
          return a.call(t) == "[object " + e + "]";
        };
      }), w.isArguments(arguments) || (w.isArguments = function (e) {
        return !(!e || !w.has(e, "callee"));
      }), w.isFunction = function (e) {
        return "function" == typeof e;
      }, w.isFinite = function (e) {
        return isFinite(e) && !isNaN(parseFloat(e));
      }, w.isNaN = function (e) {
        return w.isNumber(e) && e != +e;
      }, w.isBoolean = function (e) {
        return e === !0 || e === !1 || "[object Boolean]" == a.call(e);
      }, w.isNull = function (e) {
        return null === e;
      }, w.isUndefined = function (e) {
        return void 0 === e;
      }, w.has = function (e, t) {
        return s.call(e, t);
      }, w.identity = function (e) {
        return e;
      }, w.constant = function (e) {
        return function () {
          return e;
        };
      }, w.property = function (e) {
        return function (t) {
          return t[e];
        };
      }, w.propertyOf = function (e) {
        return null == e ? function () {} : function (t) {
          return e[t];
        };
      }, w.matches = function (e) {
        return function (t) {
          if (t === e) return !0;for (var n in e) {
            if (e[n] !== t[n]) return !1;
          }return !0;
        };
      }, w.now = Date.now || function () {
        return new Date().getTime();
      }, w.result = function (e, t) {
        if (null != e) {
          var n = e[t];return w.isFunction(n) ? n.call(e) : n;
        }
      };var _ = 0;return w.uniqueId = function (e) {
        var t = ++_ + "";return e ? e + t : t;
      }, w;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(8), n(1), n(75), n(76), n(29), n(43), n(21), n(74), n(44), n(78), n(183)], o = function (e, t, n, i, o, r, a, s, l, c, u) {
      var d = {};return d.log = function () {
        window.console && ("object" == _typeof(console.log) ? console.log(Array.prototype.slice.call(arguments, 0)) : console.log.apply(console, arguments));
      }, d.between = function (e, t, n) {
        return Math.max(Math.min(e, n), t);
      }, d.foreach = function (e, t) {
        var n, i;for (n in e) {
          "function" === d.typeOf(e.hasOwnProperty) ? e.hasOwnProperty(n) && (i = e[n], t(n, i)) : (i = e[n], t(n, i));
        }
      }, d.indexOf = t.indexOf, d.noop = function () {}, d.seconds = e.seconds, d.prefix = e.prefix, d.suffix = e.suffix, t.extend(d, r, a, l, n, s, i, o, c, u), d;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(1)], o = function (e) {
      var t = [],
          n = t.slice,
          i = { on: function on(e, t, n) {
          if (!r(this, "on", e, [t, n]) || !t) return this;this._events || (this._events = {});var i = this._events[e] || (this._events[e] = []);return i.push({ callback: t, context: n }), this;
        }, once: function once(t, n, i) {
          if (!r(this, "once", t, [n, i]) || !n) return this;var o = this,
              a = e.once(function () {
            o.off(t, a), n.apply(this, arguments);
          });return a._callback = n, this.on(t, a, i);
        }, off: function off(t, n, i) {
          var o, a, s, l, c, u, d, p;if (!this._events || !r(this, "off", t, [n, i])) return this;if (!t && !n && !i) return this._events = void 0, this;for (l = t ? [t] : e.keys(this._events), c = 0, u = l.length; c < u; c++) {
            if (t = l[c], s = this._events[t]) {
              if (this._events[t] = o = [], n || i) for (d = 0, p = s.length; d < p; d++) {
                a = s[d], (n && n !== a.callback && n !== a.callback._callback || i && i !== a.context) && o.push(a);
              }o.length || delete this._events[t];
            }
          }return this;
        }, trigger: function trigger(e) {
          if (!this._events) return this;var t = n.call(arguments, 1);if (!r(this, "trigger", e, t)) return this;var i = this._events[e],
              o = this._events.all;return i && a(i, t, this), o && a(o, arguments, this), this;
        }, triggerSafe: function triggerSafe(e) {
          if (!this._events) return this;var t = n.call(arguments, 1);if (!r(this, "trigger", e, t)) return this;var i = this._events[e],
              o = this._events.all;return i && s(i, t, this), o && s(o, arguments, this), this;
        } },
          o = /\s+/,
          r = function r(e, t, n, i) {
        if (!n) return !0;if ("object" == (typeof n === "undefined" ? "undefined" : _typeof(n))) {
          for (var r in n) {
            e[t].apply(e, [r, n[r]].concat(i));
          }return !1;
        }if (o.test(n)) {
          for (var a = n.split(o), s = 0, l = a.length; s < l; s++) {
            e[t].apply(e, [a[s]].concat(i));
          }return !1;
        }return !0;
      },
          a = function a(e, t, n) {
        var i,
            o = -1,
            r = e.length,
            a = t[0],
            s = t[1],
            l = t[2];switch (t.length) {case 0:
            for (; ++o < r;) {
              (i = e[o]).callback.call(i.context || n);
            }return;case 1:
            for (; ++o < r;) {
              (i = e[o]).callback.call(i.context || n, a);
            }return;case 2:
            for (; ++o < r;) {
              (i = e[o]).callback.call(i.context || n, a, s);
            }return;case 3:
            for (; ++o < r;) {
              (i = e[o]).callback.call(i.context || n, a, s, l);
            }return;default:
            for (; ++o < r;) {
              (i = e[o]).callback.apply(i.context || n, t);
            }return;}
      },
          s = function s(e, t, n) {
        for (var i, o = -1, r = e.length; ++o < r;) {
          try {
            (i = e[o]).callback.apply(i.context || n, t);
          } catch (a) {}
        }
      };return i;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [], o = function () {
      var e = { DRAG: "drag", DRAG_START: "dragStart", DRAG_END: "dragEnd", CLICK: "click", DOUBLE_CLICK: "doubleClick", TAP: "tap", DOUBLE_TAP: "doubleTap", OVER: "over", MOVE: "move", OUT: "out" },
          t = { COMPLETE: "complete", ERROR: "error", JWPLAYER_AD_CLICK: "adClick", JWPLAYER_AD_COMPANIONS: "adCompanions", JWPLAYER_AD_COMPLETE: "adComplete", JWPLAYER_AD_ERROR: "adError", JWPLAYER_AD_IMPRESSION: "adImpression", JWPLAYER_AD_META: "adMeta", JWPLAYER_AD_PAUSE: "adPause", JWPLAYER_AD_PLAY: "adPlay", JWPLAYER_AD_SKIPPED: "adSkipped", JWPLAYER_AD_TIME: "adTime", JWPLAYER_CAST_AD_CHANGED: "castAdChanged", JWPLAYER_MEDIA_COMPLETE: "complete", JWPLAYER_READY: "ready", JWPLAYER_MEDIA_SEEK: "seek", JWPLAYER_MEDIA_BEFOREPLAY: "beforePlay", JWPLAYER_MEDIA_BEFORECOMPLETE: "beforeComplete", JWPLAYER_MEDIA_BUFFER_FULL: "bufferFull", JWPLAYER_DISPLAY_CLICK: "displayClick", JWPLAYER_PLAYLIST_COMPLETE: "playlistComplete", JWPLAYER_CAST_SESSION: "cast", JWPLAYER_MEDIA_ERROR: "mediaError", JWPLAYER_MEDIA_FIRST_FRAME: "firstFrame", JWPLAYER_MEDIA_PLAY_ATTEMPT: "playAttempt", JWPLAYER_MEDIA_LOADED: "loaded", JWPLAYER_MEDIA_SEEKED: "seeked", JWPLAYER_SETUP_ERROR: "setupError", JWPLAYER_ERROR: "error", JWPLAYER_PLAYER_STATE: "state", JWPLAYER_CAST_AVAILABLE: "castAvailable", JWPLAYER_MEDIA_BUFFER: "bufferChange", JWPLAYER_MEDIA_TIME: "time", JWPLAYER_MEDIA_TYPE: "mediaType", JWPLAYER_MEDIA_VOLUME: "volume", JWPLAYER_MEDIA_MUTE: "mute", JWPLAYER_MEDIA_META: "meta", JWPLAYER_MEDIA_LEVELS: "levels", JWPLAYER_MEDIA_LEVEL_CHANGED: "levelsChanged", JWPLAYER_CONTROLS: "controls", JWPLAYER_FULLSCREEN: "fullscreen", JWPLAYER_RESIZE: "resize", JWPLAYER_PLAYLIST_ITEM: "playlistItem", JWPLAYER_PLAYLIST_LOADED: "playlist", JWPLAYER_AUDIO_TRACKS: "audioTracks", JWPLAYER_AUDIO_TRACK_CHANGED: "audioTrackChanged", JWPLAYER_LOGO_CLICK: "logoClick", JWPLAYER_CAPTIONS_LIST: "captionsList", JWPLAYER_CAPTIONS_CHANGED: "captionsChanged", JWPLAYER_PROVIDER_CHANGED: "providerChanged", JWPLAYER_PROVIDER_FIRST_FRAME: "providerFirstFrame", JWPLAYER_USER_ACTION: "userAction", JWPLAYER_PROVIDER_CLICK: "providerClick", JWPLAYER_VIEW_TAB_FOCUS: "tabFocus", JWPLAYER_CONTROLBAR_DRAGGING: "scrubbing", JWPLAYER_INSTREAM_CLICK: "instreamClick" };return t.touchEvents = e, t;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [], o = function () {
      return { BUFFERING: "buffering", IDLE: "idle", COMPLETE: "complete", PAUSED: "paused", PLAYING: "playing", ERROR: "error", LOADING: "loading", STALLED: "stalled" };
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  },,, function (e, t, n) {
    var i, o;i = [n(1)], o = function (e) {
      function t(e) {
        return !!/[\(,]format=m3u8-/i.test(e) && "m3u8";
      }var n = function n(e) {
        return e.replace(/^\s+|\s+$/g, "");
      },
          i = function i(e, t, n) {
        for (e = "" + e, n = n || "0"; e.length < t;) {
          e = n + e;
        }return e;
      },
          o = function o(e, t) {
        for (var n = 0; n < e.attributes.length; n++) {
          if (e.attributes[n].name && e.attributes[n].name.toLowerCase() === t.toLowerCase()) return e.attributes[n].value.toString();
        }return "";
      },
          r = function r(e) {
        if (!e || "rtmp" === e.substr(0, 4)) return "";var n = t(e);return n ? n : (e = e.split("?")[0].split("#")[0], e.lastIndexOf(".") > -1 ? e.substr(e.lastIndexOf(".") + 1, e.length).toLowerCase() : void 0);
      },
          a = function a(e) {
        var t = parseInt(e / 3600),
            n = parseInt(e / 60) % 60,
            o = e % 60;return i(t, 2) + ":" + i(n, 2) + ":" + i(o.toFixed(3), 6);
      },
          s = function s(t, n) {
        if (e.isNumber(t)) return t;t = t.replace(",", ".");var i = t.split(":"),
            o = i.length,
            r = 0;if ("s" === t.slice(-1)) r = parseFloat(t);else if ("m" === t.slice(-1)) r = 60 * parseFloat(t);else if ("h" === t.slice(-1)) r = 3600 * parseFloat(t);else if (o > 1) {
          var a = o - 1;4 === o && (n && (r = parseFloat(i[a]) / n), a -= 1), r += parseFloat(i[a]), r += 60 * parseFloat(i[a - 1]), o >= 3 && (r += 3600 * parseFloat(i[a - 2]));
        } else r = parseFloat(t);return r;
      },
          l = function l(t, n) {
        return e.map(t, function (e) {
          return n + e;
        });
      },
          c = function c(t, n) {
        return e.map(t, function (e) {
          return e + n;
        });
      };return { trim: n, pad: i, xmlAttribute: o, extension: r, hms: a, seconds: s, suffix: c, prefix: l };
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(3), n(4), n(1), n(2)], o = function (e, t, n, i) {
      function o(e, t) {
        return (/touch/.test(e.type) ? (e.originalEvent || e).changedTouches[0]["page" + t] : e["page" + t]
        );
      }function r(e) {
        var t = e || window.event;return e instanceof MouseEvent && ("which" in t ? 3 === t.which : "button" in t && 2 === t.button);
      }function a(e, t, n) {
        var i;return i = t instanceof MouseEvent || !t.touches && !t.changedTouches ? t : t.touches && t.touches.length ? t.touches[0] : t.changedTouches[0], { type: e, target: t.target, currentTarget: n, pageX: i.pageX, pageY: i.pageY };
      }function s(e) {
        (e instanceof MouseEvent || e instanceof window.TouchEvent) && (e.preventManipulation && e.preventManipulation(), e.cancelable && e.preventDefault && e.preventDefault());
      }var l = !n.isUndefined(window.PointerEvent),
          c = !l && i.isMobile(),
          u = !l && !c,
          d = i.isFF() && i.isOSX(),
          p = function p(e, i) {
        function c(e) {
          (u || l && "touch" !== e.pointerType) && v(t.touchEvents.OVER, e);
        }function p(e) {
          (u || l && "touch" !== e.pointerType) && v(t.touchEvents.MOVE, e);
        }function h(n) {
          (u || l && "touch" !== n.pointerType && !e.contains(document.elementFromPoint(n.x, n.y))) && v(t.touchEvents.OUT, n);
        }function f(t) {
          w = t.target, E = o(t, "X"), k = o(t, "Y"), r(t) || (l ? t.isPrimary && (i.preventScrolling && (y = t.pointerId, e.setPointerCapture(y)), e.addEventListener("pointermove", g), e.addEventListener("pointercancel", m), e.addEventListener("pointerup", m)) : u && (document.addEventListener("mousemove", g), d && "object" === t.target.nodeName.toLowerCase() ? e.addEventListener("click", m) : document.addEventListener("mouseup", m)), w.addEventListener("touchmove", g), w.addEventListener("touchcancel", m), w.addEventListener("touchend", m));
        }function g(e) {
          var n = t.touchEvents,
              r = 6;if (b) v(n.DRAG, e);else {
            var a = o(e, "X"),
                l = o(e, "Y"),
                c = a - E,
                u = l - k;c * c + u * u > r * r && (v(n.DRAG_START, e), b = !0, v(n.DRAG, e));
          }i.preventScrolling && s(e);
        }function m(n) {
          var o = t.touchEvents;l ? (i.preventScrolling && e.releasePointerCapture(y), e.removeEventListener("pointermove", g), e.removeEventListener("pointercancel", m), e.removeEventListener("pointerup", m)) : u && (document.removeEventListener("mousemove", g), document.removeEventListener("mouseup", m)), w.removeEventListener("touchmove", g), w.removeEventListener("touchcancel", m), w.removeEventListener("touchend", m), b ? v(o.DRAG_END, n) : i.directSelect && n.target !== e || n.type.indexOf("cancel") !== -1 || (l && n instanceof window.PointerEvent ? "touch" === n.pointerType ? v(o.TAP, n) : v(o.CLICK, n) : u ? v(o.CLICK, n) : (v(o.TAP, n), s(n))), w = null, b = !1;
        }function v(e, o) {
          var r;if (i.enableDoubleTap && (e === t.touchEvents.CLICK || e === t.touchEvents.TAP)) if (n.now() - L < _) {
            var s = e === t.touchEvents.CLICK ? t.touchEvents.DOUBLE_CLICK : t.touchEvents.DOUBLE_TAP;r = a(s, o, j), A.trigger(s, r), L = 0;
          } else L = n.now();r = a(e, o, j), A.trigger(e, r);
        }var w,
            y,
            j = e,
            b = !1,
            E = 0,
            k = 0,
            L = 0,
            _ = 300;i = i || {}, l ? (e.addEventListener("pointerdown", f), i.useHover && (e.addEventListener("pointerover", c), e.addEventListener("pointerout", h)), i.useMove && e.addEventListener("pointermove", p)) : u && (e.addEventListener("mousedown", f), i.useHover && (e.addEventListener("mouseover", c), e.addEventListener("mouseout", h)), i.useMove && e.addEventListener("mousemove", p)), e.addEventListener("touchstart", f);var A = this;return this.triggerEvent = v, this.destroy = function () {
          e.removeEventListener("touchstart", f), e.removeEventListener("mousedown", f), w && (w.removeEventListener("touchmove", g), w.removeEventListener("touchcancel", m), w.removeEventListener("touchend", m)), l && (i.preventScrolling && e.releasePointerCapture(y), e.removeEventListener("pointerover", c), e.removeEventListener("pointerdown", f), e.removeEventListener("pointermove", g), e.removeEventListener("pointermove", p), e.removeEventListener("pointercancel", m), e.removeEventListener("pointerout", h), e.removeEventListener("pointerup", m)), e.removeEventListener("click", m), e.removeEventListener("mouseover", c), e.removeEventListener("mousemove", p), e.removeEventListener("mouseout", h), document.removeEventListener("mousemove", g), document.removeEventListener("mouseup", m);
        }, this;
      };return n.extend(p.prototype, e), p;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  },, function (e, t, n) {
    e.exports = n(141)["default"];
  }, function (e, t) {
    "use strict";
    function n(e) {
      return u[e];
    }function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        for (var n in arguments[t]) {
          Object.prototype.hasOwnProperty.call(arguments[t], n) && (e[n] = arguments[t][n]);
        }
      }return e;
    }function o(e, t) {
      for (var n = 0, i = e.length; n < i; n++) {
        if (e[n] === t) return n;
      }return -1;
    }function r(e) {
      if ("string" != typeof e) {
        if (e && e.toHTML) return e.toHTML();if (null == e) return "";if (!e) return e + "";e = "" + e;
      }return p.test(e) ? e.replace(d, n) : e;
    }function a(e) {
      return !e && 0 !== e || !(!g(e) || 0 !== e.length);
    }function s(e) {
      var t = i({}, e);return t._parent = e, t;
    }function l(e, t) {
      return e.path = t, e;
    }function c(e, t) {
      return (e ? e + "." : "") + t;
    }t.__esModule = !0, t.extend = i, t.indexOf = o, t.escapeExpression = r, t.isEmpty = a, t.createFrame = s, t.blockParams = l, t.appendContextPath = c;var u = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#x27;", "`": "&#x60;", "=": "&#x3D;" },
        d = /[&<>"'`=]/g,
        p = /[&<>"'`=]/,
        h = Object.prototype.toString;t.toString = h;var f = function f(e) {
      return "function" == typeof e;
    };f(/x/) && (t.isFunction = f = function f(e) {
      return "function" == typeof e && "[object Function]" === h.call(e);
    }), t.isFunction = f;var g = Array.isArray || function (e) {
      return !(!e || "object" != (typeof e === "undefined" ? "undefined" : _typeof(e))) && "[object Array]" === h.call(e);
    };t.isArray = g;
  },, function (e, t, n) {
    var i, o;i = [n(8)], o = function (e) {
      return { localName: function localName(e) {
          return e ? e.localName ? e.localName : e.baseName ? e.baseName : "" : "";
        }, textContent: function textContent(t) {
          return t ? t.textContent ? e.trim(t.textContent) : t.text ? e.trim(t.text) : "" : "";
        }, getChildNode: function getChildNode(e, t) {
          return e.childNodes[t];
        }, numChildren: function numChildren(e) {
          return e.childNodes ? e.childNodes.length : 0;
        } };
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  },,,,, function (e, t, n) {
    var i, o;i = [n(2), n(8)], o = function (e, t) {
      function n(e) {
        var t = {},
            n = e.split("\r\n");1 === n.length && (n = e.split("\n"));var o = 1;if (n[0].indexOf(" --> ") > 0 && (o = 0), n.length > o + 1 && n[o + 1]) {
          var r = n[o],
              a = r.indexOf(" --> ");a > 0 && (t.begin = i(r.substr(0, a)), t.end = i(r.substr(a + 5)), t.text = n.slice(o + 1).join("\r\n"));
        }return t;
      }var i = e.seconds;return function (e) {
        var i = [];e = t.trim(e);var o = e.split("\r\n\r\n");1 === o.length && (o = e.split("\n\n"));for (var r = 0; r < o.length; r++) {
          if ("WEBVTT" !== o[r]) {
            var a = n(o[r]);a.text && i.push(a);
          }
        }return i;
      };
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(2), n(4), n(5), n(1)], o = function (e, t, n, i) {
      var o = e.noop,
          r = i.constant(!1),
          a = { supports: r, play: o, load: o, stop: o, volume: o, mute: o, seek: o, resize: o, remove: o, destroy: o, setVisibility: o, setFullscreen: r, getFullscreen: o, getContainer: o, setContainer: r, getName: o, getQualityLevels: o, getCurrentQuality: o, setCurrentQuality: o, getAudioTracks: o, getCurrentAudioTrack: o, setCurrentAudioTrack: o, checkComplete: o, setControls: o, attachMedia: o, detachMedia: o, setState: function setState(e) {
          var i = this.state || n.IDLE;this.state = e, e !== i && this.trigger(t.JWPLAYER_PLAYER_STATE, { newstate: e });
        }, sendMediaType: function sendMediaType(e) {
          var n = e[0].type,
              i = "oga" === n || "aac" === n || "mp3" === n || "mpeg" === n || "vorbis" === n;this.trigger(t.JWPLAYER_MEDIA_TYPE, { mediaType: i ? "audio" : "video" });
        } };return a;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(1)], o = function (e) {
      var t = {},
          n = { TIT2: "title", TT2: "title", WXXX: "url", TPE1: "artist", TP1: "artist", TALB: "album", TAL: "album" };return t.utf8ArrayToStr = function (e, t) {
        var n, i, o, r, a, s;for (n = "", o = e.length, i = t || 0; i < o;) {
          if (r = e[i++], 0 !== r && 3 !== r) switch (r >> 4) {case 0:case 1:case 2:case 3:case 4:case 5:case 6:case 7:
              n += String.fromCharCode(r);break;case 12:case 13:
              a = e[i++], n += String.fromCharCode((31 & r) << 6 | 63 & a);break;case 14:
              a = e[i++], s = e[i++], n += String.fromCharCode((15 & r) << 12 | (63 & a) << 6 | (63 & s) << 0);}
        }return n;
      }, t.utf16BigEndianArrayToStr = function (e, t) {
        var n, i, o;for (n = "", o = e.length - 1, i = t || 0; i < o;) {
          254 === e[i] && 255 === e[i + 1] || (n += String.fromCharCode((e[i] << 8) + e[i + 1])), i += 2;
        }return n;
      }, t.syncSafeInt = function (e) {
        var n = t.arrayToInt(e);return 127 & n | (32512 & n) >> 1 | (8323072 & n) >> 2 | (2130706432 & n) >> 3;
      }, t.arrayToInt = function (e) {
        for (var t = "0x", n = 0; n < e.length; n++) {
          t += e[n].toString(16);
        }return parseInt(t);
      }, t.parseID3 = function (i) {
        return e.reduce(i, function (i, o) {
          if (!("value" in o) && "data" in o && o.data instanceof ArrayBuffer) {
            var r = o,
                a = new Uint8Array(r.data),
                s = a.length;o = { value: { key: "", data: "" } };for (var l = 10; l < 14 && l < a.length && 0 !== a[l];) {
              o.value.key += String.fromCharCode(a[l]), l++;
            }var c = 19,
                u = a[c];3 !== u && 0 !== u || (u = a[++c], s--);var d = 0;if (1 !== u && 2 !== u) for (var p = c + 1; p < s; p++) {
              if (0 === a[p]) {
                d = p - c;break;
              }
            }if (d > 0) {
              var h = t.utf8ArrayToStr(a.subarray(c, c += d), 0);if ("PRIV" === o.value.key) {
                if ("com.apple.streaming.transportStreamTimestamp" === h) {
                  var f = 1 & t.syncSafeInt(a.subarray(c, c += 4)),
                      g = t.syncSafeInt(a.subarray(c, c += 4));f && (g += 4294967296), o.value.data = g;
                } else o.value.data = t.utf8ArrayToStr(a, c + 1);o.value.info = h;
              } else o.value.info = h, o.value.data = t.utf8ArrayToStr(a, c + 1);
            } else {
              var m = a[c];1 === m || 2 === m ? o.value.data = t.utf16BigEndianArrayToStr(a, c + 1) : o.value.data = t.utf8ArrayToStr(a, c + 1);
            }
          }if (n.hasOwnProperty(o.value.key) && (i[n[o.value.key]] = o.value.data), o.value.info) {
            var v = i[o.value.key];e.isObject(v) || (v = {}, i[o.value.key] = v), v[o.value.info] = o.value.data;
          } else i[o.value.key] = o.value.data;return i;
        }, {});
      }, t;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(4), n(3), n(1)], o = function (e, t, n) {
      var i = {},
          o = { NEW: 0, LOADING: 1, ERROR: 2, COMPLETE: 3 },
          r = function r(_r, a) {
        function s(t) {
          u = o.ERROR, c.trigger(e.ERROR, t);
        }function l(t) {
          u = o.COMPLETE, c.trigger(e.COMPLETE, t);
        }var c = n.extend(this, t),
            u = o.NEW;this.addEventListener = this.on, this.removeEventListener = this.off, this.makeStyleLink = function (e) {
          var t = document.createElement("link");return t.type = "text/css", t.rel = "stylesheet", t.href = e, t;
        }, this.makeScriptTag = function (e) {
          var t = document.createElement("script");return t.src = e, t;
        }, this.makeTag = a ? this.makeStyleLink : this.makeScriptTag, this.load = function () {
          if (u === o.NEW) {
            var t = i[_r];if (t && (u = t.getStatus(), u < 2)) return t.on(e.ERROR, s), void t.on(e.COMPLETE, l);var n = document.getElementsByTagName("head")[0] || document.documentElement,
                c = this.makeTag(_r),
                d = !1;c.onload = c.onreadystatechange = function (e) {
              d || this.readyState && "loaded" !== this.readyState && "complete" !== this.readyState || (d = !0, l(e), c.onload = c.onreadystatechange = null, n && c.parentNode && !a && n.removeChild(c));
            }, c.onerror = s, n.insertBefore(c, n.firstChild), u = o.LOADING, i[_r] = this;
          }
        }, this.getStatus = function () {
          return u;
        };
      };return r.loaderstatus = o, r;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(1)], o = function (e) {
      var t = "free",
          n = "premium",
          i = "enterprise",
          o = "platinum",
          r = "ads",
          a = "unlimited",
          s = "trial",
          l = { setup: [t, n, i, r, a, s, o], dash: [n, i, r, a, s, o], drm: [i, r, a, s], hls: [n, r, i, a, s, o], ads: [r, a, s, o, i], casting: [n, i, r, a, s, o], jwpsrv: [t, n, i, r, s, o] },
          c = function c(t) {
        return function (n) {
          return e.contains(l[n], t);
        };
      };return c;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  },,, function (e, t) {
    "use strict";
    function n(e, t) {
      var o = t && t.loc,
          r = void 0,
          a = void 0;o && (r = o.start.line, a = o.start.column, e += " - " + r + ":" + a);for (var s = Error.prototype.constructor.call(this, e), l = 0; l < i.length; l++) {
        this[i[l]] = s[i[l]];
      }Error.captureStackTrace && Error.captureStackTrace(this, n), o && (this.lineNumber = r, this.column = a);
    }t.__esModule = !0;var i = ["description", "fileName", "lineNumber", "message", "name", "number", "stack"];n.prototype = new Error(), t["default"] = n, e.exports = t["default"];
  }, function (e, t, n) {
    var i, o;i = [n(174), n(175), n(67), n(33)], o = function (e, t, n, i) {
      var o = {},
          r = {},
          a = function a(n, i) {
        return r[n] = new e(new t(o), i), r[n];
      },
          s = function s(e, t, r, a) {
        var s = i.getPluginName(e);o[s] || (o[s] = new n(e)), o[s].registerPlugin(e, t, r, a);
      };return { loadPlugins: a, registerPlugin: s };
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [], o = function () {
      return { repo: "http://ssl.p.jwpcdn.com/player/v/", SkinsIncluded: ["seven"], SkinsLoadable: ["beelden", "bekle", "five", "glow", "roundster", "six", "stormtrooper", "vapor"], dvrSeekLimit: -25 };
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(8), n(84)], o = function (e, t) {
      function n(e) {
        e = e.split("-");for (var t = 1; t < e.length; t++) {
          e[t] = e[t].charAt(0).toUpperCase() + e[t].slice(1);
        }return e.join("");
      }function i(t, n, i) {
        if ("" === n || void 0 === n || null === n) return "";var o = i ? " !important" : "";return "string" == typeof n && isNaN(n) ? /png|gif|jpe?g/i.test(n) && n.indexOf("url") < 0 ? "url(" + n + ")" : n + o : 0 === n || "z-index" === t || "opacity" === t ? "" + n + o : /color/i.test(t) ? "#" + e.pad(n.toString(16).replace(/^0x/i, ""), 6) + o : Math.ceil(n) + "px" + o;
      }var o = function o(e, n, i) {
        i = i || "all-players";var o = "";if ("object" == (typeof n === "undefined" ? "undefined" : _typeof(n))) {
          var a = document.createElement("div");r(a, n), o = "{" + a.style.cssText + "}";
        } else "string" == typeof n && (o = n);t.style([[e, e + o]], i);
      },
          r = function r(e, t) {
        if (void 0 !== e && null !== e) {
          void 0 === e.length && (e = [e]);var o,
              r = {};for (o in t) {
            r[o] = i(o, t[o]);
          }for (var a = 0; a < e.length; a++) {
            var s,
                l = e[a];if (void 0 !== l && null !== l) for (o in r) {
              s = n(o), l.style[s] !== r[o] && (l.style[s] = r[o]);
            }
          }
        }
      },
          a = function a(e, t) {
        r(e, { transform: t, webkitTransform: t, msTransform: t, mozTransform: t, oTransform: t });
      },
          s = function s(e, t) {
        var n = "rgb";e ? (e = String(e).replace("#", ""), 3 === e.length && (e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2])) : e = "000000";var i = [parseInt(e.substr(0, 2), 16), parseInt(e.substr(2, 2), 16), parseInt(e.substr(4, 2), 16)];return void 0 !== t && 100 !== t && (n += "a", i.push(t / 100)), n + "(" + i.join(",") + ")";
      };return { css: o, style: r, clearCss: t.clear, transform: a, hexToRgba: s };
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [], o = function () {
      return "7.6.0+commercial_v7-6-0.115.commercial.4cac33.jwplayer.640afe.googima.2587ed.vast.23d1fc.analytics.213ba9.plugin-gapro.6c22bd.plugin-related.2814b7.plugin-sharing.135631";
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(77), n(2)], o = function (e, t) {
      var n = e.extend({ constructor: function constructor(e, t, n) {
          this.el = document.createElement("div"), this.el.className = "jw-icon jw-icon-tooltip " + e + " jw-button-color jw-reset jw-hidden", t && (this.el.setAttribute("tabindex", "0"), this.el.setAttribute("role", "button"), this.el.setAttribute("aria-label", t)), n === !0 ? this.el.setAttribute("aria-hidden", "false") : this.el.setAttribute("aria-hidden", "true"), this.container = document.createElement("div"), this.container.className = "jw-overlay jw-reset", this.openClass = "jw-open", this.componentType = "tooltip", this.el.appendChild(this.container);
        }, addContent: function addContent(e) {
          this.content && this.removeContent(), this.content = e, this.container.appendChild(e);
        }, removeContent: function removeContent() {
          this.content && (this.container.removeChild(this.content), this.content = null);
        }, hasContent: function hasContent() {
          return !!this.content;
        }, element: function element() {
          return this.el;
        }, openTooltip: function openTooltip(e) {
          this.trigger("open-" + this.componentType, e, { isOpen: !0 }), this.isOpen = !0, t.toggleClass(this.el, this.openClass, this.isOpen);
        }, closeTooltip: function closeTooltip(e) {
          this.trigger("close-" + this.componentType, e, { isOpen: !1 }), this.isOpen = !1, t.toggleClass(this.el, this.openClass, this.isOpen);
        }, toggleOpenState: function toggleOpenState(e) {
          this.isOpen ? this.closeTooltip(e) : this.openTooltip(e);
        } });return n;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(2), n(49), n(167), n(1), n(3), n(182), n(4), n(5)], o = function (e, t, n, i, o, r, a, s) {
      var l = function l() {
        function r(e, t) {
          var n = i.extend({}, t, { type: e });switch (e) {case "flashThrottle":
              var o = "resume" !== t.state;this.set("flashThrottle", o), this.set("flashBlocked", o);break;case "flashBlocked":
              return void this.set("flashBlocked", !0);case "flashUnblocked":
              return void this.set("flashBlocked", !1);case "volume":case "mute":
              return void this.set(e, t[e]);case a.JWPLAYER_MEDIA_TYPE:
              return void (this.mediaModel.get("mediaType") !== t.mediaType && (this.mediaModel.set("mediaType", t.mediaType), this.mediaController.trigger(e, n)));case a.JWPLAYER_PLAYER_STATE:
              return void this.mediaModel.set("state", t.newstate);case a.JWPLAYER_MEDIA_BUFFER:
              this.set("buffer", t.bufferPercent);case a.JWPLAYER_MEDIA_META:
              var r = t.duration;i.isNumber(r) && (this.mediaModel.set("duration", r), this.set("duration", r));break;case a.JWPLAYER_MEDIA_BUFFER_FULL:
              this.mediaModel.get("playAttempt") ? this.playVideo() : this.mediaModel.on("change:playAttempt", function () {
                this.playVideo();
              }, this);break;case a.JWPLAYER_MEDIA_TIME:
              this.mediaModel.set("position", t.position), this.set("position", t.position), i.isNumber(t.duration) && (this.mediaModel.set("duration", t.duration), this.set("duration", t.duration));break;case a.JWPLAYER_PROVIDER_CHANGED:
              this.set("provider", u.getName());break;case a.JWPLAYER_MEDIA_LEVELS:
              this.setQualityLevel(t.currentQuality, t.levels), this.mediaModel.set("levels", t.levels);break;case a.JWPLAYER_MEDIA_LEVEL_CHANGED:
              this.setQualityLevel(t.currentQuality, t.levels), this.persistQualityLevel(t.currentQuality, t.levels);break;case a.JWPLAYER_AUDIO_TRACKS:
              this.setCurrentAudioTrack(t.currentTrack, t.tracks), this.mediaModel.set("audioTracks", t.tracks);break;case a.JWPLAYER_AUDIO_TRACK_CHANGED:
              this.setCurrentAudioTrack(t.currentTrack, t.tracks);break;case "subtitlesTrackChanged":
              this.setVideoSubtitleTrack(t.currentTrack, t.tracks);break;case "visualQuality":
              var s = i.extend({}, t);this.mediaModel.set("visualQuality", s);}this.mediaController.trigger(e, n);
        }var l,
            u,
            d = this,
            p = e.noop;this.mediaController = i.extend({}, o), this.mediaModel = new c(), n.model(this), this.set("mediaModel", this.mediaModel), this.setup = function (t) {
          return i.extend(this.attributes, t, { item: 0, state: s.IDLE, flashBlocked: !1, fullscreen: !1, compactUI: !1, scrubbing: !1, duration: 0, position: 0, buffer: 0 }), e.isMobile() && !t.mobileSdk && this.set("autostart", !1), this.updateProviders(), this;
        }, this.getConfiguration = function () {
          return i.omit(this.clone(), ["mediaModel"]);
        }, this.updateProviders = function () {
          l = new t(this.getConfiguration());
        }, this.setQualityLevel = function (e, t) {
          e > -1 && t.length > 1 && "youtube" !== u.getName().name && this.mediaModel.set("currentLevel", parseInt(e));
        }, this.persistQualityLevel = function (e, t) {
          var n = t[e] || {},
              i = n.label;this.set("qualityLabel", i);
        }, this.setCurrentAudioTrack = function (e, t) {
          e > -1 && t.length > 0 && e < t.length && this.mediaModel.set("currentAudioTrack", parseInt(e));
        }, this.onMediaContainer = function () {
          var e = this.get("mediaContainer");p.setContainer(e);
        }, this.changeVideoProvider = function (e) {
          if (this.off("change:mediaContainer", this.onMediaContainer), u && (u.off(null, null, this), u.getContainer() && u.remove()), !e) return u = p = e, void this.set("provider", void 0);p = new e(d.get("id"), d.getConfiguration());var t = this.get("mediaContainer");t ? p.setContainer(t) : this.once("change:mediaContainer", this.onMediaContainer), this.set("provider", p.getName()), p.getName().name.indexOf("flash") === -1 && (this.set("flashThrottle", void 0), this.set("flashBlocked", !1)), u = p, u.volume(d.get("volume")), u.mute(d.get("mute")), u.on("all", r, this);
        }, this.destroy = function () {
          this.off(), u && (u.off(null, null, this), u.destroy());
        }, this.getVideo = function () {
          return u;
        }, this.setFullscreen = function (e) {
          e = !!e, e !== d.get("fullscreen") && d.set("fullscreen", e);
        }, this.chooseProvider = function (e) {
          return l.choose(e).provider;
        }, this.setItemIndex = function (e) {
          var t = this.get("playlist");e = parseInt(e, 10) || 0, e = (e + t.length) % t.length, this.set("item", e), this.set("playlistItem", t[e]), this.setActiveItem(t[e]);
        }, this.setActiveItem = function (e) {
          this.mediaModel.off(), this.mediaModel = new c(), this.set("mediaModel", this.mediaModel), this.set("position", e.starttime || 0), this.set("duration", e.duration || 0), this.setProvider(e);
        }, this.setProvider = function (e) {
          var t = e && e.sources && e.sources[0];if (void 0 !== t) {
            var n = this.chooseProvider(t);n && p instanceof n || d.changeVideoProvider(n), p && (p.init && p.init(e), this.trigger("itemReady", e));
          }
        }, this.getProviders = function () {
          return l;
        }, this.resetProvider = function () {
          p = null;
        }, this.setVolume = function (e) {
          e = Math.round(e), this.set("volume", e), u && u.volume(e);var t = 0 === e;t !== this.get("mute") && this.setMute(t);
        }, this.setMute = function (t) {
          if (e.exists(t) || (t = !this.get("mute")), this.set("mute", t), u && u.mute(t), !t) {
            var n = Math.max(10, this.get("volume"));this.setVolume(n);
          }
        }, this.loadVideo = function (e) {
          if (!e) {
            var t = this.get("item");e = this.get("playlist")[t];
          }this.set("position", e.starttime || 0), this.set("duration", e.duration || 0), this.mediaModel.set("playAttempt", !0), this.mediaController.trigger(a.JWPLAYER_MEDIA_PLAY_ATTEMPT, { playReason: this.get("playReason") }), u.load(e);
        }, this.stopVideo = function () {
          u && u.stop();
        }, this.playVideo = function () {
          u.play();
        }, this.persistCaptionsTrack = function () {
          var e = this.get("captionsTrack");e ? this.set("captionLabel", e.label) : this.set("captionLabel", "Off");
        }, this.setVideoSubtitleTrack = function (e, t) {
          this.set("captionsIndex", e), e && t && e <= t.length && t[e - 1].data && this.set("captionsTrack", t[e - 1]), u && u.setSubtitlesTrack && u.setSubtitlesTrack(e);
        }, this.persistVideoSubtitleTrack = function (e) {
          this.setVideoSubtitleTrack(e), this.persistCaptionsTrack();
        };
      },
          c = l.MediaModel = function () {
        this.set("state", s.IDLE);
      };return i.extend(l.prototype, r), i.extend(c.prototype, r), l;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(8)], o = function (e) {
      var t = {},
          n = t.pluginPathType = { ABSOLUTE: 0, RELATIVE: 1, CDN: 2 };return t.getPluginPathType = function (t) {
        if ("string" == typeof t) {
          t = t.split("?")[0];var i = t.indexOf("://");if (i > 0) return n.ABSOLUTE;var o = t.indexOf("/"),
              r = e.extension(t);return !(i < 0 && o < 0) || r && isNaN(r) ? n.RELATIVE : n.CDN;
        }
      }, t.getPluginName = function (e) {
        return e.replace(/^(.*\/)?([^-]*)-?.*\.(swf|js)$/, "$2");
      }, t.getPluginVersion = function (e) {
        return e.replace(/[^-]*-?([^\.]*).*$/, "$1");
      }, t;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [], o = function () {
      var e = window.chrome,
          t = {};return t.NS = "urn:x-cast:com.longtailvideo.jwplayer", t.debug = !1, t.availability = null, t.available = function (n) {
        n = n || t.availability;var i = "available";return e && e.cast && e.cast.ReceiverAvailability && (i = e.cast.ReceiverAvailability.AVAILABLE), n === i;
      }, t.log = function () {
        if (t.debug) {
          var e = Array.prototype.slice.call(arguments, 0);console.log.apply(console, e);
        }
      }, t.error = function () {
        var e = Array.prototype.slice.call(arguments, 0);console.error.apply(console, e);
      }, t;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  },,,,,,, function (e, t, n) {
    var i, o;i = [n(5)], o = function (e) {
      function t(t) {
        return t === e.COMPLETE || t === e.ERROR ? e.IDLE : t;
      }return function (e, n, i) {
        if (n = t(n), i = t(i), n !== i) {
          var o = n.replace(/(?:ing|d)$/, ""),
              r = { type: o, newstate: n, oldstate: i, reason: e.mediaModel.get("state") };"play" === o && (r.playReason = e.get("playReason")), this.trigger(o, r);
        }
      };
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(1), n(66), n(173)], o = function (e, t, n) {
      var i = { sources: [], tracks: [] },
          o = function o(_o) {
        _o = _o || {}, e.isArray(_o.tracks) || delete _o.tracks;var r = e.extend({}, i, _o);e.isObject(r.sources) && !e.isArray(r.sources) && (r.sources = [t(r.sources)]), e.isArray(r.sources) && 0 !== r.sources.length || (_o.levels ? r.sources = _o.levels : r.sources = [t(_o)]);for (var a = 0; a < r.sources.length; a++) {
          var s = r.sources[a];if (s) {
            var l = s["default"];l ? s["default"] = "true" === l.toString() : s["default"] = !1, r.sources[a].label || (r.sources[a].label = a.toString()), r.sources[a] = t(r.sources[a]);
          }
        }return r.sources = e.compact(r.sources), e.isArray(r.tracks) || (r.tracks = []), e.isArray(r.captions) && (r.tracks = r.tracks.concat(r.captions), delete r.captions), r.tracks = e.compact(e.map(r.tracks, n)), r;
      };return o;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(1), n(44)], o = function (e, t) {
      function n(e) {
        return (/^(?:(?:https?|file)\:)?\/\//.test(e)
        );
      }function i(t) {
        return e.some(t, function (e) {
          return "parsererror" === e.nodeName;
        });
      }var o = {};return o.getAbsolutePath = function (e, i) {
        if (t.exists(i) || (i = document.location.href), t.exists(e)) {
          if (n(e)) return e;var o,
              r = i.substring(0, i.indexOf("://") + 3),
              a = i.substring(r.length, i.indexOf("/", r.length + 1));if (0 === e.indexOf("/")) o = e.split("/");else {
            var s = i.split("?")[0];s = s.substring(r.length + a.length + 1, s.lastIndexOf("/")), o = s.split("/").concat(e.split("/"));
          }for (var l = [], c = 0; c < o.length; c++) {
            o[c] && t.exists(o[c]) && "." !== o[c] && (".." === o[c] ? l.pop() : l.push(o[c]));
          }return r + a + "/" + l.join("/");
        }
      }, o.getScriptPath = e.memoize(function (e) {
        for (var t = document.getElementsByTagName("script"), n = 0; n < t.length; n++) {
          var i = t[n].src;if (i && i.indexOf(e) >= 0) return i.substr(0, i.indexOf(e));
        }return "";
      }), o.parseXML = function (e) {
        var t = null;try {
          "DOMParser" in window ? (t = new window.DOMParser().parseFromString(e, "text/xml"), (i(t.childNodes) || t.childNodes && i(t.childNodes[0].childNodes)) && (t = null)) : (t = new window.ActiveXObject("Microsoft.XMLDOM"), t.async = "false", t.loadXML(e));
        } catch (n) {}return t;
      }, o.serialize = function (e) {
        if (void 0 === e) return null;if ("string" == typeof e && e.length < 6) {
          var t = e.toLowerCase();if ("true" === t) return !0;if ("false" === t) return !1;if (!isNaN(Number(e)) && !isNaN(parseFloat(e))) return Number(e);
        }return e;
      }, o.parseDimension = function (e) {
        return "string" == typeof e ? "" === e ? 0 : e.lastIndexOf("%") > -1 ? e : parseInt(e.replace("px", ""), 10) : e;
      }, o.timeFormat = function (e, t) {
        if (e <= 0 && !t) return "00:00";var n = e < 0 ? "-" : "";e = Math.abs(e);var i = Math.floor(e / 3600),
            o = Math.floor((e - 3600 * i) / 60),
            r = Math.floor(e % 60);return n + (i ? i + ":" : "") + (o < 10 ? "0" : "") + o + ":" + (r < 10 ? "0" : "") + r;
      }, o.adaptiveType = function (e) {
        if (0 !== e) {
          var t = -120;if (e <= t) return "DVR";if (e < 0 || e === 1 / 0) return "LIVE";
        }return "VOD";
      }, o;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(1)], o = function (e) {
      var t = {};return t.exists = function (e) {
        switch (typeof e === "undefined" ? "undefined" : _typeof(e)) {case "string":
            return e.length > 0;case "object":
            return null !== e;case "undefined":
            return !1;}return !0;
      }, t.isHTTPS = function () {
        return 0 === window.location.href.indexOf("https");
      }, t.isRtmp = function (e, t) {
        return 0 === e.indexOf("rtmp") || "rtmp" === t;
      }, t.isYouTube = function (e, t) {
        return "youtube" === t || /^(http|\/\/).*(youtube\.com|youtu\.be)\/.+/.test(e);
      }, t.youTubeID = function (e) {
        var t = /v[=\/]([^?&]*)|youtu\.be\/([^?]*)|^([\w-]*)$/i.exec(e);return t ? t.slice(1).join("").replace("?", "") : "";
      }, t.typeOf = function (t) {
        if (null === t) return "null";var n = typeof t === "undefined" ? "undefined" : _typeof(t);return "object" === n && e.isArray(t) ? "array" : n;
      }, t;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(77), n(9), n(139), n(2)], o = function (e, t, n, i) {
      var o = e.extend({ constructor: function constructor(e, t) {
          this.className = e + " jw-background-color jw-reset", this.orientation = t, this.dragStartListener = this.dragStart.bind(this), this.dragMoveListener = this.dragMove.bind(this), this.dragEndListener = this.dragEnd.bind(this), this.tapListener = this.tap.bind(this), this.setup();
        }, setup: function setup() {
          var e = { "default": this["default"], className: this.className, orientation: "jw-slider-" + this.orientation };this.el = i.createElement(n(e)), this.elementRail = this.el.getElementsByClassName("jw-slider-container")[0], this.elementBuffer = this.el.getElementsByClassName("jw-buffer")[0], this.elementProgress = this.el.getElementsByClassName("jw-progress")[0], this.elementThumb = this.el.getElementsByClassName("jw-knob")[0], this.userInteract = new t(this.element(), { preventScrolling: !0 }), this.userInteract.on("dragStart", this.dragStartListener), this.userInteract.on("drag", this.dragMoveListener), this.userInteract.on("dragEnd", this.dragEndListener), this.userInteract.on("tap click", this.tapListener);
        }, dragStart: function dragStart() {
          this.trigger("dragStart"), this.railBounds = i.bounds(this.elementRail);
        }, dragEnd: function dragEnd(e) {
          this.dragMove(e), this.trigger("dragEnd");
        }, dragMove: function dragMove(e) {
          var t,
              n,
              o = this.railBounds = this.railBounds ? this.railBounds : i.bounds(this.elementRail);"horizontal" === this.orientation ? (t = e.pageX, n = t < o.left ? 0 : t > o.right ? 100 : 100 * i.between((t - o.left) / o.width, 0, 1)) : (t = e.pageY, n = t >= o.bottom ? 0 : t <= o.top ? 100 : 100 * i.between((o.height - (t - o.top)) / o.height, 0, 1));var r = this.limit(n);return this.render(r), this.update(r), !1;
        }, tap: function tap(e) {
          this.railBounds = i.bounds(this.elementRail), this.dragMove(e);
        }, limit: function limit(e) {
          return e;
        }, update: function update(e) {
          this.trigger("update", { percentage: e });
        }, render: function render(e) {
          e = Math.max(0, Math.min(e, 100)), "horizontal" === this.orientation ? (this.elementThumb.style.left = e + "%", this.elementProgress.style.width = e + "%") : (this.elementThumb.style.bottom = e + "%", this.elementProgress.style.height = e + "%");
        }, updateBuffer: function updateBuffer(e) {
          this.elementBuffer.style.width = e + "%";
        }, element: function element() {
          return this.el;
        } });return o;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  },, function (e, t, n) {
    var i, o;i = [n(1), n(23)], o = function (e, t) {
      var n = [{ configName: "clearkey", keyName: "org.w3.clearkey" }, { configName: "widevine", keyName: "com.widevine.alpha" }, { configName: "playready", keyName: "com.microsoft.playready" }],
          i = [],
          o = {},
          r = function r(t) {
        var n = t.get("playlist");return !!t.get("drm") || e.some(n, function (t) {
          return !!t.drm || e.some(t.sources, function (e) {
            return !!e.drm;
          });
        });
      },
          a = function a(t) {
        return u() ? t() : (e.forEach(n, function (e) {
          var t = navigator.requestMediaKeySystemAccess(e.keyName, [{}]).then(function () {
            o[e.configName] = !0;
          })["catch"](function () {
            o[e.configName] = !1;
          });i.push(t);
        }), Promise.all(i).then(t));
      },
          s = function s() {
        return !!navigator.requestMediaKeySystemAccess && !!MediaKeySystemAccess.prototype.getConfiguration;
      },
          l = function l(e) {
        return o[e];
      },
          c = function c(t) {
        u() || console.error('DRM only supported with "drm" block in initial setup.', t);var n = e.keys(t);return e.some(n, function (e) {
          return l(e);
        });
      },
          u = function u() {
        return !!i.length;
      };return { containsDrm: r, probe: function probe(e, n) {
          s() && t(n)("drm") ? a(e) : e();
        }, probed: u, anySupported: c, isSupported: l };
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(75), n(23), n(1), n(178), n(47)], o = function (e, t, n, i, o) {
      function r(i, r) {
        if (e.isSafari()) return !1;var a = t(r);if (!a("dash")) return !1;if (i.drm && !o.anySupported(i.drm)) return !1;var s = window.MediaSource;if (!window.HTMLVideoElement || !s) return !1;var l = !0;return i.mediaTypes && (l = n.all(i.mediaTypes, function (e) {
          return s.isTypeSupported(e);
        })), l && ("dash" === i.type || "mpd" === i.type || (i.file || "").indexOf("mpd-time-csf") > -1);
      }var a = n.find(i, n.matches({ name: "flash" })),
          s = a.supports;a.supports = function (n, i) {
        if (!e.isFlashSupported()) return !1;var o = n && n.type;if ("hls" === o || "m3u8" === o) {
          var r = t(i);return r("hls");
        }return s.apply(this, arguments);
      };var l = n.find(i, n.matches({ name: "html5" })),
          c = l.supports;return l.supports = function (e, n) {
        var i = c.apply(this, arguments);if (i && e.drm) {
          var o = t(n);return o("drm");
        }return i;
      }, i.push({ name: "shaka", supports: r }), i.push({ name: "caterpillar", supports: function supports(n, i) {
          if (e.isChrome() && !e.isMobile()) {
            var o = n && n.type,
                r = n && n.file;if (r.indexOf(".m3u8") > -1 || "hls" === o || "m3u8" === o) {
              var a = t(i);return a("hls");
            }
          }
        } }), i;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(179), n(1), n(48)], o = function (e, t) {
      var i,
          o = e.registerProvider,
          r = e.prototype.reorderProviders;return t.extend(e.loaders, { caterpillar: function caterpillar(e) {
          n.e(1, function (require) {
            var t = n(87);t.setEdition && t.setEdition(i), o(t), e(t);
          });
        }, shaka: function shaka(e) {
          n.e(2, function (require) {
            var t = n(89);o(t), e(t);
          });
        } }), t.extend(e.prototype, { reorderProviders: function reorderProviders() {
          if (r.apply(this), "flash" !== this.config.primary && this.config.hlshtml === !0) {
            var e = t.indexOf(this.providers, t.findWhere(this.providers, { name: "caterpillar" })),
                n = this.providers.splice(e, 1)[0],
                i = t.indexOf(this.providers, t.findWhere(this.providers, { name: "flash" }));this.providers.splice(i, 0, n);
          }
        }, providerSupports: function providerSupports(e, t) {
          return i = this.config.edition, e.supports(t, i);
        } }), e;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  },,,,,,,,,,,, function (e, t, n) {
    "use strict";
    function i(e) {
      return e && e.__esModule ? e : { "default": e };
    }function o(e, t, n) {
      this.helpers = e || {}, this.partials = t || {}, this.decorators = n || {}, l.registerDefaultHelpers(this), c.registerDefaultDecorators(this);
    }t.__esModule = !0, t.HandlebarsEnvironment = o;var r = n(12),
        a = n(26),
        s = i(a),
        l = n(144),
        c = n(142),
        u = n(152),
        d = i(u),
        p = "4.0.5";t.VERSION = p;var h = 7;t.COMPILER_REVISION = h;var f = { 1: "<= 1.0.rc.2", 2: "== 1.0.0-rc.3", 3: "== 1.0.0-rc.4", 4: "== 1.x.x", 5: "== 2.0.0-alpha.x", 6: ">= 2.0.0-beta.1", 7: ">= 4.0.0" };t.REVISION_CHANGES = f;var g = "[object Object]";o.prototype = { constructor: o, logger: d["default"], log: d["default"].log, registerHelper: function registerHelper(e, t) {
        if (r.toString.call(e) === g) {
          if (t) throw new s["default"]("Arg not supported with multiple helpers");r.extend(this.helpers, e);
        } else this.helpers[e] = t;
      }, unregisterHelper: function unregisterHelper(e) {
        delete this.helpers[e];
      }, registerPartial: function registerPartial(e, t) {
        if (r.toString.call(e) === g) r.extend(this.partials, e);else {
          if ("undefined" == typeof t) throw new s["default"]('Attempting to register a partial called "' + e + '" as undefined');this.partials[e] = t;
        }
      }, unregisterPartial: function unregisterPartial(e) {
        delete this.partials[e];
      }, registerDecorator: function registerDecorator(e, t) {
        if (r.toString.call(e) === g) {
          if (t) throw new s["default"]("Arg not supported with multiple decorators");r.extend(this.decorators, e);
        } else this.decorators[e] = t;
      }, unregisterDecorator: function unregisterDecorator(e) {
        delete this.decorators[e];
      } };var m = d["default"].log;t.log = m, t.createFrame = r.createFrame, t.logger = d["default"];
  }, function (e, t, n) {
    var i, o;i = [n(2), n(1)], o = function (e, t) {
      function i(n) {
        t.each(n, function (t, i) {
          n[i] = e.serialize(t);
        });
      }function o(e) {
        return e.slice && "px" === e.slice(-2) && (e = e.slice(0, -2)), e;
      }function r(t, n) {
        if (n.toString().indexOf("%") === -1) return 0;if ("string" != typeof t || !e.exists(t)) return 0;if (/^\d*\.?\d+%$/.test(t)) return t;var i = t.indexOf(":");if (i === -1) return 0;var o = parseFloat(t.substr(0, i)),
            r = parseFloat(t.substr(i + 1));return o <= 0 || r <= 0 ? 0 : r / o * 100 + "%";
      }var a = { autostart: !1, controls: !0, displaytitle: !0, displaydescription: !0, mobilecontrols: !1, repeat: !1, castAvailable: !1, skin: "seven", stretching: "uniform", mute: !1, volume: 90, width: 480, height: 270, localization: { play: "Play", playback: "Start playback", pause: "Pause", volume: "Volume", prev: "Previous", next: "Next", cast: "Chromecast", fullscreen: "Fullscreen", playlist: "Playlist", hd: "Quality", cc: "Closed captions", audioTracks: "Audio tracks", replay: "Replay", buffer: "Loading", more: "More", liveBroadcast: "Live broadcast", loadingAd: "Loading ad" } },
          s = function s(_s, l) {
        var c = l && l.getAllItems(),
            u = t.extend({}, (window.jwplayer || {}).defaults, c, _s);i(u);var d = t.extend({}, a, u);if ("." === d.base && (d.base = e.getScriptPath("jwplayer.js")), d.base = (d.base || e.loadFrom()).replace(/\/?$/, "/"), n.p = d.base, d.width = o(d.width), d.height = o(d.height), d.flashplayer = d.flashplayer || e.getScriptPath("jwplayer.js") + "jwplayer.flash.swf", "http:" === window.location.protocol && (d.flashplayer = d.flashplayer.replace("https", "http")), d.aspectratio = r(d.aspectratio, d.width), t.isObject(d.skin) && (d.skinUrl = d.skin.url, d.skinColorInactive = d.skin.inactive, d.skinColorActive = d.skin.active, d.skinColorBackground = d.skin.background, d.skin = t.isString(d.skin.name) ? d.skin.name : a.skin), t.isString(d.skin) && d.skin.indexOf(".xml") > 0 && (console.log("JW Player does not support XML skins, please update your config"), d.skin = d.skin.replace(".xml", "")), d.aspectratio || delete d.aspectratio, !d.playlist) {
          var p = t.pick(d, ["title", "description", "type", "mediaid", "image", "file", "sources", "tracks", "preload"]);d.playlist = [p];
        }return d;
      };return s;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(8), n(14), n(171), n(172), n(42)], o = function (e, t, n, i, o) {
      function r(t) {
        for (var r = {}, s = 0; s < t.childNodes.length; s++) {
          var l = t.childNodes[s],
              u = c(l);if (u) switch (u.toLowerCase()) {case "enclosure":
              r.file = e.xmlAttribute(l, "url");break;case "title":
              r.title = a(l);break;case "guid":
              r.mediaid = a(l);break;case "pubdate":
              r.date = a(l);break;case "description":
              r.description = a(l);break;case "link":
              r.link = a(l);break;case "category":
              r.tags ? r.tags += a(l) : r.tags = a(l);}
        }return r = i(t, r), r = n(t, r), new o(r);
      }var a = t.textContent,
          s = t.getChildNode,
          l = t.numChildren,
          c = t.localName,
          u = {};return u.parse = function (e) {
        for (var t = [], n = 0; n < l(e); n++) {
          var i = s(e, n),
              o = c(i).toLowerCase();if ("channel" === o) for (var a = 0; a < l(i); a++) {
            var u = s(i, a);"item" === c(u).toLowerCase() && t.push(r(u));
          }
        }return t;
      }, u;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(14), n(63), n(2), n(4), n(3), n(1)], o = function (e, t, n, i, o, r) {
      var a = function a() {
        function a(o) {
          var a = n.tryCatch(function () {
            var n,
                a = o.responseXML ? o.responseXML.childNodes : null,
                s = "";if (a) {
              for (var u = 0; u < a.length && (s = a[u], 8 === s.nodeType); u++) {}"xml" === e.localName(s) && (s = s.nextSibling), "rss" === e.localName(s) && (n = { playlist: t.parse(s) });
            }if (!n) try {
              var d = JSON.parse(o.responseText);if (r.isArray(d)) n = { playlist: d };else {
                if (!r.isArray(d.playlist)) throw null;n = d;
              }
            } catch (p) {
              return void l("Not a valid RSS/JSON feed");
            }c.trigger(i.JWPLAYER_PLAYLIST_LOADED, n);
          });a instanceof n.Error && l();
        }function s(e) {
          l("Playlist load error: " + e);
        }function l(e) {
          c.trigger(i.JWPLAYER_ERROR, { message: e ? e : "Error loading file" });
        }var c = r.extend(this, o);this.load = function (e) {
          n.ajax(e, a, s);
        }, this.destroy = function () {
          this.off();
        };
      };return a;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(42), n(66), n(1), n(49)], o = function (e, t, n, i) {
      function o(e, t) {
        for (var n = 0; n < e.length; n++) {
          var i = e[n],
              o = t.choose(i);if (o) return i.type;
        }return null;
      }function r(e, t) {
        return n.isUndefined(e) ? t : e;
      }var a = function a(t) {
        return t = n.isArray(t) ? t : [t], n.compact(n.map(t, e));
      };a.filterPlaylist = function (e, t, i, o, a, c, u) {
        var d = [];return n.each(e, function (e) {
          e = n.extend({}, e), e.allSources = s(e.sources, i, e.drm || o, e.preload || a, r(e.withCredentials, u)), e.sources = l(e.allSources, t), e.sources.length && (e.file = e.sources[0].file, (e.preload || a) && (e.preload = e.preload || a), (e.feedid || c) && (e.feedid = e.feedid || c), d.push(e));
        }), d;
      };var s = function s(e, i, o, a, _s2) {
        return n.compact(n.map(e, function (e) {
          if (n.isObject(e)) {
            void 0 !== i && null !== i && (e.androidhls = i), (e.drm || o) && (e.drm = e.drm || o), (e.preload || a) && (e.preload = e.preload || a);var l = r(e.withCredentials, _s2);return n.isUndefined(l) || (e.withCredentials = l), t(e);
          }
        }));
      },
          l = function l(e, t) {
        t && t.choose || (t = new i({ primary: t ? "flash" : null }));var r = o(e, t);return n.where(e, { type: r });
      };return a;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(2), n(8), n(1)], o = function (e, t, n) {
      var i = { "default": !1 },
          o = function o(_o2) {
        if (_o2 && _o2.file) {
          var r = n.extend({}, i, _o2);r.file = t.trim("" + r.file);var a = /^[^\/]+\/(?:x-)?([^\/]+)$/;if (a.test(r.type) && (r.mimeType = r.type, r.type = r.type.replace(a, "$1")), e.isYouTube(r.file) ? r.type = "youtube" : e.isRtmp(r.file) ? r.type = "rtmp" : r.type || (r.type = t.extension(r.file)), r.type) {
            switch (r.type) {case "m3u8":case "vnd.apple.mpegurl":
                r.type = "hls";break;case "dash+xml":
                r.type = "dash";break;case "smil":
                r.type = "rtmp";break;case "m4a":
                r.type = "aac";}return n.each(r, function (e, t) {
              "" === e && delete r[t];
            }), r;
          }
        }
      };return o;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(2), n(33), n(4), n(3), n(22), n(1)], o = function (e, t, n, i, o, r) {
      var a = { FLASH: 0, JAVASCRIPT: 1, HYBRID: 2 },
          s = function s(_s3) {
        function l() {
          switch (t.getPluginPathType(_s3)) {case t.pluginPathType.ABSOLUTE:
              return _s3;case t.pluginPathType.RELATIVE:
              return e.getAbsolutePath(_s3, window.location.href);}
        }function c() {
          r.defer(function () {
            m = o.loaderstatus.COMPLETE, g.trigger(n.COMPLETE);
          });
        }function u() {
          m = o.loaderstatus.ERROR, g.trigger(n.ERROR, { url: _s3 });
        }var d,
            p,
            h,
            f,
            g = r.extend(this, i),
            m = o.loaderstatus.NEW;this.load = function () {
          if (m === o.loaderstatus.NEW) {
            if (_s3.lastIndexOf(".swf") > 0) return d = _s3, m = o.loaderstatus.COMPLETE, void g.trigger(n.COMPLETE);if (t.getPluginPathType(_s3) === t.pluginPathType.CDN) return m = o.loaderstatus.COMPLETE, void g.trigger(n.COMPLETE);m = o.loaderstatus.LOADING;var e = new o(l());e.on(n.COMPLETE, c), e.on(n.ERROR, u), e.load();
          }
        }, this.registerPlugin = function (e, t, i, r) {
          f && (clearTimeout(f), f = void 0), h = t, i && r ? (d = r, p = i) : "string" == typeof i ? d = i : "function" == typeof i ? p = i : i || r || (d = e), m = o.loaderstatus.COMPLETE, g.trigger(n.COMPLETE);
        }, this.getStatus = function () {
          return m;
        }, this.getPluginName = function () {
          return t.getPluginName(_s3);
        }, this.getFlashPath = function () {
          if (d) switch (t.getPluginPathType(d)) {case t.pluginPathType.ABSOLUTE:
              return d;case t.pluginPathType.RELATIVE:
              return _s3.lastIndexOf(".swf") > 0 ? e.getAbsolutePath(d, window.location.href) : e.getAbsolutePath(d, l());}return null;
        }, this.getJS = function () {
          return p;
        }, this.getTarget = function () {
          return h;
        }, this.getPluginmode = function () {
          return void 0 !== (typeof d === "undefined" ? "undefined" : _typeof(d)) && void 0 !== (typeof p === "undefined" ? "undefined" : _typeof(p)) ? a.HYBRID : void 0 !== (typeof d === "undefined" ? "undefined" : _typeof(d)) ? a.FLASH : void 0 !== (typeof p === "undefined" ? "undefined" : _typeof(p)) ? a.JAVASCRIPT : void 0;
        }, this.getNewInstance = function (e, t, n) {
          return new p(e, t, n);
        }, this.getURL = function () {
          return _s3;
        };
      };return s;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  },,,,,,, function (e, t, n) {
    var i, o;i = [n(1), n(43)], o = function (e, t) {
      function n(e) {
        e.onload = null, e.onprogress = null, e.onreadystatechange = null, e.onerror = null, "abort" in e && e.abort();
      }function i(t, i) {
        return function (o) {
          var r = o.currentTarget || i.xhr;if (clearTimeout(i.timeoutId), i.retryWithoutCredentials && i.xhr.withCredentials) {
            n(r);var a = e.extend({}, i, { xhr: null, withCredentials: !1, retryWithoutCredentials: !1 });return void d(a);
          }i.onerror(t, i.url, r);
        };
      }function o(e) {
        return function (t) {
          var n = t.currentTarget || e.xhr;if (4 === n.readyState) {
            if (clearTimeout(e.timeoutId), n.status >= 400) {
              var i;return i = 404 === n.status ? "File not found" : "" + n.status + "(" + n.statusText + ")", e.onerror(i, e.url, n);
            }if (200 === n.status) return r(e)(t);
          }
        };
      }function r(e) {
        return function (n) {
          var i = n.currentTarget || e.xhr;if (clearTimeout(e.timeoutId), e.responseType) {
            if ("json" === e.responseType) return a(i, e);
          } else {
            var o,
                r = i.responseXML;if (r) try {
              o = r.firstChild;
            } catch (l) {}if (r && o) return s(i, r, e);if (c && i.responseText && !r && (r = t.parseXML(i.responseText), r && r.firstChild)) return s(i, r, e);if (e.requireValidXML) return void e.onerror("Invalid XML", e.url, i);
          }e.oncomplete(i);
        };
      }function a(t, n) {
        if (!t.response || e.isString(t.response) && '"' !== t.responseText.substr(1)) try {
          t = e.extend({}, t, { response: JSON.parse(t.responseText) });
        } catch (i) {
          return void n.onerror("Invalid JSON", n.url, t);
        }return n.oncomplete(t);
      }function s(t, n, i) {
        var o = n.documentElement;return i.requireValidXML && ("parsererror" === o.nodeName || o.getElementsByTagName("parsererror").length) ? void i.onerror("Invalid XML", i.url, t) : (t.responseXML || (t = e.extend({}, t, { responseXML: n })), i.oncomplete(t));
      }var l = function l() {},
          c = !1,
          u = function u(e) {
        var t = document.createElement("a"),
            n = document.createElement("a");t.href = location.href;try {
          return n.href = e, n.href = n.href, t.protocol + "//" + t.host != n.protocol + "//" + n.host;
        } catch (i) {}return !0;
      },
          d = function d(t, a, s, _d) {
        e.isObject(t) && (_d = t, t = _d.url);var p,
            h = e.extend({ xhr: null, url: t, withCredentials: !1, retryWithoutCredentials: !1, timeout: 6e4, timeoutId: -1, oncomplete: a || l, onerror: s || l, mimeType: _d && !_d.responseType ? "text/xml" : "", requireValidXML: !1, responseType: _d && _d.plainText ? "text" : "" }, _d);if ("XDomainRequest" in window && u(t)) p = h.xhr = new window.XDomainRequest(), p.onload = r(h), p.ontimeout = p.onprogress = l, c = !0;else {
          if (!("XMLHttpRequest" in window)) return void h.onerror("", t);p = h.xhr = new window.XMLHttpRequest(), p.onreadystatechange = o(h);
        }var f = i("Error loading file", h);p.onerror = f, "overrideMimeType" in p ? h.mimeType && p.overrideMimeType(h.mimeType) : c = !0;try {
          t = t.replace(/#.*$/, ""), p.open("GET", t, !0);
        } catch (g) {
          return f(g), p;
        }if (h.responseType) try {
          p.responseType = h.responseType;
        } catch (g) {}h.timeout && (h.timeoutId = setTimeout(function () {
          n(p), h.onerror("Timeout", t, p);
        }, h.timeout), p.onabort = function () {
          clearTimeout(h.timeoutId);
        });try {
          h.withCredentials && "withCredentials" in p && (p.withCredentials = !0), p.send();
        } catch (g) {
          f(g);
        }return p;
      };return { ajax: d, crossdomain: u };
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(1)], o = function (e) {
      function t(e) {
        return function () {
          return i(e);
        };
      }var n = {},
          i = e.memoize(function (e) {
        var t = navigator.userAgent.toLowerCase();return null !== t.match(e);
      }),
          o = n.isInt = function (e) {
        return parseFloat(e) % 1 === 0;
      };n.isFlashSupported = function () {
        var e = n.flashVersion();return e && e >= 11.2;
      }, n.isFF = t(/firefox/i), n.isIPod = t(/iP(hone|od)/i), n.isIPad = t(/iPad/i), n.isSafari602 = t(/Macintosh.*Mac OS X 10_8.*6\.0\.\d* Safari/i), n.isOSX = t(/Mac OS X/i), n.isEdge = t(/\sedge\/\d+/i);var r = n.isIETrident = function (e) {
        return !!n.isEdge() || (e ? (e = parseFloat(e).toFixed(1), i(new RegExp("trident/.+rv:\\s*" + e, "i"))) : i(/trident/i));
      },
          a = n.isMSIE = function (e) {
        return e ? (e = parseFloat(e).toFixed(1), i(new RegExp("msie\\s*" + e, "i"))) : i(/msie/i);
      },
          s = t(/chrome/i);n.isChrome = function () {
        return s() && !n.isEdge();
      }, n.isIE = function (e) {
        return e ? (e = parseFloat(e).toFixed(1), e >= 11 ? r(e) : a(e)) : a() || r();
      }, n.isSafari = function () {
        return i(/safari/i) && !i(/chrome/i) && !i(/chromium/i) && !i(/android/i);
      };var l = n.isIOS = function (e) {
        return i(e ? new RegExp("iP(hone|ad|od).+\\s(OS\\s" + e + "|.*\\sVersion/" + e + ")", "i") : /iP(hone|ad|od)/i);
      };n.isAndroidNative = function (e) {
        return c(e, !0);
      };var c = n.isAndroid = function (e, t) {
        return !(t && i(/chrome\/[123456789]/i) && !i(/chrome\/18/)) && (e ? (o(e) && !/\./.test(e) && (e = "" + e + "."), i(new RegExp("Android\\s*" + e, "i"))) : i(/Android/i));
      };return n.isMobile = function () {
        return l() || c();
      }, n.isIframe = function () {
        return window.frameElement && "IFRAME" === window.frameElement.nodeName;
      }, n.flashVersion = function () {
        if (n.isAndroid()) return 0;var e,
            t = navigator.plugins;if (t && (e = t["Shockwave Flash"], e && e.description)) return parseFloat(e.description.replace(/\D+(\d+\.?\d*).*/, "$1"));if ("undefined" != typeof window.ActiveXObject) {
          try {
            if (e = new window.ActiveXObject("ShockwaveFlash.ShockwaveFlash")) return parseFloat(e.GetVariable("$version").split(" ")[1].replace(/\s*,\s*/, "."));
          } catch (i) {
            return 0;
          }return e;
        }return 0;
      }, n;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(8), n(1), n(181)], o = function (e, t, n) {
      var i = {};i.createElement = function (e) {
        var t = document.createElement("div");return t.innerHTML = e, t.firstChild;
      }, i.styleDimension = function (e) {
        return e + (e.toString().indexOf("%") > 0 ? "" : "px");
      };var o = function o(e) {
        return t.isString(e.className) ? e.className.split(" ") : [];
      },
          r = function r(t, n) {
        n = e.trim(n), t.className !== n && (t.className = n);
      };return i.classList = function (e) {
        return e.classList ? e.classList : o(e);
      }, i.hasClass = n.hasClass, i.addClass = function (e, n) {
        var i = o(e),
            a = t.isArray(n) ? n : n.split(" ");t.each(a, function (e) {
          t.contains(i, e) || i.push(e);
        }), r(e, i.join(" "));
      }, i.removeClass = function (e, n) {
        var i = o(e),
            a = t.isArray(n) ? n : n.split(" ");r(e, t.difference(i, a).join(" "));
      }, i.replaceClass = function (e, t, n) {
        var i = e.className || "";t.test(i) ? i = i.replace(t, n) : n && (i += " " + n), r(e, i);
      }, i.toggleClass = function (e, n, o) {
        var r = i.hasClass(e, n);o = t.isBoolean(o) ? o : !r, o !== r && (o ? i.addClass(e, n) : i.removeClass(e, n));
      }, i.emptyElement = function (e) {
        for (; e.firstChild;) {
          e.removeChild(e.firstChild);
        }
      }, i.addStyleSheet = function (e) {
        var t = document.createElement("link");t.rel = "stylesheet", t.href = e, document.getElementsByTagName("head")[0].appendChild(t);
      }, i.empty = function (e) {
        if (e) for (; e.childElementCount > 0;) {
          e.removeChild(e.children[0]);
        }
      }, i.bounds = function (e) {
        var t = { left: 0, right: 0, width: 0, height: 0, top: 0, bottom: 0 };if (!e || !document.body.contains(e)) return t;var n = e.getBoundingClientRect(e),
            i = window.pageYOffset,
            o = window.pageXOffset;return n.width || n.height || n.left || n.top ? (t.left = n.left + o, t.right = n.right + o, t.top = n.top + i, t.bottom = n.bottom + i, t.width = n.right - n.left, t.height = n.bottom - n.top, t) : t;
      }, i;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(3), n(1)], o = function (e, t) {
      function n() {}var i = function i(e, n) {
        var i,
            o = this;i = e && t.has(e, "constructor") ? e.constructor : function () {
          return o.apply(this, arguments);
        }, t.extend(i, o, n);var r = function r() {
          this.constructor = i;
        };return r.prototype = o.prototype, i.prototype = new r(), e && t.extend(i.prototype, e), i.__super__ = o.prototype, i;
      };return n.extend = i, t.extend(n.prototype, e), n;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(28), n(1), n(44), n(43), n(30)], o = function (e, t, n, i, o) {
      var r = {};return r.repo = t.memoize(function () {
        var t = o.split("+")[0],
            i = e.repo + t + "/";return n.isHTTPS() ? i.replace(/^http:/, "https:") : i;
      }), r.versionCheck = function (e) {
        var t = ("0" + e).split(/\W/),
            n = o.split(/\W/),
            i = parseFloat(t[0]),
            r = parseFloat(n[0]);return !(i > r) && !(i === r && parseFloat("0" + t[1]) > parseFloat(n[1]));
      }, r.loadFrom = function () {
        return r.repo();
      }, r;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(1)], o = function (e) {
      var t = function t() {
        var t = {},
            n = {},
            i = {},
            o = {};return { start: function start(n) {
            t[n] = e.now(), i[n] = i[n] + 1 || 1;
          }, end: function end(i) {
            if (t[i]) {
              var o = e.now() - t[i];n[i] = n[i] + o || o;
            }
          }, dump: function dump() {
            return { counts: i, sums: n, events: o };
          }, tick: function tick(t, n) {
            o[t] = n || e.now();
          }, between: function between(e, t) {
            return o[t] && o[e] ? o[t] - o[e] : -1;
          } };
      };return t;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [], o = function () {
      return document.createElement("video");
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  },,,, function (e, t, n) {
    var i;i = function (require, e, t) {
      function n(e, t) {
        o(t, r(e));
      }function i(e) {
        var t = u[e];if (t) {
          for (var n = Object.keys(t), i = 0; i < n.length; i += 1) {
            for (var o = t[n[i]], r = 0; r < o.parts.length; r += 1) {
              o.parts[r]();
            }
          }delete u[e];
        }
      }function o(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n],
              o = (u[e] || {})[i.id];if (o) {
            for (var r = 0; r < o.parts.length; r++) {
              o.parts[r](i.parts[r]);
            }for (; r < i.parts.length; r++) {
              o.parts.push(l(e, i.parts[r]));
            }
          } else {
            for (var a = [], r = 0; r < i.parts.length; r++) {
              a.push(l(e, i.parts[r]));
            }u[e] = u[e] || {}, u[e][i.id] = { id: i.id, parts: a };
          }
        }
      }function r(e) {
        for (var t = [], n = {}, i = 0; i < e.length; i++) {
          var o = e[i],
              r = o[0],
              a = o[1],
              s = o[2],
              l = { css: a, media: s };n[r] ? n[r].parts.push(l) : t.push(n[r] = { id: r, parts: [l] });
        }return t;
      }function a(e) {
        h().appendChild(e);
      }function s(e) {
        var t = document.createElement("style");return t.type = "text/css", t.setAttribute("data-jwplayer-id", e), a(t), t;
      }function l(e, t) {
        var n,
            i,
            o,
            r = d[e];r || (r = d[e] = { element: s(e), counter: 0 });var a = r.counter++;return n = r.element, i = c.bind(null, n, a, !1), o = c.bind(null, n, a, !0), i(t), function (e) {
          if (e) {
            if (e.css === t.css && e.media === t.media) return;i(t = e);
          } else o();
        };
      }function c(e, t, n, i) {
        var o = n ? "" : i.css;if (e.styleSheet) e.styleSheet.cssText = f(t, o);else {
          var r = document.createTextNode(o),
              a = e.childNodes;a[t] && e.removeChild(a[t]), a.length ? e.insertBefore(r, a[t]) : e.appendChild(r);
        }
      }var u = {},
          d = {},
          p = function p(e) {
        var t;return function () {
          return "undefined" == typeof t && (t = e.apply(this, arguments)), t;
        };
      },
          h = p(function () {
        return document.head || document.getElementsByTagName("head")[0];
      });t.exports = { style: n, clear: i };var f = function () {
        var e = [];return function (t, n) {
          return e[t] = n, e.filter(Boolean).join("\n");
        };
      }();
    }.call(t, n, t, e), !(void 0 !== i && (e.exports = i));
  }, function (e, t, n) {
    var i, o;i = [n(160), n(27), n(1)], o = function (e, t, n) {
      var i = e.selectPlayer,
          o = function o() {
        var e = i.apply(this, arguments);return e ? e : { registerPlugin: function registerPlugin(e, n, i) {
            "jwpsrv" !== e && t.registerPlugin(e, n, i);
          } };
      };return n.extend(e, { selectPlayer: o });
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  },,,,, function (e, t, n) {
    var i, o;i = [n(2), n(91), n(23)], o = function (e, t, n) {
      var i = "invalid",
          o = "RnXcsftYjWRDA^Uy",
          r = function r(_r2) {
        function a(r) {
          e.exists(r) || (r = "");try {
            r = t.decrypt(r, o);var a = r.split("/");s = a[0], "pro" === s && (s = "premium");var u = n(s);if (a.length > 2 && u("setup")) {
              l = a[1];var d = parseInt(a[2]);d > 0 && (c = new Date(), c.setTime(d));
            } else s = i;
          } catch (p) {
            s = i;
          }
        }var s, l, c;this.edition = function () {
          return c && c.getTime() < new Date().getTime() ? i : s;
        }, this.token = function () {
          return l;
        }, this.expiration = function () {
          return c;
        }, a(_r2);
      };return r;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [], o = function () {
      var e = function e(_e2) {
        return window.atob(_e2);
      },
          t = function t(e) {
        return unescape(encodeURIComponent(e));
      },
          n = function n(e) {
        try {
          return decodeURIComponent(escape(e));
        } catch (t) {
          return e;
        }
      },
          i = function i(e) {
        for (var t = new Array(Math.ceil(e.length / 4)), n = 0; n < t.length; n++) {
          t[n] = e.charCodeAt(4 * n) + (e.charCodeAt(4 * n + 1) << 8) + (e.charCodeAt(4 * n + 2) << 16) + (e.charCodeAt(4 * n + 3) << 24);
        }return t;
      },
          o = function o(e) {
        for (var t = new Array(e.length), n = 0; n < e.length; n++) {
          t[n] = String.fromCharCode(255 & e[n], e[n] >>> 8 & 255, e[n] >>> 16 & 255, e[n] >>> 24 & 255);
        }return t.join("");
      };return { decrypt: function decrypt(r, a) {
          if (r = String(r), a = String(a), 0 == r.length) return "";for (var s, l, c = i(e(r)), u = i(t(a).slice(0, 16)), d = c.length, p = c[d - 1], h = c[0], f = 2654435769, g = Math.floor(6 + 52 / d), m = g * f; 0 != m;) {
            l = m >>> 2 & 3;for (var v = d - 1; v >= 0; v--) {
              p = c[v > 0 ? v - 1 : d - 1], s = (p >>> 5 ^ h << 2) + (h >>> 3 ^ p << 4) ^ (m ^ h) + (u[3 & v ^ l] ^ p), h = c[v] -= s;
            }m -= f;
          }var w = o(c);return w = w.replace(/\0+$/, ""), n(w);
        } };
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(201), n(4), n(215)], o = function (e, t, n) {
      var i = function i(_i2, o) {
        var r = new e(_i2, o),
            a = r.setup;return r.setup = function () {
          if (a.call(this), "trial" === o.get("edition")) {
            var e = document.createElement("div");e.className = "jw-icon jw-watermark", this.element().appendChild(e);
          }o.on("change:skipButton", this.onSkipButton, this), o.on("change:castActive change:playlistItem", this.showDisplayIconImage, this);
        }, r.showDisplayIconImage = function (e) {
          var t = e.get("castActive"),
              n = e.get("playlistItem"),
              i = r.controlsContainer().getElementsByClassName("jw-display-icon-container")[0];t && n && n.image ? (i.style.backgroundImage = 'url("' + n.image + '")', i.style.backgroundSize = "contain") : (i.style.backgroundImage = "", i.style.backgroundSize = "");
        }, r.onSkipButton = function (e, t) {
          t ? this.addSkipButton() : this._skipButton && (this._skipButton.destroy(), this._skipButton = null);
        }, r.addSkipButton = function () {
          this._skipButton = new n(this.instreamModel), this._skipButton.on(t.JWPLAYER_AD_SKIPPED, function () {
            this.api.skipAd();
          }, this), this.controlsContainer().appendChild(this._skipButton.element());
        }, r;
      };return i;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  },,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,, function (e, t, n) {
    t = e.exports = n(127)(), t.push([e.id, ".jw-reset{color:inherit;background-color:transparent;padding:0;margin:0;float:none;font-family:Arial,Helvetica,sans-serif;font-size:1em;line-height:1em;list-style:none;text-align:left;text-transform:none;vertical-align:baseline;border:0;direction:ltr;font-variant:inherit;font-stretch:inherit;-webkit-tap-highlight-color:rgba(255,255,255,0)}@font-face{font-family:jw-icons;src:url(" + n(129) + ") format('woff'),url(" + n(128) + ') format(\'truetype\');font-weight:400;font-style:normal}.jw-controlbar .jw-menu .jw-option:before,.jw-icon-display,.jw-icon-inline,.jw-icon-tooltip{font-family:jw-icons;-webkit-font-smoothing:antialiased;font-style:normal;font-weight:400;text-transform:none;background-color:transparent;font-variant:normal;-webkit-font-feature-settings:"liga";-ms-font-feature-settings:"liga" 1;-o-font-feature-settings:"liga";font-feature-settings:"liga";-moz-osx-font-smoothing:grayscale}.jw-icon-audio-tracks:before{content:"\\E600"}.jw-icon-buffer:before{content:"\\E601"}.jw-icon-cast:before{content:"\\E603"}.jw-icon-cast.jw-off:before{content:"\\E602"}.jw-icon-cc:before{content:"\\E605"}.jw-icon-cue:before,.jw-icon-menu-bullet:before{content:"\\E606"}.jw-icon-error:before{content:"\\E607"}.jw-icon-fullscreen:before{content:"\\E608"}.jw-icon-fullscreen.jw-off:before{content:"\\E613"}.jw-icon-hd:before{content:"\\E60A"}.jw-rightclick-logo:before,.jw-watermark:before{content:"\\E60B"}.jw-icon-next:before{content:"\\E60C"}.jw-icon-pause:before{content:"\\E60D"}.jw-icon-play:before{content:"\\E60E"}.jw-icon-prev:before{content:"\\E60F"}.jw-icon-replay:before{content:"\\E610"}.jw-icon-volume:before{content:"\\E612"}.jw-icon-volume.jw-off:before{content:"\\E611"}.jw-icon-more:before{content:"\\E614"}.jw-icon-close:before{content:"\\E615"}.jw-icon-playlist:before{content:"\\E616"}.jwplayer{width:100%;font-size:16px;position:relative;display:block;min-height:0;overflow:hidden;box-sizing:border-box;font-family:Arial,Helvetica,sans-serif;background-color:#000;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.jwplayer *{box-sizing:inherit}.jwplayer.jw-flag-aspect-mode{height:auto!important}.jwplayer.jw-flag-aspect-mode .jw-aspect{display:block}.jwplayer .jw-aspect{display:none}.jwplayer.jw-no-focus:focus,.jwplayer .jw-swf{outline:none}.jwplayer.jw-ie:focus{outline:1px dotted #585858}.jwplayer:hover .jw-display-icon-container{background-color:#212121}.jw-controls,.jw-media,.jw-overlays,.jw-preview{position:absolute;width:100%;height:100%;top:0;left:0;bottom:0;right:0}.jw-media{overflow:hidden;cursor:pointer}.jw-overlays{cursor:auto}.jw-media.jw-media-show{visibility:visible;opacity:1}.jw-controls.jw-controls-disabled{display:none}.jw-controls .jw-controls-right{position:absolute;top:0;right:0;left:0;bottom:2.5em}.jw-text{height:1em;font-family:Arial,Helvetica,sans-serif;font-size:.75em;font-style:normal;font-weight:400;color:#fff;text-align:center;font-variant:normal;font-stretch:normal}.jw-plugin{position:absolute;bottom:2.5em}.jw-plugin .jw-banner{max-width:100%;opacity:0;cursor:pointer;position:absolute;margin:auto auto 0;left:0;right:0;bottom:0;display:block}.jw-cast-screen{width:100%;height:100%}.jw-instream{position:absolute;top:0;right:0;bottom:0;left:0;display:none}.jw-icon-playback:before{content:"\\E60E"}.jw-captions,.jw-controls,.jw-overlays,.jw-preview,.jw-title{pointer-events:none}.jw-controlbar,.jw-display-icon-container,.jw-dock,.jw-logo,.jw-media,.jw-overlays>div,.jw-skip{pointer-events:all}.jwplayer video{position:absolute;top:0;right:0;bottom:0;left:0;width:100%;height:100%;margin:auto;background:transparent}.jwplayer video::-webkit-media-controls-start-playback-button{display:none}.jwplayer.jw-stretch-uniform video{-o-object-fit:contain;object-fit:contain}.jwplayer.jw-stretch-none video{-o-object-fit:none;object-fit:none}.jwplayer.jw-stretch-fill video{-o-object-fit:cover;object-fit:cover}.jwplayer.jw-stretch-exactfit video{-o-object-fit:fill;object-fit:fill}.jw-click,.jw-preview{position:absolute;width:100%;height:100%}.jw-preview{display:none;opacity:1;visibility:visible;background:#000 no-repeat 50% 50%}.jw-error .jw-preview,.jw-stretch-uniform .jw-preview,.jwplayer .jw-preview{background-size:contain}.jw-stretch-none .jw-preview{background-size:auto auto}.jw-stretch-fill .jw-preview{background-size:cover}.jw-stretch-exactfit .jw-preview{background-size:100% 100%}.jw-display-icon-container{position:relative;top:50%;display:table;height:3.75em;width:3.75em;margin:-1.875em auto 0;cursor:pointer}.jw-display-icon-container .jw-icon-display{position:relative;display:table-cell;text-align:center;vertical-align:middle!important;background-position:50% 50%;background-repeat:no-repeat;font-size:2.5em}.jw-flag-audio-player .jw-display-icon-container,.jw-flag-dragging .jw-display-icon-container{display:none}.jw-icon{font-family:jw-icons;-webkit-font-smoothing:antialiased;font-style:normal;font-weight:400;text-transform:none;background-color:transparent;font-variant:normal;-webkit-font-feature-settings:"liga";-ms-font-feature-settings:"liga" 1;-o-font-feature-settings:"liga";font-feature-settings:"liga";-moz-osx-font-smoothing:grayscale}.jw-controlbar{display:table;position:absolute;bottom:0;height:2.5em;width:100%;padding:0 .4em}.jw-controlbar .jw-hidden{display:none}.jw-controlbar.jw-drawer-expanded .jw-controlbar-center-group,.jw-controlbar.jw-drawer-expanded .jw-controlbar-left-group{opacity:0}.jw-background-color{background-color:rgba(33,33,33,.8)}.jw-slider-horizontal{background-color:transparent}.jw-group{display:table-cell}.jw-controlbar-center-group{width:100%;padding:0 .4em}.jw-controlbar-center-group .jw-slider-time,.jw-controlbar-center-group .jw-text-alt{padding:0}.jw-controlbar-center-group .jw-text-alt{display:none}.jw-controlbar-left-group,.jw-controlbar-right-group{white-space:nowrap}.jw-icon-display:hover,.jw-icon-inline:hover,.jw-icon-tooltip:hover,.jw-knob:hover,.jw-option:before:hover{color:#fff}.jw-icon-inline,.jw-icon-tooltip,.jw-slider-horizontal,.jw-text-duration,.jw-text-elapsed{display:inline-block;height:2.5em;position:relative;line-height:2.5em;vertical-align:middle;cursor:pointer;padding:0 .4em}.jw-icon-inline,.jw-icon-tooltip{min-width:1.5625em;text-align:center}.jw-icon-playback{min-width:2.25em}.jw-icon-volume{min-width:1.75em;text-align:left}.jw-time-tip{line-height:1em;pointer-events:none}.jw-icon-cast,.jw-icon-inline.jw-icon-volume,.jw-slider-volume.jw-slider-horizontal{display:none}.jw-button-color{color:hsla(0,0%,100%,.6)}.jw-button-color:hover{color:#fff}.jw-button-color:focus{outline:none;color:#fff}.jw-toggle{color:#fff}.jw-toggle.jw-off{color:hsla(0,0%,100%,.6)}.jw-toggle:focus{outline:none;color:#fff}.jw-dock{margin:.75em;display:block;opacity:1;clear:right}.jw-dock:after{content:\'\';clear:both;display:block}.jw-dock-button{cursor:pointer;float:right;position:relative;width:2.5em;height:2.5em;margin:.5em}.jw-dock-button .jw-arrow{display:none;position:absolute;bottom:-.2em;width:.5em;height:.2em;left:50%;margin-left:-.25em}.jw-dock-button .jw-overlay{display:none;position:absolute;top:2.5em;right:0;margin-top:.25em;padding:.5em;white-space:nowrap}.jw-dock-button:hover .jw-arrow,.jw-dock-button:hover .jw-overlay{display:block}.jw-dock-image{width:100%;height:100%;background-position:50% 50%;background-repeat:no-repeat;opacity:.75}.jw-title{display:none;position:absolute;top:0;width:100%;font-size:.875em;height:8em;background:-webkit-linear-gradient(top,#000,#000 18%,transparent);background:linear-gradient(180deg,#000 0,#000 18%,transparent)}.jw-title-primary,.jw-title-secondary{padding:.75em 1.5em;min-height:2.5em;width:100%;color:#fff;white-space:nowrap;text-overflow:ellipsis;overflow-x:hidden}.jw-title-primary{font-weight:700}.jw-title-secondary{margin-top:-.5em}.jw-slider-container{height:1em;width:100%;position:relative;touch-action:none}.jw-buffer,.jw-progress,.jw-rail{position:absolute;cursor:pointer}.jw-progress{background-color:#fff}.jw-rail{background-color:hsla(0,0%,100%,.2)}.jw-buffer{background-color:hsla(0,0%,100%,.3)}.jw-cue,.jw-knob{position:absolute;cursor:pointer}.jw-cue{height:.25em;background-color:rgba(33,33,33,.9);border-radius:25%;width:.4em}.jw-knob{background-color:#fff;width:.5em;height:.5em;border-radius:.25em}.jw-slider-horizontal{height:.25em}.jw-slider-horizontal.jw-slider-volume{width:4em}.jw-slider-horizontal .jw-rail{width:100%}.jw-slider-horizontal .jw-knob{top:-.125em;margin-left:-.25em}.jw-slider-horizontal .jw-buffer,.jw-slider-horizontal .jw-progress,.jw-slider-horizontal .jw-rail{height:.25em}.jw-slider-vertical{padding:.8em .8em 0;position:absolute}.jw-slider-vertical .jw-buffer,.jw-slider-vertical .jw-progress,.jw-slider-vertical .jw-rail{bottom:0;height:100%;left:0;right:0;margin:0 auto}.jw-slider-vertical .jw-progress,.jw-slider-vertical .jw-rail,.jw-slider-vertical .jw-slider-container{width:.25em}.jw-slider-vertical .jw-slider-container{height:4em}.jw-slider-vertical .jw-knob{right:0;left:-.125em}.jw-slider-time{width:100%}.jw-tooltip-time{position:absolute}.jw-slider-volume .jw-buffer{display:none}.jw-captions{position:absolute;width:100%;height:inherit;text-align:center;display:none;max-height:81.375%;line-height:1.3em;letter-spacing:normal;word-spacing:normal;text-transform:none;text-indent:0;text-decoration:none;pointer-events:none;overflow:hidden;top:0}.jw-captions.jw-captions-enabled{display:block}.jw-captions-window{display:none;padding:.25em;border-radius:.25em}.jw-captions-text,.jw-captions-window.jw-captions-window-active{display:inline-block}.jw-captions-text{color:#fff;background-color:#000;word-wrap:normal;word-break:normal;white-space:pre-line;font-style:normal;font-weight:400;text-align:center;text-decoration:none;line-height:1.3em;padding:.1em .8em}.jw-text-track-display{font-size:inherit;line-height:1.3em}.jwplayer video::-webkit-media-controls{-webkit-box-pack:start;justify-content:flex-start}.jwplayer video::-webkit-media-text-track-container{max-height:81.375%;line-height:1.3em}.jwplayer .jw-rightclick{display:none;position:absolute;white-space:nowrap}.jwplayer .jw-rightclick.jw-open{display:block}.jwplayer .jw-rightclick ul{list-style:none;font-weight:700;border-radius:.15em;margin:0;border:1px solid #444;padding:0}.jwplayer .jw-rightclick ul li{background-color:#000;border-bottom:1px solid #444;margin:0}.jwplayer .jw-rightclick ul li .jw-rightclick-logo{font-size:2em;color:#ff0147;vertical-align:middle;padding-right:.3em;margin-right:.3em;border-right:1px solid #444}.jwplayer .jw-rightclick ul li a{color:#fff;text-decoration:none;padding:1em;display:block;font-size:.6875em;line-height:1em}.jwplayer .jw-rightclick ul li:last-child{border-bottom:none}.jwplayer .jw-rightclick ul li:hover{background-color:#1a1a1a;cursor:pointer}.jwplayer .jw-rightclick ul .jw-featured{background-color:#252525;vertical-align:middle}.jwplayer .jw-rightclick ul .jw-featured a{color:#777}.jw-logo{position:absolute;margin:.75em;cursor:pointer;pointer-events:all;background-repeat:no-repeat;background-size:contain;top:auto;right:auto;left:auto;bottom:auto}.jw-logo .jw-flag-audio-player{display:none}.jw-logo-top-right{top:0;right:0}.jw-logo-top-left{top:0;left:0}.jw-logo-bottom-left{bottom:0;left:0}.jw-logo-bottom-right,.jw-watermark{bottom:0;right:0}.jw-watermark{position:absolute;top:50%;left:0;text-align:center;font-size:14em;color:#fff;opacity:.33;pointer-events:none}.jw-icon-tooltip.jw-open .jw-overlay{opacity:1;visibility:visible}.jw-icon-tooltip.jw-hidden,.jw-icon-tooltip.jw-open-drawer:before,.jw-overlay-horizontal{display:none}.jw-icon-tooltip.jw-open-drawer .jw-overlay-horizontal{opacity:1;display:inline-block;vertical-align:top}.jw-overlay:before{position:absolute;top:0;bottom:0;left:-50%;width:100%;background-color:transparent;content:" "}.jw-slider-time .jw-overlay:before{height:1em;top:auto}.jw-menu,.jw-time-tip,.jw-volume-tip{position:relative;left:-50%;margin:0}.jw-volume-tip{width:100%;height:100%;display:block}.jw-time-tip{text-align:center;font-family:inherit;bottom:1.25em;padding:.4em;border-radius:.25em}.jw-time-tip .jw-text{color:#fff;line-height:1em}.jw-controlbar .jw-overlay{margin:0;position:absolute;bottom:2.5em;left:50%;opacity:0;visibility:hidden}.jw-controlbar .jw-overlay .jw-contents{position:relative}.jw-controlbar .jw-option{position:relative;white-space:nowrap;cursor:pointer;list-style:none;height:1.5em;font-family:inherit;line-height:1.5em;color:hsla(0,0%,100%,.6);padding:0 .5em;font-size:.8em}.jw-controlbar .jw-option:before:hover,.jw-controlbar .jw-option:hover{color:#fff}.jw-controlbar .jw-option:before{padding-right:.125em}.jw-controlbar .jw-option.jw-active-option{color:#fff}.jw-playlist-container{left:-51%}.jw-playlist-container ::-webkit-scrollbar-track{background-color:hsla(0,0%,100%,.6)}.jw-playlist-container ::-webkit-scrollbar{width:5px;border:0}.jw-playlist-container ::-webkit-scrollbar-thumb{background-color:#fff;border-radius:5px}.jw-tooltip-title{border-bottom:1px solid hsla(0,0%,100%,.6);text-align:left;padding-left:.4em}.jw-playlist{max-height:11em;min-height:4.5em;overflow-x:hidden;overflow-y:scroll;width:calc(100% - 2px)}.jw-playlist .jw-option{height:3em;color:#fff;padding-left:1em;font-size:.75em}.jw-playlist .jw-label,.jw-playlist .jw-name{display:inline-block;line-height:3em;text-align:left;overflow:hidden;white-space:nowrap}.jw-playlist .jw-label{width:1em}.jw-playlist .jw-name{width:11em}.jw-skip{cursor:default;position:absolute;float:right;display:inline-block;right:.75em;bottom:3em;padding:.4em}.jw-skip.jw-skippable{cursor:pointer}.jw-skip.jw-hidden{visibility:hidden}.jw-skip .jw-skip-icon{display:none;margin-left:-.75em}.jw-skip .jw-skip-icon:before{content:"\\E60C"}.jw-skip .jw-skip-icon,.jw-skip .jw-text{color:hsla(0,0%,100%,.6);vertical-align:middle;line-height:1.5em;font-size:.7em}.jw-skip.jw-skippable:hover{cursor:pointer}.jw-skip.jw-skippable:hover .jw-skip-icon,.jw-skip.jw-skippable:hover .jw-text{color:#fff}.jw-skip.jw-skippable .jw-skip-icon{display:inline;margin:0}.jwplayer.jw-state-paused.jw-flag-casting .jw-display-icon-container,.jwplayer.jw-state-playing.jw-flag-casting .jw-display-icon-container{display:table}.jwplayer.jw-flag-casting .jw-display-icon-container{border-radius:0;border:1px solid #fff;position:absolute;top:auto;left:.5em;right:.5em;bottom:50%;margin-bottom:-12.5%;height:50%;width:50%;padding:0;background-repeat:no-repeat;background-position:50%}.jwplayer.jw-flag-casting .jw-display-icon-container .jw-icon{font-size:3em}.jwplayer.jw-flag-casting.jw-state-complete .jw-preview{display:none}.jw-cast{position:absolute;width:100%;height:100%;background-repeat:no-repeat;background-size:auto;background-position:50% 50%}.jw-cast-label{position:absolute;left:.5em;right:.5em;bottom:75%;margin-bottom:1.5em;text-align:center}.jw-cast-name{color:#ccc}.jw-state-idle .jw-preview{display:block}.jw-state-idle .jw-icon-display:before{content:"\\E60E"}.jw-state-idle .jw-captions,.jw-state-idle .jw-controlbar{display:none}.jw-state-idle .jw-title{display:block}.jwplayer.jw-state-playing .jw-display-icon-container{display:none}.jwplayer.jw-state-playing .jw-display-icon-container .jw-icon-display:before,.jwplayer.jw-state-playing .jw-icon-playback:before{content:"\\E60D"}.jwplayer.jw-state-paused .jw-display-icon-container{display:none}.jwplayer.jw-state-paused .jw-display-icon-container .jw-icon-display:before,.jwplayer.jw-state-paused .jw-icon-playback:before{content:"\\E60E"}.jwplayer.jw-state-buffering .jw-display-icon-container .jw-icon-display{-webkit-animation:spin 2s linear infinite;animation:spin 2s linear infinite}.jwplayer.jw-state-buffering .jw-display-icon-container .jw-icon-display:before{content:"\\E601"}@-webkit-keyframes spin{to{-webkit-transform:rotate(1turn)}}@keyframes spin{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.jwplayer.jw-state-buffering .jw-display-icon-container .jw-text{display:none}.jwplayer.jw-state-buffering .jw-icon-playback:before{content:"\\E60D"}.jwplayer.jw-state-complete .jw-preview{display:block}.jwplayer.jw-state-complete .jw-display-icon-container .jw-icon-display:before{content:"\\E610"}.jwplayer.jw-state-complete .jw-display-icon-container .jw-text{display:none}.jwplayer.jw-state-complete .jw-icon-playback:before{content:"\\E60E"}.jwplayer.jw-state-complete .jw-captions{display:none}.jwplayer.jw-state-error .jw-title,body .jw-error .jw-title{display:block}.jwplayer.jw-state-error .jw-title .jw-title-primary,body .jw-error .jw-title .jw-title-primary{white-space:normal}.jwplayer.jw-state-error .jw-preview,body .jw-error .jw-preview{display:block}.jwplayer.jw-state-error .jw-captions,.jwplayer.jw-state-error .jw-controlbar,body .jw-error .jw-captions,body .jw-error .jw-controlbar{display:none}.jwplayer.jw-state-error:hover .jw-display-icon-container,body .jw-error:hover .jw-display-icon-container{cursor:default;color:#fff;background:#000}.jwplayer.jw-state-error .jw-icon-display,body .jw-error .jw-icon-display{cursor:default;font-family:jw-icons;-webkit-font-smoothing:antialiased;font-style:normal;font-weight:400;text-transform:none;background-color:transparent;font-variant:normal;-webkit-font-feature-settings:"liga";-ms-font-feature-settings:"liga" 1;-o-font-feature-settings:"liga";font-feature-settings:"liga";-moz-osx-font-smoothing:grayscale}.jwplayer.jw-state-error .jw-icon-display:before,body .jw-error .jw-icon-display:before{content:"\\E607"}.jwplayer.jw-state-error .jw-icon-display:hover,body .jw-error .jw-icon-display:hover{color:#fff}body .jw-error{font-size:16px;background-color:#000;color:#fff;width:100%;height:100%;display:table;opacity:1;position:relative}body .jw-error .jw-icon-container{position:absolute;width:100%;height:100%;top:0;left:0;bottom:0;right:0}.jwplayer.jw-flag-cast-available .jw-controlbar{display:table}.jwplayer.jw-flag-cast-available .jw-icon-cast{display:inline-block}.jwplayer.jw-flag-skin-loading .jw-captions,.jwplayer.jw-flag-skin-loading .jw-controls,.jwplayer.jw-flag-skin-loading .jw-title{display:none}.jwplayer.jw-flag-fullscreen{width:100%!important;height:100%!important;top:0;right:0;bottom:0;left:0;z-index:1000;margin:0;position:fixed}.jwplayer.jw-flag-live .jw-controlbar .jw-slider-time,.jwplayer.jw-flag-live .jw-controlbar .jw-text-duration,.jwplayer.jw-flag-live .jw-controlbar .jw-text-elapsed{display:none}.jwplayer.jw-flag-live .jw-controlbar .jw-text-alt{display:inline}.jwplayer.jw-flag-user-inactive.jw-state-playing .jw-controlbar,.jwplayer.jw-flag-user-inactive.jw-state-playing .jw-dock,.jwplayer.jw-flag-user-inactive.jw-state-playing .jw-logo.jw-hide{display:none}.jwplayer.jw-flag-user-inactive.jw-state-playing .jw-plugin{bottom:.5em}.jwplayer.jw-flag-user-inactive.jw-state-playing .jw-media{cursor:none;-webkit-cursor-visibility:auto-hide}.jwplayer.jw-flag-user-inactive.jw-state-playing .jw-captions{max-height:none}.jwplayer.jw-flag-user-inactive.jw-state-playing video::-webkit-media-text-track-container{max-height:none}.jwplayer.jw-flag-user-inactive.jw-state-buffering .jw-controlbar{display:none}.jwplayer.jw-flag-media-audio .jw-controlbar,.jwplayer.jw-flag-media-audio.jw-flag-user-inactive .jw-controlbar{display:table}.jwplayer.jw-flag-media-audio.jw-flag-user-inactive.jw-state-playing .jw-plugin{bottom:3em}.jwplayer.jw-flag-media-audio.jw-flag-user-inactive.jw-state-playing .jw-captions{max-height:81.375%}.jwplayer.jw-flag-media-audio.jw-flag-user-inactive.jw-state-playing video::-webkit-media-text-track-container{max-height:81.375%}.jwplayer.jw-flag-media-audio.jw-flag-user-inactive.jw-state-playing.jw-flag-touch video::-webkit-media-text-track-container{max-height:70%}.jw-flag-media-audio .jw-preview{display:block}.jwplayer.jw-flag-ads .jw-captions.jw-captions-enabled,.jwplayer.jw-flag-ads .jw-dock,.jwplayer.jw-flag-ads .jw-logo,.jwplayer.jw-flag-ads .jw-preview{display:none}.jwplayer.jw-flag-ads video::-webkit-media-text-track-container{display:none}.jwplayer.jw-flag-ads .jw-controlbar .jw-icon-inline,.jwplayer.jw-flag-ads .jw-controlbar .jw-icon-tooltip,.jwplayer.jw-flag-ads .jw-controlbar .jw-slider-horizontal,.jwplayer.jw-flag-ads .jw-controlbar .jw-text{display:none}.jwplayer.jw-flag-ads .jw-controlbar .jw-icon-fullscreen,.jwplayer.jw-flag-ads .jw-controlbar .jw-icon-playback,.jwplayer.jw-flag-ads .jw-controlbar .jw-icon-volume,.jwplayer.jw-flag-ads .jw-controlbar .jw-slider-volume{display:inline-block}.jwplayer.jw-flag-ads .jw-controlbar .jw-text-alt{display:inline}.jwplayer.jw-flag-ads .jw-controlbar .jw-icon-inline.jw-icon-volume,.jwplayer.jw-flag-ads .jw-controlbar .jw-slider-volume.jw-slider-horizontal{display:inline-block}.jwplayer.jw-flag-ads .jw-controlbar .jw-icon-tooltip.jw-icon-volume{display:none}.jwplayer.jw-flag-ads-googleima .jw-controlbar{display:table;bottom:0}.jwplayer.jw-flag-ads-googleima.jw-flag-touch .jw-controlbar{font-size:1em}.jwplayer.jw-flag-ads-googleima.jw-flag-touch.jw-state-paused .jw-display-icon-container{display:none}.jwplayer.jw-flag-ads-googleima.jw-skin-seven .jw-controlbar{font-size:.9em}.jwplayer.jw-flag-ads.jw-flag-touch .jw-controlbar{display:table}.jwplayer.jw-flag-ads-vpaid .jw-controlbar,.jwplayer.jw-flag-touch.jw-flag-ads-vpaid .jw-controlbar{display:none}.jwplayer.jw-flag-ads-hide-controls .jw-controls{display:none!important}.jwplayer.jw-flag-overlay-open-related .jw-controls,.jwplayer.jw-flag-overlay-open-related .jw-title,.jwplayer.jw-flag-overlay-open-sharing .jw-controls,.jwplayer.jw-flag-overlay-open-sharing .jw-title,.jwplayer.jw-flag-overlay-open .jw-controls-right .jw-logo,.jwplayer.jw-flag-overlay-open .jw-title{display:none}.jwplayer.jw-flag-rightclick-open{overflow:visible}.jwplayer.jw-flag-rightclick-open .jw-rightclick{z-index:16777215}.jw-flag-controls-disabled .jw-controls{visibility:hidden}.jw-flag-controls-disabled .jw-logo{visibility:visible}.jw-flag-controls-disabled .jw-media{cursor:auto}.jw-flag-controls-disabled.jwplayer .jw-captions{max-height:none}.jw-flag-controls-disabled.jwplayer video::-webkit-media-text-track-container{max-height:none}body .jwplayer.jw-flag-flash-blocked .jw-title{display:block}body .jwplayer.jw-flag-flash-blocked .jw-controls,body .jwplayer.jw-flag-flash-blocked .jw-overlays,body .jwplayer.jw-flag-flash-blocked .jw-preview{display:none}.jw-flag-touch .jw-controlbar,.jw-flag-touch .jw-plugin,.jw-flag-touch .jw-skip{font-size:1.5em}.jw-flag-touch .jw-captions{bottom:4.25em}.jw-flag-touch video::-webkit-media-text-track-container{max-height:70%}.jw-flag-touch .jw-icon-tooltip.jw-open-drawer:before{display:inline;content:"\\E615"}.jw-flag-touch .jw-display-icon-container{pointer-events:none}.jw-flag-touch.jw-state-paused .jw-display-icon-container{display:table}.jw-flag-compact-player .jw-icon-playlist,.jw-flag-compact-player .jw-text-duration,.jw-flag-compact-player .jw-text-elapsed,.jw-flag-touch.jw-state-paused.jw-flag-dragging .jw-display-icon-container{display:none}.jwplayer.jw-flag-audio-player{background-color:transparent}.jwplayer.jw-flag-audio-player .jw-media{visibility:hidden}.jwplayer.jw-flag-audio-player .jw-media object{width:1px;height:1px}.jwplayer.jw-flag-audio-player .jw-display-icon-container,.jwplayer.jw-flag-audio-player .jw-preview,.jwplayer.jw-flag-audio-player .jw-title{display:none}.jwplayer.jw-flag-audio-player .jw-controlbar{vertical-align:middle;display:table;height:100%;left:0;bottom:0;margin:0;width:100%;min-width:100%}.jwplayer.jw-flag-audio-player .jw-controlbar .jw-icon-fullscreen,.jwplayer.jw-flag-audio-player .jw-controlbar .jw-icon-tooltip{display:none}.jwplayer.jw-flag-audio-player .jw-controlbar .jw-icon-inline.jw-icon-volume,.jwplayer.jw-flag-audio-player .jw-controlbar .jw-slider-volume.jw-slider-horizontal{display:inline-block}.jwplayer.jw-flag-audio-player .jw-controlbar .jw-icon-tooltip.jw-icon-volume{display:none}.jwplayer.jw-flag-audio-player.jw-flag-user-inactive .jw-controlbar{display:table}.jwplayer.jw-flag-audio-player .jw-icon-inline{height:auto;line-height:normal}.jwplayer.jw-flag-audio-player .jw-group{vertical-align:middle}.jwplayer.jw-flag-audio-player .jw-controlbar-center-group{padding-bottom:2px}.jw-skin-seven .jw-color-active,.jw-skin-seven .jw-color-active-hover:hover{color:#fff;stroke:#fff;border-color:#fff}.jw-skin-seven .jw-color-inactive,.jw-skin-seven .jw-color-inactive-hover:hover{color:#cecece;stroke:#cecece;border-color:#cecece}.jw-skin-seven .jw-active-option{background-color:hsla(0,0%,100%,.1)}.jw-skin-seven .jw-display-icon-container{display:table;font-size:20px;border-radius:3.5em}.jw-skin-seven .jw-display-icon-container:hover .jw-icon{color:#fff}.jw-skin-seven .jw-display-icon-container>.jw-icon{color:hsla(0,0%,100%,.9);font-size:1.7em}.jw-skin-seven.jw-state-idle .jw-display-icon-container>.jw-icon{padding-left:4px}.jw-skin-seven .jw-dock-button{border-radius:2.5em}.jw-skin-seven .jw-menu{padding:0}.jw-skin-seven .jw-dock .jw-overlay,.jw-skin-seven .jw-skip{border-radius:.4em}.jw-skin-seven .jw-text{text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}', ""]);
  }, function (e, t) {
    e.exports = function () {
      var e = [];return e.toString = function () {
        for (var e = [], t = 0; t < this.length; t++) {
          var n = this[t];n[2] ? e.push("@media " + n[2] + "{" + n[1] + "}") : e.push(n[1]);
        }return e.join("");
      }, e.i = function (t, n) {
        "string" == typeof t && (t = [[null, t, ""]]);for (var i = {}, o = 0; o < this.length; o++) {
          var r = this[o][0];"number" == typeof r && (i[r] = !0);
        }for (o = 0; o < t.length; o++) {
          var a = t[o];"number" == typeof a[0] && i[a[0]] || (n && !a[2] ? a[2] = n : n && (a[2] = "(" + a[2] + ") and (" + n + ")"), e.push(a));
        }
      }, e;
    };
  }, function (e, t, n) {
    e.exports = n.p + "jw-icons.ttf";
  }, function (e, t, n) {
    e.exports = n.p + "jw-icons.woff";
  }, function (e, t, n) {
    var i = n(11);e.exports = (i["default"] || i).template({ compiler: [7, ">= 4.0.0"], main: function main(e, t, n, i, o) {
        return '<div class="jw-skip jw-background-color jw-hidden jw-reset">\n    <span class="jw-text jw-skiptext jw-reset"></span>\n    <span class="jw-icon-inline jw-skip-icon jw-reset"></span>\n</div>';
      }, useData: !0 });
  }, function (e, t, n) {
    var i = n(11);e.exports = (i["default"] || i).template({ compiler: [7, ">= 4.0.0"], main: function main(e, t, n, i, o) {
        var r;return '<div class="jw-display-icon-container jw-background-color jw-reset">\n    <div class="jw-icon jw-icon-display jw-button-color jw-reset" role="button" tabindex="0" aria-label="' + e.escapeExpression((r = null != (r = n.ariaLabel || (null != t ? t.ariaLabel : t)) ? r : n.helperMissing, "function" == typeof r ? r.call(null != t ? t : {}, { name: "ariaLabel", hash: {}, data: o }) : r)) + '"></div>\n</div>\n';
      }, useData: !0 });
  }, function (e, t, n) {
    var i = n(11);e.exports = (i["default"] || i).template({ 1: function _(e, t, n, i, o) {
        var r,
            a,
            s = null != t ? t : {};return '    <div class="jw-dock-button jw-background-color jw-reset' + (null != (r = n["if"].call(s, null != t ? t.btnClass : t, { name: "if", hash: {}, fn: e.program(2, o, 0), inverse: e.noop, data: o })) ? r : "") + '" button="' + e.escapeExpression((a = null != (a = n.id || (null != t ? t.id : t)) ? a : n.helperMissing, "function" == typeof a ? a.call(s, { name: "id", hash: {}, data: o }) : a)) + '">\n        <div class="jw-icon jw-dock-image jw-reset" ' + (null != (r = n["if"].call(s, null != t ? t.img : t, { name: "if", hash: {}, fn: e.program(4, o, 0), inverse: e.noop, data: o })) ? r : "") + '></div>\n        <div class="jw-arrow jw-reset"></div>\n' + (null != (r = n["if"].call(s, null != t ? t.tooltip : t, { name: "if", hash: {}, fn: e.program(6, o, 0), inverse: e.noop, data: o })) ? r : "") + "    </div>\n";
      }, 2: function _(e, t, n, i, o) {
        var r;return " " + e.escapeExpression((r = null != (r = n.btnClass || (null != t ? t.btnClass : t)) ? r : n.helperMissing, "function" == typeof r ? r.call(null != t ? t : {}, { name: "btnClass", hash: {}, data: o }) : r));
      }, 4: function _(e, t, n, i, o) {
        var r;return "style='background-image: url(\"" + e.escapeExpression((r = null != (r = n.img || (null != t ? t.img : t)) ? r : n.helperMissing, "function" == typeof r ? r.call(null != t ? t : {}, { name: "img", hash: {}, data: o }) : r)) + "\")'";
      }, 6: function _(e, t, n, i, o) {
        var r;return '        <div class="jw-overlay jw-background-color jw-reset">\n            <span class="jw-text jw-dock-text jw-reset">' + e.escapeExpression((r = null != (r = n.tooltip || (null != t ? t.tooltip : t)) ? r : n.helperMissing, "function" == typeof r ? r.call(null != t ? t : {}, { name: "tooltip", hash: {}, data: o }) : r)) + "</span>\n        </div>\n";
      }, compiler: [7, ">= 4.0.0"], main: function main(e, t, n, i, o) {
        var r;return '<div class="jw-dock jw-reset">\n' + (null != (r = n.each.call(null != t ? t : {}, t, { name: "each", hash: {}, fn: e.program(1, o, 0), inverse: e.noop, data: o })) ? r : "") + "</div>";
      }, useData: !0 });
  }, function (e, t, n) {
    var i = n(11);e.exports = (i["default"] || i).template({ compiler: [7, ">= 4.0.0"], main: function main(e, t, n, i, o) {
        var r,
            a = null != t ? t : {},
            s = n.helperMissing,
            l = "function",
            c = e.escapeExpression;return '<div id="' + c((r = null != (r = n.id || (null != t ? t.id : t)) ? r : s, (typeof r === "undefined" ? "undefined" : _typeof(r)) === l ? r.call(a, { name: "id", hash: {}, data: o }) : r)) + '"class="jw-skin-' + c((r = null != (r = n.skin || (null != t ? t.skin : t)) ? r : s, (typeof r === "undefined" ? "undefined" : _typeof(r)) === l ? r.call(a, { name: "skin", hash: {}, data: o }) : r)) + ' jw-error jw-reset">\n    <div class="jw-title jw-reset">\n        <div class="jw-title-primary jw-reset">' + c((r = null != (r = n.title || (null != t ? t.title : t)) ? r : s, (typeof r === "undefined" ? "undefined" : _typeof(r)) === l ? r.call(a, { name: "title", hash: {}, data: o }) : r)) + '</div>\n        <div class="jw-title-secondary jw-reset">' + c((r = null != (r = n.body || (null != t ? t.body : t)) ? r : s, (typeof r === "undefined" ? "undefined" : _typeof(r)) === l ? r.call(a, { name: "body", hash: {}, data: o }) : r)) + '</div>\n    </div>\n\n    <div class="jw-icon-container jw-reset">\n        <div class="jw-display-icon-container jw-background-color jw-reset">\n            <div class="jw-icon jw-icon-display jw-reset" aria-hidden="true"></div>\n        </div>\n    </div>\n</div>\n';
      }, useData: !0 });
  }, function (e, t, n) {
    var i = n(11);e.exports = (i["default"] || i).template({ compiler: [7, ">= 4.0.0"], main: function main(e, t, n, i, o) {
        return '<div class="jw-logo jw-reset"></div>';
      }, useData: !0 });
  }, function (e, t, n) {
    var i = n(11);e.exports = (i["default"] || i).template({ 1: function _(e, t, n, i, o) {
        var r,
            a = e.escapeExpression;return "        <li class='jw-text jw-option jw-item-" + a((r = null != (r = n.index || o && o.index) ? r : n.helperMissing, "function" == typeof r ? r.call(null != t ? t : {}, { name: "index", hash: {}, data: o }) : r)) + " jw-reset'>" + a(e.lambda(null != t ? t.label : t, t)) + "</li>\n";
      }, compiler: [7, ">= 4.0.0"], main: function main(e, t, n, i, o) {
        var r;return '<ul class="jw-menu jw-background-color jw-reset">\n' + (null != (r = n.each.call(null != t ? t : {}, t, { name: "each", hash: {}, fn: e.program(1, o, 0), inverse: e.noop, data: o })) ? r : "") + "</ul>";
      }, useData: !0 });
  }, function (e, t, n) {
    var i = n(11);e.exports = (i["default"] || i).template({ compiler: [7, ">= 4.0.0"], main: function main(e, t, n, i, o) {
        var r;return '<div id="' + e.escapeExpression((r = null != (r = n.id || (null != t ? t.id : t)) ? r : n.helperMissing, "function" == typeof r ? r.call(null != t ? t : {}, { name: "id", hash: {}, data: o }) : r)) + '" class="jwplayer jw-reset jw-state-idle" tabindex="0">\n    <div class="jw-aspect jw-reset"></div>\n    <div class="jw-media jw-reset"></div>\n    <div class="jw-preview jw-reset"></div>\n    <div class="jw-title jw-reset">\n        <div class="jw-title-primary jw-reset"></div>\n        <div class="jw-title-secondary jw-reset"></div>\n    </div>\n    <div class="jw-overlays jw-reset"></div>\n    <div class="jw-controls jw-reset"></div>\n</div>';
      }, useData: !0 });
  }, function (e, t, n) {
    var i = n(11);e.exports = (i["default"] || i).template({ 1: function _(e, t, n, i, o) {
        var r;return null != (r = n["if"].call(null != t ? t : {}, null != t ? t.active : t, { name: "if", hash: {}, fn: e.program(2, o, 0), inverse: e.program(4, o, 0), data: o })) ? r : "";
      }, 2: function _(e, t, n, i, o) {
        var r,
            a = e.escapeExpression;return "                <li class='jw-option jw-text jw-active-option jw-item-" + a((r = null != (r = n.index || o && o.index) ? r : n.helperMissing, "function" == typeof r ? r.call(null != t ? t : {}, { name: "index", hash: {}, data: o }) : r)) + ' jw-reset\'>\n                    <span class="jw-label jw-reset"><span class="jw-icon jw-icon-play jw-reset"></span></span>\n                    <span class="jw-name jw-reset">' + a(e.lambda(null != t ? t.title : t, t)) + "</span>\n                </li>\n";
      }, 4: function _(e, t, n, i, o) {
        var r,
            a = e.escapeExpression,
            s = e.lambda;return "                <li class='jw-option jw-text jw-item-" + a((r = null != (r = n.index || o && o.index) ? r : n.helperMissing, "function" == typeof r ? r.call(null != t ? t : {}, { name: "index", hash: {}, data: o }) : r)) + ' jw-reset\'>\n                    <span class="jw-label jw-reset">' + a(s(null != t ? t.label : t, t)) + '</span>\n                    <span class="jw-name jw-reset">' + a(s(null != t ? t.title : t, t)) + "</span>\n                </li>\n";
      }, compiler: [7, ">= 4.0.0"], main: function main(e, t, n, i, o) {
        var r;return '<div class="jw-menu jw-playlist-container jw-background-color jw-reset">\n\n    <div class="jw-tooltip-title jw-reset">\n        <span class="jw-icon jw-icon-inline jw-icon-playlist jw-reset"></span>\n        <span class="jw-text jw-reset">PLAYLIST</span>\n    </div>\n\n    <ul class="jw-playlist jw-reset">\n' + (null != (r = n.each.call(null != t ? t : {}, t, { name: "each", hash: {}, fn: e.program(1, o, 0), inverse: e.noop, data: o })) ? r : "") + "    </ul>\n</div>";
      }, useData: !0 });
  }, function (e, t, n) {
    var i = n(11);e.exports = (i["default"] || i).template({ 1: function _(e, t, n, i, o) {
        var r,
            a,
            s = null != t ? t : {},
            l = n.helperMissing,
            c = "function",
            u = e.escapeExpression;return '        <li class="jw-reset' + (null != (r = n["if"].call(s, null != t ? t.featured : t, { name: "if", hash: {}, fn: e.program(2, o, 0), inverse: e.noop, data: o })) ? r : "") + '">\n            <a href="' + u((a = null != (a = n.link || (null != t ? t.link : t)) ? a : l, (typeof a === "undefined" ? "undefined" : _typeof(a)) === c ? a.call(s, { name: "link", hash: {}, data: o }) : a)) + '" class="jw-reset" target="_top">\n' + (null != (r = n["if"].call(s, null != t ? t.showLogo : t, { name: "if", hash: {}, fn: e.program(4, o, 0), inverse: e.noop, data: o })) ? r : "") + "                " + u((a = null != (a = n.title || (null != t ? t.title : t)) ? a : l, (typeof a === "undefined" ? "undefined" : _typeof(a)) === c ? a.call(s, { name: "title", hash: {}, data: o }) : a)) + "\n            </a>\n        </li>\n";
      }, 2: function _(e, t, n, i, o) {
        return " jw-featured";
      }, 4: function _(e, t, n, i, o) {
        return '                <span class="jw-icon jw-rightclick-logo jw-reset"></span>\n';
      }, compiler: [7, ">= 4.0.0"], main: function main(e, t, n, i, o) {
        var r;return '<div class="jw-rightclick jw-reset">\n    <ul class="jw-reset">\n' + (null != (r = n.each.call(null != t ? t : {}, null != t ? t.items : t, { name: "each", hash: {}, fn: e.program(1, o, 0), inverse: e.noop, data: o })) ? r : "") + "    </ul>\n</div>";
      }, useData: !0 });
  }, function (e, t, n) {
    var i = n(11);e.exports = (i["default"] || i).template({ compiler: [7, ">= 4.0.0"], main: function main(e, t, n, i, o) {
        var r,
            a = null != t ? t : {},
            s = n.helperMissing,
            l = "function",
            c = e.escapeExpression;return '<div class="' + c((r = null != (r = n.className || (null != t ? t.className : t)) ? r : s, (typeof r === "undefined" ? "undefined" : _typeof(r)) === l ? r.call(a, { name: "className", hash: {}, data: o }) : r)) + " " + c((r = null != (r = n.orientation || (null != t ? t.orientation : t)) ? r : s, (typeof r === "undefined" ? "undefined" : _typeof(r)) === l ? r.call(a, { name: "orientation", hash: {}, data: o }) : r)) + ' jw-reset" aria-hidden="true">\n    <div class="jw-slider-container jw-reset">\n        <div class="jw-rail jw-reset"></div>\n        <div class="jw-buffer jw-reset"></div>\n        <div class="jw-progress jw-reset"></div>\n        <div class="jw-knob jw-reset"></div>\n    </div>\n</div>';
      }, useData: !0 });
  },, function (e, t, n) {
    "use strict";
    function i(e) {
      return e && e.__esModule ? e : { "default": e };
    }function o(e) {
      if (e && e.__esModule) return e;var t = {};if (null != e) for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }return t["default"] = e, t;
    }function r() {
      var e = new s.HandlebarsEnvironment();return h.extend(e, s), e.SafeString = c["default"], e.Exception = d["default"], e.Utils = h, e.escapeExpression = h.escapeExpression, e.VM = g, e.template = function (t) {
        return g.template(t, e);
      }, e;
    }t.__esModule = !0;var a = n(61),
        s = o(a),
        l = n(155),
        c = i(l),
        u = n(26),
        d = i(u),
        p = n(12),
        h = o(p),
        f = n(154),
        g = o(f),
        m = n(153),
        v = i(m),
        w = r();w.create = r, v["default"](w), w["default"] = w, t["default"] = w, e.exports = t["default"];
  }, function (e, t, n) {
    "use strict";
    function i(e) {
      return e && e.__esModule ? e : { "default": e };
    }function o(e) {
      a["default"](e);
    }t.__esModule = !0, t.registerDefaultDecorators = o;var r = n(143),
        a = i(r);
  }, function (e, t, n) {
    "use strict";
    t.__esModule = !0;var i = n(12);t["default"] = function (e) {
      e.registerDecorator("inline", function (e, t, n, o) {
        var r = e;return t.partials || (t.partials = {}, r = function r(o, _r3) {
          var a = n.partials;n.partials = i.extend({}, a, t.partials);var s = e(o, _r3);return n.partials = a, s;
        }), t.partials[o.args[0]] = o.fn, r;
      });
    }, e.exports = t["default"];
  }, function (e, t, n) {
    "use strict";
    function i(e) {
      return e && e.__esModule ? e : { "default": e };
    }function o(e) {
      a["default"](e), l["default"](e), u["default"](e), p["default"](e), f["default"](e), m["default"](e), w["default"](e);
    }t.__esModule = !0, t.registerDefaultHelpers = o;var r = n(145),
        a = i(r),
        s = n(146),
        l = i(s),
        c = n(147),
        u = i(c),
        d = n(148),
        p = i(d),
        h = n(149),
        f = i(h),
        g = n(150),
        m = i(g),
        v = n(151),
        w = i(v);
  }, function (e, t, n) {
    "use strict";
    t.__esModule = !0;var i = n(12);t["default"] = function (e) {
      e.registerHelper("blockHelperMissing", function (t, n) {
        var o = n.inverse,
            r = n.fn;if (t === !0) return r(this);if (t === !1 || null == t) return o(this);if (i.isArray(t)) return t.length > 0 ? (n.ids && (n.ids = [n.name]), e.helpers.each(t, n)) : o(this);if (n.data && n.ids) {
          var a = i.createFrame(n.data);a.contextPath = i.appendContextPath(n.data.contextPath, n.name), n = { data: a };
        }return r(t, n);
      });
    }, e.exports = t["default"];
  }, function (e, t, n) {
    "use strict";
    function i(e) {
      return e && e.__esModule ? e : { "default": e };
    }t.__esModule = !0;var o = n(12),
        r = n(26),
        a = i(r);t["default"] = function (e) {
      e.registerHelper("each", function (e, t) {
        function n(t, n, r) {
          c && (c.key = t, c.index = n, c.first = 0 === n, c.last = !!r, u && (c.contextPath = u + t)), l += i(e[t], { data: c, blockParams: o.blockParams([e[t], t], [u + t, null]) });
        }if (!t) throw new a["default"]("Must pass iterator to #each");var i = t.fn,
            r = t.inverse,
            s = 0,
            l = "",
            c = void 0,
            u = void 0;if (t.data && t.ids && (u = o.appendContextPath(t.data.contextPath, t.ids[0]) + "."), o.isFunction(e) && (e = e.call(this)), t.data && (c = o.createFrame(t.data)), e && "object" == (typeof e === "undefined" ? "undefined" : _typeof(e))) if (o.isArray(e)) for (var d = e.length; s < d; s++) {
          s in e && n(s, s, s === e.length - 1);
        } else {
          var p = void 0;for (var h in e) {
            e.hasOwnProperty(h) && (void 0 !== p && n(p, s - 1), p = h, s++);
          }void 0 !== p && n(p, s - 1, !0);
        }return 0 === s && (l = r(this)), l;
      });
    }, e.exports = t["default"];
  }, function (e, t, n) {
    "use strict";
    function i(e) {
      return e && e.__esModule ? e : { "default": e };
    }t.__esModule = !0;var o = n(26),
        r = i(o);t["default"] = function (e) {
      e.registerHelper("helperMissing", function () {
        if (1 !== arguments.length) throw new r["default"]('Missing helper: "' + arguments[arguments.length - 1].name + '"');
      });
    }, e.exports = t["default"];
  }, function (e, t, n) {
    "use strict";
    t.__esModule = !0;var i = n(12);t["default"] = function (e) {
      e.registerHelper("if", function (e, t) {
        return i.isFunction(e) && (e = e.call(this)), !t.hash.includeZero && !e || i.isEmpty(e) ? t.inverse(this) : t.fn(this);
      }), e.registerHelper("unless", function (t, n) {
        return e.helpers["if"].call(this, t, { fn: n.inverse, inverse: n.fn, hash: n.hash });
      });
    }, e.exports = t["default"];
  }, function (e, t) {
    "use strict";
    t.__esModule = !0, t["default"] = function (e) {
      e.registerHelper("log", function () {
        for (var t = [void 0], n = arguments[arguments.length - 1], i = 0; i < arguments.length - 1; i++) {
          t.push(arguments[i]);
        }var o = 1;null != n.hash.level ? o = n.hash.level : n.data && null != n.data.level && (o = n.data.level), t[0] = o, e.log.apply(e, t);
      });
    }, e.exports = t["default"];
  }, function (e, t) {
    "use strict";
    t.__esModule = !0, t["default"] = function (e) {
      e.registerHelper("lookup", function (e, t) {
        return e && e[t];
      });
    }, e.exports = t["default"];
  }, function (e, t, n) {
    "use strict";
    t.__esModule = !0;var i = n(12);t["default"] = function (e) {
      e.registerHelper("with", function (e, t) {
        i.isFunction(e) && (e = e.call(this));var n = t.fn;if (i.isEmpty(e)) return t.inverse(this);var o = t.data;return t.data && t.ids && (o = i.createFrame(t.data), o.contextPath = i.appendContextPath(t.data.contextPath, t.ids[0])), n(e, { data: o, blockParams: i.blockParams([e], [o && o.contextPath]) });
      });
    }, e.exports = t["default"];
  }, function (e, t, n) {
    "use strict";
    t.__esModule = !0;var i = n(12),
        o = { methodMap: ["debug", "info", "warn", "error"], level: "info", lookupLevel: function lookupLevel(e) {
        if ("string" == typeof e) {
          var t = i.indexOf(o.methodMap, e.toLowerCase());e = t >= 0 ? t : parseInt(e, 10);
        }return e;
      }, log: function log(e) {
        if (e = o.lookupLevel(e), "undefined" != typeof console && o.lookupLevel(o.level) <= e) {
          var t = o.methodMap[e];console[t] || (t = "log");for (var n = arguments.length, i = Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++) {
            i[r - 1] = arguments[r];
          }console[t].apply(console, i);
        }
      } };t["default"] = o, e.exports = t["default"];
  }, function (e, t) {
    (function (n) {
      "use strict";
      t.__esModule = !0, t["default"] = function (e) {
        var t = "undefined" != typeof n ? n : window,
            i = t.Handlebars;e.noConflict = function () {
          return t.Handlebars === e && (t.Handlebars = i), e;
        };
      }, e.exports = t["default"];
    }).call(t, function () {
      return this;
    }());
  }, function (e, t, n) {
    "use strict";
    function i(e) {
      return e && e.__esModule ? e : { "default": e };
    }function o(e) {
      if (e && e.__esModule) return e;var t = {};if (null != e) for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }return t["default"] = e, t;
    }function r(e) {
      var t = e && e[0] || 1,
          n = v.COMPILER_REVISION;if (t !== n) {
        if (t < n) {
          var i = v.REVISION_CHANGES[n],
              o = v.REVISION_CHANGES[t];throw new m["default"]("Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" + i + ") or downgrade your runtime to an older version (" + o + ").");
        }throw new m["default"]("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" + e[1] + ").");
      }
    }function a(e, t) {
      function n(n, i, o) {
        o.hash && (i = f.extend({}, i, o.hash), o.ids && (o.ids[0] = !0)), n = t.VM.resolvePartial.call(this, n, i, o);var r = t.VM.invokePartial.call(this, n, i, o);if (null == r && t.compile && (o.partials[o.name] = t.compile(n, e.compilerOptions, t), r = o.partials[o.name](i, o)), null != r) {
          if (o.indent) {
            for (var a = r.split("\n"), s = 0, l = a.length; s < l && (a[s] || s + 1 !== l); s++) {
              a[s] = o.indent + a[s];
            }r = a.join("\n");
          }return r;
        }throw new m["default"]("The partial " + o.name + " could not be compiled when running in runtime-only mode");
      }function i(t) {
        function n(t) {
          return "" + e.main(o, t, o.helpers, o.partials, a, l, s);
        }var r = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1],
            a = r.data;i._setup(r), !r.partial && e.useData && (a = d(t, a));var s = void 0,
            l = e.useBlockParams ? [] : void 0;return e.useDepths && (s = r.depths ? t !== r.depths[0] ? [t].concat(r.depths) : r.depths : [t]), (n = p(e.main, n, o, r.depths || [], a, l))(t, r);
      }if (!t) throw new m["default"]("No environment passed to template");if (!e || !e.main) throw new m["default"]("Unknown template object: " + (typeof e === "undefined" ? "undefined" : _typeof(e)));e.main.decorator = e.main_d, t.VM.checkRevision(e.compiler);var o = { strict: function strict(e, t) {
          if (!(t in e)) throw new m["default"]('"' + t + '" not defined in ' + e);return e[t];
        }, lookup: function lookup(e, t) {
          for (var n = e.length, i = 0; i < n; i++) {
            if (e[i] && null != e[i][t]) return e[i][t];
          }
        }, lambda: function lambda(e, t) {
          return "function" == typeof e ? e.call(t) : e;
        }, escapeExpression: f.escapeExpression, invokePartial: n, fn: function fn(t) {
          var n = e[t];return n.decorator = e[t + "_d"], n;
        }, programs: [], program: function program(e, t, n, i, o) {
          var r = this.programs[e],
              a = this.fn(e);return t || o || i || n ? r = s(this, e, a, t, n, i, o) : r || (r = this.programs[e] = s(this, e, a)), r;
        }, data: function data(e, t) {
          for (; e && t--;) {
            e = e._parent;
          }return e;
        }, merge: function merge(e, t) {
          var n = e || t;return e && t && e !== t && (n = f.extend({}, t, e)), n;
        }, noop: t.VM.noop, compilerInfo: e.compiler };return i.isTop = !0, i._setup = function (n) {
        n.partial ? (o.helpers = n.helpers, o.partials = n.partials, o.decorators = n.decorators) : (o.helpers = o.merge(n.helpers, t.helpers), e.usePartial && (o.partials = o.merge(n.partials, t.partials)), (e.usePartial || e.useDecorators) && (o.decorators = o.merge(n.decorators, t.decorators)));
      }, i._child = function (t, n, i, r) {
        if (e.useBlockParams && !i) throw new m["default"]("must pass block params");if (e.useDepths && !r) throw new m["default"]("must pass parent depths");return s(o, t, e[t], n, 0, i, r);
      }, i;
    }function s(e, t, n, i, o, r, a) {
      function s(t) {
        var o = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1],
            s = a;return a && t !== a[0] && (s = [t].concat(a)), n(e, t, e.helpers, e.partials, o.data || i, r && [o.blockParams].concat(r), s);
      }return s = p(n, s, e, a, i, r), s.program = t, s.depth = a ? a.length : 0, s.blockParams = o || 0, s;
    }function l(e, t, n) {
      return e ? e.call || n.name || (n.name = e, e = n.partials[e]) : e = "@partial-block" === n.name ? n.data["partial-block"] : n.partials[n.name], e;
    }function c(e, t, n) {
      n.partial = !0, n.ids && (n.data.contextPath = n.ids[0] || n.data.contextPath);var i = void 0;if (n.fn && n.fn !== u && (n.data = v.createFrame(n.data), i = n.data["partial-block"] = n.fn, i.partials && (n.partials = f.extend({}, n.partials, i.partials))), void 0 === e && i && (e = i), void 0 === e) throw new m["default"]("The partial " + n.name + " could not be found");if (e instanceof Function) return e(t, n);
    }function u() {
      return "";
    }function d(e, t) {
      return t && "root" in t || (t = t ? v.createFrame(t) : {}, t.root = e), t;
    }function p(e, t, n, i, o, r) {
      if (e.decorator) {
        var a = {};t = e.decorator(t, a, n, i && i[0], o, r, i), f.extend(t, a);
      }return t;
    }t.__esModule = !0, t.checkRevision = r, t.template = a, t.wrapProgram = s, t.resolvePartial = l, t.invokePartial = c, t.noop = u;var h = n(12),
        f = o(h),
        g = n(26),
        m = i(g),
        v = n(61);
  }, function (e, t) {
    "use strict";
    function n(e) {
      this.string = e;
    }t.__esModule = !0, n.prototype.toString = n.prototype.toHTML = function () {
      return "" + this.string;
    }, t["default"] = n, e.exports = t["default"];
  }, function (e, t, n) {
    var i, o;i = [n(27), n(1)], o = function (e, t) {
      return function (n, i) {
        var o = ["seek", "skipAd", "stop", "playlistNext", "playlistPrev", "playlistItem", "resize", "addButton", "removeButton", "registerPlugin", "attachMedia"];t.each(o, function (e) {
          n[e] = function () {
            return i[e].apply(i, arguments), n;
          };
        }), n.registerPlugin = e.registerPlugin;
      };
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(1)], o = function (e) {
      return function (t, n) {
        var i = ["buffer", "controls", "position", "duration", "fullscreen", "volume", "mute", "item", "stretching", "playlist", "captions"];e.each(i, function (e) {
          var i = e.slice(0, 1).toUpperCase() + e.slice(1);t["get" + i] = function () {
            return n._model.get(e);
          };
        });var o = ["getAudioTracks", "getCaptionsList", "getWidth", "getHeight", "getCurrentAudioTrack", "setCurrentAudioTrack", "getCurrentCaptions", "setCurrentCaptions", "getCurrentQuality", "setCurrentQuality", "getQualityLevels", "getVisualQuality", "getConfig", "getState", "getSafeRegion", "isBeforeComplete", "isBeforePlay", "getProvider", "detachMedia"],
            r = ["setControls", "setFullscreen", "setVolume", "setMute", "setCues", "setCaptions"];e.each(o, function (e) {
          t[e] = function () {
            return n[e] ? n[e].apply(n, arguments) : null;
          };
        }), e.each(r, function (e) {
          t[e] = function () {
            return n[e].apply(n, arguments), t;
          };
        }), t.getPlaylistIndex = t.getItem;
      };
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(4), n(5), n(3), n(2), n(79), n(1), n(210), n(156), n(157), n(159), n(30)], o = function (e, t, n, i, o, r, a, s, l, c, u) {
      var d = function d(_d2, p) {
        var h,
            f = this,
            g = !1,
            m = {};r.extend(this, n), this.utils = i, this._ = r, this.Events = n, this.version = u, this.trigger = function (e, t) {
          return t = r.isObject(t) ? r.extend({}, t) : {}, t.type = e, window.jwplayer && window.jwplayer.debug ? n.trigger.call(f, e, t) : n.triggerSafe.call(f, e, t);
        }, this.dispatchEvent = this.trigger, this.removeEventListener = this.off.bind(this);var v = function v() {
          h = new a(_d2), s(f, h), l(f, h), h.on(e.JWPLAYER_PLAYLIST_ITEM, function () {
            m = {};
          }), h.on(e.JWPLAYER_MEDIA_META, function (e) {
            r.extend(m, e.metadata);
          }), h.on(e.JWPLAYER_READY, function (e) {
            g = !0, w.tick("ready"), e.setupTime = w.between("setup", "ready");
          }), h.on("all", f.trigger);
        };v(), c(this), this.id = _d2.id;var w = this._qoe = new o();w.tick("init");var y = function y() {
          g = !1, m = {}, f.off(), h && h.off(), h && h.playerDestroy && h.playerDestroy();
        };return this.getPlugin = function (e) {
          return f.plugins && f.plugins[e];
        }, this.addPlugin = function (e, t) {
          this.plugins = this.plugins || {}, this.plugins[e] = t, this.onReady(t.addToPlayer), t.resize && this.onResize(t.resizeHandler);
        }, this.setup = function (e) {
          return w.tick("setup"), y(), v(), i.foreach(e.events, function (e, t) {
            var n = f[e];"function" == typeof n && n.call(f, t);
          }), e.id = f.id, h.setup(e, this), f;
        }, this.qoe = function () {
          var t = h.getItemQoe(),
              n = w.between("setup", "ready"),
              i = t.between(e.JWPLAYER_MEDIA_PLAY_ATTEMPT, e.JWPLAYER_MEDIA_FIRST_FRAME);return { setupTime: n, firstFrame: i, player: w.dump(), item: t.dump() };
        }, this.getContainer = function () {
          return h.getContainer ? h.getContainer() : _d2;
        }, this.getMeta = this.getItemMeta = function () {
          return m;
        }, this.getPlaylistItem = function (e) {
          if (!i.exists(e)) return h._model.get("playlistItem");var t = f.getPlaylist();return t ? t[e] : null;
        }, this.getRenderingMode = function () {
          return "html5";
        }, this.load = function (e) {
          var t = this.getPlugin("vast") || this.getPlugin("googima");return t && t.destroy(), h.load(e), f;
        }, this.play = function (e, n) {
          if (r.isBoolean(e) || (n = e), n || (n = { reason: "external" }), e === !0) return h.play(n), f;if (e === !1) return h.pause(), f;switch (e = f.getState()) {case t.PLAYING:case t.BUFFERING:
              h.pause();break;default:
              h.play(n);}return f;
        }, this.pause = function (e) {
          return r.isBoolean(e) ? this.play(!e) : this.play();
        }, this.createInstream = function () {
          return h.createInstream();
        }, this.castToggle = function () {
          h && h.castToggle && h.castToggle();
        }, this.playAd = this.pauseAd = i.noop, this.remove = function () {
          return p(f), f.trigger("remove"), y(), f;
        }, this;
      };return d;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(1), n(4)], o = function (e, t) {
      return function (n) {
        var i = { onBufferChange: t.JWPLAYER_MEDIA_BUFFER, onBufferFull: t.JWPLAYER_MEDIA_BUFFER_FULL, onError: t.JWPLAYER_ERROR, onSetupError: t.JWPLAYER_SETUP_ERROR, onFullscreen: t.JWPLAYER_FULLSCREEN, onMeta: t.JWPLAYER_MEDIA_META, onMute: t.JWPLAYER_MEDIA_MUTE, onPlaylist: t.JWPLAYER_PLAYLIST_LOADED, onPlaylistItem: t.JWPLAYER_PLAYLIST_ITEM, onPlaylistComplete: t.JWPLAYER_PLAYLIST_COMPLETE, onReady: t.JWPLAYER_READY, onResize: t.JWPLAYER_RESIZE, onComplete: t.JWPLAYER_MEDIA_COMPLETE, onSeek: t.JWPLAYER_MEDIA_SEEK, onTime: t.JWPLAYER_MEDIA_TIME, onVolume: t.JWPLAYER_MEDIA_VOLUME, onBeforePlay: t.JWPLAYER_MEDIA_BEFOREPLAY, onBeforeComplete: t.JWPLAYER_MEDIA_BEFORECOMPLETE, onDisplayClick: t.JWPLAYER_DISPLAY_CLICK, onControls: t.JWPLAYER_CONTROLS, onQualityLevels: t.JWPLAYER_MEDIA_LEVELS, onQualityChange: t.JWPLAYER_MEDIA_LEVEL_CHANGED, onCaptionsList: t.JWPLAYER_CAPTIONS_LIST, onCaptionsChange: t.JWPLAYER_CAPTIONS_CHANGED, onAdError: t.JWPLAYER_AD_ERROR, onAdClick: t.JWPLAYER_AD_CLICK, onAdImpression: t.JWPLAYER_AD_IMPRESSION, onAdTime: t.JWPLAYER_AD_TIME, onAdComplete: t.JWPLAYER_AD_COMPLETE, onAdCompanions: t.JWPLAYER_AD_COMPANIONS, onAdSkipped: t.JWPLAYER_AD_SKIPPED, onAdPlay: t.JWPLAYER_AD_PLAY, onAdPause: t.JWPLAYER_AD_PAUSE, onAdMeta: t.JWPLAYER_AD_META, onCast: t.JWPLAYER_CAST_SESSION, onAudioTrackChange: t.JWPLAYER_AUDIO_TRACK_CHANGED, onAudioTracks: t.JWPLAYER_AUDIO_TRACKS },
            o = { onBuffer: "buffer", onPause: "pause", onPlay: "play", onIdle: "idle" };e.each(o, function (t, i) {
          n[i] = e.partial(n.on, t, e);
        }), e.each(i, function (t, i) {
          n[i] = e.partial(n.on, t, e);
        });
      };
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(158), n(1), n(49), n(48), n(27)], o = function (e, t, n, i, o) {
      var r = [],
          a = 0,
          s = function s(t) {
        var n, i;return t ? "string" == typeof t ? (n = l(t), n || (i = document.getElementById(t))) : "number" == typeof t ? n = r[t] : t.nodeType && (i = t, n = l(i.id)) : n = r[0], n ? n : i ? c(new e(i, u)) : { registerPlugin: o.registerPlugin };
      },
          l = function l(e) {
        for (var t = 0; t < r.length; t++) {
          if (r[t].id === e) return r[t];
        }return null;
      },
          c = function c(e) {
        return a++, e.uniqueId = a, r.push(e), e;
      },
          u = function u(e) {
        for (var t = r.length; t--;) {
          if (r[t].uniqueId === e.uniqueId) {
            r.splice(t, 1);break;
          }
        }
      },
          d = { selectPlayer: s, registerProvider: n.registerProvider, availableProviders: i, registerPlugin: o.registerPlugin };return s.api = d, d;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(211), n(3), n(1), n(4)], o = function (e, t, n, i) {
      var o = function o(t, _o3, r, a) {
        function s() {
          p("Setup Timeout Error", "Setup took longer than " + m + " seconds to complete.");
        }function l() {
          n.each(g, function (e) {
            e.complete !== !0 && e.running !== !0 && null !== t && u(e.depends) && (e.running = !0, c(e));
          });
        }function c(e) {
          var n = function n(t) {
            t = t || {}, d(e, t);
          };e.method(n, _o3, t, r, a);
        }function u(e) {
          return n.all(e, function (e) {
            return g[e].complete;
          });
        }function d(e, t) {
          "error" === t.type ? p(t.msg, t.reason) : "complete" === t.type ? (clearTimeout(h), f.trigger(i.JWPLAYER_READY)) : (e.complete = !0, l());
        }function p(e, t) {
          clearTimeout(h), f.trigger(i.JWPLAYER_SETUP_ERROR, { message: e + ": " + t }), f.destroy();
        }var h,
            f = this,
            g = e.getQueue(),
            m = 30;this.start = function () {
          h = setTimeout(s, 1e3 * m), l();
        }, this.destroy = function () {
          clearTimeout(h), this.off(), g.length = 0, t = null, _o3 = null, r = null;
        };
      };return o.prototype = t, o;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [], o = function () {
      var e = function e(_e3, t) {
        function n(e) {
          if (e.tracks.length) {
            d = [], p = {}, h = {}, f = 0;for (var t = e.tracks || [], n = 0; n < t.length; n++) {
              var i = t[n];i.label = i.label || i.name || i.language, a(i);
            }var o = s();this.setCaptionsList(o), l();
          }
        }function i(e, t) {
          u = t, d = [], p = {}, h = {}, f = 0;
        }function o(e) {
          i(t, e), t.mediaController.on("subtitlesTracks", n, this);var o = s();this.setCaptionsList(o), l();
        }function r(e, t) {
          var n = null;0 !== t && (n = d[t - 1]), e.set("captionsTrack", n);
        }function a(e) {
          e.data = e.data || [], e.label || (e.label = "Unknown CC", f++, f > 1 && (e.label += " (" + f + ")")), d.push(e), p[e._id] = e;
        }function s() {
          for (var e = [{ id: "off", label: "Off" }], t = 0; t < d.length; t++) {
            e.push({ id: d[t]._id, label: d[t].label || "Unknown CC" });
          }return e;
        }function l() {
          var e = 0,
              n = t.get("captionLabel");if ("Off" === n) return void t.set("captionsIndex", 0);for (var i = 0; i < d.length; i++) {
            var o = d[i];if (n && n === o.label) {
              e = i + 1;break;
            }o["default"] || o.defaulttrack || "default" === o._id ? e = i + 1 : o.autoselect;
          }c(e);
        }function c(e) {
          d.length ? t.setVideoSubtitleTrack(e, d) : t.set("captionsIndex", e);
        }t.on("change:playlistItem", i, this), t.on("change:captionsIndex", r, this), t.on("itemReady", o, this), t.mediaController.on("subtitlesTracks", n, this);var u = {},
            d = [],
            p = {},
            h = {},
            f = 0;this.getCurrentIndex = function () {
          return t.get("captionsIndex");
        }, this.getCaptionsList = function () {
          return t.get("captionsList");
        }, this.setCaptionsList = function (e) {
          t.set("captionsList", e);
        };
      };return e;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(62), n(164), n(1), n(161), n(162), n(32), n(169), n(65), n(64), n(2), n(92), n(3), n(41), n(5), n(4), n(196)], o = function (e, t, n, i, o, r, a, s, l, c, u, d, p, h, f, g) {
      function m(e) {
        return function () {
          var t = Array.prototype.slice.call(arguments, 0);this._model.getVideo() ? this["_" + e].apply(this, t) : this.eventsQueue.push([e, t]);
        };
      }function v(e) {
        return e === h.LOADING || e === h.STALLED ? h.BUFFERING : e;
      }var w = function w(e) {
        this.originalContainer = this.currentContainer = e, this.eventsQueue = [], n.extend(this, d), this._model = new r();
      };return w.prototype = { play: m("play"), pause: m("pause"), seek: m("seek"), stop: m("stop"), load: m("load"), playlistNext: m("next"), playlistPrev: m("prev"), playlistItem: m("item"), setCurrentCaptions: m("setCurrentCaptions"), setCurrentQuality: m("setCurrentQuality"), setFullscreen: m("setFullscreen"), setup: function setup(r, d) {
          function g(e, t) {
            ie.triggerAfterReady(e, t);
          }function m() {
            q = null, Q.on("all", g, ie), ie.showView(Q.element()), n.defer(w);
          }function w() {
            ie.trigger(f.JWPLAYER_READY, { setupTime: 0 }), ie.triggerAfterReady = ie.trigger;for (var e = 0; e < se.length; e++) {
              var t = se[e];ie.trigger(t.type, t.args);
            }ee.get("autostart") && ie.play({ reason: "autostart" });
          }function y(e) {
            var t = ee.getProviders(),
                n = t.required(e);return t.load(n).then(function () {
              ie.getProvider() || (ee.setProvider(ee.get("playlistItem")), j());
            });
          }function j() {
            for (; ie.eventsQueue.length > 0;) {
              var e = ie.eventsQueue.shift(),
                  t = e[0],
                  n = e[1] || [];ie["_" + t].apply(ie, n);
            }
          }function b(e) {
            switch (ee.get("state") === h.ERROR && ee.set("state", h.IDLE), _(!0), ee.get("autostart") && ee.once("itemReady", L), typeof e === "undefined" ? "undefined" : _typeof(e)) {case "string":
                E(e);break;case "object":
                var t = T(e);t && R(0);break;case "number":
                R(e);}
          }function E(e) {
            var t = new l();t.on(f.JWPLAYER_PLAYLIST_LOADED, function (e) {
              b(e.playlist);
            }), t.on(f.JWPLAYER_ERROR, function (e) {
              e.message = "Error loading playlist: " + e.message, this.triggerError(e);
            }, this), t.load(e);
          }function k() {
            var e = ie._instreamAdapter && ie._instreamAdapter.getState();return n.isString(e) ? e : ee.get("state");
          }function L(e) {
            var t;if (e && ee.set("playReason", e.reason), ee.get("state") !== h.ERROR) {
              var i = ie._instreamAdapter && ie._instreamAdapter.getState();if (n.isString(i)) return d.pauseAd(!1);if (ee.get("state") === h.COMPLETE && (_(!0), R(0)), !te && (te = !0, ie.trigger(f.JWPLAYER_MEDIA_BEFOREPLAY, { playReason: ee.get("playReason") }), te = !1, Z)) return Z = !1, void ($ = null);if (C()) {
                if (0 === ee.get("playlist").length) return !1;t = c.tryCatch(function () {
                  ee.loadVideo();
                });
              } else ee.get("state") === h.PAUSED && (t = c.tryCatch(function () {
                ee.playVideo();
              }));return !(t instanceof c.Error) || (ie.triggerError(t), $ = null, !1);
            }
          }function _(e) {
            ee.off("itemReady", L);var t = !e;$ = null;var n = c.tryCatch(function () {
              ee.stopVideo();
            }, ie);return n instanceof c.Error ? (ie.triggerError(n), !1) : (t && (ne = !0), te && (Z = !0), !0);
          }function A() {
            $ = null;var e = ie._instreamAdapter && ie._instreamAdapter.getState();if (n.isString(e)) return d.pauseAd(!0);switch (ee.get("state")) {case h.ERROR:
                return !1;case h.PLAYING:case h.BUFFERING:
                var t = c.tryCatch(function () {
                  oe().pause();
                }, this);if (t instanceof c.Error) return ie.triggerError(t), !1;break;default:
                te && (Z = !0);}return !0;
          }function C() {
            var e = ee.get("state");return e === h.IDLE || e === h.COMPLETE || e === h.ERROR;
          }function x(e) {
            ee.get("state") !== h.ERROR && (ee.get("scrubbing") || ee.get("state") === h.PLAYING || L(!0), oe().seek(e));
          }function P(e, t) {
            _(!0), R(e), L(t);
          }function T(e) {
            var t = s(e);return t = s.filterPlaylist(t, ee.getProviders(), ee.get("androidhls"), ee.get("drm"), ee.get("preload"), ee.get("feedid"), ee.get("withCredentials")), ee.set("playlist", t), n.isArray(t) && 0 !== t.length ? (y(t), !0) : (ie.triggerError({ message: "Error loading playlist: No playable sources found" }), !1);
          }function R(e) {
            ee.setItemIndex(e);
          }function I(e) {
            P(ee.get("item") - 1, e || { reason: "external" });
          }function M(e) {
            P(ee.get("item") + 1, e || { reason: "external" });
          }function S() {
            if (C()) {
              if (ne) return void (ne = !1);$ = S;var e = ee.get("item");return e === ee.get("playlist").length - 1 ? void (ee.get("repeat") ? M({ reason: "repeat" }) : (ee.set("state", h.COMPLETE), ie.trigger(f.JWPLAYER_PLAYLIST_COMPLETE, {}))) : void M({ reason: "playlist" });
            }
          }function O(e) {
            oe() && (e = parseInt(e, 10) || 0, oe().setCurrentQuality(e));
          }function D() {
            return oe() ? oe().getCurrentQuality() : -1;
          }function N() {
            if (this._model) return this._model.getConfiguration();
          }function Y() {
            if (this._model.mediaModel) return this._model.mediaModel.get("visualQuality");var e = W();if (e) {
              var t = D(),
                  i = e[t];if (i) return { level: n.extend({ index: t }, i), mode: "", reason: "" };
            }return null;
          }function W() {
            return oe() ? oe().getQualityLevels() : null;
          }function F(e) {
            oe() && (e = parseInt(e, 10) || 0, oe().setCurrentAudioTrack(e));
          }function J() {
            return oe() ? oe().getCurrentAudioTrack() : -1;
          }function V() {
            return oe() ? oe().getAudioTracks() : null;
          }function B(e) {
            e = parseInt(e, 10) || 0, ee.persistVideoSubtitleTrack(e), ie.trigger(f.JWPLAYER_CAPTIONS_CHANGED, { tracks: z(), track: e });
          }function U() {
            return X.getCurrentIndex();
          }function z() {
            return X.getCaptionsList();
          }function H() {
            var e = ee.getVideo();if (e) {
              var t = e.detachMedia();if (t instanceof HTMLVideoElement) return t;
            }return null;
          }function G() {
            var e = c.tryCatch(function () {
              ee.getVideo().attachMedia();
            });return e instanceof c.Error ? void c.log("Error calling _attachMedia", e) : void ("function" == typeof $ && $());
          }function K(e) {
            n.isBoolean(e) || (e = !ee.get("fullscreen")), ee.set("fullscreen", e), this._instreamAdapter && this._instreamAdapter._adModel && this._instreamAdapter._adModel.set("fullscreen", e);
          }var Q,
              X,
              q,
              $,
              Z,
              ee = this._model,
              te = !1,
              ne = !1,
              ie = this,
              oe = function oe() {
            return ee.getVideo();
          },
              re = new a();re.track(ee);var ae = new e(r, re),
              se = [];ee.setup(ae, re), Q = this._view = new u(d, ee), X = new o(d, ee), q = new i(d, ee, Q, T), q.on(f.JWPLAYER_READY, m, this), q.on(f.JWPLAYER_SETUP_ERROR, this.setupError, this), ee.mediaController.on("all", g, this), ee.mediaController.on(f.JWPLAYER_MEDIA_COMPLETE, function () {
            n.defer(S);
          }), ee.mediaController.on(f.JWPLAYER_MEDIA_ERROR, this.triggerError, this), ee.on("change:flashBlocked", function (e, t) {
            if (!t) return void this._model.set("errorEvent", void 0);var n = !!e.get("flashThrottle"),
                i = { message: n ? "Click to run Flash" : "Flash plugin failed to load" };n || this.trigger(f.JWPLAYER_ERROR, i), this._model.set("errorEvent", i);
          }, this), ee.on("change:state", p, this), ee.on("change:castState", function (e, t) {
            ie.trigger(f.JWPLAYER_CAST_SESSION, t);
          }), ee.on("change:fullscreen", function (e, t) {
            ie.trigger(f.JWPLAYER_FULLSCREEN, { fullscreen: t });
          }), ee.on("itemReady", function () {
            ie.triggerAfterReady(f.JWPLAYER_PLAYLIST_ITEM, { index: ee.get("item"), item: ee.get("playlistItem") });
          }), ee.on("change:playlist", function (e, t) {
            t.length && ie.triggerAfterReady(f.JWPLAYER_PLAYLIST_LOADED, { playlist: t });
          }), ee.on("change:volume", function (e, t) {
            ie.trigger(f.JWPLAYER_MEDIA_VOLUME, { volume: t });
          }), ee.on("change:mute", function (e, t) {
            ie.trigger(f.JWPLAYER_MEDIA_MUTE, { mute: t });
          }), ee.on("change:controls", function (e, t) {
            ie.trigger(f.JWPLAYER_CONTROLS, { controls: t });
          }), ee.on("change:scrubbing", function (e, t) {
            t ? A() : L();
          }), ee.on("change:captionsList", function (e, t) {
            try {
              ie.triggerAfterReady(f.JWPLAYER_CAPTIONS_LIST, { tracks: t, track: U() });
            } catch (n) {
              c.log("Error with captionsList event:", n);
            }
          }), ee.on("change:mediaModel", function (e) {
            e.mediaModel.on("change:state", function (t, n) {
              var i = v(n);e.set("state", i);
            });
          }), this.triggerAfterReady = function (e, t) {
            se.push({ type: e, args: t });
          }, this._play = L, this._pause = A, this._seek = x, this._stop = _, this._load = b, this._next = M, this._prev = I, this._item = P, this._setCurrentCaptions = B, this._setCurrentQuality = O, this._setFullscreen = K, this.detachMedia = H, this.attachMedia = G, this.getCurrentQuality = D, this.getQualityLevels = W, this.setCurrentAudioTrack = F, this.getCurrentAudioTrack = J, this.getAudioTracks = V, this.getCurrentCaptions = U, this.getCaptionsList = z, this.getVisualQuality = Y, this.getConfig = N, this.getState = k, this.setVolume = ee.setVolume.bind(ee), this.setMute = ee.setMute.bind(ee), this.getProvider = function () {
            return ee.get("provider");
          }, this.getWidth = function () {
            return ee.get("containerWidth");
          }, this.getHeight = function () {
            return ee.get("containerHeight");
          }, this.getContainer = function () {
            return this.currentContainer;
          }, this.resize = Q.resize, this.getSafeRegion = Q.getSafeRegion, this.setCues = Q.addCues, this.setCaptions = Q.setCaptions, this.addButton = function (e, t, i, o, r) {
            var a = { img: e, tooltip: t, callback: i, id: o, btnClass: r },
                s = ee.get("dock");s = s ? s.slice(0) : [], s = n.reject(s, n.matches({ id: a.id })), s.push(a), ee.set("dock", s);
          }, this.removeButton = function (e) {
            var t = ee.get("dock") || [];t = n.reject(t, n.matches({ id: e })), ee.set("dock", t);
          }, this.checkBeforePlay = function () {
            return te;
          }, this.getItemQoe = function () {
            return ee._qoeItem;
          }, this.setControls = function (e) {
            n.isBoolean(e) || (e = !ee.get("controls")), ee.set("controls", e);var t = ee.getVideo();t && t.setControls(e);
          }, this.playerDestroy = function () {
            this.stop(), this.showView(this.originalContainer), Q && Q.destroy(), ee && ee.destroy(), q && (q.destroy(), q = null);
          }, this.isBeforePlay = this.checkBeforePlay, this.isBeforeComplete = function () {
            return ee.getVideo().checkComplete();
          }, this.createInstream = function () {
            return this.instreamDestroy(), this._instreamAdapter = new t(this, ee, Q), ee.persistCaptionsTrack(), this._instreamAdapter;
          }, this.skipAd = function () {
            this._instreamAdapter && this._instreamAdapter.skipAd();
          }, this.instreamDestroy = function () {
            ie._instreamAdapter && ie._instreamAdapter.destroy();
          }, q.start();
        }, showView: function showView(e) {
          (document.documentElement.contains(this.currentContainer) || (this.currentContainer = document.getElementById(this._model.get("id")), this.currentContainer)) && (this.currentContainer.parentElement && this.currentContainer.parentElement.replaceChild(e, this.currentContainer), this.currentContainer = e);
        }, triggerError: function triggerError(e) {
          this._model.set("errorEvent", e), this._model.set("state", h.ERROR), this._model.once("change:state", function () {
            this._model.set("errorEvent", void 0);
          }, this), this.trigger(f.JWPLAYER_ERROR, e);
        }, setupError: function setupError(e) {
          var t = e.message,
              i = c.createElement(g(this._model.get("id"), this._model.get("skin"), t)),
              o = this._model.get("width"),
              r = this._model.get("height");
          c.style(i, { width: o.toString().indexOf("%") > 0 ? o : o + "px", height: r.toString().indexOf("%") > 0 ? r : r + "px" }), this.showView(i);var a = this;n.defer(function () {
            a.trigger(f.JWPLAYER_SETUP_ERROR, { message: t });
          });
        } }, w;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(166), n(165), n(4), n(5), n(2), n(3), n(1)], o = function (e, t, n, i, o, r, a) {
      function s(n) {
        var i = "",
            o = n.get("provider");return o && (i = o.name), i.indexOf("flash") >= 0 ? t : e;
      }var l = { skipoffset: null, tag: null },
          c = function c(e, t, r) {
        function c() {
          y._adModel.set("state", "buffering"), t.set("skipButton", !1), j++;var e,
              n = h[j];f && (e = f[j]), E.loadItem(n, e);
        }function u(e, t) {
          "complete" !== e && (t = t || {}, b.tag && !t.tag && (t.tag = b.tag), this.trigger(e, t), "mediaError" !== e && "error" !== e || h && j + 1 < h.length && c());
        }function d(e) {
          y._adModel.set("duration", e.duration), y._adModel.set("position", e.position);
        }function p(e) {
          var t = {};b.tag && (t.tag = b.tag), h && j + 1 < h.length ? (this.trigger(n.JWPLAYER_MEDIA_COMPLETE, t), c()) : (e.type === n.JWPLAYER_MEDIA_COMPLETE && (this.trigger(n.JWPLAYER_MEDIA_COMPLETE, t), this.trigger(n.JWPLAYER_PLAYLIST_COMPLETE, {})), this.destroy());
        }var h,
            f,
            g,
            m,
            v,
            w = s(t),
            y = new w(e, t),
            j = 0,
            b = {},
            E = this,
            k = a.bind(function (e) {
          e = e || {}, e.hasControls = !!t.get("controls"), this.trigger(n.JWPLAYER_INSTREAM_CLICK, e), y && y._adModel && (y._adModel.get("state") === i.PAUSED ? e.hasControls && y.instreamPlay() : y.instreamPause());
        }, this),
            L = a.bind(function () {
          y && y._adModel && y._adModel.get("state") === i.PAUSED && t.get("controls") && (e.setFullscreen(), e.play());
        }, this);this.type = "instream", this.init = function () {
          g = t.getVideo(), m = t.get("position"), v = t.get("playlist")[t.get("item")], y.on("all", u, this), y.on(n.JWPLAYER_MEDIA_TIME, d, this), y.on(n.JWPLAYER_MEDIA_COMPLETE, p, this), y.init(), g.detachMedia(), t.mediaModel.set("state", i.BUFFERING), e.checkBeforePlay() || 0 === m && !g.checkComplete() ? (m = 0, t.set("preInstreamState", "instream-preroll")) : g && g.checkComplete() || t.get("state") === i.COMPLETE ? t.set("preInstreamState", "instream-postroll") : t.set("preInstreamState", "instream-midroll");var a = t.get("state");return a !== i.PLAYING && a !== i.BUFFERING || g.pause(), r.setupInstream(y._adModel), y._adModel.set("state", i.BUFFERING), r.clickHandler().setAlternateClickHandlers(o.noop, null), this.setText(t.get("localization").loadingAd), this;
        }, this.loadItem = function (e, i) {
          if (o.isAndroid(2.3)) return void this.trigger({ type: n.JWPLAYER_ERROR, message: "Error loading instream: Cannot play instream on Android 2.3" });var r = e;a.isArray(e) ? (h = e, f = i, e = h[j], f && (i = f[j])) : r = [e];var s = this,
              c = t.getProviders(),
              u = c.required(r);c.load(u).then(function () {
            if (null !== y) {
              s.trigger(n.JWPLAYER_PLAYLIST_ITEM, { index: j, item: e }), b = a.extend({}, l, i), y.load(e), s.addClickHandler();var o = e.skipoffset || b.skipoffset;o && (y._adModel.set("skipMessage", b.skipMessage), y._adModel.set("skipText", b.skipText), y._adModel.set("skipOffset", o), t.set("skipButton", !0));
            }
          });
        }, this.applyProviderListeners = function (e) {
          y.applyProviderListeners(e), this.addClickHandler();
        }, this.play = function () {
          y.instreamPlay();
        }, this.pause = function () {
          y.instreamPause();
        }, this.hide = function () {
          y.hide();
        }, this.addClickHandler = function () {
          r.clickHandler().setAlternateClickHandlers(k, L), y.on(n.JWPLAYER_MEDIA_META, this.metaHandler, this);
        }, this.skipAd = function (e) {
          var t = n.JWPLAYER_AD_SKIPPED;this.trigger(t, e), p.call(this, { type: t });
        }, this.metaHandler = function (e) {
          e.width && e.height && r.resizeMedia();
        }, this.destroy = function () {
          if (this.off(), t.set("skipButton", !1), y) {
            r.clickHandler() && r.clickHandler().revertAlternateClickHandlers(), y.instreamDestroy(), r.destroyInstream(), y = null, e.attachMedia();var n = t.get("preInstreamState");switch (n) {case "instream-preroll":case "instream-midroll":
                var s = a.extend({}, v);s.starttime = m, t.loadVideo(s), o.isMobile() && t.mediaModel.get("state") === i.BUFFERING && g.setState(i.BUFFERING), g.play();break;case "instream-postroll":case "instream-idle":
                g.stop();}
          }
        }, this.getState = function () {
          return !(!y || !y._adModel) && y._adModel.get("state");
        }, this.setText = function (e) {
          r.setAltText(e ? e : "");
        }, this.hide = function () {
          r.useExternalControls();
        };
      };return a.extend(c.prototype, r), c;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(3), n(32), n(41), n(4), n(5), n(2), n(1)], o = function (e, t, n, i, o, r, a) {
      var s = function s(e, i) {
        this.model = i, this._adModel = new t().setup({ id: i.get("id"), volume: i.get("volume"), fullscreen: i.get("fullscreen"), mute: i.get("mute") }), this._adModel.on("change:state", n, this);var o = e.getContainer();this.swf = o.querySelector("object");
      };return s.prototype = a.extend({ init: function init() {
          if (r.isChrome()) {
            var e = -1,
                t = !1;this.swf.on("throttle", function (n) {
              if (clearTimeout(e), "resume" === n.state) t && (t = !1, this.instreamPlay());else {
                var i = this;e = setTimeout(function () {
                  i._adModel.get("state") === o.PLAYING && (t = !0, i.instreamPause());
                }, 250);
              }
            }, this);
          }this.swf.on("instream:state", function (e) {
            switch (e.newstate) {case o.PLAYING:
                this._adModel.set("state", e.newstate);break;case o.PAUSED:
                this._adModel.set("state", e.newstate);}
          }, this).on("instream:time", function (e) {
            this._adModel.set("position", e.position), this._adModel.set("duration", e.duration), this.trigger(i.JWPLAYER_MEDIA_TIME, e);
          }, this).on("instream:complete", function (e) {
            this.trigger(i.JWPLAYER_MEDIA_COMPLETE, e);
          }, this).on("instream:error", function (e) {
            this.trigger(i.JWPLAYER_MEDIA_ERROR, e);
          }, this), this.swf.triggerFlash("instream:init"), this.applyProviderListeners = function (e) {
            this.model.on("change:volume", function (t, n) {
              e.volume(n);
            }, this), this.model.on("change:mute", function (t, n) {
              e.mute(n);
            }, this);
          };
        }, instreamDestroy: function instreamDestroy() {
          this._adModel && (this.off(), this.swf.off(null, null, this), this.swf.triggerFlash("instream:destroy"), this.swf = null, this._adModel.off(), this._adModel = null, this.model = null);
        }, load: function load(e) {
          this.swf.triggerFlash("instream:load", e);
        }, instreamPlay: function instreamPlay() {
          this.swf.triggerFlash("instream:play");
        }, instreamPause: function instreamPause() {
          this.swf.triggerFlash("instream:pause");
        } }, e), s;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(1), n(3), n(41), n(4), n(5), n(32)], o = function (e, t, n, i, o, r) {
      var a = function a(_a, s) {
        function l(t) {
          var o = t || p.getVideo();if (h !== o) {
            if (h = o, !o) return;o.off(), o.on("all", function (t, n) {
              n = e.extend({}, n, { type: t }), this.trigger(t, n);
            }, f), o.on(i.JWPLAYER_MEDIA_BUFFER_FULL, d), o.on(i.JWPLAYER_PLAYER_STATE, c), o.attachMedia(), o.volume(s.get("volume")), o.mute(s.get("mute")), p.on("change:state", n, f);
          }
        }function c(e) {
          switch (e.newstate) {case o.PLAYING:
              p.set("state", e.newstate);break;case o.PAUSED:
              p.set("state", e.newstate);}
        }function u(e) {
          s.trigger(e.type, e), f.trigger(i.JWPLAYER_FULLSCREEN, { fullscreen: e.jwstate });
        }function d() {
          p.getVideo().play();
        }var p,
            h,
            f = e.extend(this, t);return _a.on(i.JWPLAYER_FULLSCREEN, function (e) {
          this.trigger(i.JWPLAYER_FULLSCREEN, e);
        }, f), this.init = function () {
          p = new r().setup({ id: s.get("id"), volume: s.get("volume"), fullscreen: s.get("fullscreen"), mute: s.get("mute") }), p.on("fullscreenchange", u), this._adModel = p;
        }, f.load = function (e) {
          p.set("item", 0), p.set("playlistItem", e), p.setActiveItem(e), l(), p.off(i.JWPLAYER_ERROR), p.on(i.JWPLAYER_ERROR, function (e) {
            this.trigger(i.JWPLAYER_ERROR, e);
          }, f), p.loadVideo(e);
        }, f.applyProviderListeners = function (e) {
          l(e), e.off(i.JWPLAYER_ERROR), e.on(i.JWPLAYER_ERROR, function (e) {
            this.trigger(i.JWPLAYER_ERROR, e);
          }, f), s.on("change:volume", function (e, t) {
            h.volume(t);
          }, f), s.on("change:mute", function (e, t) {
            h.mute(t);
          }, f);
        }, this.instreamDestroy = function () {
          p && (p.off(), this.off(), h && (h.detachMedia(), h.off(), p.getVideo() && h.destroy()), p = null, _a.off(null, null, this), _a = null);
        }, f.instreamPlay = function () {
          p.getVideo() && p.getVideo().play(!0);
        }, f.instreamPause = function () {
          p.getVideo() && p.getVideo().pause(!0);
        }, f;
      };return a;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(79), n(4), n(1)], o = function (e, t, n) {
      function i(e) {
        e.mediaController.off(t.JWPLAYER_MEDIA_PLAY_ATTEMPT, e._onPlayAttempt), e.mediaController.off(t.JWPLAYER_PROVIDER_FIRST_FRAME, e._triggerFirstFrame), e.mediaController.off(t.JWPLAYER_MEDIA_TIME, e._onTime);
      }function o(e) {
        i(e), e._triggerFirstFrame = n.once(function () {
          var n = e._qoeItem;n.tick(t.JWPLAYER_MEDIA_FIRST_FRAME);var o = n.between(t.JWPLAYER_MEDIA_PLAY_ATTEMPT, t.JWPLAYER_MEDIA_FIRST_FRAME);e.mediaController.trigger(t.JWPLAYER_MEDIA_FIRST_FRAME, { loadTime: o }), i(e);
        }), e._onTime = a(e._triggerFirstFrame), e._onPlayAttempt = function () {
          e._qoeItem.tick(t.JWPLAYER_MEDIA_PLAY_ATTEMPT);
        }, e.mediaController.on(t.JWPLAYER_MEDIA_PLAY_ATTEMPT, e._onPlayAttempt), e.mediaController.once(t.JWPLAYER_PROVIDER_FIRST_FRAME, e._triggerFirstFrame), e.mediaController.on(t.JWPLAYER_MEDIA_TIME, e._onTime);
      }function r(n) {
        function i(n, i, r) {
          n._qoeItem && r && n._qoeItem.end(r.get("state")), n._qoeItem = new e(), n._qoeItem.tick(t.JWPLAYER_PLAYLIST_ITEM), n._qoeItem.start(i.get("state")), o(n), i.on("change:state", function (e, t, i) {
            n._qoeItem.end(i), n._qoeItem.start(t);
          });
        }n.on("change:mediaModel", i);
      }var a = function a(e) {
        var t = Number.MIN_VALUE;return function (n) {
          n.position > t && e(), t = n.position;
        };
      };return { model: r };
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(27), n(64), n(22), n(28), n(1), n(2), n(4)], o = function (e, t, i, o, r, a, s) {
      function l() {
        var e = { LOAD_PROMISE_POLYFILL: { method: c, depends: [] }, LOAD_BASE64_POLYFILL: { method: u, depends: [] }, LOAD_VTTCUE_POLYFILL: { method: d, depends: [] }, LOADED_POLYFILLS: { method: p, depends: ["LOAD_PROMISE_POLYFILL", "LOAD_BASE64_POLYFILL", "LOAD_VTTCUE_POLYFILL"] }, LOAD_PLUGINS: { method: h, depends: ["LOADED_POLYFILLS"] }, INIT_PLUGINS: { method: f, depends: ["LOAD_PLUGINS", "SETUP_VIEW"] }, LOAD_SKIN: { method: b, depends: ["LOADED_POLYFILLS"] }, LOAD_PLAYLIST: { method: m, depends: ["LOADED_POLYFILLS"] }, FILTER_PLAYLIST: { method: v, depends: ["LOAD_PLAYLIST"] }, SETUP_VIEW: { method: E, depends: ["LOAD_SKIN"] }, SET_ITEM: { method: k, depends: ["INIT_PLUGINS", "FILTER_PLAYLIST"] }, SEND_READY: { method: L, depends: ["SETUP_VIEW", "SET_ITEM"] } };return e;
      }function c(e) {
        window.Promise ? e() : n.e(9, function (require) {
          n(69), e();
        });
      }function u(e) {
        window.btoa && window.atob ? e() : n.e(10, function (require) {
          n(68), e();
        });
      }function d(e) {
        window.VTTCue ? e() : n.e(7, function (require) {
          n(71), e();
        });
      }function p(e) {
        e();
      }function h(t, n) {
        A = e.loadPlugins(n.get("id"), n.get("plugins")), A.on(s.COMPLETE, t), A.on(s.ERROR, r.partial(g, t)), A.load();
      }function f(e, t, n) {
        A.setupPlugins(n, t), e();
      }function g(e, t) {
        _(e, "Could not load plugin", t.message);
      }function m(e, n) {
        var i = n.get("playlist");r.isString(i) ? (C = new t(), C.on(s.JWPLAYER_PLAYLIST_LOADED, function (t) {
          n.set("playlist", t.playlist), n.set("feedid", t.feedid), e();
        }), C.on(s.JWPLAYER_ERROR, r.partial(w, e)), C.load(i)) : e();
      }function v(e, t, n, i, o) {
        var r = t.get("playlist"),
            a = o(r);a ? e() : w(e);
      }function w(e, t) {
        t && t.message ? _(e, "Error loading playlist", t.message) : _(e, "Error loading player", "No playable sources found");
      }function y(e, t) {
        if (r.contains(o.SkinsLoadable, e)) return t + "skins/" + e + ".css";
      }function j(e) {
        for (var t = document.styleSheets, n = 0, i = t.length; n < i; n++) {
          if (t[n].href === e) return !0;
        }return !1;
      }function b(e, t) {
        var n = t.get("skin"),
            a = t.get("skinUrl");if (r.contains(o.SkinsIncluded, n)) return void e();if (a || (a = y(n, t.get("base"))), r.isString(a) && !j(a)) {
          t.set("skin-loading", !0);var l = !0,
              c = new i(a, l);c.addEventListener(s.COMPLETE, function () {
            t.set("skin-loading", !1);
          }), c.addEventListener(s.ERROR, function () {
            t.set("skin", "seven"), t.set("skin-loading", !1);
          }), c.load();
        }r.defer(function () {
          e();
        });
      }function E(e, t, n, i) {
        i.setup(), e();
      }function k(e, t) {
        t.once("itemReady", e), t.setItemIndex(t.get("item"));
      }function L(e) {
        e({ type: "complete" });
      }function _(e, t, n) {
        e({ type: "error", msg: t, reason: n });
      }var A, C;return { getQueue: l, error: _ };
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(1), n(2)], o = function (e, t) {
      function n(e) {
        return "jwplayer." + e;
      }function i() {
        return e.reduce(this.persistItems, function (e, i) {
          var o = c[n(i)];return o && (e[i] = t.serialize(o)), e;
        }, {});
      }function o(e, t) {
        try {
          c[n(e)] = t;
        } catch (i) {
          l && l.debug && console.error(i);
        }
      }function r() {
        e.each(this.persistItems, function (e) {
          c.removeItem(n(e));
        });
      }function a() {
        this.persistItems = ["volume", "mute", "captionLabel", "qualityLabel"];
      }function s(t) {
        e.each(this.persistItems, function (e) {
          t.on("change:" + e, function (t, n) {
            o(e, n);
          });
        });
      }var l = window.jwplayer,
          c = { removeItem: t.noop };try {
        c = window.localStorage;
      } catch (u) {}return e.extend(a.prototype, { getAllItems: i, track: s, clear: r }), a;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(85), n(2)], o = function (e, t) {
      return n.p = t.loadFrom(), e.selectPlayer;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(14), n(8), n(2)], o = function (e, t, n) {
      var i = "jwplayer",
          o = function o(_o4, r) {
        for (var a = [], s = [], l = t.xmlAttribute, c = "default", u = "label", d = "file", p = "type", h = 0; h < _o4.childNodes.length; h++) {
          var f = _o4.childNodes[h];if (f.prefix === i) {
            var g = e.localName(f);"source" === g ? (delete r.sources, a.push({ file: l(f, d), "default": l(f, c), label: l(f, u), type: l(f, p) })) : "track" === g ? (delete r.tracks, s.push({ file: l(f, d), "default": l(f, c), kind: l(f, "kind"), label: l(f, u) })) : (r[g] = n.serialize(e.textContent(f)), "file" === g && r.sources && delete r.sources);
          }r[d] || (r[d] = r.link);
        }if (a.length) for (r.sources = [], h = 0; h < a.length; h++) {
          a[h].file.length > 0 && (a[h][c] = "true" === a[h][c], a[h].label.length || delete a[h].label, r.sources.push(a[h]));
        }if (s.length) for (r.tracks = [], h = 0; h < s.length; h++) {
          s[h].file.length > 0 && (s[h][c] = "true" === s[h][c], s[h].kind = s[h].kind.length ? s[h].kind : "captions", s[h].label.length || delete s[h].label, r.tracks.push(s[h]));
        }return r;
      };return o;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(14), n(8), n(2)], o = function (e, t, n) {
      function i(e) {
        for (var t = [], n = 0; n < s(e); n++) {
          var i = e.childNodes[n];"jwplayer" === i.prefix && "mediatypes" === r(i).toLowerCase() && t.push(a(i));
        }return t;
      }var o = t.xmlAttribute,
          r = e.localName,
          a = e.textContent,
          s = e.numChildren,
          l = "media",
          c = function c(e, t) {
        function u(e) {
          var t = { zh: "Chinese", nl: "Dutch", en: "English", fr: "French", de: "German", it: "Italian", ja: "Japanese", pt: "Portuguese", ru: "Russian", es: "Spanish" };return t[e] ? t[e] : e;
        }var d,
            p,
            h = "tracks",
            f = [];for (p = 0; p < s(e); p++) {
          if (d = e.childNodes[p], d.prefix === l) {
            if (!r(d)) continue;switch (r(d).toLowerCase()) {case "content":
                if (o(d, "duration") && (t.duration = n.seconds(o(d, "duration"))), o(d, "url")) {
                  t.sources || (t.sources = []);var g = { file: o(d, "url"), type: o(d, "type"), width: o(d, "width"), label: o(d, "label") },
                      m = i(d);m.length && (g.mediaTypes = m), t.sources.push(g);
                }s(d) > 0 && (t = c(d, t));break;case "title":
                t.title = a(d);break;case "description":
                t.description = a(d);break;case "guid":
                t.mediaid = a(d);break;case "thumbnail":
                t.image || (t.image = o(d, "url"));break;case "player":
                break;case "group":
                c(d, t);break;case "subtitle":
                var v = {};v.file = o(d, "url"), v.kind = "captions", o(d, "lang").length > 0 && (v.label = u(o(d, "lang"))), f.push(v);}
          }
        }for (t.hasOwnProperty(h) || (t[h] = []), p = 0; p < f.length; p++) {
          t[h].push(f[p]);
        }return t;
      };return c;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(1)], o = function (e) {
      var t = { kind: "captions", "default": !1 },
          n = function n(_n) {
        if (_n && _n.file) return e.extend({}, t, _n);
      };return n;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(33), n(2), n(4), n(3), n(1), n(22)], o = function (e, t, n, i, o, r) {
      function a(e, t, n) {
        return function () {
          var i = e.getContainer().getElementsByClassName("jw-overlays")[0];i && (i.appendChild(n), n.left = i.style.left, n.top = i.style.top, t.displayArea = i);
        };
      }function s(e) {
        function t() {
          var t = e.displayArea;t && e.resize(t.clientWidth, t.clientHeight);
        }return function () {
          t(), setTimeout(t, 400);
        };
      }var l = function l(_l, c) {
        function u() {
          m || (m = !0, g = r.loaderstatus.COMPLETE, f.trigger(n.COMPLETE));
        }function d() {
          if (!w && (c && 0 !== o.keys(c).length || u(), !m)) {
            var i = _l.getPlugins();h = o.after(v, u), o.each(c, function (o, a) {
              var s = e.getPluginName(a),
                  l = i[s],
                  c = l.getJS(),
                  u = l.getTarget(),
                  d = l.getStatus();d !== r.loaderstatus.LOADING && d !== r.loaderstatus.NEW && (c && !t.versionCheck(u) && f.trigger(n.ERROR, { message: "Incompatible player version" }), h());
            });
          }
        }function p(e) {
          if (!w) {
            var i = "File not found";e.url && t.log(i, e.url), this.off(), this.trigger(n.ERROR, { message: i }), d();
          }
        }var h,
            f = o.extend(this, i),
            g = r.loaderstatus.NEW,
            m = !1,
            v = o.size(c),
            w = !1;this.setupPlugins = function (n, i) {
          var r = [],
              c = _l.getPlugins(),
              u = i.get("plugins");o.each(u, function (i, l) {
            var d = e.getPluginName(l),
                p = c[d],
                h = p.getFlashPath(),
                f = p.getJS(),
                g = p.getURL();if (h) {
              var m = o.extend({ name: d, swf: h, pluginmode: p.getPluginmode() }, i);r.push(m);
            }var v = t.tryCatch(function () {
              if (f && u[g]) {
                var e = document.createElement("div");e.id = n.id + "_" + d, e.className = "jw-plugin jw-reset";var t = o.extend({}, u[g]),
                    i = p.getNewInstance(n, t, e);i.addToPlayer = a(n, i, e), i.resizeHandler = s(i), n.addPlugin(d, i, e);
              }
            });v instanceof t.Error && t.log("ERROR: Failed to load " + d + ".");
          }), i.set("flashPlugins", r);
        }, this.load = function () {
          if (t.exists(c) && "object" !== t.typeOf(c)) return void d();g = r.loaderstatus.LOADING, o.each(c, function (e, i) {
            if (t.exists(i)) {
              var o = _l.addPlugin(i);o.on(n.COMPLETE, d), o.on(n.ERROR, p);
            }
          });var e = _l.getPlugins();o.each(e, function (e) {
            e.load();
          }), d();
        }, this.destroy = function () {
          w = !0, this.off();
        }, this.getStatus = function () {
          return g;
        };
      };return l;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(33), n(67)], o = function (e, t) {
      var n = function n(_n2) {
        this.addPlugin = function (i) {
          var o = e.getPluginName(i);return _n2[o] || (_n2[o] = new t(i)), _n2[o];
        }, this.getPlugins = function () {
          return _n2;
        };
      };return n;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  },, function (e, t, n) {
    var i, o;i = [], o = function () {
      return {};
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(2), n(1), n(80)], o = function (e, t, n) {
      function i(t) {
        if ("hls" === t.type) if (t.androidhls !== !1) {
          var n = e.isAndroidNative;if (n(2) || n(3) || n("4.0")) return !1;if (e.isAndroid()) return !0;
        } else if (e.isAndroid()) return !1;return null;
      }var o = [{ name: "youtube", supports: function supports(t) {
          return e.isYouTube(t.file, t.type);
        } }, { name: "html5", supports: function supports(t) {
          var o = { aac: "audio/mp4", mp4: "video/mp4", f4v: "video/mp4", m4v: "video/mp4", mov: "video/mp4", mp3: "audio/mpeg", mpeg: "audio/mpeg", ogv: "video/ogg", ogg: "video/ogg", oga: "video/ogg", vorbis: "video/ogg", webm: "video/webm", f4a: "video/aac", m3u8: "application/vnd.apple.mpegurl", m3u: "application/vnd.apple.mpegurl", hls: "application/vnd.apple.mpegurl" },
              r = t.file,
              a = t.type,
              s = i(t);if (null !== s) return s;if (e.isRtmp(r, a)) return !1;if (!o[a]) return !1;if (n.canPlayType) {
            var l = n.canPlayType(o[a]);return !!l;
          }return !1;
        } }, { name: "flash", supports: function supports(n) {
          var i = { flv: "video", f4v: "video", mov: "video", m4a: "video", m4v: "video", mp4: "video", aac: "video", f4a: "video", mp3: "sound", mpeg: "sound", smil: "rtmp" },
              o = t.keys(i);if (!e.isFlashSupported()) return !1;var r = n.file,
              a = n.type;return !!e.isRtmp(r, a) || t.contains(o, a);
        } }];return o;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(20), n(48), n(177), n(1)], o = function (e, t, i, o) {
      function r(e) {
        this.providers = t.slice(), this.config = e || {}, this.reorderProviders();
      }r.loaders = { html5: function html5(e) {
          n.e(4, function (require) {
            var t = n(88);a(t), e(t);
          });
        }, flash: function flash(e) {
          n.e(5, function (require) {
            var t = n(72);a(t), e(t);
          });
        }, youtube: function youtube(e) {
          n.e(6, function (require) {
            var t = n(73);a(t), e(t);
          });
        } };var a = r.registerProvider = function (n) {
        var r = n.getName().name;if (!i[r]) {
          if (!o.find(t, o.matches({ name: r }))) {
            if (!o.isFunction(n.supports)) throw { message: "Tried to register a provider with an invalid object" };t.unshift({ name: r, supports: n.supports });
          }var a = function a() {};a.prototype = e, n.prototype = new a(), i[r] = n;
        }
      };return o.extend(r.prototype, { load: function load(e) {
          return Promise.all(o.map(e, function (e) {
            return new Promise(function (t) {
              var n = r.loaders[e.name];n ? n(t) : t();
            });
          }));
        }, reorderProviders: function reorderProviders() {
          if ("flash" === this.config.primary) {
            var e = o.indexOf(this.providers, o.findWhere(this.providers, { name: "flash" })),
                t = this.providers.splice(e, 1)[0],
                n = o.indexOf(this.providers, o.findWhere(this.providers, { name: "html5" }));this.providers.splice(n, 0, t);
          }
        }, providerSupports: function providerSupports(e, t) {
          return e.supports(t);
        }, required: function required(e) {
          var t = this;return e = e.slice(), o.compact(o.map(this.providers, function (n) {
            for (var i = !1, o = e.length; o--;) {
              var r = e[o],
                  a = t.providerSupports(n, r.sources[0]);a && e.splice(o, 1), i = i || a;
            }if (i) return n;
          }));
        }, choose: function choose(e) {
          e = o.isObject(e) ? e : {};for (var t = this.providers.length, n = 0; n < t; n++) {
            var r = this.providers[n];if (this.providerSupports(r, e)) {
              var a = t - n - 1;return { priority: a, name: r.name, type: e.type, provider: i[r.name] };
            }
          }return null;
        } }), r;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  },, function (e, t, n) {
    var i, o;i = [], o = function () {
      return { hasClass: function hasClass(e, t) {
          var n = " " + t + " ";return 1 === e.nodeType && (" " + e.className + " ").replace(/[\t\r\n\f]/g, " ").indexOf(n) >= 0;
        } };
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(1), n(3)], o = function (e, t) {
      var n = e.extend({ get: function get(e) {
          return this.attributes = this.attributes || {}, this.attributes[e];
        }, set: function set(e, t) {
          if (this.attributes = this.attributes || {}, this.attributes[e] !== t) {
            var n = this.attributes[e];this.attributes[e] = t, this.trigger("change:" + e, this, t, n);
          }
        }, clone: function clone() {
          return e.clone(this.attributes);
        } }, t);return n;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [], o = function () {
      var e = function e(_e4, n, i) {
        if (n = n || this, i = i || [], window.jwplayer && window.jwplayer.debug) return _e4.apply(n, i);try {
          return _e4.apply(n, i);
        } catch (o) {
          return new t(_e4.name, o);
        }
      },
          t = function t(e, _t) {
        this.name = e, this.message = _t.message || _t.toString(), this.error = _t;
      };return { tryCatch: e, Error: t };
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(2), n(29), n(5), n(1)], o = function (e, t, i, o) {
      var r = t.style,
          a = { back: !0, fontSize: 14, fontFamily: "Arial,sans-serif", fontOpacity: 100, color: "#FFF", backgroundColor: "#000", backgroundOpacity: 100, edgeStyle: null, windowColor: "#FFF", windowOpacity: 0, preprocessor: o.identity },
          s = function s(_s4) {
        function l(e, n, i) {
          if (t.css("#" + e + " .jw-text-track-display", n, e), t.css("#" + e + " .jw-text-track-cue", i, e), t.css("#" + e + " .jw-video::-webkit-media-text-track-display", n, e), t.css("#" + e + " .jw-video::cue", i, e), i.backgroundColor) {
            var o = "{background-color: " + i.backgroundColor + " !important;}";t.css("#" + e + " .jw-video::-webkit-media-text-track-display-backdrop", o, e);
          }
        }function c(e, n, i) {
          var o = t.hexToRgba("#000000", i);"dropshadow" === e ? n.textShadow = "0 2px 1px " + o : "raised" === e ? n.textShadow = "0 0 5px " + o + ", 0 1px 5px " + o + ", 0 2px 5px " + o : "depressed" === e ? n.textShadow = "0 -2px 1px " + o : "uniform" === e && (n.textShadow = "-2px 0 1px " + o + ",2px 0 1px " + o + ",0 -2px 1px " + o + ",0 2px 1px " + o + ",-1px 1px 1px " + o + ",1px 1px 1px " + o + ",1px -1px 1px " + o + ",1px 1px 1px " + o);
        }function u() {
          var t = _s4.get("provider");return t.name.indexOf("flash") === -1 && (e.isChrome() || e.isIOS() || e.isSafari());
        }function d(e) {
          g = e, this.selectCues(h, g);
        }function p() {
          u() || n.e(8, function (require) {
            y = n(70);
          });
        }var h,
            f,
            g,
            m,
            v,
            w,
            y,
            j = {};m = document.createElement("div"), m.className = "jw-captions jw-reset", this.show = function () {
          m.className = "jw-captions jw-captions-enabled jw-reset";
        }, this.hide = function () {
          m.className = "jw-captions jw-reset";
        }, this.populate = function (e) {
          return f = [], h = e, e ? void this.selectCues(e, g) : (f = [], void this.renderCues());
        }, this.resize = function () {
          var e = m.clientWidth,
              t = Math.pow(e / 400, .6);if (t) {
            var n = j.fontSize * t;r(m, { fontSize: Math.floor(2 * n) / 2 + "px" });
          }this.renderCues(!0);
        }, this.renderCues = function (e) {
          e = !!e, y && y.WebVTT.processCues(window, f, m, e);
        }, this.selectCues = function (e, t) {
          var n, i;e && e.data && t && (i = this.getAlignmentPosition(e, t), i !== !1 && (n = this.getCurrentCues(e.data, i), this.updateCurrentCues(n), this.renderCues()));
        }, this.getCurrentCues = function (e, t) {
          return o.filter(e, function (e) {
            return t >= e.startTime && (!e.endTime || t <= e.endTime);
          });
        }, this.updateCurrentCues = function (e) {
          return e.length ? o.difference(e, f).length && (v.className = "jw-captions-window jw-reset jw-captions-window-active", f = e) : f = [], f;
        }, this.getAlignmentPosition = function (e, t) {
          var n = e.source,
              i = t.metadata;return n ? !(!i || !o.isNumber(i[n])) && i[n] : t.position;
        }, this.clear = function () {
          e.empty(m);
        }, this.setContainerHeight = function (e) {
          r(m, { height: e });
        }, this.setup = function (e, n) {
          v = document.createElement("div"), w = document.createElement("span"), v.className = "jw-captions-window jw-reset", w.className = "jw-captions-text jw-reset", j = o.extend({}, a, n);var i = j.fontOpacity,
              u = j.windowOpacity,
              d = j.edgeStyle,
              p = j.backgroundColor,
              h = {},
              f = { color: t.hexToRgba(j.color, i), fontFamily: j.fontFamily, fontStyle: j.fontStyle, fontWeight: j.fontWeight, textDecoration: j.textDecoration };u && (h.backgroundColor = t.hexToRgba(j.windowColor, u)), c(d, f, i), j.back ? f.backgroundColor = t.hexToRgba(p, j.backgroundOpacity) : null === d && c("uniform", f), r(v, h), r(w, f), l(e, h, f), v.appendChild(w), m.appendChild(v), this.populate(_s4.get("captionsTrack")), _s4.set("captions", j);
        }, this.element = function () {
          return m;
        }, _s4.on("change:playlistItem", function () {
          g = null, f = [];
        }, this), _s4.on("change:captionsTrack", function (e, t) {
          this.populate(t);
        }, this), _s4.mediaController.on("seek", function () {
          f = [];
        }, this), _s4.mediaController.on("time seek", d, this), _s4.mediaController.on("subtitlesTrackData", function () {
          this.selectCues(h, g);
        }, this), _s4.on("change:state", function (e, t) {
          switch (t) {case i.IDLE:case i.ERROR:case i.COMPLETE:
              this.hide();break;default:
              this.show();}
        }, this), _s4.on("itemReady", p, this);
      };return s;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(9), n(4), n(3), n(1)], o = function (e, t, n, i) {
      var o = function o(_o5, r, a) {
        function s(e) {
          if (!_o5.get("flashBlocked")) return u ? void u(e) : void f.trigger(e.type === t.touchEvents.CLICK ? "click" : "tap");
        }function l() {
          return d ? void d() : void f.trigger("doubleClick");
        }var c,
            u,
            d,
            p = { enableDoubleTap: !0, useMove: !0 };i.extend(this, n), c = r, this.element = function () {
          return c;
        };var h = new e(c, i.extend(p, a));h.on("click tap", s), h.on("doubleClick doubleTap", l), h.on("move", function () {
          f.trigger("move");
        }), h.on("over", function () {
          f.trigger("over");
        }), h.on("out", function () {
          f.trigger("out");
        }), this.clickHandler = s;var f = this;this.setAlternateClickHandlers = function (e, t) {
          u = e, d = t || null;
        }, this.revertAlternateClickHandlers = function () {
          u = null, d = null;
        };
      };return o;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(1), n(2), n(19)], o = function (e, t, n) {
      function i(e, t) {
        this.time = e, this.text = t, this.el = document.createElement("div"), this.el.className = "jw-cue jw-reset";
      }e.extend(i.prototype, { align: function align(e) {
          if ("%" === this.time.toString().slice(-1)) this.pct = this.time;else {
            var t = this.time / e * 100;this.pct = t + "%";
          }this.el.style.left = this.pct;
        } });var o = { loadChapters: function loadChapters(e) {
          t.ajax(e, this.chaptersLoaded.bind(this), this.chaptersFailed, { plainText: !0 });
        }, chaptersLoaded: function chaptersLoaded(t) {
          var i = n(t.responseText);e.isArray(i) && (e.each(i, this.addCue, this), this.drawCues());
        }, chaptersFailed: function chaptersFailed() {}, addCue: function addCue(e) {
          this.cues.push(new i(e.begin, e.text));
        }, drawCues: function drawCues() {
          var t = this._model.mediaModel.get("duration");if (!t || t <= 0) return void this._model.mediaModel.once("change:duration", this.drawCues, this);var n = this;e.each(this.cues, function (e) {
            e.align(t), e.el.addEventListener("mouseover", function () {
              n.activeCue = e;
            }), e.el.addEventListener("mouseout", function () {
              n.activeCue = null;
            }), n.elementRail.appendChild(e.el);
          });
        }, resetChapters: function resetChapters() {
          e.each(this.cues, function (e) {
            e.el.parentNode && e.el.parentNode.removeChild(e.el);
          }, this), this.cues = [];
        } };return o;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(31), n(2), n(1), n(9)], o = function (e, t, n, i) {
      var o = e.extend({ constructor: function constructor(t, n) {
          e.call(this, t, n), this.container.className = "jw-overlay-horizontal jw-reset", this.openClass = "jw-open-drawer", this.componentType = "drawer";
        }, setup: function setup(e, o) {
          this.iconUI || (this.iconUI = new i(this.el, { useHover: !0, directSelect: !0 }), this.toggleOpenStateListener = this.toggleOpenState.bind(this), this.openTooltipListener = this.openTooltip.bind(this), this.closeTooltipListener = this.closeTooltip.bind(this)), this.reset(), e = n.isArray(e) ? e : [], this.activeContents = n.filter(e, function (e) {
            return e.isActive;
          }), t.toggleClass(this.el, "jw-hidden", !o || this.activeContents.length < 2), o && this.activeContents.length > 1 && (t.removeClass(this.el, "jw-off"), this.iconUI.on("tap", this.toggleOpenStateListener).on("over", this.openTooltipListener).on("out", this.closeTooltipListener), n.each(e, function (e) {
            this.container.appendChild(e.el);
          }, this));
        }, reset: function reset() {
          t.addClass(this.el, "jw-off"), this.iconUI.off(), this.contentUI && this.contentUI.off().destroy(), this.removeContent();
        } });return o;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(31), n(2), n(1), n(9), n(135)], o = function (e, t, n, i, o) {
      var r = e.extend({ setup: function setup(e, r, a) {
          a = a || {}, this.iconUI || (this.iconUI = new i(this.el, { useHover: !0, directSelect: !0 }), this.toggleValueListener = this.toggleValue.bind(this), this.toggleOpenStateListener = this.toggleOpenState.bind(this), this.openTooltipListener = this.openTooltip.bind(this), this.closeTooltipListener = this.closeTooltip.bind(this), this.selectListener = this.select.bind(this)), this.reset(), e = n.isArray(e) ? e : [], t.toggleClass(this.el, "jw-hidden", e.length < 2);var s = e.length > 2 || 2 === e.length && a && a.toggle === !1,
              l = !s && 2 === e.length;if (t.toggleClass(this.el, "jw-toggle", l || !!a.isToggle), t.toggleClass(this.el, "jw-button-color", !l), this.isActive = s || l, s) {
            t.removeClass(this.el, "jw-off"), this.iconUI.on("tap", this.toggleOpenStateListener).on("over", this.openTooltipListener).on("out", this.closeTooltipListener);var c = o(e),
                u = t.createElement(c);this.addContent(u), this.contentUI = new i(this.content).on("click tap", this.selectListener);
          } else l && this.iconUI.on("click tap", this.toggleValueListener);this.selectItem(r);
        }, toggleValue: function toggleValue() {
          this.trigger("toggleValue");
        }, select: function select(e) {
          if (e.target.parentElement === this.content) {
            var i = t.classList(e.target),
                o = n.find(i, function (e) {
              return 0 === e.indexOf("jw-item");
            });o && (this.trigger("select", parseInt(o.split("-")[2])), this.closeTooltipListener());
          }
        }, selectItem: function selectItem(e) {
          if (this.content) for (var n = 0; n < this.content.children.length; n++) {
            t.toggleClass(this.content.children[n], "jw-active-option", e === n);
          }t.toggleClass(this.el, "jw-off", 0 === e);
        }, reset: function reset() {
          t.addClass(this.el, "jw-off"), this.iconUI.off(), this.contentUI && this.contentUI.off().destroy(), this.removeContent();
        } });return r;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(2), n(1), n(31), n(9), n(137)], o = function (e, t, n, i, o) {
      var r = n.extend({ setup: function setup(n, o) {
          if (this.iconUI || (this.iconUI = new i(this.el, { useHover: !0 }), this.toggleOpenStateListener = this.toggleOpenState.bind(this), this.openTooltipListener = this.openTooltip.bind(this), this.closeTooltipListener = this.closeTooltip.bind(this), this.selectListener = this.onSelect.bind(this)), this.reset(), n = t.isArray(n) ? n : [], e.toggleClass(this.el, "jw-hidden", n.length < 2), n.length >= 2) {
            this.iconUI = new i(this.el, { useHover: !0 }).on("tap", this.toggleOpenStateListener).on("over", this.openTooltipListener).on("out", this.closeTooltipListener);var r = this.menuTemplate(n, o),
                a = e.createElement(r);this.addContent(a), this.contentUI = new i(this.content), this.contentUI.on("click tap", this.selectListener);
          }this.originalList = n;
        }, menuTemplate: function menuTemplate(n, i) {
          var r = t.map(n, function (t, n) {
            var o = t.title ? e.createElement(t.title).textContent : "";return { active: n === i, label: n + 1 + ".", title: o };
          });return o(r);
        }, onSelect: function onSelect(n) {
          var i = n.target;if ("UL" !== i.tagName) {
            "LI" !== i.tagName && (i = i.parentElement);var o = e.classList(i),
                r = t.find(o, function (e) {
              return 0 === e.indexOf("jw-item");
            });r && (this.trigger("select", parseInt(r.split("-")[2])), this.closeTooltip());
          }
        }, selectItem: function selectItem(e) {
          this.setup(this.originalList, e);
        }, reset: function reset() {
          this.iconUI.off(), this.contentUI && this.contentUI.off().destroy(), this.removeContent();
        } });return r;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(1), n(2), n(19)], o = function (e, t, n) {
      function i(e) {
        this.begin = e.begin, this.end = e.end, this.img = e.text;
      }var o = { loadThumbnails: function loadThumbnails(e) {
          e && (this.vttPath = e.split("?")[0].split("/").slice(0, -1).join("/"), this.individualImage = null, t.ajax(e, this.thumbnailsLoaded.bind(this), this.thumbnailsFailed.bind(this), { plainText: !0 }));
        }, thumbnailsLoaded: function thumbnailsLoaded(t) {
          var o = n(t.responseText);e.isArray(o) && (e.each(o, function (e) {
            this.thumbnails.push(new i(e));
          }, this), this.drawCues());
        }, thumbnailsFailed: function thumbnailsFailed() {}, chooseThumbnail: function chooseThumbnail(t) {
          var n = e.sortedIndex(this.thumbnails, { end: t }, e.property("end"));n >= this.thumbnails.length && (n = this.thumbnails.length - 1);var i = this.thumbnails[n].img;return i.indexOf("://") < 0 && (i = this.vttPath ? this.vttPath + "/" + i : i), i;
        }, loadThumbnail: function loadThumbnail(t) {
          var n = this.chooseThumbnail(t),
              i = { display: "block", margin: "0 auto", backgroundPosition: "0 0" },
              o = n.indexOf("#xywh");if (o > 0) try {
            var r = /(.+)\#xywh=(\d+),(\d+),(\d+),(\d+)/.exec(n);n = r[1], i.backgroundPosition = r[2] * -1 + "px " + r[3] * -1 + "px", i.width = r[4], i.height = r[5];
          } catch (a) {
            return;
          } else this.individualImage || (this.individualImage = new Image(), this.individualImage.onload = e.bind(function () {
            this.individualImage.onload = null, this.timeTip.image({ width: this.individualImage.width, height: this.individualImage.height });
          }, this), this.individualImage.src = n);return i.backgroundImage = 'url("' + n + '")', i;
        }, showThumbnail: function showThumbnail(e) {
          this.thumbnails.length < 1 || this.timeTip.image(this.loadThumbnail(e));
        }, resetThumbnails: function resetThumbnails() {
          this.timeTip.image({ backgroundImage: "", width: 0, height: 0 }), this.thumbnails = [];
        } };return o;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(1), n(2), n(28), n(45), n(31), n(186), n(190)], o = function (e, t, n, i, o, r, a) {
      var s = o.extend({ setup: function setup() {
          this.text = document.createElement("span"), this.text.className = "jw-text jw-reset", this.img = document.createElement("div"), this.img.className = "jw-reset";var e = document.createElement("div");e.className = "jw-time-tip jw-background-color jw-reset", e.appendChild(this.img), e.appendChild(this.text), t.removeClass(this.el, "jw-hidden"), this.addContent(e);
        }, image: function image(e) {
          t.style(this.img, e);
        }, update: function update(e) {
          this.text.innerHTML = e;
        } }),
          l = i.extend({ constructor: function constructor(t, n) {
          this._model = t, this._api = n, this.timeTip = new s("jw-tooltip-time"), this.timeTip.setup(), this.cues = [], this.seekThrottled = e.throttle(this.performSeek, 400), this._model.on("change:playlistItem", this.onPlaylistItem, this).on("change:position", this.onPosition, this).on("change:duration", this.onDuration, this).on("change:buffer", this.onBuffer, this), i.call(this, "jw-slider-time", "horizontal");
        }, setup: function setup() {
          i.prototype.setup.apply(this, arguments), this._model.get("playlistItem") && this.onPlaylistItem(this._model, this._model.get("playlistItem")), this.elementRail.appendChild(this.timeTip.element()), this.el.addEventListener("mousemove", this.showTimeTooltip.bind(this), !1), this.el.addEventListener("mouseout", this.hideTimeTooltip.bind(this), !1);
        }, limit: function limit(i) {
          if (this.activeCue && e.isNumber(this.activeCue.pct)) return this.activeCue.pct;var o = this._model.get("duration"),
              r = t.adaptiveType(o);if ("DVR" === r) {
            var a = (1 - i / 100) * o,
                s = this._model.get("position"),
                l = Math.min(a, Math.max(n.dvrSeekLimit, s)),
                c = 100 * l / o;return 100 - c;
          }return i;
        }, update: function update(e) {
          this.seekTo = e, this.seekThrottled(), i.prototype.update.apply(this, arguments);
        }, dragStart: function dragStart() {
          this._model.set("scrubbing", !0), i.prototype.dragStart.apply(this, arguments);
        }, dragEnd: function dragEnd() {
          i.prototype.dragEnd.apply(this, arguments), this._model.set("scrubbing", !1);
        }, onSeeked: function onSeeked() {
          this._model.get("scrubbing") && this.performSeek();
        }, onBuffer: function onBuffer(e, t) {
          this.updateBuffer(t);
        }, onPosition: function onPosition(e, t) {
          this.updateTime(t, e.get("duration"));
        }, onDuration: function onDuration(e, t) {
          this.updateTime(e.get("position"), t);
        }, updateTime: function updateTime(e, n) {
          var i = 0;if (n) {
            var o = t.adaptiveType(n);"DVR" === o ? i = (n - e) / n * 100 : "VOD" === o && (i = e / n * 100);
          }this.render(i);
        }, onPlaylistItem: function onPlaylistItem(t, n) {
          this.reset(), t.mediaModel.on("seeked", this.onSeeked, this);var i = n.tracks;e.each(i, function (e) {
            e && e.kind && "thumbnails" === e.kind.toLowerCase() ? this.loadThumbnails(e.file) : e && e.kind && "chapters" === e.kind.toLowerCase() && this.loadChapters(e.file);
          }, this);
        }, performSeek: function performSeek() {
          var e,
              n = this.seekTo,
              i = this._model.get("duration"),
              o = t.adaptiveType(i);0 === i ? this._api.play() : "DVR" === o ? (e = (100 - n) / 100 * i, this._api.seek(e)) : (e = n / 100 * i, this._api.seek(Math.min(e, i - .25)));
        }, showTimeTooltip: function showTimeTooltip(e) {
          var i = this._model.get("duration");if (0 !== i) {
            var o = t.bounds(this.elementRail),
                r = e.pageX ? e.pageX - o.left : e.x;r = t.between(r, 0, o.width);var a = r / o.width,
                s = i * a;i < 0 && (s = i - s);var l;if (this.activeCue) l = this.activeCue.text;else {
              var c = !0;l = t.timeFormat(s, c), i < 0 && s > n.dvrSeekLimit && (l = "Live");
            }this.timeTip.update(l), this.showThumbnail(s), t.addClass(this.timeTip.el, "jw-open"), this.timeTip.el.style.left = 100 * a + "%";
          }
        }, hideTimeTooltip: function hideTimeTooltip() {
          t.removeClass(this.timeTip.el, "jw-open");
        }, reset: function reset() {
          this.resetChapters(), this.resetThumbnails();
        } });return e.extend(l.prototype, r, a), l;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(31), n(45), n(9), n(2)], o = function (e, t, n, i) {
      var o = e.extend({ constructor: function constructor(o, r, a) {
          this._model = o, e.call(this, r, a, !0), this.volumeSlider = new t("jw-slider-volume jw-volume-tip", "vertical"), this.addContent(this.volumeSlider.element()), this.volumeSlider.on("update", function (e) {
            this.trigger("update", e);
          }, this), i.removeClass(this.el, "jw-hidden"), new n(this.el, { useHover: !0, directSelect: !0 }).on("click", this.toggleValue, this).on("tap", this.toggleOpenState, this).on("over", this.openTooltip, this).on("out", this.closeTooltip, this), this._model.on("change:volume", this.onVolume, this);
        }, toggleValue: function toggleValue() {
          this.trigger("toggleValue");
        } });return o;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(2), n(1), n(3), n(28), n(9), n(45), n(191), n(188), n(189), n(192), n(187)], o = function (e, t, n, i, o, r, a, s, l, c, u) {
      function d(e, t, n) {
        var i = document.createElement("div");return i.className = "jw-icon jw-icon-inline jw-button-color jw-reset " + e, i.setAttribute("role", "button"), i.setAttribute("tabindex", "0"), n && i.setAttribute("aria-label", n), i.style.display = "none", t && new o(i).on("click tap", function () {
          t();
        }), { element: function element() {
            return i;
          }, toggle: function toggle(e) {
            e ? this.show() : this.hide();
          }, show: function show() {
            i.style.display = "";
          }, hide: function hide() {
            i.style.display = "none";
          } };
      }function p(e, t) {
        var n = document.createElement("span");return n.className = "jw-text jw-reset " + e, t && n.setAttribute("role", t), n;
      }function h(e, t) {
        var n = new s(e, t);return n;
      }function f(e, n) {
        var i = document.createElement("div");return i.className = "jw-group jw-controlbar-" + e + "-group jw-reset", t.each(n, function (e) {
          e.element && (e = e.element()), i.appendChild(e);
        }), i;
      }function g(t, n) {
        this._api = t, this._model = n, this._isMobile = e.isMobile(), this._compactModeMaxSize = 400, this._maxCompactWidth = -1, this._localization = this._model.get("localization"), this.setup();
      }return t.extend(g.prototype, n, { setup: function setup() {
          this.build(), this.initialize();
        }, build: function build() {
          var e,
              n,
              i,
              o,
              s = new a(this._model, this._api),
              g = new u("jw-icon-more", this._localization.more);this._model.get("visualplaylist") !== !1 && (e = new l("jw-icon-playlist", this._localization.playlist));var m = this._localization.play,
              v = this._localization.prev,
              w = this._localization.next,
              y = this._localization.volume;this._isMobile || (o = d("jw-icon-volume", this._api.setMute, y), n = new r("jw-slider-volume", "horizontal"), i = new c(this._model, "jw-icon-volume", y)), this.elements = { alt: p("jw-text-alt", "status"), play: d("jw-icon-playback", this._api.play.bind(this, { reason: "interaction" }), m), prev: d("jw-icon-prev", this._api.playlistPrev.bind(this, { reason: "interaction" }), v), next: d("jw-icon-next", this._api.playlistNext.bind(this, { reason: "interaction" }), w), playlist: e, elapsed: p("jw-text-elapsed", "timer"), time: s, duration: p("jw-text-duration", "timer"), drawer: g, hd: h("jw-icon-hd", this._localization.hd), cc: h("jw-icon-cc", this._localization.cc), audiotracks: h("jw-icon-audio-tracks", this._localization.audioTracks), mute: o, volume: n, volumetooltip: i, cast: d("jw-icon-cast jw-off", this._api.castToggle, this._localization.cast), fullscreen: d("jw-icon-fullscreen", this._api.setFullscreen, this._localization.fullscreen) }, this.layout = { left: [this.elements.play, this.elements.prev, this.elements.playlist, this.elements.next, this.elements.elapsed], center: [this.elements.time, this.elements.alt], right: [this.elements.duration, this.elements.hd, this.elements.cc, this.elements.audiotracks, this.elements.drawer, this.elements.mute, this.elements.cast, this.elements.volume, this.elements.volumetooltip, this.elements.fullscreen], drawer: [this.elements.hd, this.elements.cc, this.elements.audiotracks] }, this.menus = t.compact([this.elements.playlist, this.elements.hd, this.elements.cc, this.elements.audiotracks, this.elements.volumetooltip]), this.layout.left = t.compact(this.layout.left), this.layout.center = t.compact(this.layout.center), this.layout.right = t.compact(this.layout.right), this.layout.drawer = t.compact(this.layout.drawer), this.el = document.createElement("div"), this.el.className = "jw-controlbar jw-background-color jw-reset", this.elements.left = f("left", this.layout.left), this.elements.center = f("center", this.layout.center), this.elements.right = f("right", this.layout.right), this.el.appendChild(this.elements.left), this.el.appendChild(this.elements.center), this.el.appendChild(this.elements.right);
        }, initialize: function initialize() {
          this.elements.play.show(), this.elements.fullscreen.show(), this.elements.mute && this.elements.mute.show(), this.onVolume(this._model, this._model.get("volume")), this.onPlaylist(this._model, this._model.get("playlist")), this.onPlaylistItem(this._model, this._model.get("playlistItem")), this.onMediaModel(this._model, this._model.get("mediaModel")), this.onCastAvailable(this._model, this._model.get("castAvailable")), this.onCastActive(this._model, this._model.get("castActive")), this.onCaptionsList(this._model, this._model.get("captionsList")), this._model.on("change:volume", this.onVolume, this), this._model.on("change:mute", this.onMute, this), this._model.on("change:playlist", this.onPlaylist, this), this._model.on("change:playlistItem", this.onPlaylistItem, this), this._model.on("change:mediaModel", this.onMediaModel, this), this._model.on("change:castAvailable", this.onCastAvailable, this), this._model.on("change:castActive", this.onCastActive, this), this._model.on("change:duration", this.onDuration, this), this._model.on("change:position", this.onElapsed, this), this._model.on("change:fullscreen", this.onFullscreen, this), this._model.on("change:captionsList", this.onCaptionsList, this), this._model.on("change:captionsIndex", this.onCaptionsIndex, this), this._model.on("change:compactUI", this.onCompactUI, this), this.elements.volume && this.elements.volume.on("update", function (e) {
            var t = e.percentage;this._api.setVolume(t);
          }, this), this.elements.volumetooltip && (this.elements.volumetooltip.on("update", function (e) {
            var t = e.percentage;this._api.setVolume(t);
          }, this), this.elements.volumetooltip.on("toggleValue", function () {
            this._api.setMute();
          }, this)), this.elements.playlist && this.elements.playlist.on("select", function (e) {
            this._model.once("itemReady", function () {
              this._api.play({ reason: "interaction" });
            }, this), this._api.load(e);
          }, this), this.elements.hd.on("select", function (e) {
            this._model.getVideo().setCurrentQuality(e);
          }, this), this.elements.hd.on("toggleValue", function () {
            this._model.getVideo().setCurrentQuality(0 === this._model.getVideo().getCurrentQuality() ? 1 : 0);
          }, this), this.elements.cc.on("select", function (e) {
            this._api.setCurrentCaptions(e);
          }, this), this.elements.cc.on("toggleValue", function () {
            var e = this._model.get("captionsIndex");this._api.setCurrentCaptions(e ? 0 : 1);
          }, this), this.elements.audiotracks.on("select", function (e) {
            this._model.getVideo().setCurrentAudioTrack(e);
          }, this), new o(this.elements.duration).on("click tap", function () {
            if ("DVR" === e.adaptiveType(this._model.get("duration"))) {
              var t = this._model.get("position");this._api.seek(Math.max(i.dvrSeekLimit, t));
            }
          }, this), new o(this.el).on("click tap drag", function () {
            this.trigger("userAction");
          }, this), this.elements.drawer.on("open-drawer close-drawer", function (t, n) {
            e.toggleClass(this.el, "jw-drawer-expanded", n.isOpen), n.isOpen || this.closeMenus();
          }, this), t.each(this.menus, function (e) {
            e.on("open-tooltip", this.closeMenus, this);
          }, this);
        }, onCaptionsList: function onCaptionsList(e, t) {
          var n = e.get("captionsIndex");this.elements.cc.setup(t, n, { isToggle: !0 }), this.clearCompactMode();
        }, onCaptionsIndex: function onCaptionsIndex(e, t) {
          this.elements.cc.selectItem(t);
        }, onPlaylist: function onPlaylist(e, t) {
          var n = t.length > 1;this.elements.next.toggle(n), this.elements.prev.toggle(n), this.elements.playlist && this.elements.playlist.setup(t, e.get("item"));
        }, onPlaylistItem: function onPlaylistItem(e) {
          this.elements.time.updateBuffer(0), this.elements.time.render(0), this.elements.duration.innerHTML = "00:00", this.elements.elapsed.innerHTML = "00:00", this.clearCompactMode();var t = e.get("item");this.elements.playlist && this.elements.playlist.selectItem(t), this.elements.audiotracks.setup();
        }, onMediaModel: function onMediaModel(n, i) {
          i.on("change:levels", function (e, t) {
            this.elements.hd.setup(t, e.get("currentLevel")), this.clearCompactMode();
          }, this), i.on("change:currentLevel", function (e, t) {
            this.elements.hd.selectItem(t);
          }, this), i.on("change:audioTracks", function (e, n) {
            var i = t.map(n, function (e) {
              return { label: e.name };
            });this.elements.audiotracks.setup(i, e.get("currentAudioTrack"), { toggle: !1 }), this.clearCompactMode();
          }, this), i.on("change:currentAudioTrack", function (e, t) {
            this.elements.audiotracks.selectItem(t);
          }, this), i.on("change:state", function (t, n) {
            "complete" === n && (this.elements.drawer.closeTooltip(), e.removeClass(this.el, "jw-drawer-expanded"));
          }, this);
        }, onVolume: function onVolume(e, t) {
          this.renderVolume(e.get("mute"), t);
        }, onMute: function onMute(e, t) {
          this.renderVolume(t, e.get("volume"));
        }, renderVolume: function renderVolume(t, n) {
          this.elements.mute && e.toggleClass(this.elements.mute.element(), "jw-off", t), this.elements.volume && this.elements.volume.render(t ? 0 : n), this.elements.volumetooltip && (this.elements.volumetooltip.volumeSlider.render(t ? 0 : n), e.toggleClass(this.elements.volumetooltip.element(), "jw-off", t));
        }, onCastAvailable: function onCastAvailable(e, t) {
          this.elements.cast.toggle(t), this.clearCompactMode();
        }, onCastActive: function onCastActive(t, n) {
          e.toggleClass(this.elements.cast.element(), "jw-off", !n);
        }, onElapsed: function onElapsed(t, n) {
          var i,
              o = t.get("duration");i = "DVR" === e.adaptiveType(o) ? "-" + e.timeFormat(-o) : e.timeFormat(n), this.elements.elapsed.innerHTML = i;
        }, onDuration: function onDuration(t, n) {
          var i;"DVR" === e.adaptiveType(n) ? (i = "Live", this.clearCompactMode()) : i = e.timeFormat(n), this.elements.duration.innerHTML = i;
        }, onFullscreen: function onFullscreen(t, n) {
          e.toggleClass(this.elements.fullscreen.element(), "jw-off", n);
        }, element: function element() {
          return this.el;
        }, getVisibleBounds: function getVisibleBounds() {
          var t,
              n = this.el,
              i = getComputedStyle ? getComputedStyle(n) : n.currentStyle;return "table" === i.display ? e.bounds(n) : (n.style.visibility = "hidden", n.style.display = "table", t = e.bounds(n), n.style.visibility = n.style.display = "", t);
        }, setAltText: function setAltText(e) {
          this.elements.alt.innerHTML = e;
        }, addCues: function addCues(e) {
          this.elements.time && (t.each(e, function (e) {
            this.elements.time.addCue(e);
          }, this), this.elements.time.drawCues());
        }, closeMenus: function closeMenus(e) {
          t.each(this.menus, function (t) {
            e && e.target === t.el || t.closeTooltip(e);
          });
        }, hideComponents: function hideComponents() {
          this.closeMenus(), this.elements.drawer.closeTooltip(), e.removeClass(this.el, "jw-drawer-expanded");
        }, clearCompactMode: function clearCompactMode() {
          this._maxCompactWidth = -1, this._model.set("compactUI", !1), this._containerWidth && this.checkCompactMode(this._containerWidth);
        }, setCompactModeBounds: function setCompactModeBounds() {
          if (this.element().offsetWidth > 0) {
            var t = this.elements.left.offsetWidth + this.elements.right.offsetWidth;if ("LIVE" === e.adaptiveType(this._model.get("duration"))) this._maxCompactWidth = t + this.elements.alt.offsetWidth;else {
              var n = t + (this.elements.center.offsetWidth - this.elements.time.el.offsetWidth),
                  i = .2;this._maxCompactWidth = n / (1 - i);
            }
          }
        }, checkCompactMode: function checkCompactMode(e) {
          this._maxCompactWidth === -1 && this.setCompactModeBounds(), this._containerWidth = e, this._maxCompactWidth !== -1 && (e >= this._compactModeMaxSize && e > this._maxCompactWidth ? this._model.set("compactUI", !1) : (e < this._compactModeMaxSize || e <= this._maxCompactWidth) && this._model.set("compactUI", !0));
        }, onCompactUI: function onCompactUI(n, i) {
          e.removeClass(this.el, "jw-drawer-expanded"), this.elements.drawer.setup(this.layout.drawer, i), (!i || this.elements.drawer.activeContents.length < 2) && t.each(this.layout.drawer, function (e) {
            this.elements.right.insertBefore(e.el, this.elements.drawer.el);
          }, this);
        } }), g;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(2), n(3), n(9), n(131), n(1)], o = function (e, t, n, i, o) {
      var r = function r(_r4) {
        o.extend(this, t), this.model = _r4, this.el = e.createElement(i({ ariaLabel: this.model.get("localization").playback }));var a = this;this.iconUI = new n(this.el).on("click tap", function (e) {
          a.trigger(e.type);
        }), this.model.on("change:state", function (e, t) {
          var n = a.el.getElementsByClassName("jw-icon-display");if (n.length) {
            var i = a.model.get("localization"),
                o = i.playback;switch (t) {case "buffering":
                o = i.buffer;break;case "playing":
                o = i.pause;break;case "complete":
                o = i.replay;break;case "error":
                o = "";}"" === o ? n[0].removeAttribute("aria-label") : n[0].setAttribute("aria-label", o);
          }
        });
      };return o.extend(r.prototype, { element: function element() {
          return this.el;
        } }), r;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(132), n(2), n(1), n(9)], o = function (e, t, n, i) {
      var o = function o(e) {
        this.model = e, this.setup(), this.model.on("change:dock", this.render, this);
      };return n.extend(o.prototype, { setup: function setup() {
          var n = this.model.get("dock"),
              o = this.click.bind(this),
              r = e(n);this.el = t.createElement(r), new i(this.el).on("click tap", o);
        }, getDockButton: function getDockButton(e) {
          return t.hasClass(e.target, "jw-dock-button") ? e.target : t.hasClass(e.target, "jw-dock-text") ? e.target.parentElement.parentElement : e.target.parentElement;
        }, click: function click(e) {
          var t = this.getDockButton(e),
              i = t.getAttribute("button"),
              o = this.model.get("dock"),
              r = n.findWhere(o, { id: i });r && r.callback && r.callback(e);
        }, render: function render() {
          var n = this.model.get("dock"),
              i = e(n),
              o = t.createElement(i);this.el.innerHTML = o.innerHTML;
        }, element: function element() {
          return this.el;
        } }), o;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(133)], o = function (e) {
      function t(t, n, i, o) {
        return e({ id: t, skin: n, title: i, body: o });
      }return t;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(9), n(2), n(4), n(1), n(3), n(134)], o = function (e, t, n, i, o, r) {
      var a = t.style,
          s = { linktarget: "_blank", margin: 8, hide: !1, position: "top-right" },
          l = function l(_l2) {
        var c,
            u,
            d = new Image(),
            p = i.extend({}, _l2.get("logo"));return i.extend(this, o), this.setup = function (o) {
          if (u = i.extend({}, s, p), u.hide = "true" === u.hide.toString(), c = t.createElement(r()), u.file) {
            u.hide && t.addClass(c, "jw-hide"), t.addClass(c, "jw-logo-" + (u.position || s.position)), "top-right" === u.position && (_l2.on("change:dock", this.topRight, this), _l2.on("change:controls", this.topRight, this), this.topRight(_l2)), _l2.set("logo", u), d.onload = function () {
              var e = { backgroundImage: 'url("' + this.src + '")', width: this.width, height: this.height };if (u.margin !== s.margin) {
                var t = /(\w+)-(\w+)/.exec(u.position);3 === t.length && (e["margin-" + t[1]] = u.margin, e["margin-" + t[2]] = u.margin);
              }a(c, e), _l2.set("logoWidth", e.width);
            }, d.src = u.file;var h = new e(c);h.on("click tap", function (e) {
              t.exists(e) && e.stopPropagation && e.stopPropagation(), this.trigger(n.JWPLAYER_LOGO_CLICK, { link: u.link, linktarget: u.linktarget });
            }, this), o.appendChild(c);
          }
        }, this.topRight = function (e) {
          var t = e.get("controls"),
              n = e.get("dock"),
              i = t && (n && n.length || e.get("sharing") || e.get("related"));a(c, { top: i ? "3.5em" : 0 });
        }, this.element = function () {
          return c;
        }, this.position = function () {
          return u.position;
        }, this.destroy = function () {
          d.onload = null;
        }, this;
      };return l;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(1), n(2)], o = function (e, t) {
      function n(e, t) {
        t.off("change:mediaType", null, this), t.on("change:mediaType", function (t, n) {
          "audio" === n && this.setImage(e.get("playlistItem").image);
        }, this);
      }function i(e, n) {
        var i = e.get("autostart") && !t.isMobile() || e.get("item") > 0;return i ? (this.setImage(null), e.off("change:state", null, this), void e.on("change:state", function (e, t) {
          "complete" !== t && "idle" !== t && "error" !== t || (this.setImage(n.image), this.resize(null, null, e.get("stretching")));
        }, this)) : void this.setImage(n.image);
      }var o = function o(e) {
        this.model = e, e.on("change:playlistItem", i, this), e.on("change:mediaModel", n, this);
      };return e.extend(o.prototype, { setup: function setup(e) {
          this.el = e;var t = this.model.get("playlistItem");t && this.setImage(t.image);
        }, setImage: function setImage(n) {
          var i = this.image;i && (i.onload = null, this.image = null), this.model.off("change:state", null, this);var o = "";e.isString(n) && (o = 'url("' + n + '")', i = this.image = new Image(), i.src = n), t.style(this.el, { backgroundImage: o });
        }, resize: function resize(e, n, i) {
          if ("uniform" === i) {
            if (e && (this.playerAspectRatio = e / n), !this.playerAspectRatio) return;var o = this.image,
                r = null;if (o) {
              if (0 === o.width) {
                var a = this;return void (o.onload = function () {
                  a.resize(e, n, i);
                });
              }var s = o.width / o.height;Math.abs(this.playerAspectRatio - s) < .09 && (r = "cover");
            }t.style(this.el, { backgroundSize: r });
          }
        }, element: function element() {
          return this.el;
        } }), o;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(2), n(138), n(1), n(9), n(30)], o = function (e, t, n, i, o) {
      var r = function r() {};return n.extend(r.prototype, { buildArray: function buildArray() {
          var t = o.split("+"),
              n = t[0],
              i = { items: [{ title: "Powered by JW Player " + n, featured: !0, showLogo: !0, link: "https://jwplayer.com/learn-more" }] },
              r = n.indexOf("-") > 0,
              a = t[1];if (r && a) {
            var s = a.split(".");i.items.push({ title: "build: (" + s[0] + "." + s[1] + ")", link: "#" });
          }var l = this.model.get("provider");if (l && l.name.indexOf("flash") >= 0) {
            var c = "Flash Version " + e.flashVersion();i.items.push({ title: c, link: "http://www.adobe.com/software/flash/about/" });
          }return i;
        }, buildMenu: function buildMenu() {
          var n = this.buildArray();return e.createElement(t(n));
        }, updateHtml: function updateHtml() {
          this.el.innerHTML = this.buildMenu().innerHTML;
        }, rightClick: function rightClick(e) {
          return this.lazySetup(), !this.mouseOverContext && (this.hideMenu(), this.showMenu(e), !1);
        }, getOffset: function getOffset(e) {
          for (var t = e.target, n = e.offsetX || e.layerX, i = e.offsetY || e.layerY; t !== this.playerElement;) {
            n += t.offsetLeft, i += t.offsetTop, t = t.parentNode;
          }return { x: n, y: i };
        }, showMenu: function showMenu(t) {
          var n = this.getOffset(t);return this.el.style.left = n.x + "px", this.el.style.top = n.y + "px", e.addClass(this.playerElement, "jw-flag-rightclick-open"), e.addClass(this.el, "jw-open"), !1;
        }, hideMenu: function hideMenu() {
          this.mouseOverContext || (e.removeClass(this.playerElement, "jw-flag-rightclick-open"), e.removeClass(this.el, "jw-open"));
        }, lazySetup: function lazySetup() {
          this.el || (this.el = this.buildMenu(), this.layer.appendChild(this.el), this.hideMenuHandler = this.hideMenu.bind(this), this.addOffListener(this.playerElement), this.addOffListener(document), this.model.on("change:provider", this.updateHtml, this), this.elementUI = new i(this.el, { useHover: !0 }).on("over", function () {
            this.mouseOverContext = !0;
          }, this).on("out", function () {
            this.mouseOverContext = !1;
          }, this));
        }, setup: function setup(e, t, n) {
          this.playerElement = t, this.model = e, this.mouseOverContext = !1, this.layer = n, t.oncontextmenu = this.rightClick.bind(this);
        }, addOffListener: function addOffListener(e) {
          e.addEventListener("mousedown", this.hideMenuHandler), e.addEventListener("touchstart", this.hideMenuHandler), e.addEventListener("pointerdown", this.hideMenuHandler);
        }, removeOffListener: function removeOffListener(e) {
          e.removeEventListener("mousedown", this.hideMenuHandler), e.removeEventListener("touchstart", this.hideMenuHandler), e.removeEventListener("pointerdown", this.hideMenuHandler);
        }, destroy: function destroy() {
          this.el && (this.hideMenu(), this.elementUI.off(), this.removeOffListener(this.playerElement), this.removeOffListener(document), this.hideMenuHandler = null, this.el = null), this.playerElement && (this.playerElement.oncontextmenu = null, this.playerElement = null), this.model && (this.model.off("change:provider", this.updateHtml), this.model = null);
        } }), r;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(1), n(2)], o = function (e, t) {
      var n = function n(e) {
        this.model = e, this.model.on("change:playlistItem", this.playlistItem, this);
      };return e.extend(n.prototype, { hide: function hide() {
          this.el.style.display = "none";
        }, show: function show() {
          this.el.style.display = "";
        }, setup: function setup(e) {
          this.el = e;var t = this.el.getElementsByTagName("div");this.title = t[0], this.description = t[1], this.model.get("playlistItem") && this.playlistItem(this.model, this.model.get("playlistItem")), this.model.on("change:logoWidth", this.update, this), this.model.on("change:dock", this.update, this);
        }, update: function update(e) {
          var n = { paddingLeft: 0, paddingRight: 0 },
              i = e.get("controls"),
              o = e.get("dock"),
              r = e.get("logo");if (r) {
            var a = 1 * ("" + r.margin).replace("px", ""),
                s = e.get("logoWidth") + (isNaN(a) ? 0 : a);"top-left" === r.position ? n.paddingLeft = s : "top-right" === r.position && (n.paddingRight = s);
          }if (i && o && o.length) {
            var l = 56 * o.length;n.paddingRight = Math.max(n.paddingRight, l);
          }t.style(this.el, n);
        }, playlistItem: function playlistItem(e, t) {
          if (e.get("displaytitle") || e.get("displaydescription")) {
            var n = "",
                i = "";t.title && e.get("displaytitle") && (n = t.title), t.description && e.get("displaydescription") && (i = t.description), this.updateText(n, i);
          } else this.hide();
        }, updateText: function updateText(e, t) {
          this.title.innerHTML = e, this.description.innerHTML = t, this.title.firstChild || this.description.firstChild ? this.show() : this.hide();
        }, element: function element() {
          return this.el;
        } }), n;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(2), n(4), n(3), n(28), n(5), n(184), n(185), n(194), n(195), n(197), n(193), n(198), n(216), n(200), n(1), n(136)], o = function (e, t, i, o, r, a, s, l, c, u, d, p, h, f, g, m) {
      var v = e.style,
          w = e.bounds,
          y = e.isMobile(),
          j = ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "MSFullscreenChange"],
          b = function b(_b, E) {
        function k(t) {
          var n = 0,
              i = E.get("duration"),
              r = E.get("position");"DVR" === e.adaptiveType(i) && (n = i, i = Math.max(r, o.dvrSeekLimit));var a = e.between(r + t, n, i);_b.seek(a);
        }function L(t) {
          var n = e.between(E.get("volume") + t, 0, 100);_b.setVolume(n);
        }function _(e) {
          return !e.ctrlKey && !e.metaKey && !!E.get("controls");
        }function A(e) {
          if (!_(e)) return !0;switch (Ne || oe(), e.keyCode) {case 27:
              _b.setFullscreen(!1);break;case 13:case 32:
              _b.play({ reason: "interaction" });break;case 37:
              Ne || k(-5);break;case 39:
              Ne || k(5);break;case 38:
              L(10);break;case 40:
              L(-10);break;case 67:
              var t = _b.getCaptionsList(),
                  n = t.length;if (n) {
                var i = (_b.getCurrentCaptions() + 1) % n;_b.setCurrentCaptions(i);
              }break;case 77:
              _b.setMute();break;case 70:
              _b.setFullscreen();break;default:
              if (e.keyCode >= 48 && e.keyCode <= 59) {
                var o = e.keyCode - 48,
                    r = o / 10 * E.get("duration");_b.seek(r);
              }}return (/13|32|37|38|39|40/.test(e.keyCode) ? (e.preventDefault(), !1) : void 0
          );
        }function C() {
          ze = !1, e.removeClass(fe, "jw-no-focus");
        }function x(e) {
          e.target && e.target.blur && e.target.blur();
        }function P() {
          ze = !0, e.addClass(fe, "jw-no-focus");
        }function T() {
          ze || C(), Ne || oe();
        }function R() {
          var e = w(fe),
              n = Math.round(e.width),
              i = Math.round(e.height);Ve(Fe), n && i && (n !== ve || i !== we) && (ve = n, we = i, clearTimeout(We), We = setTimeout(Z, 50), E.set("containerWidth", n), E.set("containerHeight", i), He.trigger(t.JWPLAYER_RESIZE, { width: n, height: i }));
        }function I() {
          document.body.contains(fe) ? (Ve(Fe), Fe = Je(R)) : (window.removeEventListener("resize", I), y && window.removeEventListener("orientationchange", I));
        }function M(t, n, i) {
          var o = { color: t, borderColor: t, stroke: t },
              r = { color: n, borderColor: n, stroke: n };e.css("#" + i + " .jw-color-active", o, i), e.css("#" + i + " .jw-color-active-hover:hover", o, i), e.css("#" + i + " .jw-color-inactive", r, i), e.css("#" + i + " .jw-color-inactive-hover:hover", r, i);
        }function S(t, n) {
          n = n || !1, e.toggleClass(fe, "jw-flag-casting", n);
        }function O(t, n) {
          e.toggleClass(fe, "jw-flag-cast-available", n), e.toggleClass(ge, "jw-flag-cast-available", n);
        }function D(t, n) {
          e.replaceClass(fe, /jw-stretch-\S+/, "jw-stretch-" + n);
        }function N(t, n) {
          e.toggleClass(fe, "jw-flag-compact-player", n);
        }function Y(e) {
          e && !y && (e.element().addEventListener("mousemove", J, !1), e.element().addEventListener("mouseout", V, !1));
        }function W() {
          E.get("state") !== r.IDLE && E.get("state") !== r.COMPLETE && E.get("state") !== r.PAUSED || !E.get("controls") || _b.play({ reason: "interaction" }), Ye ? ie() : oe();
        }function F(e) {
          e.link ? (_b.pause(!0), _b.setFullscreen(!1), window.open(e.link, e.linktarget)) : E.get("controls") && _b.play({ reason: "interaction" });
        }function J() {
          clearTimeout(Se);
        }function V() {
          oe();
        }function B(e) {
          He.trigger(e.type, e);
        }function U(t, n) {
          n ? (Pe && Pe.destroy(), e.addClass(fe, "jw-flag-flash-blocked")) : (Pe && Pe.setup(E, fe, fe), e.removeClass(fe, "jw-flag-flash-blocked"));
        }function z() {
          E.get("controls") && _b.setFullscreen();
        }function H() {
          var n = fe.getElementsByClassName("jw-overlays")[0];n.addEventListener("mousemove", oe), Ee = new s(E, me, { useHover: !0 }), Ee.on("click", function () {
            B({ type: t.JWPLAYER_DISPLAY_CLICK }), E.get("controls") && _b.play({ reason: "interaction" });
          }), Ee.on("tap", function () {
            B({ type: t.JWPLAYER_DISPLAY_CLICK }), W();
          }), Ee.on("doubleClick", z), Ee.on("move", oe), Ee.on("over", oe);var i = new l(E);i.on("click", function () {
            B({ type: t.JWPLAYER_DISPLAY_CLICK }), _b.play({ reason: "interaction" });
          }), i.on("tap", function () {
            B({ type: t.JWPLAYER_DISPLAY_CLICK }), W();
          }), e.isChrome() && i.el.addEventListener("mousedown", function () {
            var e = E.getVideo(),
                t = e && 0 === e.getName().name.indexOf("flash");if (t) {
              var n = function n() {
                document.removeEventListener("mouseup", n), i.el.style.pointerEvents = "auto";
              };this.style.pointerEvents = "none", document.addEventListener("mouseup", n);
            }
          }), ge.appendChild(i.element()), Le = new c(E), _e = new u(E), _e.on(t.JWPLAYER_LOGO_CLICK, F);var o = document.createElement("div");o.className = "jw-controls-right jw-reset", _e.setup(o), o.appendChild(Le.element()), ge.appendChild(o), Ce = new a(E), Ce.setup(fe.id, E.get("captions")), ge.parentNode.insertBefore(Ce.element(), Ae.element());var r = E.get("height");y && ("string" == typeof r || r >= 1.5 * De) ? e.addClass(fe, "jw-flag-touch") : (Pe = new h(), Pe.setup(E, fe, fe)), je = new d(_b, E), je.on(t.JWPLAYER_USER_ACTION, oe), E.on("change:scrubbing", K), E.on("change:compactUI", N), ge.appendChild(je.element()), fe.addEventListener("focus", T), fe.addEventListener("blur", C), fe.addEventListener("keydown", A), fe.onmousedown = P, fe.onmouseup = x;
        }function G(t) {
          return t.get("state") === r.PAUSED ? void t.once("change:state", G) : void (t.get("scrubbing") === !1 && e.removeClass(fe, "jw-flag-dragging"));
        }function K(t, n) {
          t.off("change:state", G), n ? e.addClass(fe, "jw-flag-dragging") : G(t);
        }function Q(t, n, i) {
          var o,
              r = fe.className;i = !!i, i && (r = r.replace(/\s*aspectMode/, ""), fe.className !== r && (fe.className = r), v(fe, { display: "block" }, i)), e.exists(t) && e.exists(n) && (E.set("width", t), E.set("height", n)), o = { width: t }, e.hasClass(fe, "jw-flag-aspect-mode") || (o.height = n), E.get("aspectratio") && he(), v(fe, o, !0), X(n), Z(t, n);
        }function X(t) {
          if (xe = q(t), je && !xe) {
            var n = Ne ? ye : E;pe(n, n.get("state"));
          }e.toggleClass(fe, "jw-flag-audio-player", xe);
        }function q(e) {
          if (E.get("aspectratio")) return !1;if (g.isString(e) && e.indexOf("%") > -1) return !1;var t = g.isNumber(e) ? e : E.get("containerHeight");return $(t);
        }function $(e) {
          return e && e <= De * (y ? 1.75 : 1);
        }function Z(t, n) {
          if (!t || isNaN(Number(t))) {
            if (!me) return;t = me.clientWidth;
          }if (!n || isNaN(Number(n))) {
            if (!me) return;n = me.clientHeight;
          }be && be.resize(t, n, E.get("stretching")), e.isMSIE(9) && document.all && !window.atob && (t = n = "100%");var i = E.getVideo();if (i) {
            var o = i.resize(t, n, E.get("stretching"));o && (clearTimeout(We), We = setTimeout(Z, 250)), E.get("aspectratio") && he(), Ce.resize(), je.checkCompactMode(t);
          }
        }function ee() {
          if (Ue) {
            var e = document.fullscreenElement || document.webkitCurrentFullScreenElement || document.mozFullScreenElement || document.msFullscreenElement;return !(!e || e.id !== E.get("id"));
          }return Ne ? ye.getVideo().getFullScreen() : E.getVideo().getFullScreen();
        }function te(e) {
          var t = E.get("fullscreen"),
              n = void 0 !== e.jwstate ? e.jwstate : ee();t !== n && E.set("fullscreen", n), clearTimeout(We), We = setTimeout(Z, 200);
        }function ne(t, n) {
          n ? (e.addClass(t, "jw-flag-fullscreen"), v(document.body, { "overflow-y": "hidden" }), oe()) : (e.removeClass(t, "jw-flag-fullscreen"), v(document.body, { "overflow-y": "" })), Z();
        }function ie() {
          Ye = !1, clearTimeout(Se), je.hideComponents(), e.addClass(fe, "jw-flag-user-inactive"), Ce.renderCues(!0);
        }function oe() {
          Ye || (e.removeClass(fe, "jw-flag-user-inactive"), je.checkCompactMode(me.clientWidth), Ce.renderCues(!0)), Ye = !0, clearTimeout(Se), Se = setTimeout(ie, Oe);
        }function re() {
          _b.setFullscreen(!1);
        }function ae() {
          ke && ke.setState(E.get("state")), se(E, E.mediaModel.get("mediaType")), E.mediaModel.on("change:mediaType", se, this);
        }function se(t, n) {
          var i = "audio" === n,
              o = E.getVideo(),
              r = o && 0 === o.getName().name.indexOf("flash");e.toggleClass(fe, "jw-flag-media-audio", i), i && !r ? fe.insertBefore(be.el, me) : fe.insertBefore(be.el, Ce.element());
        }function le(t, n) {
          var i = "LIVE" === e.adaptiveType(n);e.toggleClass(fe, "jw-flag-live", i), He.setAltText(i ? t.get("localization").liveBroadcast : "");
        }function ce(e, t) {
          return t ? void (t.name ? Ae.updateText(t.name, t.message) : Ae.updateText(t.message, "")) : void Ae.playlistItem(e, e.get("playlistItem"));
        }function ue() {
          var e = E.getVideo();return !!e && e.isCaster;
        }function de() {
          e.replaceClass(fe, /jw-state-\S+/, "jw-state-" + Te);
        }function pe(t, n) {
          if (Te = n, clearTimeout(Be), n === r.COMPLETE || n === r.IDLE ? Be = setTimeout(de, 100) : de(), ue()) return void e.addClass(me, "jw-media-show");switch (n) {case r.PLAYING:
              Z();break;case r.PAUSED:
              oe();}
        }function he() {
          var e = fe.getElementsByClassName("jw-aspect")[0];Ce.setContainerHeight(e.offsetHeight);
        }var fe,
            ge,
            me,
            ve,
            we,
            ye,
            je,
            be,
            Ee,
            ke,
            Le,
            _e,
            Ae,
            Ce,
            xe,
            Pe,
            Te,
            Re,
            Ie,
            Me,
            Se = -1,
            Oe = y ? 4e3 : 2e3,
            De = 40,
            Ne = !1,
            Ye = !1,
            We = -1,
            Fe = -1,
            Je = window.requestAnimationFrame || function (e) {
          return window.setTimeout(e, 17);
        },
            Ve = window.cancelAnimationFrame || window.clearTimeout,
            Be = -1,
            Ue = !1,
            ze = !1,
            He = g.extend(this, i);window.webpackJsonpjwplayer && n(203), this.model = E, this.api = _b, fe = e.createElement(m({ id: E.get("id") })), e.isIE() && e.addClass(fe, "jw-ie");var Ge = E.get("width"),
            Ke = E.get("height");v(fe, { width: Ge.toString().indexOf("%") > 0 ? Ge : Ge + "px", height: Ke.toString().indexOf("%") > 0 ? Ke : Ke + "px" }), Ie = fe.requestFullscreen || fe.webkitRequestFullscreen || fe.webkitRequestFullScreen || fe.mozRequestFullScreen || fe.msRequestFullscreen, Me = document.exitFullscreen || document.webkitExitFullscreen || document.webkitCancelFullScreen || document.mozCancelFullScreen || document.msExitFullscreen, Ue = Ie && Me, this.onChangeSkin = function (t, n) {
          e.replaceClass(fe, /jw-skin-\S+/, n ? "jw-skin-" + n : "");
        }, this.handleColorOverrides = function () {
          function t(t, i, o) {
            if (o) {
              t = e.prefix(t, "#" + n + " ");var r = {};r[i] = o, e.css(t.join(", "), r, n);
            }
          }var n = E.get("id"),
              i = E.get("skinColorActive"),
              o = E.get("skinColorInactive"),
              r = E.get("skinColorBackground");t([".jw-toggle", ".jw-button-color:hover"], "color", i), t([".jw-active-option", ".jw-progress", ".jw-playlist-container .jw-option.jw-active-option", ".jw-playlist-container .jw-option:hover"], "background", i), t([".jw-text", ".jw-option", ".jw-button-color", ".jw-toggle.jw-off", ".jw-tooltip-title", ".jw-skip .jw-skip-icon", ".jw-playlist-container .jw-icon"], "color", o), t([".jw-cue", ".jw-knob"], "background", o), t([".jw-playlist-container .jw-option"], "border-bottom-color", o), t([".jw-background-color", ".jw-tooltip-title", ".jw-playlist", ".jw-playlist-container .jw-option"], "background", r), t([".jw-playlist-container ::-webkit-scrollbar"], "border-color", r), M(i, o, n);
        }, this.setup = function () {
          this.handleColorOverrides(), E.get("skin-loading") === !0 && (e.addClass(fe, "jw-flag-skin-loading"), E.once("change:skin-loading", function () {
            e.removeClass(fe, "jw-flag-skin-loading");
          })), this.onChangeSkin(E, E.get("skin"), ""), E.on("change:skin", this.onChangeSkin, this), me = fe.getElementsByClassName("jw-media")[0], ge = fe.getElementsByClassName("jw-controls")[0];var n = fe.getElementsByClassName("jw-preview")[0];be = new p(E), be.setup(n);var i = fe.getElementsByClassName("jw-title")[0];Ae = new f(E), Ae.setup(i), H(), oe(), E.set("mediaContainer", me), E.mediaController.on("fullscreenchange", te);for (var o = j.length; o--;) {
            document.addEventListener(j[o], te, !1);
          }window.removeEventListener("resize", I), window.addEventListener("resize", I, !1), y && (window.removeEventListener("orientationchange", I), window.addEventListener("orientationchange", I, !1)), E.on("change:errorEvent", ce), E.on("change:controls", Qe), Qe(E, E.get("controls")), E.on("change:state", pe), E.on("change:duration", le, this), E.on("change:flashBlocked", U), U(E, E.get("flashBlocked")), _b.onPlaylistComplete(re), _b.onPlaylistItem(ae), E.on("change:castAvailable", O), O(E, E.get("castAvailable")), E.on("change:castActive", S), S(E, E.get("castActive")), E.get("stretching") && D(E, E.get("stretching")), E.on("change:stretching", D), pe(E, r.IDLE), E.on("change:fullscreen", Xe), Y(je), Y(_e);var a = E.get("aspectratio");if (a) {
            e.addClass(fe, "jw-flag-aspect-mode");var s = fe.getElementsByClassName("jw-aspect")[0];v(s, { paddingTop: a });
          }_b.on(t.JWPLAYER_READY, function () {
            R(), Q(E.get("width"), E.get("height"));
          });
        };var Qe = function Qe(t, n) {
          if (n) {
            var i = Ne ? ye.get("state") : E.get("state");pe(t, i);
          }e.toggleClass(fe, "jw-flag-controls-disabled", !n);
        },
            Xe = function Xe(t, n) {
          var i = E.getVideo();Ue ? (n ? Ie.apply(fe) : Me.apply(document), ne(fe, n)) : e.isIE() ? ne(fe, n) : (ye && ye.getVideo() && ye.getVideo().setFullscreen(n), i.setFullscreen(n)), i && 0 === i.getName().name.indexOf("flash") && i.setFullscreen(n);
        };this.resize = function (e, t) {
          var n = !0;Q(e, t, n), R();
        }, this.resizeMedia = Z, this.reset = function () {
          document.contains(fe) && fe.parentNode.replaceChild(Re, fe), e.emptyElement(fe);
        }, this.setupInstream = function (t) {
          this.instreamModel = ye = t, ye.on("change:controls", Qe, this), ye.on("change:state", pe, this), Ne = !0, e.addClass(fe, "jw-flag-ads"), oe();
        }, this.setAltText = function (e) {
          je.setAltText(e);
        }, this.useExternalControls = function () {
          e.addClass(fe, "jw-flag-ads-hide-controls");
        }, this.destroyInstream = function () {
          if (Ne = !1, ye && (ye.off(null, null, this), ye = null), this.setAltText(""), e.removeClass(fe, "jw-flag-ads"), e.removeClass(fe, "jw-flag-ads-hide-controls"), E.getVideo) {
            var t = E.getVideo();t.setContainer(me);
          }le(E, E.get("duration")), Ee.revertAlternateClickHandlers();
        }, this.addCues = function (e) {
          je && je.addCues(e);
        }, this.clickHandler = function () {
          return Ee;
        }, this.controlsContainer = function () {
          return ge;
        }, this.getContainer = this.element = function () {
          return fe;
        }, this.getSafeRegion = function (t) {
          var n = { x: 0, y: 0, width: E.get("containerWidth") || 0, height: E.get("containerHeight") || 0 },
              i = E.get("dock");return i && i.length && E.get("controls") && (n.y = Le.element().clientHeight, n.height -= n.y), t = t || !e.exists(t), t && E.get("controls") && (n.height -= je.element().clientHeight), n;
        }, this.setCaptions = function (e) {
          Ce.clear(), Ce.setup(E.get("id"), e), Ce.resize();
        }, this.destroy = function () {
          window.removeEventListener("resize", I), window.removeEventListener("orientationchange", I);for (var t = j.length; t--;) {
            document.removeEventListener(j[t], te, !1);
          }E.mediaController && E.mediaController.off("fullscreenchange", te), fe.removeEventListener("keydown", A, !1), Pe && Pe.destroy(), ke && (E.off("change:state", ke.statusDelegate), ke.destroy(), ke = null), Ne && this.destroyInstream(), _e && _e.destroy(), e.clearCss(E.get("id"));
        };
      };return b;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  },, function (e, t, n) {
    var i = n(126);"string" == typeof i && (i = [["all-players", i, ""]]), n(84).style(i, "all-players"), i.locals && (e.exports = i.locals);
  },, function (e, t, n) {
    var i, o;i = [n(85), n(1), n(30), n(2), n(8), n(9), n(90), n(22), n(91), n(80), n(4), n(5), n(65), n(42), n(34), n(63), n(27)], o = function (e, t, n, i, o, r, a, s, l, c, u, d, p, h, f, g, m) {
      var v = {};return v.api = e, v._ = t, v.version = n, v.utils = t.extend(i, o, { canCast: f.available, key: a, extend: t.extend, scriptloader: s, rssparser: g, tea: l, UI: r }), v.utils.css.style = v.utils.style, v.vid = c, v.events = t.extend({}, u, { state: d }), v.playlist = t.extend({}, p, { item: h }), v.plugins = m, v.cast = f, v;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  },,,,, function (e, t, n) {
    var i, o;i = [n(163), n(23), n(214)], o = function (e, t, i) {
      var o = e.prototype.setup;return e.prototype.setup = function (e, r) {
        e.analytics && (e.sdkplatform = e.sdkplatform || e.analytics.sdkplatform), o.apply(this, arguments);var a = this._model.get("edition"),
            s = t(a),
            l = this._model.get("cast"),
            c = this;s("casting") && l && l.appid && n.e(3, function (require) {
          var e = n(86);c._castController = new e(c, c._model), c.castToggle = c._castController.castToggle.bind(c._castController);
        });var u = i.setup();this.once("ready", u.onReady, this), r.getAdBlock = u.checkAdBlock;
      }, e;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(90), n(23), n(1), n(2), n(78), n(168), n(47)], o = function (e, t, i, o, r, a, s) {
      function l(e, t, n) {
        if (t) {
          var i = t.client;delete t.client, /\.(js|swf)$/.test(i || "") || (i = r.repo() + n), e[i] = t;
        }
      }function c(e, n) {
        var o = i.clone(n.get("plugins")) || {},
            a = n.get("edition"),
            s = t(a),
            c = /^(vast|googima)$/,
            u = /\.(js|swf)$/,
            d = r.repo(),
            p = i.clone(n.get("advertising"));if (s("ads") && p && (u.test(p.client) ? o[p.client] = p : c.test(p.client) && (o[d + p.client + ".js"] = p), delete p.client), s("jwpsrv")) {
          var h = n.get("analytics");i.isObject(h) || (h = {}), l(o, h, "jwpsrv.js");
        }l(o, n.get("ga"), "gapro.js"), l(o, n.get("sharing"), "sharing.js"), l(o, n.get("related"), "related.js"), n.set("plugins", o), e();
      }function u(t, i) {
        var s = i.get("key") || window.jwplayer && window.jwplayer.key,
            l = new e(s),
            c = l.edition();if (i.set("key", s), i.set("edition", c), "unlimited" === c) {
          var u = o.getScriptPath("jwplayer.js");if (!u) return void a.error(t, "Error setting up player", "Could not locate jwplayer.js script tag");n.p = u, o.repo = r.repo = r.loadFrom = function () {
            return u;
          };
        }i.updateProviders(), "invalid" === c ? a.error(t, "Error setting up player", (void 0 === s ? "Missing" : "Invalid") + " license key") : t();
      }function d(e, t) {
        s.containsDrm(t) ? s.probe(e, t.get("edition")) : e();
      }function p() {
        var e = a.getQueue();return e.CHECK_KEY = { method: u, depends: ["LOADED_POLYFILLS"] }, e.PROBE_DRM_SUPPORT = { method: d, depends: ["CHECK_KEY"] }, e.FILTER_PLUGINS = { method: c, depends: ["CHECK_KEY"] }, e.FILTER_PLAYLIST.depends.push("PROBE_DRM_SUPPORT"), e.LOAD_PLUGINS.depends.push("FILTER_PLUGINS"), e.SETUP_VIEW.depends.push("CHECK_KEY"), e;
      }return { getQueue: p };
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(170), n(205), n(1)], o = function (e, t, n) {
      return window.jwplayer ? window.jwplayer : n.extend(e, t);
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  },, function (e, t, n) {
    var i, o;i = [], o = function () {
      function e() {
        var e = document.createElement("div");return e.className = n, e.innerHTML = "&nbsp;", e.style.width = "1px", e.style.height = "1px", e.style.position = "absolute", e.style.background = "transparent", e;
      }function t() {
        function t() {
          var e = this,
              t = e._view.element();t.appendChild(a), o = !0, i() && e.trigger("adBlock");
        }function i() {
          return !!o && (!!r || ("" !== a.innerHTML && a.className === n && null !== a.offsetParent && 0 !== a.clientHeight || (r = !0), r));
        }var o = !1,
            r = !1,
            a = e();return { onReady: t, checkAdBlock: i };
      }var n = "afs_ads";return { setup: t };
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(2), n(4), n(9), n(3), n(1), n(130)], o = function (e, t, n, i, o, r) {
      var a = function a(e) {
        this.model = e, this.setup();
      };return o.extend(a.prototype, i, { setup: function setup() {
          this.destroy(), this.skipMessage = this.model.get("skipText"), this.skipMessageCountdown = this.model.get("skipMessage"), this.setWaitTime(this.model.get("skipOffset"));var t = r();this.el = e.createElement(t), this.skiptext = this.el.getElementsByClassName("jw-skiptext")[0], this.skipAdOnce = o.once(this.skipAd.bind(this)), new n(this.el).on("click tap", o.bind(function () {
            this.skippable && this.skipAdOnce();
          }, this)), this.model.on("change:duration", this.onChangeDuration, this), this.model.on("change:position", this.onChangePosition, this), this.onChangeDuration(this.model, this.model.get("duration")), this.onChangePosition(this.model, this.model.get("position"));
        }, updateMessage: function updateMessage(e) {
          this.skiptext.innerHTML = e;
        }, updateCountdown: function updateCountdown(e) {
          this.updateMessage(this.skipMessageCountdown.replace(/xx/gi, Math.ceil(this.waitTime - e)));
        }, onChangeDuration: function onChangeDuration(t, n) {
          if (n) {
            if (this.waitPercentage) {
              if (!n) return;this.itemDuration = n, this.setWaitTime(this.waitPercentage), delete this.waitPercentage;
            }e.removeClass(this.el, "jw-hidden");
          }
        }, onChangePosition: function onChangePosition(t, n) {
          this.waitTime - n > 0 ? this.updateCountdown(n) : (this.updateMessage(this.skipMessage), this.skippable = !0, e.addClass(this.el, "jw-skippable"));
        }, element: function element() {
          return this.el;
        }, setWaitTime: function setWaitTime(t) {
          if (o.isString(t) && "%" === t.slice(-1)) {
            var n = parseFloat(t);return void (this.itemDuration && !isNaN(n) ? this.waitTime = this.itemDuration * n / 100 : this.waitPercentage = t);
          }o.isNumber(t) ? this.waitTime = t : "string" === e.typeOf(t) ? this.waitTime = e.seconds(t) : isNaN(Number(t)) ? this.waitTime = 0 : this.waitTime = Number(t);
        }, skipAd: function skipAd() {
          this.trigger(t.JWPLAYER_AD_SKIPPED);
        }, destroy: function destroy() {
          this.el && (this.el.removeEventListener("click", this.skipAdOnce), this.el.parentElement && this.el.parentElement.removeChild(this.el)), delete this.skippable, delete this.itemDuration, delete this.waitPercentage;
        } }), a;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }, function (e, t, n) {
    var i, o;i = [n(199), n(1)], o = function (e, t) {
      var n = function n() {};return t.extend(n.prototype, e.prototype, { buildArray: function buildArray() {
          var t = e.prototype.buildArray.apply(this, arguments);if (this.model.get("abouttext")) {
            t.items[0].showLogo = !1, t.items.push(t.items.shift());var n = { title: this.model.get("abouttext"), link: this.model.get("aboutlink") || t.items[0].link };t.items.unshift(n);
          }return t;
        } }), n;
    }.apply(t, i), !(void 0 !== o && (e.exports = o));
  }]);
});
}.call(window));

/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = {"playlistUrlBase":"//content.jwplatform.com/jw6/","settings":{"advertising":{"vpaidmode":"insecure","client":"vast","schedule":{"myAds":{"offset":"pre","tag":""},"postroll":{"offset":"post","tag":""}},"skipoffset":5,"skipmessage":"Omitir en \"xx\"","skiptext":"Omitir","admessage":"Este video comenzará en \"xx\" segundos."},"aspectratio":"16:9","autostart":false,"controls":true,"displaydescription":false,"displaytitle":false,"flashplayer":"https://player.h-cdn.com/jwplayer.flash.7_6_0.swf","height":270,"mute":false,"ph":1,"plugins":{"//assets-jpcust.jwpsrv.com/player/6/6124956/ping.js":{"pixel":"//content.jwplatform.com/ping.gif"}},"preload":"none","primary":"html5","hlshtml":true,"modes":[{"type":"html5","src":"//assets-jpcust.jwpsrv.com/player/6/6124956/jwplayer.html5.js"},{"type":"flash","src":"//assets-jpcust.jwpsrv.com/player/6/6124956/jwplayer.flash.swf"}],"repeat":false,"sharing":{"link":"//content.jwplatform.com/previews/MEDIAID-Vb7evTaC","heading":"Compartir"},"skin":{"active":"#FFFFFF","inactive":"#FFFFFF","name":"roundster","background":"#0084B6"},"stagevideo":false,"stretching":"uniform","visualplaylist":false,"width":"100%"}}

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var tableroUrlWS = window.config.Statics.TableroUrl;
var pathDatosUrl = "obtenerTableros/procesarTablero/";
var pathCambiosWS = "obtenerCC/procesarCC/";
var isDebugging = false;
var tableros = [];

/* CodigoControl*/ /////////////////////////////////////////////////////////////////////////////
var codigoControl = function codigoControl(encuentroId, _codigoControl) {
    //console.log("this " + this)
    this._encuentroId = encuentroId, this._codigo = parseInt("0x" + _codigoControl, 16), this._encuentro = 0x0000000F & this._codigo, this._incidencias = (0x0000FFF0 & this._codigo) >> 4, this._formaciones = (0x000F0000 & this._codigo) >> 16, this._imagenes = (0x0FF00000 & this._codigo) >> 20, this._tablero = (0xF0000000 & this._codigo) >> 28, this.encuentroId = function () {
        return this._encuentroId;
    }, this.incidencias = function () {
        return this._incidencias;
    }, this.encuentro = function () {
        return this._encuentro;
    }, this.formaciones = function () {
        return this._formaciones;
    }, this.imagenes = function () {
        return this._imagenes;
    }, this.tablero = function () {
        return this._tablero;
    }, this.isTypeOf = function (value) {
        var _isTypeCodigoControl = false;
        if (value == "codigoControl") _isTypeCodigoControl = !_isTypeCodigoControl;
        return _isTypeCodigoControl;
    };
    return false;
};

/* metodo que recibe un array en notacion json ej: {"cc":[{"id":000,"valor":001},{..},{..}]} */
/* lo convierte en array de objetos tipo CodigoControl */
function factoryCodigoControl(arr) {
    var list = new Array();
    //  console.log("factoryCodigoControl")
    try {
        for (var x = 0; x <= arr.length - 1; x++) {
            var codControl = new codigoControl(arr[x].id, arr[x].valor);
            list.push(codControl);
        }
    } catch (err) {
        if (isDebugging) {
            showError('factoryCodigoControl', err);
        };
    }
    return list;
};

/*recibe una lista de objetos de tipo ComparadorCodigoControl*/
/*devuelve una lista de objetos CodigoSolicitud concatenados */
function generarUrlParamCodigoSolicitud(arr) {
    try {
        var list = new Array();
        for (var x = 0; x <= arr.length - 1; x++) {
            var cs = new codigoSolicitud(arr[x].cambiosEncuentro(), arr[x].cambiosIncidencias(), arr[x].cambiosFormaciones());
            // verifico si hay cambios.                             
            if (!cs.allFalse()) {
                list.push(arr[x].encuentroId() + "-" + cs.toString() + "1");
            };
        }
        /// agregar la validacion de todos, que hago si ninguno va?
        return list.toString();
    } catch (err) {
        if (isDebugging) {
            showError('generarUrlParamCodigoSolicitud', err);
        };
        return "";
    }
};

/*recibe dos objetos de tipo CodigoControl y permite comparlos*/
var comparadorCodigoControl = function comparadorCodigoControl(old, newslast) {
    //  console.log("comparadorCodigoControl")
    this.encuentroId = function () {
        return old.encuentroId();
    }, this.cambiosIncidencias = function () {
        var _hayCambios = false;
        if (old.incidencias() != newslast.incidencias()) {
            _hayCambios = !_hayCambios;
        }
        return _hayCambios;
    }, this.cambiosFormaciones = function () {
        var _hayCambios = false;
        if (old.formaciones() != newslast.formaciones()) {
            _hayCambios = !_hayCambios;
        }
        return _hayCambios;
    }, this.cambiosEncuentro = function () {
        var _hayCambios = false;
        if (old.encuentro() != newslast.encuentro()) {
            _hayCambios = !_hayCambios;
        }
        return _hayCambios;
    };
};

/*recibe los parametros (booleans) relacionados con los cambios en el nuevo codigo de control*/
/*devuelve la concatenacion*/
var codigoSolicitud = function codigoSolicitud(e, i, f) {
    this.allFalse = function () {
        var _allFalse = false;
        if (!e && !i && !f) {
            _allFalse = !_allFalse;
        }
        return _allFalse;
    };

    var convert = function convert(value) {
        var _hasValue = '0';
        if (value) {
            _hasValue = '1';
        }
        return _hasValue;
    };

    this.toString = function () {
        return convert(e) + convert(i) + convert(f);
    };
};

/*agrega un objeto de tipo tablero a el array tableros*/
function agregarTablero(value) {
    tableros.push(value);
};

/* procesa el codigo de control verificando que tipo de cambios hubo */
/* solicitando la actualizacion de los tableros*/
window.procesarCC = function (json) {
    // console.log("procesarCC")
    try {
        // array de objetos comparador // 
        var _arrComparador = new Array();

        // creo los codigo de control //
        var _arr = factoryCodigoControl(json);

        // comparo los codigos de control //
        for (var i = 0; i < _arr.length; i++) {
            //console.log("buscarTablero")
            var oTablero = buscarTablero(_arr[i].encuentroId());
            //console.log("actualizarReloj")
            oTablero.actualizarReloj();
            //console.log("codigoControl")
            var oCCOld = new codigoControl(oTablero._value.cc.id, oTablero._value.cc.valor);
            // comparo los codigo de control, el que tengo y el actualizado //
            var oComparador = new comparadorCodigoControl(oCCOld, _arr[i]);
            _arrComparador.push(oComparador);
        }
        //console.log("generarUrlParamCodigoSolicitud")
        var _param = generarUrlParamCodigoSolicitud(_arrComparador);

        /*solicito la actualizacion de los tableros*/
        /*siempre y cuando existan tableros para actualizar*/
        if (_param != "") {
            //console.log("actualizarTablero")
            actualizarTablero(_param);
        }
    } catch (err) {
        if (isDebugging) {
            showError('procesarCC', err);
        };
    }
};

var verificarCambiosCodigoControl = exports.verificarCambiosCodigoControl = function verificarCambiosCodigoControl() {
    //console.log("verificarCambiosCodigoControl")
    // tomo todos los objeto de tipo tablero de tableros[] //
    var _arr = new Array();

    try {
        //obtengo los codigo de control y defino que voy a pedir // 
        for (var i = 0; i < tableros.length; i++) {
            // armo la url con el encuentroId - cc //
            var _cadena = tableros[i]._value.cc.id;
            if (tableros[i]._estaActivo) {
                _arr.push(_cadena);
            }
        }
        if (_arr.length > 0) {
            //console.log("parametros " + tableroUrlWS + pathCambiosWS + _arr.toString())
            var obj = new Object();
            obj.url = tableroUrlWS + pathCambiosWS;
            obj.pars = _arr.toString(); // recibe un cadena de ids o un objeto tablero??
            var ajaxConexion = new ajaxData(obj);
            ajaxConexion.conectar();
        }
    } catch (err) {
        if (isDebugging) {
            showError('verificarCambiosCodigoControl', err);
        };
    }
};

/*busca un objeto de tipo tablero dentro del array tableros*/
function buscarTablero(value) {
    //console.log("buscarTablero")
    var oTablero = null;
    try {
        for (var i = 0; i < tableros.length; i++) {
            if (tableros[i]._value.cc.id == value) {
                oTablero = tableros[i];
            }
        }
    } catch (err) {
        if (isDebugging) {
            showError('buscarTablero', err);
        };
    }
    return oTablero;
};

function showError(m, e) {
    alert("metodo: " + m + ", error = " + e);
}

var ajaxData = function ajaxData(options) {
    this._pars = options.pars, this._url = options.url, this._metodoCallBack = options.metodoCallBack, this.conectar = function () {
        $.ajax({
            dataType: "jsonp",
            url: this._url + this._pars,
            success: function success(json) {}
        });
    };
};
window.procesarTablero = function (json) {
    //console.log("procesarTablero")
    /*este metodo tiene que recibir un json que actualice los tableros*/
    var _arr = new Array();
    try {
        _arr = json;
        for (var i = 0; i < _arr.length; i++) {
            if (_arr[i].hasOwnProperty('cc')) {
                var oTablero = buscarTablero(_arr[i].cc.id);
                if (oTablero == null) {
                    throw err;
                } else {
                    oTablero.setValue(_arr[i]);
                }
                oTablero.execute();
            }
        };
    } catch (err) {
        if (isDebugging) {
            showError('procesarTablero', err);
        };
    }
};

/*recibe una cadena con el codigo de encuentro y el codigo de solicitud ej: 2375-111,,, */
function actualizarTablero(value) {
    try {
        /*tiene que haber una llamada al ws verificando si existen cambios para que se actualice*/
        var obj = new Object();
        obj.url = tableroUrlWS + pathDatosUrl;
        obj.pars = value; // recibe un cadena de ids
        var ajaxConexion = new ajaxData(obj);
        ajaxConexion.conectar();
    } catch (err) {
        if (isDebugging) {
            showError('actualizarTablero', err);
        };
    }
};

/*actualiza el tiempo de los tableros*/
function actualizarTiempo() {
    try {
        for (var i = 0; i < tableros.length; i++) {
            tableros[i].actualizarReloj();
        }
    } catch (err) {
        if (isDebugging) {
            showError('actualizarTiempo', err);
        };
    }
}

var iniciarTableros = exports.iniciarTableros = function iniciarTableros(tablerosParam) {
    try {
        tableros = tablerosParam;
        var _cadena = new Array();
        for (var i = 0; i < tableros.length; i++) {
            _cadena.push(tableros[i]._value.cc.id + "-" + tableros[i]._value.cc.valor);
        }
        //console.log(_cadena.toString())
        actualizarTablero(_cadena.toString());
        //a partir de aca, una vez que se actualiza por primera vez el tablero
        // setear un intervalo de tiempo para un metodo que actualice el tiempo en los tableros.
        setInterval(actualizarTiempo, 1000);
    } catch (err) {
        if (isDebugging) {
            showError('iniciarTableros', err);
        };
    }
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

/* objeto Tablero Futbol */
var tableroFutbol = function tableroFutbol(value, isActive) {
    var isDebugging = false;
    //    console.log(value);
    //    console.log(isActive);

    this._value = value;
    this._estaActivo = isActive || true;
    this._cambioEncuentro = false;
    this._cambioIncidencias = false;
    this._cambioExtras = false;
    this._cambioFormaciones = false;
    this._tieneTiempo = true;

    /* TAG A ACTUALIZAR */
    if (this._value.cc.hasOwnProperty('tipoTablero')) {
        this.TAG_RESULTADOS = this._value.cc.tipoTablero + "resultado";
        this.TAG_RESULTADOS_PENALES = this._value.cc.tipoTablero + "penales";
        this.TAG_INCIDENCIA = this._value.cc.tipoTablero + "i";
        this.TAG_ESTADO = this._value.cc.tipoTablero + "estado";
        this.TAG_PERIODO = this._value.cc.tipoTablero + "periodo";
        this.TAG_TIEMPO = this._value.cc.tipoTablero + "tiempo";
        this.TAG_TIEMPO_MINUTOS = this._value.cc.tipoTablero + "minutos";
        this.TAG_RESUMEN = this._value.cc.tipoTablero + "resumen";
    } else {
        this.TAG_RESULTADOS = "resultado";
        this.TAG_RESULTADOS_PENALES = "penales";
        this.TAG_INCIDENCIA = "i";
        this.TAG_ESTADO = "estado";
        this.TAG_PERIODO = "periodo";
        this.TAG_TIEMPO = "tiempo";
        this.TAG_TIEMPO_MINUTOS = "minutos";
        this.TAG_RESUMEN = "resumen";
    }

    /* ******************** */

    this.setValue = function (valorActualizado) {
        try {
            if (valorActualizado.hasOwnProperty('cc')) {
                this._value.cc = valorActualizado.cc;
            };
            if (valorActualizado.hasOwnProperty('encuentro')) {
                this._value.encuentro = valorActualizado.encuentro;this._cambioEncuentro = true;
            } else {
                this._cambioEncuentro = false;
            };
            if (valorActualizado.hasOwnProperty('ins')) {
                this._value.ins = valorActualizado.ins;this._cambioIncidencias = true;
            } else {
                this._cambioIncidencias = false;
            };
            if (valorActualizado.hasOwnProperty('fors')) {
                this._value.fors = valorActualizado.fors;this._cambioFormaciones = true;
            } else {
                this._cambioFormaciones = false;
            };
            if (valorActualizado.hasOwnProperty('extras')) {
                this._value.tablero = valorActualizado.extras;this._cambioExtras = true;
            } else {
                this._cambioExtras = false;
            };
        } catch (err) {
            if (isDebugging) {
                showError('tableroFutbol.setValue', err);
            };
        }
    };
    this.cambiarActivo = function (isActive) {
        try {
            this._estaActivo = isActive;
        } catch (err) {
            if (isDebugging) {
                showError('tableroFutbol.estaActivo', err);
            };
        }
    };
    this.tieneTiempo = function () {
        return this._tieneTiempo;
    };

    this.estaActivo = function () {
        return this._estaActivo;
    };

    this.actualizarResultado = function () {
        try {
            var local, visitante;
            if (this._value.encuentro.local.id != undefined && this._value.encuentro.visitante.id) {

                this.actualizarResultado90Minutos();
                if (this._value.encuentro.local.golesPenal != "" && this._value.encuentro.visitante.golesPenal != "" || this._value.encuentro.tiempo == "22") {
                    this.actualizarResultadoPenales();
                }
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroFutbol.actualizarResultado', err);
            };
        }
    };

    this.actualizarResultado90Minutos = function () {
        var local = $("#" + this.TAG_RESULTADOS + this._value.encuentro.local.id);
        var visitante = $("#" + this.TAG_RESULTADOS + this._value.encuentro.visitante.id);

        if (local.length && visitante.length) {
            if (this._value.encuentro.estado == "1") {
                local.html("-");
                visitante.html("-");
            } else {
                local.html(this._value.encuentro.local.goles);
                visitante.html(this._value.encuentro.visitante.goles);

                if (this._value.encuentro.local.goles == "" || this._value.encuentro.local.goles == "NaN") {
                    local.html("0");
                }

                if (this._value.encuentro.visitante.goles == "" || this._value.encuentro.visitante.goles == "NaN") {
                    visitante.html("0");
                }
            }
        }
    };

    this.actualizarResultadoPenales = function () {

        var golesPenalLocal = this._value.encuentro.local.golesPenal == undefined ? 0 : this._value.encuentro.local.golesPenal;
        var golesPenalVisitante = this._value.encuentro.visitante.golesPenal == undefined ? 0 : this._value.encuentro.visitante.golesPenal;
        if (golesPenalLocal > 0 || golesPenalVisitante > 0) {
            var local = $("#" + this.TAG_RESULTADOS_PENALES + this._value.encuentro.local.id);
            var visitante = $("#" + this.TAG_RESULTADOS_PENALES + this._value.encuentro.visitante.id);

            if (local.length && visitante.length) {
                //var classpadre = local.closest("ul").attr("class");
                //if (!classpadre.indexOf("penales") >= 0) {
                //    local.closest("ul").addClass("penales");
                //    visitante.closest("ul").addClass("penales");
                //}
            } else {
                $('div.equipo.local ul li').append('<span id="' + this.TAG_RESULTADOS_PENALES + this._value.encuentro.local.id + '">');
                $('div.equipo.visitante ul li').append('<span id="' + this.TAG_RESULTADOS_PENALES + this._value.encuentro.visitante.id + '">');
                local = $("#" + this.TAG_RESULTADOS_PENALES + this._value.encuentro.local.id);
                visitante = $("#" + this.TAG_RESULTADOS_PENALES + this._value.encuentro.visitante.id);
            }
            local.closest("ul").addClass("penales");
            visitante.closest("ul").addClass("penales");

            this.actualizarGolesPenal(local, golesPenalLocal);
            this.actualizarGolesPenal(visitante, golesPenalVisitante);
        }
    };

    this.actualizarGolesPenal = function (obj, goles) {
        $(obj).html(goles);
        //        if ($("#resultadoPenales", obj).length) {
        //            $(obj).removeClass("hidePenales");
        //            if ($("#e" + this._value.encuentro.id).length) {
        //                if (!($("#e" + this._value.encuentro.id).attr("class").indexOf("conPenales") > 0)) {
        //                    $("#e" + this._value.encuentro.id).addClass("conPenales");
        //                }
        //            }
        //            $("#resultadoPenales", obj).html(goles);
        //        }
    };

    this.actualizarEstado = function () {

        try {
            var estado;
            if (this._value.encuentro.estado != undefined) {
                estado = $("#" + this.TAG_ESTADO + this._value.cc.id);
                if (this._value.encuentro.estado != '2') {
                    estado.show();
                    $("#" + this.TAG_PERIODO + this._value.cc.id).hide();
                }
                if (estado.length) {
                    switch (this._value.encuentro.estado) {
                        case "1":
                            estado.html(this.ESTADO_SIN_COMIENZO);
                            break;
                        case "2":
                            estado.html(this.ESTADO_EN_JUEGO);
                            break;
                        case "3":
                            estado.html(this.ESTADO_FINALIZADO);
                            this._estaActivo = false;
                            break;
                        case "4":
                            estado.html(this.ESTADO_SUSPENDIDO);
                            break;
                        case "5":
                            estado.html(this.ESTADO_ENTRETIEMPO);
                            break;
                    }
                }
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroFutbol.actualizarEstado', err);
            };
        }
    };
    this.actualizarPeriodo = function () {
        try {
            if (this._value.encuentro.tiempo != undefined) {
                var oPeriodo = $("#" + this.TAG_PERIODO + this._value.cc.id);
                if (oPeriodo.length) {
                    if (this._value.encuentro.estado == "2") {
                        oPeriodo.html("");
                        oPeriodo.show();
                        switch (this._value.encuentro.tiempo) {
                            case "1":
                                oPeriodo.html(this.PRIMER_TIEMPO);
                                break;
                            case "2":
                                oPeriodo.html(this.SEGUNDO_TIEMPO);
                                break;
                            case "3":
                                oPeriodo.html(this.ESTADO_ENTRETIEMPO);
                                break;
                            case "21":
                                oPeriodo.html(this.PRIMER_TIEMPO_SUPLEMENTARIO);
                                break;
                            case "23":
                                oPeriodo.html(this.SEGUNDO_TIEMPO_SUPLEMENTARIO);
                                break;
                            case "22":
                                oPeriodo.html(this.PENALES);
                                break;
                        }
                        $("#" + this.TAG_ESTADO + this._value.cc.id).hide();
                    } else {
                        switch (this._value.encuentro.estado) {
                            case "1":
                                //oPeriodo.html(this.ESTADO_SIN_COMIENZO);
                                break;
                            case "3":
                                var oTiempo = $("#" + this.TAG_TIEMPO + this._value.cc.id);
                                var oTiempoMin = $("#" + this.TAG_TIEMPO_MINUTOS + this._value.cc.id);

                                if (oPeriodo.length) {
                                    oPeriodo.html('&nbsp;');
                                }
                                if (oTiempoMin.length) {
                                    oTiempoMin.html('&nbsp;');
                                }
                                //                                oPeriodo.html("");
                                this._estaActivo = false;
                                break;
                            case "4":
                                oPeriodo.html(this.ESTADO_SUSPENDIDO);
                                break;
                            case "5":
                                //oPeriodo.html(this.ESTADO_ENTRETIEMPO);
                                break;
                        }
                    }
                }
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroFutbol.actualizarPeriodo', err);
            };
        }
    };

    this.actualizarIncidencia = function () {
        try {

            if (this._value.ins[0].inc.id != undefined) {
                var oIncidencia = $("#" + this.TAG_INCIDENCIA + this._value.cc.id);
                if (oIncidencia.length) {
                    var clase = "";
                    switch (this._value.ins[0].inc.tp.toLowerCase()) {
                        case "amarilla":
                            clase = "amarilla";
                            break;
                        case "roja":
                            clase = "roja";
                            break;
                        case "gol":
                            clase = "gol";
                            break;
                        case "cambio":
                            clase = "cambio";
                            break;
                        case "lesion":
                            clase = "lesion";
                        default:
                            clase = "fallo";
                            break;
                    }
                    oTextoIncidencia = $("#textoIncidencia", oIncidencia);
                    oTextoIncidencia.html(this._value.ins[0].inc.cm);
                    oIncidencia.addClass(clase).slideDown('slow').delay(7000).hide('fast', function () {
                        $(this).removeClass(clase);
                    });
                }
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroFutbol.actualizarIncidencia', err);
            };
        }
    };

    this.isTypeOf = function (value) {
        var _isTypeOf = false;
        if (value == "tableroFutbol") _isTypeOf = !_isTypeOf;
        return _isTypeOf;
    };
    this.PRIMER_TIEMPO = "1er tiempo";
    this.SEGUNDO_TIEMPO = "2do tiempo";
    this.PRIMER_TIEMPO_SUPLEMENTARIO = "1er Supl.";
    this.SEGUNDO_TIEMPO_SUPLEMENTARIO = "2do Supl.";
    this.PENALES = "Penales";
    this.ESTADO_SIN_COMIENZO = "Sin comienzo";
    this.ESTADO_EN_JUEGO = "En juego";
    this.ESTADO_FINALIZADO = "Finalizado";
    this.ESTADO_SUSPENDIDO = "Suspendido";
    this.ESTADO_ENTRETIEMPO = "Entretiempo";

    this.calcularDelta = function () {
        var horaPC = new Date();
        var toReturn = 0;

        //if (fechaServidor != null) {
        //    toReturn = (horaPC - fechaServidor) / 1000;
        //}
        return toReturn;
    };

    this.tiempoTranscurrido = function (horaInicio) {
        var elReloj = new Date();
        var deltaTiempo = this.calcularDelta();
        if (horaInicio != null) {
            // Armo el dia con la horacomienzo
            var relojComienzo = new Date(elReloj.getFullYear(), elReloj.getMonth(), elReloj.getDate(), Number(horaInicio.substr(0, 2)), Number(horaInicio.substr(3, 2)), 0);
            if (elReloj > relojComienzo) {
                var miliSegundos = elReloj - deltaTiempo - relojComienzo;
                var Hora = Math.floor(miliSegundos / 3600000); // Horas
                var Minuto = Math.floor(miliSegundos / 60000) - Hora * 60; // Minutos
                var Segundo = Math.floor(miliSegundos / 1000) - Minuto * 60 - Hora * 3600; // Segundos

                if (Hora != 0 && Hora > 0) Hora += ":";else Hora = "";

                if (typeof Segundo == "undefined") Segundo = SegundoAnt;else var SegundoAnt = Segundo;

                if (typeof Minuto == "undefined") Minuto = MinutoAnt;else var MinutoAnt = Minuto;

                if (Minuto < 10) Minuto = "0" + Minuto.toString();

                if (Segundo < 10) Segundo = "0" + Segundo.toString();
                return Minuto + ":" + Segundo;
            } else {
                return "";
            }
        } else {
            return "";
        }
    };
    this.actualizarReloj = function () {
        this.renderReloj();
    };

    this.renderReloj = function () {
        var oTiempo, oTiempo_min;
        try {

            oTiempo = $("#" + this.TAG_TIEMPO + this._value.cc.id);
            oTiempo_min = $("#" + this.TAG_TIEMPO_MINUTOS + this._value.cc.id);
            //oTiempo_nom = $("#" + this.TAG_TIEMPO + "nom" + this._value.cc.id);
            if (oTiempo.length) {
                if (this._value.encuentro.estado == "2" && this._value.encuentro.tiempo != "5") {
                    oTiempo.css("display", "inline");
                    oTiempo_min.css("display", "inline");
                    oTiempo_min.html(this.tiempoTranscurrido(this._value.encuentro.inicio_tiempo));
                } else {
                    if (this._value.encuentro.estado != "2") {
                        if (oTiempo_min.length) {
                            oTiempo_min.html(" ");
                        }
                        if (oTiempo_nom.length) {
                            oTiempo_nom.html(" ");
                        }
                    }
                    this._tieneTiempo = false;
                }
            } else {
                this._tieneTiempo = false;
            }
            //oTiempo = null;
        } catch (err) {
            if (isDebugging) {
                showError('tableroFutbol.renderReloj', err);
            };
            this._tieneTiempo = false;
        }
    };

    this.actualizarExtras = function () {
        var marquesina;
        try {
            if (this._value.tablero.mq.texto != undefined && this._value.tablero.mq.texto != '' && this._value.tablero.mq.texto != null) {
                $("#marquesina" + this._value.cc.id).html("");
                $("#marquesina" + this._value.cc.id).append(this._value.tablero.mq.texto);
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroFutbol.actualizarEstado', err);
            };
        }
    };

    // implementa diferente para cada tipo de tablero: tennis, futbol
    this.execute = function () {
        try {
            if (this._cambioEncuentro) {
                this.actualizarEstado();
                this.actualizarPeriodo();
                this.actualizarResultado();
                this.actualizarReloj();
                this.actualizarExtras();
            }
            this.actualizarIncidencia();
        } catch (err) {
            if (isDebugging) {
                showError('tableroFutbol.execute', err);
            };
        }
    };
};

var agregarTableroFutbol = exports.agregarTableroFutbol = function agregarTableroFutbol(idPartido, codigoSolicitud) {
    //if (tableros != null) {
    var objTablero = new tableroFutbol({ cc: { id: idPartido, valor: codigoSolicitud } });
    //}
    return objTablero;
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* objeto Tablero Tenis */
var tableroTenis = function tableroTenis(value, isActive) {
    var isDebugging = false;
    this._value = value;
    this._estaActivo = isActive || true;
    this._cambioEncuentro = false;
    this._cambioIncidencias = false;
    this._cambioExtras = false;
    this._cambioFormaciones = false;
    this._cantidadSet = 0;
    this._tieneTiempo = true;
    this.URL_bandera = "http://canchallena.lanacion.com.ar/_ui/desktop/imgs/layout/iconos/banderas";

    /* TAG A ACTUALIZAR */
    if (this._value.cc.hasOwnProperty('tipoTablero')) {
        this.tipoTablero = this._value.cc.tipoTablero;
    } else {
        this.tipoTablero = "";
    }
    this.TAG_RESULTADOS = this.tipoTablero + "resultado";
    this.TAG_INCIDENCIA = this.tipoTablero + "i";
    this.TAG_ESTADO = this.tipoTablero + "st";
    this.TAG_PERIODO = this.tipoTablero + "p";
    this.TAG_TIEMPO = this.tipoTablero + "t";
    this.TAG_GAMECAST = this.tipoTablero + "gamec";
    this.TAG_SAQUE = this.tipoTablero + "saque";
    this.TAG_EQUIPO = this.tipoTablero + "eq";
    this.TAG_BANDERA = this.tipoTablero + "img";
    this.TAG_PUNTOS = "puntos";

    /* ******************** */

    this.setValue = function (valorActualizado) {
        try {
            if (valorActualizado.hasOwnProperty('cc')) {
                this._value.cc = valorActualizado.cc;
            };
            if (valorActualizado.hasOwnProperty('encuentro')) {
                this._value.encuentro = valorActualizado.encuentro;this._cambioEncuentro = true;
            } else {
                this._cambioEncuentro = false;
            };
            if (valorActualizado.hasOwnProperty('ins')) {
                this._value.ins = valorActualizado.ins;this._cambioIncidencias = true;
            } else {
                this._cambioIncidencias = false;
            };
            if (valorActualizado.hasOwnProperty('fors')) {
                this._value.fors = valorActualizado.fors;this._cambioFormaciones = true;
            } else {
                this._cambioFormaciones = false;
            };
            if (valorActualizado.hasOwnProperty('extras')) {
                this._value.extras = valorActualizado.extras;this._cambioExtras = true;
            } else {
                this._cambioExtras = false;
            };
        } catch (err) {
            if (isDebugging) {
                showError('tableroTenis.setValue', err);
            };
        }
    };
    this.cambiarActivo = function (isActive) {
        try {
            this._estaActivo = isActive;
        } catch (err) {
            if (isDebugging) {
                showError('tableroTenis.estaActivo', err);
            };
        }
    };
    this.tieneTiempo = function () {
        return this._tieneTiempo;
    };
    this.estaActivo = function () {
        return this._estaActivo;
    };

    this.actualizarIncidencias = function () {
        try {
            var oIncidencia = jQuery("#" + this.TAG_INCIDENCIA + this._value.cc.id)[0];
            if (oIncidencia != undefined && this._value.ins[0].inc.cm != undefined) {
                for (var i = 0; i < this._value.ins.length; i++) {
                    oIncidencia.innerHTML = this._value.ins[0].inc.mm + "' " + this._value.ins[0].inc.cm;
                }
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroTenis.actualizarIncidencias', err);
            };
        }
    };
    this.actualizarGamecast = function () {
        try {
            var oGamecast = jQuery("#" + this.TAG_GAMECAST + this._value.cc.id)[0];
            if (oGamecast != undefined && this._value.encuentro.linkeable != undefined) {
                if (this._value.encuentro.linkeable == "1") {
                    oGamecast.style.display = "block";
                } else {
                    oGamecast.style.display = "none";
                }
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroFutbol.actualizarGamecast', err);
            };
        }
    };

    this.actualizarBanderas = function () {
        try {
            local = $("#" + this.TAG_BANDERA + this._value.encuentro.local.id);
            visitante = $("#" + this.TAG_BANDERA + this._value.encuentro.visitante.id);
            if (local != undefined) {
                if (this._value.encuentro.local.pais != "") {
                    local.attr("src", this.URL_bandera + "/18x14/paises/" + this._value.encuentro.local.pais + ".gif");
                }
            }
            if (visitante != undefined) {
                if (this._value.encuentro.visitante.pais != "") {
                    visitante.attr("src", this.URL_bandera + "/18x14/paises/" + this._value.encuentro.visitante.pais + ".gif");
                }
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroFutbol.actualizarResultado', err);
            };
        }
    };

    this.actualizarSets = function () {
        try {
            for (var i = 0; i < this._value.encuentro.local.tantos.length; i++) {
                if (this._value.encuentro.local.tantos[i].id == "5") this._cantidadSet += 1;
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroTenis.actualizarSets', err);
            };
        }
    };

    this.actualizarResultado = function () {
        try {
            //this.actualizarBanderas();
            var local, visitante;
            if (this._value.encuentro.local.id != undefined && this._value.encuentro.visitante.id) {
                //SET TOTALES
                local = $("#" + this.TAG_RESULTADOS + this._value.encuentro.local.id + "_0");
                visitante = $("#" + this.TAG_RESULTADOS + this._value.encuentro.visitante.id + "_0");

                if (local != undefined && visitante != undefined) {
                    local.html(this._value.encuentro.local.sets);
                    visitante.html(this._value.encuentro.visitante.sets);
                }
                for (var i = 0; i < this._value.encuentro.local.tantos.length; i++) {
                    switch (this._value.encuentro.local.tantos[i].id) {
                        case "5":
                            // RESALTA GANADOR SETS
                            local = $("#" + this.TAG_RESULTADOS + this._value.encuentro.local.id + "_" + this._value.encuentro.local.tantos[i].orden);
                            visitante = $("#" + this.TAG_RESULTADOS + this._value.encuentro.visitante.id + "_" + this._value.encuentro.local.tantos[i].orden);
                            if (this._value.encuentro.local.tantos[i].valor >= 6 || this._value.encuentro.visitante.tantos[i].valor >= 6) {
                                if (this._value.encuentro.local.tantos[i].valor > this._value.encuentro.visitante.tantos[i].valor) {
                                    local.addClass("won");
                                    visitante.removeClass("won");
                                }
                                if (this._value.encuentro.local.tantos[i].valor < this._value.encuentro.visitante.tantos[i].valor) {
                                    local.removeClass("won");
                                    visitante.addClass("won");
                                }
                            }
                            //SETS
                            local = $("#" + this.TAG_RESULTADOS + this._value.encuentro.local.id + "_" + this._value.encuentro.local.tantos[i].orden);
                            if (local.length) {
                                local.html(this._value.encuentro.local.tantos[i].valor);
                            }
                            break;
                        case "6":
                            //Break  
                            local = $("#" + this.TAG_RESULTADOS + this._value.encuentro.local.id + "_" + this._value.encuentro.local.tantos[i].orden);
                            if (local.length) {
                                local.append("<span>" + this._value.encuentro.local.tantos[i].valor + "</span>");
                            }
                            break;
                        default:
                            break;
                    }
                }

                for (var i = 0; i < this._value.encuentro.visitante.tantos.length; i++) {
                    switch (this._value.encuentro.visitante.tantos[i].id) {
                        case "5":
                            //SETS               
                            visitante = $("#" + this.TAG_RESULTADOS + this._value.encuentro.visitante.id + "_" + this._value.encuentro.visitante.tantos[i].orden);
                            if (visitante.length) {
                                visitante.html(this._value.encuentro.visitante.tantos[i].valor);
                            }
                            break;
                        case "6":
                            //Break
                            visitante = $("#" + this.TAG_RESULTADOS + this._value.encuentro.visitante.id + "_" + this._value.encuentro.visitante.tantos[i].orden);
                            if (visitante.length) {
                                visitante.append("<span>" + this._value.encuentro.visitante.tantos[i].valor + "</span>");
                            }
                            break;
                        default:
                            break;
                    }
                }

                if (this._value.encuentro.estado == "3") {
                    this._estaActivo = false;
                } else {
                    this.actualizarPuntos(this._value.encuentro.local, this._value.encuentro);
                    this.actualizarPuntos(this._value.encuentro.visitante, this._value.encuentro);
                }
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroTenis.actualizarResultado', err);
            };
        }
    };

    this.actualizarPuntos = function (jugador, encuentro) {
        //objJugador = $("#" + this.TAG_RESULTADOS + jugador.id + "_" + this.TAG_PUNTOS);
        //objSaque = $(".tablero.tenis" + this.TAG_SAQUE + jugador.id);
        var objSaque = $('.tablero.tenis[data-id="' + encuentro.id + '"] [data-equipoId="' + jugador.id + '"]');
        if (encuentro.estado === "2") {
            if (jugador.saque === '1' || jugador.saque === 'S') {
                objSaque.addClass('saque');
            } else {
                objSaque.removeClass('saque');
            }
        } else {
            //  objJugador.html(jugador.sets);
        }
    };

    this.actualizarEstado = function () {
        try {
            var estado;
            if (this._value.encuentro.estado != undefined) {
                estado = $("." + this.TAG_ESTADO + this._value.cc.id);
                if (estado.length) {
                    switch (this._value.encuentro.estado) {
                        case "1":
                            estado.html(this.ESTADO_SIN_COMIENZO);
                            break;
                        case "2":
                            estado.html(this.ESTADO_EN_JUEGO);
                            break;
                        case "3":
                            estado.html(this.ESTADO_FINALIZADO);
                            break;
                        case "4":
                            estado.html(this.ESTADO_SUSPENDIDO);
                            break;
                        case "5":
                            estado.html(this.ESTADO_ENTRETIEMPO);
                            break;
                    }
                }
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroTenis.actualizarPeriodo', err);
            };
        }
    };
    this.actualizarPeriodo = function () {
        try {
            if (this._value.encuentro.tiempo != undefined) {
                var oPeriodo = $("#" + this.TAG_PERIODO + this._value.cc.id);
                if (oPeriodo.length) {
                    if (this._value.encuentro.estado == "2") {
                        if (oPeriodo != undefined) {
                            oPeriodo.html("");
                            switch (this._value.encuentro.tiempo) {
                                case "1":
                                    oPeriodo.html(this.PRIMER_TIEMPO);
                                    break;
                                case "2":
                                    oPeriodo.html(this.SEGUNDO_TIEMPO);
                                    break;
                                case "3":
                                    oPeriodo.html(this.PRIMER_TIEMPO_SUPLEMENTARIO);
                                    break;
                                case "4":
                                    oPeriodo.html(this.SEGUNDO_TIEMPO_SUPLEMENTARIO);
                                    break;
                                case "5":
                                    oPeriodo.html(this.PENALES);
                                    break;
                            }
                        }
                    } else {
                        oPeriodo.html("");
                    }
                }
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroTenis.actualizarEstado', err);
            };
        }
    };
    this.isTypeOf = function (value) {
        var _isTypeOf = false;
        if (value == "tableroTenis") _isTypeOf = !_isTypeOf;
        return _isTypeOf;
    };
    this.PRIMER_TIEMPO = "1er tiempo";
    this.SEGUNDO_TIEMPO = "2do tiempo";
    this.PRIMER_TIEMPO_SUPLEMENTARIO = "1er Supl.";
    this.SEGUNDO_TIEMPO_SUPLEMENTARIO = "2do Supl.";
    this.PENALES = "Penales";
    this.ESTADO_SIN_COMIENZO = "Sin comienzo";
    this.ESTADO_EN_JUEGO = "En juego";
    this.ESTADO_FINALIZADO = "Finalizado";
    this.ESTADO_SUSPENDIDO = "Suspendido";
    this.ESTADO_ENTRETIEMPO = "Entretiempo";

    this.calcularDelta = function () {
        var horaPC = new Date();
        var toReturn = 0;

        if (fechaServidor != null) {
            toReturn = (horaPC - fechaServidor) / 1000;
        }
        return toReturn;
    };

    this.tiempoTranscurrido = function (horaInicio) {
        var elReloj = new Date();
        var deltaTiempo = this.calcularDelta();

        if (horaInicio != null) {
            // Armo el dia con la horacomienzo	
            var relojComienzo = new Date(elReloj.getFullYear(), elReloj.getMonth(), elReloj.getDate(), Number(horaInicio.substr(0, 2)), Number(horaInicio.substr(3, 2)), 0);
            if (elReloj > relojComienzo) {
                var miliSegundos = elReloj - deltaTiempo - relojComienzo;
                var Hora = Math.floor(miliSegundos / 3600000); // Horas
                var Minuto = Math.floor(miliSegundos / 60000) - Hora * 60; // Minutos
                var Segundo = Math.floor(miliSegundos / 1000) - Minuto * 60 - Hora * 3600; // Segundos

                if (Hora != 0 && Hora > 0) Hora += ":";else Hora = "";

                if (typeof Segundo == "undefined") Segundo = SegundoAnt;else var SegundoAnt = Segundo;

                if (typeof Minuto == "undefined") Minuto = MinutoAnt;else var MinutoAnt = Minuto;

                if (Minuto < 10) Minuto = "0" + Minuto.toString();

                if (Segundo < 10) Segundo = "0" + Segundo.toString();

                return Minuto + ":" + Segundo;
            } else {
                return "";
            }
        } else {
            return "";
        }
    };
    this.actualizarReloj = function () {
        this.renderReloj();
    };

    this.renderReloj = function () {
        var oTiempo;
        try {
            oTiempo = $("#" + this.TAG_TIEMPO + this._value.cc.id);

            if (oTiempo.length) {
                if (this._value.encuentro.estado == "2") {
                    oTiempo.css("display", "inline");
                    oTiempo.html(this.tiempoTranscurrido(this._value.encuentro.inicio_tiempo));
                } else {
                    oTiempo.html("");
                }
            }
            oTiempo = null;
        } catch (err) {
            if (isDebugging) {
                showError('tableroTenis.renderReloj', err);
            };
            this._tieneTiempo = false;
        }
    };

    // implementa diferente para cada tipo de tablero: tennis, futbol
    this.execute = function () {
        try {
            if (this._cambioEncuentro) {
                if (this._cantidadSet == 0) this.actualizarSets();
                this.actualizarEstado();
                this.actualizarPeriodo();
                this.actualizarResultado();
                this.actualizarGamecast();
            }
            if (this._cambioIncidencias) {
                this.actualizarIncidencias();
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroTenis.execute', err);
            };
        }
    };
};

var agregarTableroTenis = exports.agregarTableroTenis = function agregarTableroTenis(idPartido, codigoSolicitud) {
    //if (tableros != null) {
    var objTablero = new tableroTenis({ cc: { id: idPartido, valor: codigoSolicitud } });
    //}
    return objTablero;
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getNewsletter = exports.getSugerenciasPie = undefined;

var _ajax = __webpack_require__(1);

var Ajax = _interopRequireWildcard(_ajax);

var _bucket = __webpack_require__(2);

var BucketTools = _interopRequireWildcard(_bucket);

var _utilities = __webpack_require__(4);

var Utilities = _interopRequireWildcard(_utilities);

var _nota = __webpack_require__(8);

var _cookie = __webpack_require__(0);

var Cookie = _interopRequireWildcard(_cookie);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var sitioId = window.config.Sitio.Id;
var urlApiRoot = window.config.Statics.ApiContenidoUrlRoot;
var urlApiCategorias = window.config.Statics.ApiContenidoUrlRoot + window.config.Statics.ApiCategoriasUrl;
var urlApiLogin = window.config.Statics.APILoginUrl;
var bucket = window.config.Statics.BucketUrl;
var urlApiNewsletter = urlApiLogin + window.config.Statics.ApiNewsletterSugerenciaUrl;
var urlApiSuscribirse = urlApiLogin + window.config.Statics.ApiUrlSuscribirse;

var renderNotasPieCategoria = function renderNotasPieCategoria(data, categoriaRandom) {
    var container = document.getElementById("bloque-4");
    if (!container || data == null) return;
    var heightBucket = void 0;
    var widthBucket = void 0;
    var conAutor = void 0;
    var categoria = void 0;
    var listado = void 0;
    for (var j = 0; j < categoriaRandom.length; j++) {
        if (data[categoriaRandom[j]].items.length > 0) {
            categoria = data[categoriaRandom[j]].items[0].categoriaDescripcion;
            listado = "<div>";
            var notas = data[categoriaRandom[j]].items.slice(0, 5);
            listado += "<h3>" + categoria + "</h3>";
            for (var i = 0; i < notas.length; i++) {
                var nota = notas[i];
                var conImagen = nota.imagenes.length > 0 && nota.imagenes[0].src !== "";
                i === 0 ? heightBucket = 183 : heightBucket = 80;
                i === 0 ? widthBucket = 282 : widthBucket = 107;
                nota.autores.length > 0 && nota.autores[0].hdImagenId !== null && nota.autores[0].valor !== "" ? conAutor = "autor" : conAutor = "";
                listado += "<article class=\"nota " + conAutor + " floatFix\">";

                if (i === 0) {
                    listado += "<a class=\"figure\" href=\"" + nota.url + "\" \"data-numero=\"" + i + "\" data-tipo=\"normal-primera\">";
                    listado += conImagen ? "<img src=\"" + BucketTools.urlBucketBalance(bucket, nota.imagenes[0].src, heightBucket) + "\"/>" : "";
                    listado += "</a>";
                } else {
                    if (conAutor === "") {
                        //conImagen && Si se lo saco qu eonda?
                        listado += "<a class=\"figure\"  href=\"" + nota.url + "\" data-numero=\"" + i + "\" data-tipo=\"normal\">";
                        listado += conImagen ? "<img src=\"" + BucketTools.urlBucketBalance(bucket, nota.imagenes[0].src, heightBucket) + "\"/>" : "";
                        listado += "</a>";
                    } else if (conAutor !== "") {
                        // && nota.autores[0].hdImagenId !== 0 - Si se lo saco qu eonda?
                        listado += "<a class=\"figure\"  href=\"" + nota.url + "\" data-numero=\"" + i + "\" data-tipo=\"autor\">";
                        listado += nota.autores[0].hdImagenId !== 0 ? "<img src=\"" + BucketTools.urlBucketBalance(bucket, nota.autores[0].hdImagenId, heightBucket, "", nota.autores[0].hdImagenExtension) + "\"/>" : "";
                        listado += "</a>";
                    }
                }

                listado += "<h2><a href=\"" + nota.url + "\">" + nota.titulo + "</a></h2>";
                if (conAutor !== "") {
                    listado += "<a href=\"" + Utilities.formatoUrlAcuAutor(nota.autores[0].valor, nota.autores[0].id) + "\" class=\"autor\">" + nota.autores[0].valor + "</a>";
                }
                listado += "</article>";
            }
            listado += "</div>";
            container.insertAdjacentHTML("afterbegin", listado);
        }
    }
};

var renderSugerenciaNewsletter = function renderSugerenciaNewsletter(data) {
    var suscripcionPendiente = localStorage.getItem("suscripcionPendiente");
    var fechaSuscripcionPendiente = localStorage.getItem("fechaSuscripcionPendiente");
    var token = Cookie.LeerCookie("token");
    var tiempoCacheMilisegundos = 300000; ///TODO:Cambiar a configuracion
    var dif = tiempoCacheMilisegundos;

    if (fechaSuscripcionPendiente !== null) {
        dif = Date.now() - fechaSuscripcionPendiente;
    }

    if (token !== "" && suscripcionPendiente !== null && dif < tiempoCacheMilisegundos) {
        var objPendiente = data.filter(function (p) {
            return p.servicioId === parseInt(suscripcionPendiente);
        });
        if (objPendiente.length > 0) {
            var tituloPendiente = objPendiente[0].titulo;
            renderCajaSuscribir(tituloPendiente);
        }

        suscribirNewsletterAjax(data, token, suscripcionPendiente);
        localStorage.removeItem("suscripcionPendiente");
        localStorage.removeItem("fechaSuscripcionPendiente");
    } else if (data.length > 0) {
        if (suscripcionPendiente !== null) {
            localStorage.removeItem("suscripcionPendiente");
            localStorage.removeItem("fechaSuscripcionPendiente");
        }

        var sinSuscripcion = data.filter(function (d) {
            return d.suscripto === 0;
        });
        if (sinSuscripcion.length === 0) {
            return;
        }

        var sugerenciasSuscripcion = [];
        for (var i = 0; sinSuscripcion.length > i; i++) {
            sugerenciasSuscripcion.push(sinSuscripcion[i].servicioId);
        }

        var newsRandom = Utilities.getRandom(sugerenciasSuscripcion, 1);

        var objSugerencia = newsRandom.length > 0 ? data.filter(function (x) {
            return x.servicioId === newsRandom[0];
        }) : [];

        if (objSugerencia.length > 0) {
            var tituloSugerencia = objSugerencia[0].titulo;
            renderCajaSuscribir(tituloSugerencia);
        }

        var btn = document.getElementById("suscribirse");
        if (btn == null) return;
        if (token !== "") {
            btn.addEventListener("click", function () {
                suscribirNewsletterAjax(data, token, newsRandom);
            });
        } else {
            btn.addEventListener("click", function () {
                loguearYSuscribir(newsRandom);
            });
        }
    }
};

var renderCajaSuscribir = function renderCajaSuscribir(tituloADibujar) {
    var boton = document.createElement("BUTTON");
    var textoBoton = document.createTextNode("SUSCRIBIRME");
    boton.setAttribute("id", "suscribirse");
    boton.appendChild(textoBoton);

    var containerFinCuerpo = document.getElementsByClassName("fin-cuerpo")[0];
    var containerSegunda = document.getElementsByClassName("segunda floatFix")[0];

    var container = containerFinCuerpo !== undefined ? containerFinCuerpo : containerSegunda !== undefined ? containerSegunda : false;

    if (!container) return;
    var recomendacion = "<div class='titulares-del-dia'>";
    recomendacion += "<span class='icon-mail-line'></span>";
    recomendacion += "<div><b>" + tituloADibujar + "</b>";
    recomendacion += "<p id='textSuscripcion'>Suscribite al newsletter</p>";
    recomendacion += "</div>";
    recomendacion += boton.outerHTML;
    recomendacion += "</div>";
    container.insertAdjacentHTML("beforeend", recomendacion);
};
var saveNewsletterLocalStorage = function saveNewsletterLocalStorage(data) {
    localStorage.setItem("fechaSugerenciaTitulares", Date.now().toString());
    localStorage.setItem("sugerenciasTitulares", JSON.stringify(data));
    renderSugerenciaNewsletter(data);
};
var saveNewsletterLocalStorageDefault = function saveNewsletterLocalStorageDefault(data) {
    localStorage.setItem("sugerenciasTitularesDefault", JSON.stringify(data));
    renderSugerenciaNewsletter(data);
};

var getSugerenciasPie = exports.getSugerenciasPie = function getSugerenciasPie() {
    var data = _nota.sugerenciasPie;
    var categoriaRandom = Utilities.getRandom(data[0].categoriasPosibles, data[0].cantidad);
    var categoriaString = categoriaRandom.join() + "?c=5";

    Ajax.get(urlApiCategorias + categoriaString).then(function (rs) {
        return renderNotasPieCategoria(JSON.parse(rs), categoriaRandom);
    });
};

var getNewsletter = exports.getNewsletter = function getNewsletter() {
    var fechaSugerencia = localStorage.getItem("fechaSugerenciaTitulares"),
        sugerenciasData = JSON.parse(localStorage.getItem("sugerenciasTitulares")),
        tokenStorage = localStorage.getItem("token"),
        sugerenciaDataDefault = JSON.parse(localStorage.getItem("sugerenciasTitularesDefault"));
    var tiempoCacheMilisegundos = 300000; ///TODO:Cambiar a configuracion
    var dif = 0;

    if (tokenStorage != null) {
        //se fija que el localstorage tenga datos y el token coincida con el guardado
        if (fechaSugerencia != null && sugerenciasData != null) {
            dif = Date.now() - fechaSugerencia;
            //se fija que no haya vencido el cache
            if (dif < tiempoCacheMilisegundos) {
                renderSugerenciaNewsletter(sugerenciasData);
            } else {
                //vencio el cache entonces va a buscar de nuevo la data actualiza el localstorage y renderea
                obtenerSuscripciones(tokenStorage);
            }
        } else {
            obtenerSuscripciones(tokenStorage);
        }
    } else {
        //Si no esta logueado, se fija que tenga informacion en el LocalStorage
        if (sugerenciaDataDefault != null) {
            // dibuja con la data ya existente
            renderSugerenciaNewsletter(sugerenciaDataDefault);
        } else {
            obtenerSuscripciones("default");
        }
    }
};

var obtenerSuscripciones = function obtenerSuscripciones(tipo) {
    if (tipo === "default") {
        Ajax.post(urlApiNewsletter).then(function (rs) {
            return JSON.parse(rs);
        }).then(saveNewsletterLocalStorageDefault);
    } else {
        var objHeaders = {
            "X-Token": tipo
        };
        Ajax.post(urlApiNewsletter + "PorUsuario", "", objHeaders).then(function (rs) {
            return JSON.parse(rs);
        }).then(saveNewsletterLocalStorage);
    }
};

var suscribirNewsletterAjax = function suscribirNewsletterAjax(data, token, suscribirse) {
    var serviciosYaSuscripto = data.filter(function (s) {
        return s.suscripto === 1;
    });
    var urlSuscribirse = urlApiSuscribirse;
    var stringIds = "";
    if (serviciosYaSuscripto.length > 0) {
        for (var k = 0; serviciosYaSuscripto.length > k; k++) {
            stringIds += serviciosYaSuscripto[k].servicioId + ",";
        }
    }
    stringIds += suscribirse;
    var objParam = {
        "servicios_ids": stringIds,
        "acepta_novedades": null
    };
    var objHeaders = {
        "Content-Type": "application/json",
        "X-Token": token
    };

    suscribirNewsletterLogueado(urlSuscribirse, objParam, objHeaders);
};

var suscribirNewsletterLogueado = function suscribirNewsletterLogueado(url, objParam, objHeaders) {
    document.getElementById("suscribirse").style.display = "none";
    Ajax.post(urlApiSuscribirse, objParam, objHeaders).then(suscripcionCorrecta).catch(suscripcionError);
    localStorage.removeItem("sugerenciasTitulares");
};

var loguearYSuscribir = function loguearYSuscribir(newsRandom) {
    document.getElementById("suscribirse").style.display = "none";
    localStorage.setItem("tareaPendiente", newsRandom);
    localStorage.setItem("fechaPendiente", Date.now().toString());
    localStorage.removeItem("sugerenciasTitulares");
    location.href = window.config.Statics.LoginUrl + window.btoa(location.href);
};

var suscripcionCorrecta = function suscripcionCorrecta(mensaje) {
    document.getElementById("textSuscripcion").innerText = "¡Ya estás suscripto!";
    localStorage.removeItem("tareaPendiente");
    localStorage.removeItem("fechaPendiente");
};

var suscripcionError = function suscripcionError() {
    document.getElementById("textSuscripcion").innerText = "¡Ups volvé a intentarlo!";
    document.getElementById("suscribirse").style.display = "block";
};

/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.popUpCompartirNotaFB = popUpCompartirNotaFB;
exports.popUpCompartirNotaTW = popUpCompartirNotaTW;
exports.popUpCompartirNotaGoogle = popUpCompartirNotaGoogle;
exports.popUpCompartirMailTo = popUpCompartirMailTo;
exports.popUpCompartirNotaRss = popUpCompartirNotaRss;
window.fbAsyncInit = function () {
    FB.init({
        appId: window.config.Statics.FacebookId,
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v2.9'
    });
    FB.AppEvents.logPageView();
};

(function (d, s, id) {
    var js = void 0,
        fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
        return;
    }
    js = d.createElement(s);js.id = id;
    js.src = "//connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
})(document, 'script', 'facebook-jssdk');

//COMPARTIR EN NOTA ----------------------------------------------------------------------
function popUpCompartirNotaFB(notaId, dominio, titulo) {
    if (notaId.length > 0) {
        debugger;
        popUpRedSocial('//www.facebook.com/sharer.php?m2w&s=100&p[url]=' + dominio + notaId);
    } else {
        window.open("https://www.facebook.com/lanacion", "_blank");
    }
}

function popUpCompartirNotaTW(notaId, dominio, titulo) {
    if (notaId.length > 0) {
        popUpRedSocial("//twitter.com/share?text=" + titulo + "&url=" + dominio + notaId + "&via=LANACION"); //$("#hs-twitter").val());
    } else {
        window.open("//twitter.lanacion.com.ar/", "_blank");
    }
};

function popUpCompartirNotaGoogle(notaId, dominio, titulo) {
    if (notaId.length > 0) {
        popUpRedSocial("//plus.google.com/share?url=" + dominio + notaId); //$("#hs-twitter").val());
    } else {
        window.open("https://plus.google.com/+lanacion", "_blank");
    }
};

function popUpCompartirMailTo(notaId, dominio) {
    if (notaId.length > 0) {
        popUpRedSocial(dominio + "herramientas/nota/enviar-por-mail.html?nota_id" + notaId);
    }
};

function popUpCompartirNotaRss() {
    window.open("http://servicios.lanacion.com.ar/herramientas/rss/ayuda", '_blank');
};

function popUpRedSocial(url) {
    open(url, "", "top=300,left=550,width=800,height=380");
};

var shareWhastApp = exports.shareWhastApp = function shareWhastApp() {
    try {
        $(".share-whatsapp").each(function (i, nodo) {
            var notaId = $(nodo).attr("data-notaId"),
                texto = $(nodo).attr("data-text") + ": " + $(nodo).attr("data-titulo");

            $(nodo).click(function () {
                var whatsappUrl = 'whatsapp://send?text=' + texto + ' - ' + window.config.Statics.DominioUrl + notaId;
                window.location.href = whatsappUrl;
            });
        });

        /***** Whatsapp  *****/
        if (/Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            $(".wapp").css("display", "inline-block");
            $("body").addClass("touch");
        }
    } catch (e) {
        console.warn && console.warn("Initialize: ", e);
    }
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*! pym.js - v1.3.1 - 2017-07-25 */
!function (a) {
   true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (a),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "undefined" != typeof module && module.exports ? module.exports = a() : window.pym = a.call(this);
}(function () {
  var a = "xPYMx",
      b = {},
      c = function c(a) {
    var b = document.createEvent("Event");b.initEvent("pym:" + a, !0, !0), document.dispatchEvent(b);
  },
      d = function d(a) {
    var b = new RegExp("[\\?&]" + a.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]") + "=([^&#]*)"),
        c = b.exec(location.search);return null === c ? "" : decodeURIComponent(c[1].replace(/\+/g, " "));
  },
      e = function e(a, b) {
    if (("*" === b.xdomain || a.origin.match(new RegExp(b.xdomain + "$"))) && "string" == typeof a.data) return !0;
  },
      f = function f(b, c, d) {
    var e = ["pym", b, c, d];return e.join(a);
  },
      g = function g(b) {
    var c = ["pym", b, "(\\S+)", "(.*)"];return new RegExp("^" + c.join(a) + "$");
  },
      h = Date.now || function () {
    return new Date().getTime();
  },
      i = function i(a, b, c) {
    var d,
        e,
        f,
        g = null,
        i = 0;c || (c = {});var j = function j() {
      i = c.leading === !1 ? 0 : h(), g = null, f = a.apply(d, e), g || (d = e = null);
    };return function () {
      var k = h();i || c.leading !== !1 || (i = k);var l = b - (k - i);return d = this, e = arguments, l <= 0 || l > b ? (g && (clearTimeout(g), g = null), i = k, f = a.apply(d, e), g || (d = e = null)) : g || c.trailing === !1 || (g = setTimeout(j, l)), f;
    };
  },
      j = function j() {
    for (var a = b.autoInitInstances.length, c = a - 1; c >= 0; c--) {
      var d = b.autoInitInstances[c];d.el.getElementsByTagName("iframe").length && d.el.getElementsByTagName("iframe")[0].contentWindow || b.autoInitInstances.splice(c, 1);
    }
  };return b.autoInitInstances = [], b.autoInit = function (a) {
    var d = document.querySelectorAll("[data-pym-src]:not([data-pym-auto-initialized])"),
        e = d.length;j();for (var f = 0; f < e; ++f) {
      var g = d[f];g.setAttribute("data-pym-auto-initialized", ""), "" === g.id && (g.id = "pym-" + f + "-" + Math.random().toString(36).substr(2, 5));var h = g.getAttribute("data-pym-src"),
          i = { xdomain: "string", title: "string", name: "string", id: "string", sandbox: "string", allowfullscreen: "boolean", parenturlparam: "string", parenturlvalue: "string", optionalparams: "boolean", trackscroll: "boolean", scrollwait: "number" },
          k = {};for (var l in i) {
        if (null !== g.getAttribute("data-pym-" + l)) switch (i[l]) {case "boolean":
            k[l] = !("false" === g.getAttribute("data-pym-" + l));break;case "string":
            k[l] = g.getAttribute("data-pym-" + l);break;case "number":
            var m = Number(g.getAttribute("data-pym-" + l));isNaN(m) || (k[l] = m);break;default:
            console.err("unrecognized attribute type");}
      }var n = new b.Parent(g.id, h, k);b.autoInitInstances.push(n);
    }return a || c("pym-initialized"), b.autoInitInstances;
  }, b.Parent = function (a, b, c) {
    this.id = a, this.url = b, this.el = document.getElementById(a), this.iframe = null, this.settings = { xdomain: "*", optionalparams: !0, parenturlparam: "parentUrl", parenturlvalue: window.location.href, trackscroll: !1, scrollwait: 100 }, this.messageRegex = g(this.id), this.messageHandlers = {}, c = c || {}, this._constructIframe = function () {
      var a = this.el.offsetWidth.toString();this.iframe = document.createElement("iframe");var b = "",
          c = this.url.indexOf("#");for (c > -1 && (b = this.url.substring(c, this.url.length), this.url = this.url.substring(0, c)), this.url.indexOf("?") < 0 ? this.url += "?" : this.url += "&", this.iframe.src = this.url + "initialWidth=" + a + "&childId=" + this.id, this.settings.optionalparams && (this.iframe.src += "&parentTitle=" + encodeURIComponent(document.title), this.iframe.src += "&" + this.settings.parenturlparam + "=" + encodeURIComponent(this.settings.parenturlvalue)), this.iframe.src += b, this.iframe.setAttribute("width", "100%"), this.iframe.setAttribute("scrolling", "no"), this.iframe.setAttribute("marginheight", "0"), this.iframe.setAttribute("frameborder", "0"), this.settings.title && this.iframe.setAttribute("title", this.settings.title), void 0 !== this.settings.allowfullscreen && this.settings.allowfullscreen !== !1 && this.iframe.setAttribute("allowfullscreen", ""), void 0 !== this.settings.sandbox && "string" == typeof this.settings.sandbox && this.iframe.setAttribute("sandbox", this.settings.sandbox), this.settings.id && (document.getElementById(this.settings.id) || this.iframe.setAttribute("id", this.settings.id)), this.settings.name && this.iframe.setAttribute("name", this.settings.name); this.el.firstChild;) {
        this.el.removeChild(this.el.firstChild);
      }this.el.appendChild(this.iframe), window.addEventListener("resize", this._onResize), this.settings.trackscroll && window.addEventListener("scroll", this._throttleOnScroll);
    }, this._onResize = function () {
      this.sendWidth(), this.settings.trackscroll && this.sendViewportAndIFramePosition();
    }.bind(this), this._onScroll = function () {
      this.sendViewportAndIFramePosition();
    }.bind(this), this._fire = function (a, b) {
      if (a in this.messageHandlers) for (var c = 0; c < this.messageHandlers[a].length; c++) {
        this.messageHandlers[a][c].call(this, b);
      }
    }, this.remove = function () {
      window.removeEventListener("message", this._processMessage), window.removeEventListener("resize", this._onResize), this.el.removeChild(this.iframe), j();
    }, this._processMessage = function (a) {
      if (e(a, this.settings) && "string" == typeof a.data) {
        var b = a.data.match(this.messageRegex);if (!b || 3 !== b.length) return !1;var c = b[1],
            d = b[2];this._fire(c, d);
      }
    }.bind(this), this._onHeightMessage = function (a) {
      var b = parseInt(a);this.iframe.setAttribute("height", b + "px");
    }, this._onNavigateToMessage = function (a) {
      document.location.href = a;
    }, this._onScrollToChildPosMessage = function (a) {
      var b = document.getElementById(this.id).getBoundingClientRect().top + window.pageYOffset,
          c = b + parseInt(a);window.scrollTo(0, c);
    }, this.onMessage = function (a, b) {
      a in this.messageHandlers || (this.messageHandlers[a] = []), this.messageHandlers[a].push(b);
    }, this.sendMessage = function (a, b) {
      this.el.getElementsByTagName("iframe").length && (this.el.getElementsByTagName("iframe")[0].contentWindow ? this.el.getElementsByTagName("iframe")[0].contentWindow.postMessage(f(this.id, a, b), "*") : this.remove());
    }, this.sendWidth = function () {
      var a = this.el.offsetWidth.toString();this.sendMessage("width", a);
    }, this.sendViewportAndIFramePosition = function () {
      var a = this.iframe.getBoundingClientRect(),
          b = window.innerWidth || document.documentElement.clientWidth,
          c = window.innerHeight || document.documentElement.clientHeight,
          d = b + " " + c;d += " " + a.top + " " + a.left, d += " " + a.bottom + " " + a.right, this.sendMessage("viewport-iframe-position", d);
    };for (var d in c) {
      this.settings[d] = c[d];
    }return this._throttleOnScroll = i(this._onScroll.bind(this), this.settings.scrollwait), this.onMessage("height", this._onHeightMessage), this.onMessage("navigateTo", this._onNavigateToMessage), this.onMessage("scrollToChildPos", this._onScrollToChildPosMessage), this.onMessage("parentPositionInfo", this.sendViewportAndIFramePosition), window.addEventListener("message", this._processMessage, !1), this._constructIframe(), this;
  }, b.Child = function (b) {
    this.parentWidth = null, this.id = null, this.parentTitle = null, this.parentUrl = null, this.settings = { renderCallback: null, xdomain: "*", polling: 0, parenturlparam: "parentUrl" }, this.timerId = null, this.messageRegex = null, this.messageHandlers = {}, b = b || {}, this.onMessage = function (a, b) {
      a in this.messageHandlers || (this.messageHandlers[a] = []), this.messageHandlers[a].push(b);
    }, this._fire = function (a, b) {
      if (a in this.messageHandlers) for (var c = 0; c < this.messageHandlers[a].length; c++) {
        this.messageHandlers[a][c].call(this, b);
      }
    }, this._processMessage = function (a) {
      if (e(a, this.settings) && "string" == typeof a.data) {
        var b = a.data.match(this.messageRegex);if (b && 3 === b.length) {
          var c = b[1],
              d = b[2];this._fire(c, d);
        }
      }
    }.bind(this), this._onWidthMessage = function (a) {
      var b = parseInt(a);b !== this.parentWidth && (this.parentWidth = b, this.settings.renderCallback && this.settings.renderCallback(b), this.sendHeight());
    }, this.sendMessage = function (a, b) {
      window.parent.postMessage(f(this.id, a, b), "*");
    }, this.sendHeight = function () {
      var a = document.getElementsByTagName("body")[0].offsetHeight.toString();return this.sendMessage("height", a), a;
    }.bind(this), this.getParentPositionInfo = function () {
      this.sendMessage("parentPositionInfo");
    }, this.scrollParentTo = function (a) {
      this.sendMessage("navigateTo", "#" + a);
    }, this.navigateParentTo = function (a) {
      this.sendMessage("navigateTo", a);
    }, this.scrollParentToChildEl = function (a) {
      var b = document.getElementById(a).getBoundingClientRect().top + window.pageYOffset;this.scrollParentToChildPos(b);
    }, this.scrollParentToChildPos = function (a) {
      this.sendMessage("scrollToChildPos", a.toString());
    };var g = function g(a) {
      var b,
          d = document.getElementsByTagName("html")[0],
          e = d.className;try {
        b = window.self !== window.top ? "embedded" : "not-embedded";
      } catch (a) {
        b = "embedded";
      }e.indexOf(b) < 0 && (d.className = e ? e + " " + b : b, a && a(b), c("marked-embedded"));
    };this.remove = function () {
      window.removeEventListener("message", this._processMessage), this.timerId && clearInterval(this.timerId);
    };for (var h in b) {
      this.settings[h] = b[h];
    }this.id = d("childId") || b.id, this.messageRegex = new RegExp("^pym" + a + this.id + a + "(\\S+)" + a + "(.*)$");var i = parseInt(d("initialWidth"));return this.parentUrl = d(this.settings.parenturlparam), this.parentTitle = d("parentTitle"), this.onMessage("width", this._onWidthMessage), window.addEventListener("message", this._processMessage, !1), this.settings.renderCallback && this.settings.renderCallback(i), this.sendHeight(), this.settings.polling && (this.timerId = window.setInterval(this.sendHeight, this.settings.polling)), g(b.onMarkedEmbeddedStatus), this;
  }, "undefined" != typeof document && b.autoInit(!0), b;
});

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(13);

var app = _interopRequireWildcard(_app);

__webpack_require__(60);

var _banners = __webpack_require__(19);

var Banners = _interopRequireWildcard(_banners);

var _compartir = __webpack_require__(51);

var Share = _interopRequireWildcard(_compartir);

var _slide = __webpack_require__(88);

var Galeria = _interopRequireWildcard(_slide);

var _functions = __webpack_require__(17);

var Functions = _interopRequireWildcard(_functions);

var _utilities = __webpack_require__(4);

var Utilities = _interopRequireWildcard(_utilities);

__webpack_require__(87);

var _framework = __webpack_require__(86);

var LiveFyre = _interopRequireWildcard(_framework);

__webpack_require__(89);

var _tercera = __webpack_require__(35);

var Tercera = _interopRequireWildcard(_tercera);

var _login = __webpack_require__(15);

var Login = _interopRequireWildcard(_login);

var _logout = __webpack_require__(5);

var Logout = _interopRequireWildcard(_logout);

var _global = __webpack_require__(11);

var _cookie = __webpack_require__(0);

var Cookie = _interopRequireWildcard(_cookie);

var _tableros = __webpack_require__(40);

var Tablero = _interopRequireWildcard(_tableros);

var _tableroTenis = __webpack_require__(42);

var TableroTenis = _interopRequireWildcard(_tableroTenis);

var _tableroFutbol = __webpack_require__(41);

var TableroFutbol = _interopRequireWildcard(_tableroFutbol);

var _sugerencias = __webpack_require__(43);

var Sugerencias = _interopRequireWildcard(_sugerencias);

var _notasAdicionales = __webpack_require__(96);

var NotasAdicionales = _interopRequireWildcard(_notasAdicionales);

var _pymV1Min = __webpack_require__(52);

var _pymV1Min2 = _interopRequireDefault(_pymV1Min);

__webpack_require__(85);

var _bombaIntrasitio = __webpack_require__(32);

var bomba = _interopRequireWildcard(_bombaIntrasitio);

var _personalizacion = __webpack_require__(20);

var Personalizacion = _interopRequireWildcard(_personalizacion);

var _CustomDimension = __webpack_require__(29);

var CustomDimension = _interopRequireWildcard(_CustomDimension);

var _NotaCustomDimension = __webpack_require__(95);

var NotaCustomDimension = _interopRequireWildcard(_NotaCustomDimension);

var _session = __webpack_require__(7);

var Session = _interopRequireWildcard(_session);

var _video = __webpack_require__(37);

var Video = _interopRequireWildcard(_video);

var _footer = __webpack_require__(83);

var Footer = _interopRequireWildcard(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

window.pym = _pymV1Min2.default;
//import * as Movil from './scripts/common/menu-movil';

window.LN = {};
window.LN.tipoPaginaBanner = "nota";
window.LN.configBanners = _global.banners;
var dominio = window.config.Statics.DominioUrl;
var httpDominio = "http:" + dominio;

var FirstQuarter = false;
var SecondQuarter = false;
var ThirdQuarter = false;
var FourthQuarter = false;
var EventFinContenido = false;
var EventFinSugerencias = false;
var CommentsLoad = false;
var Comentarios = document.getElementById("tokenLF");

//Set click event to Facebook and Twitter buttons.
var shareClickEvents = function shareClickEvents() {
    if (document.getElementById("hs-notaId")) {
        var notaId = document.getElementById("hs-notaId").value;
        var titulo = document.getElementById("hs-titulo").value;
        //facebooks
        Array.from(document.querySelectorAll('button[data-id="facebookShare"]')).map(function (o) {
            o.addEventListener("click", function () {
                Share.popUpCompartirNotaFB(notaId, httpDominio);
                if (window.dataLayer != undefined) {
                    dataLayer.push({ 'event': 'shareItem', 'socialNetwork': 'facebook' });
                }
            });
        });
        //twitter
        Array.from(document.querySelectorAll('button[data-id="twitterShare"]')).map(function (o) {
            o.addEventListener("click", function () {
                Share.popUpCompartirNotaTW(notaId, httpDominio, titulo);
                if (window.dataLayer != undefined) {
                    dataLayer.push({ 'event': 'shareItem', 'socialNetwork': 'twitter' });
                }
            });
        });

        document.querySelector('button[data-id="emailShare"]').addEventListener("click", function (e) {
            var notaUrl = e.target.getAttribute("data-url");
            window.location.href = "mailto:?subject=Te%20recomiendo%20esta%20nota%20de%20LA%20NACION&body=Lee%20esta%20nota%20de%20LA%20NACION%3A%20" + dominio + notaUrl;
            if (window.dataLayer != undefined) {
                dataLayer.push({ 'event': 'shareItem', 'socialNetwork': 'mail' });
            }
        });

        //google
        //document.querySelector('button[data-id="googleShare"').addEventListener("click", () => {
        //    Share.popUpCompartirNotaGoogle(notaId, httpDominio, titulo);
        //});
        //rss
        //document.querySelector('button[data-id="rssShare"').addEventListener("click", () => {
        //    Share.popUpCompartirNotaRss();
        //});

        //WhatsApp
        Share.shareWhastApp();

        ////Blockquotes
        //let nodeShareQuote = document.querySelectorAll("blockquote");
        //for (let element of Array.from(nodeShareQuote)) {
        //    const blockquote = element.querySelector("label");
        //    if (blockquote) {
        //        const blockquoteText = blockquote.innerHTML;
        //        const twBtn = element.querySelector("div > .icon-twitter");
        //        if (twBtn) {
        //            twBtn.addEventListener("click", () => {
        //                Share.popUpCompartirNotaTW(notaId, httpDominio, blockquoteText);
        //            });
        //        }
        //        const fbBtn = element.querySelector("div > .icon-facebook");
        //        if (fbBtn) {
        //            fbBtn.addEventListener("click", () => {
        //                Share.popUpCompartirNotaFB(notaId, httpDominio, blockquoteText);
        //            });    
        //        }
        //    }
        //}

        ////Images
        //assignEventsClicksShare(document.querySelectorAll("figure[data-is='imagen']"), "imagen");
        ////shareGalery
        //assignEventsClicksShare(document.querySelectorAll("#slider"), "galeria");
    }
};

var eventsMetrics = function eventsMetrics() {
    Array.from(document.querySelectorAll('[data-DLdescripcion]')).filter(function (k) {
        return k.getAttribute("data-DLdescripcion") != null && k.getAttribute("data-DLdescripcion") !== "" && k.getAttribute("data-DLdescripcion") !== undefined;
    }).map(function (d) {
        d.addEventListener("click", function () {
            if (window.dataLayer != undefined && d.getAttribute("class") !== "seguir activo") {
                window.dataLayer.push({
                    'event': 'followAuth',
                    'followedAuth': d.getAttribute("data-DLdescripcion")
                });
            }
        });
    });

    Array.from(document.querySelectorAll('[data-event]')).filter(function (t) {
        return t.getAttribute("data-event") != null && t.getAttribute !== "";
    }).map(function (tag) {
        tag.addEventListener("click", function () {

            if (window.dataLayer != undefined) {
                window.dataLayer.push({ 'event': 'contentLinkClick' });
            }
        });
    });

    var botonMeGusta = document.getElementsByClassName("icon-me-gusta");
    if (botonMeGusta.length > 0) {
        botonMeGusta[0].addEventListener("click", function () {
            if (window.dataLayer != undefined) {
                dataLayer.push({ 'event': 'trackEvent', 'eventCategory': 'engagement', 'eventAction': 'like', 'eventLabel': 'yes', 'nonInteraction': false });
            }
            botonMeGusta[0].className = "icon-me-gusta activo";
        });
    }

    window.onscroll = function () {

        if (CommentsLoad === false && Comentarios != null) {
            if (window.scrollY > Comentarios.offsetTop - 1000) {
                CommentsLoad = true;
                LiveFyre.loadLivefyre(Cookie.LeerCookie('cookieLogin'), Cookie.LeerCookie('usuario%5Flogtkn'), Login.Login);
            }
        }
        if (FirstQuarter === true && SecondQuarter === true && ThirdQuarter === true && FourthQuarter === true && EventFinContenido === true && EventFinSugerencias === true) {
            return true;
        }
        var scrollTop = $(window).scrollTop();
        var docHeight = $(document).height();
        var winHeight = $(window).height();
        var scrollPercent = scrollTop / (docHeight - winHeight);
        var scrollPercentRounded = Math.round(scrollPercent * 100);
        if (scrollPercentRounded > 25 && FirstQuarter === false) {
            FirstQuarter = true;
            if (window.dataLayer !== undefined) {
                dataLayer.push({ 'event': 'trackScroll', 'quartile': '25' });
            }
        }
        if (scrollPercentRounded > 50 && SecondQuarter === false) {
            SecondQuarter = true;
            if (window.dataLayer !== undefined) {
                dataLayer.push({ 'event': 'trackScroll', 'quartile': '50' });
            }
        }
        if (scrollPercentRounded > 75 && ThirdQuarter === false) {
            ThirdQuarter = true;
            if (window.dataLayer !== undefined) {
                dataLayer.push({ 'event': 'trackScroll', 'quartile': '75' });
            }
        }
        if (scrollPercentRounded === 100 && FourthQuarter === false) {
            FourthQuarter = true;
            if (window.dataLayer !== undefined) {
                dataLayer.push({ 'event': 'trackScroll', 'quartile': '100' });
            }
        }

        if (Utilities.scrolledIntoView(".fin-cuerpo") && EventFinContenido === false && window.dataLayer !== undefined) {
            EventFinContenido = true;
            dataLayer.push({ 'event': 'trackScroll', 'quartile': 'fin del contenido ' });
        }
        if (Utilities.scrolledIntoView("#comentarios") && EventFinSugerencias === false && window.dataLayer !== undefined) {
            EventFinSugerencias = true;
            dataLayer.push({ 'event': 'trackScroll', 'quartile': 'fin caja sugerencias' });
        }
    };
};

var obtenerComentarios = function obtenerComentarios() {
    if (Comentarios !== null) {
        var comentarioSpan = document.querySelector('span[data-id="contadorComentarios"]'); //data-lf-site-id="@Model.SiteIdLF" data-lf-article-id="@Model.EntradaId"
        comentarioSpan.setAttribute("data-lf-site-id", Comentarios.getAttribute("data-lf-siteId"));
        comentarioSpan.setAttribute("data-lf-article-id", Comentarios.getAttribute("data-entrada"));

        var script = document.createElement("script");
        script.type = "text/javascript";
        script.setAttribute("data-lf-domain", "la-nacion.fyre.co");
        script.src = "https://cdn.livefyre.com/libs/commentcount/v1.0/commentcount.js";
        document.body.appendChild(script);
        var verLegales = document.getElementsByClassName("ver-legales")[0];
        var legales = document.getElementsByClassName("legales")[0];

        verLegales.addEventListener("click", function () {
            verLegales.classList.toggle("flecha-arriba");
            legales.classList.toggle("desplegado");
        });
    }
};

var getTableros = function getTableros() {
    var tablero = document.querySelector("section.tablero");
    if (tablero != null) {
        var tableros = []; /*array de objetos de tipo tablero*/
        if (hasClass(tablero, "tenis")) {
            tableros.push(TableroTenis.agregarTableroTenis(document.querySelector(".tenis").getAttribute("data-id"), '1000'));
        } else if (hasClass(tablero, "futbol")) {
            tableros.push(TableroFutbol.agregarTableroFutbol(document.querySelector(".futbol").getAttribute("data-id"), '1101'));
        }
        Tablero.iniciarTableros(tableros);
        Tablero.verificarCambiosCodigoControl();
        setInterval(Tablero.verificarCambiosCodigoControl, 15000);
    }
};

function hasClass(element, classNode) {
    return (' ' + element.className + ' ').indexOf(' ' + classNode + ' ') > -1;
}

var techos = function techos() {
    var classMain = document.querySelector('div[data-classMain]').getAttribute('data-classMain').trim();
    var nodoMain = document.querySelector('main');
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = classMain.split(" ")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var className = _step.value;

            if (classMain.indexOf(" ") == -1) nodoMain.classList.add(className.trim());
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};

var initIframePym = function initIframePym() {

    $("iframe.pym").each(function (i, nodo) {
        var id = $(nodo).data('id') || 'pymnro' + i,
            url = $(nodo).attr('src') || $(nodo).data('src'),
            opts = /*$(nodo).data('opts') || HAY QUE PARSEAR JSON*/{};

        if (!!url) {
            $(nodo).after('<div id="' + id + '"></div>');
            $(nodo).remove();

            var mypym = new _pymV1Min2.default.Parent(id, url, opts);
            mypym.onMessage('pymEspecialesLoaded', function (status) {
                if (status === 'ready') mypym.sendMessage('setShareUrl', document.URL);
            });
        }
    });
};

var bannersRepetidos = function bannersRepetidos() {
    var node = Array.from(document.querySelectorAll('#caja_1[data-dispositivo="tablet"]'));
    node.length > 1 ? node[1].classList.remove("ad-slot") : "";
    node = Array.from(document.querySelectorAll('#caja_2[data-dispositivo="tablet"]'));
    node.length > 1 ? node[1].classList.remove("ad-slot") : "";
};

var initialize = function initialize() {
    bannersRepetidos();
    Personalizacion.initPreferencias();
    Banners.loadBanners(window.LN.tipoPaginaBanner);
    Session.init();
    techos();
    var divElement = document.querySelectorAll("#slider");
    Galeria.getAllGalerias(divElement);
    shareClickEvents();
    Tercera.getRanking();
    getTableros();
    Login.Initialize();
    Logout.Initialize();
    obtenerComentarios();
    NotasAdicionales.notasAdemas();
    Tercera.getPromoClubLn();
    Functions.functions();
    Functions.buscador();
    bomba.checkBomba();
    CustomDimension.MakeCustomDimension();
    NotaCustomDimension.MakeCustomDimension();
    Sugerencias.getSugerenciasPie();
    Sugerencias.getNewsletter();
    NotasAdicionales.notasMasComentadas();
    eventsMetrics();
    Footer.linksFooter();
    Video.initialize();
    initIframePym();
    Utilities.metaRefresh(600000);
};

app.start().then(initialize);

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var linksFooter = exports.linksFooter = function linksFooter() {

    if (document.querySelector("#pie-facebook")) {
        document.querySelector("#pie-facebook").addEventListener("click", function () {
            window.open("https://www.facebook.com/lanacion", "_blank");
        });
    }

    if (document.querySelector("#pie-twitter")) document.querySelector("#pie-twitter").addEventListener("click", function () {
        window.open("https://twitter.com/LANACION", "_blank");
    });

    if (document.querySelector("#pie-instagram")) document.querySelector("#pie-instagram").addEventListener("click", function () {
        window.open("https://www.instagram.com/lanacioncom/", "_blank");
    });

    if (document.querySelector("#pie-rss")) document.querySelector("#pie-rss").addEventListener("click", function () {
        window.open("http://servicios.lanacion.com.ar/herramientas/rss/ayuda", "_blank");
    });

    if (document.querySelector("#pie-apple")) document.querySelector("#pie-apple").addEventListener("click", function () {
        window.open("https://www.google.com.ar/url?sa=t&rct=j&q=&esrc=s&source=web&cd=1&cad=rja&uact=8&ved=0ahUKEwjsqvOLkr7XAhUDjpAKHZyiBigQFgglMAA&url=https%3A%2F%2Fitunes.apple.com%2Far%2Fapp%2Fla-nacion%2Fid410689702%3Fmt%3D8&usg=AOvVaw3LqfU_ag8u27BMNAtmRxqN", "_blank");
    });

    if (document.querySelector("#pie-android")) document.querySelector("#pie-android").addEventListener("click", function () {
        window.open("https://play.google.com/store/apps/details?id=app.lanacion.activity&hl=es_419", "_blank");
    });
};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getHtml = exports.getHtml = function getHtml(nodo) {
    var htmlResult = "";
    if (nodo.Type == "Texto") {
        htmlResult += nodo.Value;
    }
    if (nodo.Type == "Html") {
        htmlResult += "<" + nodo.HtmlTag + ">";
    }
    if (nodo.Nodes != null) {
        for (var i = 0; i < nodo.Nodes.length; i++) {
            htmlResult += getHtml(nodo.Nodes[i]);
        }
    }
    if (nodo.Type == "Html") {
        htmlResult += "</" + nodo.HtmlTag + ">";
    }
    return htmlResult;
};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*
 * jQuery Mobile Framework v1.2.1
 * http://jquerymobile.com
 *
 * Copyright 2010, 2013 jQuery Foundation, Inc. and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 */

(function (root, doc, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($) {
            factory($, root, doc);
            return $.mobile;
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {
        // Browser globals
        factory(root.jQuery, root, doc);
    }
})(undefined, document, function (jQuery, window, document, undefined) {

    // This plugin is an experiment for abstracting away the touch and mouse
    // events so that developers don't have to worry about which method of input
    // the device their document is loaded on supports.
    //
    // The idea here is to allow the developer to register listeners for the
    // basic mouse events, such as mousedown, mousemove, mouseup, and click,
    // and the plugin will take care of registering the correct listeners
    // behind the scenes to invoke the listener at the fastest possible time
    // for that device, while still retaining the order of event firing in
    // the traditional mouse environment, should multiple handlers be registered
    // on the same element for different events.
    //
    // The current version exposes the following virtual events to jQuery bind methods:
    // "vmouseover vmousedown vmousemove vmouseup vclick vmouseout vmousecancel"

    (function ($, window, document, undefined) {

        var dataPropertyName = "virtualMouseBindings",
            touchTargetPropertyName = "virtualTouchID",
            virtualEventNames = "vmouseover vmousedown vmousemove vmouseup vclick vmouseout vmousecancel".split(" "),
            touchEventProps = "clientX clientY pageX pageY screenX screenY".split(" "),
            mouseHookProps = $.event.mouseHooks ? $.event.mouseHooks.props : [],

        //mouseEventProps = $.event.props.concat( mouseHookProps ),
        activeDocHandlers = {},
            resetTimerID = 0,
            startX = 0,
            startY = 0,
            didScroll = false,
            clickBlockList = [],
            blockMouseTriggers = false,
            blockTouchTriggers = false,
            eventCaptureSupported = "addEventListener" in document,
            $document = $(document),
            nextTouchID = 1,
            lastTouchID = 0,
            threshold;

        $.vmouse = {
            moveDistanceThreshold: 10,
            clickDistanceThreshold: 10,
            resetTimerDuration: 1500
        };

        function getNativeEvent(event) {

            while (event && typeof event.originalEvent !== "undefined") {
                event = event.originalEvent;
            }
            return event;
        }

        function createVirtualEvent(event, eventType) {

            var t = event.type,
                oe,
                props,
                ne,
                prop,
                ct,
                touch,
                i,
                j,
                len;

            event = $.Event(event);
            event.type = eventType;

            oe = event.originalEvent;
            props = $.event.props;

            // addresses separation of $.event.props in to $.event.mouseHook.props and Issue 3280
            // https://github.com/jquery/jquery-mobile/issues/3280
            if (t.search(/^(mouse|click)/) > -1) {
                props = mouseEventProps;
            }

            // copy original event properties over to the new event
            // this would happen if we could call $.event.fix instead of $.Event
            // but we don't have a way to force an event to be fixed multiple times
            if (oe) {
                for (i = props.length, prop; i;) {
                    prop = props[--i];
                    event[prop] = oe[prop];
                }
            }

            // make sure that if the mouse and click virtual events are generated
            // without a .which one is defined
            if (t.search(/mouse(down|up)|click/) > -1 && !event.which) {
                event.which = 1;
            }

            if (t.search(/^touch/) !== -1) {
                ne = getNativeEvent(oe);
                t = ne.touches;
                ct = ne.changedTouches;
                touch = t && t.length ? t[0] : ct && ct.length ? ct[0] : undefined;

                if (touch) {
                    for (j = 0, len = touchEventProps.length; j < len; j++) {
                        prop = touchEventProps[j];
                        event[prop] = touch[prop];
                    }
                }
            }

            return event;
        }

        function getVirtualBindingFlags(element) {

            var flags = {},
                b,
                k;

            while (element) {

                b = $.data(element, dataPropertyName);

                for (k in b) {
                    if (b[k]) {
                        flags[k] = flags.hasVirtualBinding = true;
                    }
                }
                element = element.parentNode;
            }
            return flags;
        }

        function getClosestElementWithVirtualBinding(element, eventType) {
            var b;
            while (element) {

                b = $.data(element, dataPropertyName);

                if (b && (!eventType || b[eventType])) {
                    return element;
                }
                element = element.parentNode;
            }
            return null;
        }

        function enableTouchBindings() {
            blockTouchTriggers = false;
        }

        function disableTouchBindings() {
            blockTouchTriggers = true;
        }

        function enableMouseBindings() {
            lastTouchID = 0;
            clickBlockList.length = 0;
            blockMouseTriggers = false;

            // When mouse bindings are enabled, our
            // touch bindings are disabled.
            disableTouchBindings();
        }

        function disableMouseBindings() {
            // When mouse bindings are disabled, our
            // touch bindings are enabled.
            enableTouchBindings();
        }

        function startResetTimer() {
            clearResetTimer();
            resetTimerID = setTimeout(function () {
                resetTimerID = 0;
                enableMouseBindings();
            }, $.vmouse.resetTimerDuration);
        }

        function clearResetTimer() {
            if (resetTimerID) {
                clearTimeout(resetTimerID);
                resetTimerID = 0;
            }
        }

        function triggerVirtualEvent(eventType, event, flags) {
            var ve;

            if (flags && flags[eventType] || !flags && getClosestElementWithVirtualBinding(event.target, eventType)) {

                ve = createVirtualEvent(event, eventType);

                $(event.target).trigger(ve);
            }

            return ve;
        }

        function mouseEventCallback(event) {
            var touchID = $.data(event.target, touchTargetPropertyName);

            if (!blockMouseTriggers && (!lastTouchID || lastTouchID !== touchID)) {
                var ve = triggerVirtualEvent("v" + event.type, event);
                if (ve) {
                    if (ve.isDefaultPrevented()) {
                        event.preventDefault();
                    }
                    if (ve.isPropagationStopped()) {
                        event.stopPropagation();
                    }
                    if (ve.isImmediatePropagationStopped()) {
                        event.stopImmediatePropagation();
                    }
                }
            }
        }

        function handleTouchStart(event) {

            var touches = getNativeEvent(event).touches,
                target,
                flags;

            if (touches && touches.length === 1) {

                target = event.target;
                flags = getVirtualBindingFlags(target);

                if (flags.hasVirtualBinding) {

                    lastTouchID = nextTouchID++;
                    $.data(target, touchTargetPropertyName, lastTouchID);

                    clearResetTimer();

                    disableMouseBindings();
                    didScroll = false;

                    var t = getNativeEvent(event).touches[0];
                    startX = t.pageX;
                    startY = t.pageY;

                    triggerVirtualEvent("vmouseover", event, flags);
                    triggerVirtualEvent("vmousedown", event, flags);
                }
            }
        }

        function handleScroll(event) {
            if (blockTouchTriggers) {
                return;
            }

            if (!didScroll) {
                triggerVirtualEvent("vmousecancel", event, getVirtualBindingFlags(event.target));
            }

            didScroll = true;
            startResetTimer();
        }

        function handleTouchMove(event) {
            if (blockTouchTriggers) {
                return;
            }

            var t = getNativeEvent(event).touches[0],
                didCancel = didScroll,
                moveThreshold = $.vmouse.moveDistanceThreshold,
                flags = getVirtualBindingFlags(event.target);

            didScroll = didScroll || Math.abs(t.pageX - startX) > moveThreshold || Math.abs(t.pageY - startY) > moveThreshold;

            if (didScroll && !didCancel) {
                triggerVirtualEvent("vmousecancel", event, flags);
            }

            triggerVirtualEvent("vmousemove", event, flags);
            startResetTimer();
        }

        function handleTouchEnd(event) {
            if (blockTouchTriggers) {
                return;
            }

            disableTouchBindings();

            var flags = getVirtualBindingFlags(event.target),
                t;
            triggerVirtualEvent("vmouseup", event, flags);

            if (!didScroll) {
                var ve = triggerVirtualEvent("vclick", event, flags);
                if (ve && ve.isDefaultPrevented()) {
                    // The target of the mouse events that follow the touchend
                    // event don't necessarily match the target used during the
                    // touch. This means we need to rely on coordinates for blocking
                    // any click that is generated.
                    t = getNativeEvent(event).changedTouches[0];
                    clickBlockList.push({
                        touchID: lastTouchID,
                        x: t.clientX,
                        y: t.clientY
                    });

                    // Prevent any mouse events that follow from triggering
                    // virtual event notifications.
                    blockMouseTriggers = true;
                }
            }
            triggerVirtualEvent("vmouseout", event, flags);
            didScroll = false;

            startResetTimer();
        }

        function hasVirtualBindings(ele) {
            var bindings = $.data(ele, dataPropertyName),
                k;

            if (bindings) {
                for (k in bindings) {
                    if (bindings[k]) {
                        return true;
                    }
                }
            }
            return false;
        }

        function dummyMouseHandler() {}

        function getSpecialEventObject(eventType) {
            var realType = eventType.substr(1);

            return {
                setup: function setup(data, namespace) {
                    // If this is the first virtual mouse binding for this element,
                    // add a bindings object to its data.

                    if (!hasVirtualBindings(this)) {
                        $.data(this, dataPropertyName, {});
                    }

                    // If setup is called, we know it is the first binding for this
                    // eventType, so initialize the count for the eventType to zero.
                    var bindings = $.data(this, dataPropertyName);
                    bindings[eventType] = true;

                    // If this is the first virtual mouse event for this type,
                    // register a global handler on the document.

                    activeDocHandlers[eventType] = (activeDocHandlers[eventType] || 0) + 1;

                    if (activeDocHandlers[eventType] === 1) {
                        $document.bind(realType, mouseEventCallback);
                    }

                    // Some browsers, like Opera Mini, won't dispatch mouse/click events
                    // for elements unless they actually have handlers registered on them.
                    // To get around this, we register dummy handlers on the elements.

                    $(this).bind(realType, dummyMouseHandler);

                    // For now, if event capture is not supported, we rely on mouse handlers.
                    if (eventCaptureSupported) {
                        // If this is the first virtual mouse binding for the document,
                        // register our touchstart handler on the document.

                        activeDocHandlers["touchstart"] = (activeDocHandlers["touchstart"] || 0) + 1;

                        if (activeDocHandlers["touchstart"] === 1) {
                            $document.bind("touchstart", handleTouchStart).bind("touchend", handleTouchEnd)

                            // On touch platforms, touching the screen and then dragging your finger
                            // causes the window content to scroll after some distance threshold is
                            // exceeded. On these platforms, a scroll prevents a click event from being
                            // dispatched, and on some platforms, even the touchend is suppressed. To
                            // mimic the suppression of the click event, we need to watch for a scroll
                            // event. Unfortunately, some platforms like iOS don't dispatch scroll
                            // events until *AFTER* the user lifts their finger (touchend). This means
                            // we need to watch both scroll and touchmove events to figure out whether
                            // or not a scroll happenens before the touchend event is fired.

                            .bind("touchmove", handleTouchMove).bind("scroll", handleScroll);
                        }
                    }
                },

                teardown: function teardown(data, namespace) {
                    // If this is the last virtual binding for this eventType,
                    // remove its global handler from the document.

                    --activeDocHandlers[eventType];

                    if (!activeDocHandlers[eventType]) {
                        $document.unbind(realType, mouseEventCallback);
                    }

                    if (eventCaptureSupported) {
                        // If this is the last virtual mouse binding in existence,
                        // remove our document touchstart listener.

                        --activeDocHandlers["touchstart"];

                        if (!activeDocHandlers["touchstart"]) {
                            $document.unbind("touchstart", handleTouchStart).unbind("touchmove", handleTouchMove).unbind("touchend", handleTouchEnd).unbind("scroll", handleScroll);
                        }
                    }

                    var $this = $(this),
                        bindings = $.data(this, dataPropertyName);

                    // teardown may be called when an element was
                    // removed from the DOM. If this is the case,
                    // jQuery core may have already stripped the element
                    // of any data bindings so we need to check it before
                    // using it.
                    if (bindings) {
                        bindings[eventType] = false;
                    }

                    // Unregister the dummy event handler.

                    $this.unbind(realType, dummyMouseHandler);

                    // If this is the last virtual mouse binding on the
                    // element, remove the binding data from the element.

                    if (!hasVirtualBindings(this)) {
                        $this.removeData(dataPropertyName);
                    }
                }
            };
        }

        // Expose our custom events to the jQuery bind/unbind mechanism.

        for (var i = 0; i < virtualEventNames.length; i++) {
            $.event.special[virtualEventNames[i]] = getSpecialEventObject(virtualEventNames[i]);
        }

        // Add a capture click handler to block clicks.
        // Note that we require event capture support for this so if the device
        // doesn't support it, we punt for now and rely solely on mouse events.
        if (eventCaptureSupported) {
            document.addEventListener("click", function (e) {
                var cnt = clickBlockList.length,
                    target = e.target,
                    x,
                    y,
                    ele,
                    i,
                    o,
                    touchID;

                if (cnt) {
                    x = e.clientX;
                    y = e.clientY;
                    threshold = $.vmouse.clickDistanceThreshold;

                    // The idea here is to run through the clickBlockList to see if
                    // the current click event is in the proximity of one of our
                    // vclick events that had preventDefault() called on it. If we find
                    // one, then we block the click.
                    //
                    // Why do we have to rely on proximity?
                    //
                    // Because the target of the touch event that triggered the vclick
                    // can be different from the target of the click event synthesized
                    // by the browser. The target of a mouse/click event that is syntehsized
                    // from a touch event seems to be implementation specific. For example,
                    // some browsers will fire mouse/click events for a link that is near
                    // a touch event, even though the target of the touchstart/touchend event
                    // says the user touched outside the link. Also, it seems that with most
                    // browsers, the target of the mouse/click event is not calculated until the
                    // time it is dispatched, so if you replace an element that you touched
                    // with another element, the target of the mouse/click will be the new
                    // element underneath that point.
                    //
                    // Aside from proximity, we also check to see if the target and any
                    // of its ancestors were the ones that blocked a click. This is necessary
                    // because of the strange mouse/click target calculation done in the
                    // Android 2.1 browser, where if you click on an element, and there is a
                    // mouse/click handler on one of its ancestors, the target will be the
                    // innermost child of the touched element, even if that child is no where
                    // near the point of touch.

                    ele = target;

                    while (ele) {
                        for (i = 0; i < cnt; i++) {
                            o = clickBlockList[i];
                            touchID = 0;

                            if (ele === target && Math.abs(o.x - x) < threshold && Math.abs(o.y - y) < threshold || $.data(ele, touchTargetPropertyName) === o.touchID) {
                                // XXX: We may want to consider removing matches from the block list
                                //      instead of waiting for the reset timer to fire.
                                e.preventDefault();
                                e.stopPropagation();
                                return;
                            }
                        }
                        ele = ele.parentNode;
                    }
                }
            }, true);
        }
    })(jQuery, window, document);

    (function ($, undefined) {
        var support = {
            touch: "ontouchend" in document
        };

        $.mobile = $.mobile || {};
        $.mobile.support = $.mobile.support || {};
        $.extend($.support, support);
        $.extend($.mobile.support, support);
    })(jQuery);

    (function ($, window, undefined) {
        // add new event shortcuts
        $.each(("touchstart touchmove touchend " + "tap taphold " + "swipe swipeleft swiperight " + "scrollstart scrollstop").split(" "), function (i, name) {

            $.fn[name] = function (fn) {
                return fn ? this.bind(name, fn) : this.trigger(name);
            };

            // jQuery < 1.8
            if ($.attrFn) {
                $.attrFn[name] = true;
            }
        });

        var supportTouch = $.mobile.support.touch,
            scrollEvent = "touchmove scroll",
            touchStartEvent = supportTouch ? "touchstart" : "mousedown",
            touchStopEvent = supportTouch ? "touchend" : "mouseup",
            touchMoveEvent = supportTouch ? "touchmove" : "mousemove";

        function triggerCustomEvent(obj, eventType, event) {
            var originalType = event.type;
            event.type = eventType;
            $.event.handle.call(obj, event);
            event.type = originalType;
        }

        // also handles scrollstop
        $.event.special.scrollstart = {

            enabled: true,

            setup: function setup() {

                var thisObject = this,
                    $this = $(thisObject),
                    scrolling,
                    timer;

                function trigger(event, state) {
                    scrolling = state;
                    triggerCustomEvent(thisObject, scrolling ? "scrollstart" : "scrollstop", event);
                }

                // iPhone triggers scroll after a small delay; use touchmove instead
                $this.bind(scrollEvent, function (event) {

                    if (!$.event.special.scrollstart.enabled) {
                        return;
                    }

                    if (!scrolling) {
                        trigger(event, true);
                    }

                    clearTimeout(timer);
                    timer = setTimeout(function () {
                        trigger(event, false);
                    }, 50);
                });
            }
        };

        // also handles taphold
        $.event.special.tap = {
            tapholdThreshold: 750,

            setup: function setup() {
                var thisObject = this,
                    $this = $(thisObject);

                $this.bind("vmousedown", function (event) {

                    if (event.which && event.which !== 1) {
                        return false;
                    }

                    var origTarget = event.target,
                        origEvent = event.originalEvent,
                        timer;

                    function clearTapTimer() {
                        clearTimeout(timer);
                    }

                    function clearTapHandlers() {
                        clearTapTimer();

                        $this.unbind("vclick", clickHandler).unbind("vmouseup", clearTapTimer);
                        $(document).unbind("vmousecancel", clearTapHandlers);
                    }

                    function clickHandler(event) {
                        clearTapHandlers();

                        // ONLY trigger a 'tap' event if the start target is
                        // the same as the stop target.
                        if (origTarget === event.target) {
                            triggerCustomEvent(thisObject, "tap", event);
                        }
                    }

                    $this.bind("vmouseup", clearTapTimer).bind("vclick", clickHandler);
                    $(document).bind("vmousecancel", clearTapHandlers);

                    timer = setTimeout(function () {
                        triggerCustomEvent(thisObject, "taphold", $.Event("taphold", { target: origTarget }));
                    }, $.event.special.tap.tapholdThreshold);
                });
            }
        };

        // also handles swipeleft, swiperight
        $.event.special.swipe = {
            scrollSupressionThreshold: 30, // More than this horizontal displacement, and we will suppress scrolling.

            durationThreshold: 1000, // More time than this, and it isn't a swipe.

            horizontalDistanceThreshold: 30, // Swipe horizontal displacement must be more than this.

            verticalDistanceThreshold: 75, // Swipe vertical displacement must be less than this.

            setup: function setup() {
                var thisObject = this,
                    $this = $(thisObject);

                $this.bind(touchStartEvent, function (event) {
                    var data = event.originalEvent.touches ? event.originalEvent.touches[0] : event,
                        start = {
                        time: new Date().getTime(),
                        coords: [data.pageX, data.pageY],
                        origin: $(event.target)
                    },
                        stop;

                    function moveHandler(event) {

                        if (!start) {
                            return;
                        }

                        var data = event.originalEvent.touches ? event.originalEvent.touches[0] : event;

                        stop = {
                            time: new Date().getTime(),
                            coords: [data.pageX, data.pageY]
                        };

                        // prevent scrolling
                        if (Math.abs(start.coords[0] - stop.coords[0]) > $.event.special.swipe.scrollSupressionThreshold) {
                            event.preventDefault();
                        }
                    }

                    $this.bind(touchMoveEvent, moveHandler).one(touchStopEvent, function (event) {
                        $this.unbind(touchMoveEvent, moveHandler);

                        if (start && stop) {
                            if (stop.time - start.time < $.event.special.swipe.durationThreshold && Math.abs(start.coords[0] - stop.coords[0]) > $.event.special.swipe.horizontalDistanceThreshold && Math.abs(start.coords[1] - stop.coords[1]) < $.event.special.swipe.verticalDistanceThreshold) {

                                start.origin.trigger("swipe").trigger(start.coords[0] > stop.coords[0] ? "swipeleft" : "swiperight");
                            }
                        }
                        start = stop = undefined;
                    });
                });
            }
        };
        $.each({
            scrollstop: "scrollstart",
            taphold: "tap",
            swipeleft: "swipe",
            swiperight: "swipe"
        }, function (event, sourceEvent) {

            $.event.special[event] = {
                setup: function setup() {
                    $(this).bind(sourceEvent, $.noop);
                }
            };
        });
    })(jQuery, this);
});

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var loadLivefyre = exports.loadLivefyre = function loadLivefyre(cookieloginvalue, cookievalue, logincb) {
    var tokencookie = cookievalue;
    var logincookie = cookieloginvalue;

    var dataLiveFyre = document.querySelector("#tokenLF");
    if (dataLiveFyre != null) {
        var LiveFyre = {};

        LiveFyre.networkConfig = {
            network: 'la-nacion.fyre.co'
        };

        LiveFyre.customStrings = {
            "editProfile": "Editar perfil",
            "modQ": "Configuración de notificaciones",
            "signIn": "Ingresar",
            "signOut": "Salir",
            "siteAdmin": "Moderación",
            "archiveHeaderTitle": "Cargar imagen desde archivo",
            "archiveShowMore": "Mostrar más",
            "backToHotThreads": "Volver a \"Conversaciones destacadas\"",
            "backToComments": "Volver a \"lo más nuevo\"",
            "sortHotThreads": "Conversaciones destacadas",
            "sortNewest": "Más nuevos",
            "sortOldest": "Más viejos",
            "sortSeparator": "|",
            "sortTopComments": "Destacados",
            "streamSorting": "Cargando",
            "hotThreadsContentNotFoundMsg": "Todavía no hay suficientes comentarios",
            "topCommentsContentNotFoundMsg": "Todavía no hay suficientes \"me gusta\"",
            "threadBreakoutButton": "Ver conversación completa",
            "showMore": "Ver más",
            "showMoreLiveblog": "Ver más posteos",
            "streamRefreshMsg": "Lo nuevo",
            "refresh": "Actualizar",
            "newComment": "Nuevo comentario",
            "newComments": "Nuevos comentarios",
            "newReply": "Nueva respuesta",
            "newReplies": "Nuevas respuestas",
            "listenerCount": "persona siguiendo",
            "listenerCountPlural": "personas siguiendo",
            "commentCountLabel": "comentario",
            "commentCountLabelPlural": "comentarios",
            "liveblogPostCountLabel": "posteo",
            "liveblogPostCountLabelPlural": "posteos",
            "commentNotifier": "Nuevo comentario",
            "commentNotifierPlural": "Nuevos comentarios",
            "liveblogNotifier": "Nuevo posteo",
            "liveblogNotifierPlural": "Nuevos posteos",
            "hovercardViewProfile": "Ver perfil",
            "moderator": "moderador",
            "timeDaysAgo": "día atrás",
            "timeDaysAgoPlural": "días atrás",
            "timeHoursAgo": "una hora",
            "timeHoursAgoPlural": "unas horas",
            "timeInDays": "en 1 día",
            "timeInDaysPlural": "en %s días",
            "timeInHours": "en %s hora",
            "timeInHoursPlural": "en %s horas",
            "timeInMinutes": "en %s minuto",
            "timeInMinutesPlural": "en %s minutos",
            "timeJustNow": "Ahora mismo",
            "timeMinutesAgo": "minuto atrás",
            "timeMinutesAgoPlural": "minutos atrás",
            "commentTombstone": "El comentario ha sido borrado. Las respuestas que generó se siguen mostrando aquí abajo.",
            "likesPlural": "Me gusta",
            "likesSingular": "Me gusta",
            "moderatorEditTimestamp": "Editado por un moderador",
            "permalinkNotFoundMsg": "",
            "quickProfileTooltip": "Ver perfil",
            "featuredCommentsTitlePlural": "Destacado por el editor",
            "featuredCommentsTag": "Destacado por el editor",
            "flagButton": "Reportar",
            "flagCancelButton": "Cancelar",
            "flagCommentTooltip": "Reportar",
            "flagConfirmationMessage": "Reportar %s's comentario como %s?",
            "flagConfirmButton": "Confirmar",
            "flagDefaultSelectOption": "Seleccionar",
            "flagDisagree": "En desacuerdo",
            "flagDisagreeButton": "En desacuerdo",
            "flagDisagreeCommentTooltip": "En desacuerdo",
            "flagEmail": "Email",
            "flagEmailPlaceholder": "usuario@dominio.com",
            "flagNotes": "Notas",
            "flagNotesPlaceholder": "Escribe aquí...",
            "flagOffensive": "Ofensivo",
            "flagOffensiveButton": "Ofensivo",
            "flagOffensiveCommentTooltip": "Ofensivo",
            "flagOffTopic": "Fuera de tema",
            "flagOffTopicButton": "Fuera de tema",
            "flagOffTopicCommentTooltip": "Fuera de tema",
            "flagSpam": "Spam",
            "flagSpamButton": "Spam",
            "flagSpamCommentTooltip": "Spam",
            "flagSubtitle": "Reportar como",
            "flagSuccessMsg": "Este comentario ha sido reportado.",
            "flagTitle": "Reportar comentario",
            "follow": "Seguir",
            "liveblogFollow": "Seguir 'Liveblog'",
            "liveblogUnfollow": "Dejar de seguir 'Liveblog'",
            "unfollow": "Dejar de seguir",
            "likeButton": "Me gusta",
            "unlikeButton": "Me gusta",
            "loadingPermalink": "Cargando URL",
            "shareButton": "Compartir",
            "shareButtonText": "Compartir",
            "shareDefaultText": "Mira el comentario de %s",
            "shareLabel": "Compartir en:",
            "sharePermalink": "URL",
            "shareText": "Acabo de escribir un comentario. ¡Miralo!",
            "shareTextFacebook": "Acabo de escribir un comentario. ¡Miralo!",
            "shareTextLinkedin": "Acabo de escribir un comentario. ¡Miralo!",
            "shareTextTwitter": "Acabo de escribir un comentario. ¡Miralo!",
            "shareTitle": "Compartir comentario",
            "mentionCancelButton": "Cancelar",
            "mentionConfirmButton": "Confirmar",
            "mentionDefaultText": "¡Te mencioné en un comentario!",
            "mentionErrorGeneral": "¡Ups! Algo no funcionó. Ya fue reportado.",
            "mentionErrorNoneSelected": "Tenés que mencionar al menos una persona.",
            "mentionMenuTitle": "Conectá tu cuenta para mencionar a tus amigos:",
            "mentionSubtitleFacebook": "Compartir el posteo de Facebook con:",
            "mentionSubtitleTwitter": "Compartir el tweet con:",
            "mentionSuccessMsg": "Las menciones se han realizado exitosamente.",
            "mentionTitle": "Compartir mención",
            "voteDownvote": "No",
            "voteReplyTitle": "¿Te ha ayudado esta respuesta?",
            "voteTitle": "¿Es valioso este comentario?",
            "voteUpvote": "Si",
            "customHtmlDialogTitle": "Add Custom HTML",
            "editButton": "Editar",
            "editorDisabled": "Esta nota se encuentra cerrada a comentarios.",
            "livechatOtherInstruction": "Presioná CMD+Enter para comentar",
            "livechatPostEditButton": "Editar",
            "livechatPostButtonLabel": "Comentar",
            "livechatWindowsInstruction": "Presioná CTRL + Enter para comentar",
            "postAsButton": "Comentar",
            "postEditAsButton": "Editar",
            "postEditCancelButton": "Cancelar",
            "postEditButton": "Comentar",
            "postReplyAsButton": "Responder",
            "postReplyButton": "Responder",
            "postButton": "Comentar",
            "replyButton": "Responder",
            "replyButtonSingular": "Respuesta",
            "replyButtonPlural": "Respuestas",
            "banCancelButton": "Cancelar",
            "banConfirmation": "¿Estás seguro que querés bannear a este usuario?",
            "banConfirmButton": "Ok",
            "banTitle": "Bannear usuario",
            "banUserButton": "Bannear usuario",
            "banUserTooltip": "Bannear usuario",
            "bozoButton": "Bozo",
            "bozoCommentTooltip": "Bozo",
            "deleteButton": "Borrar",
            "deleteCommentTooltip": "Borrar",
            "featureButton": "Destacado",
            "featureCommentTooltip": "Destacado",
            "featuredCommentTooltip": "Dejar de destacar",
            "pendingComment": "pendiente",
            "shareCommentTooltip": "Compartir",
            "unfeatureButton": "Dejar de destacar",
            "errorAuthError": "No estás autorizado a comentar en esta conversación.",
            "errorCommentsNotAllowed": "Los comentarios no están habilitados en esta nota.",
            "errorDefault": "Ocurrió un error. Por favor intente nuevamente.",
            "errorDuplicate": "Disculpe. No se puede comentar dos veces lo mismo.",
            "errorEditDuplicate": "Tiene que modificar el cuerpo del comentario cuando lo edita.",
            "errorEditNotAllowed": "No estás autorizado a editar el comentario.",
            "errorEditTimeExceeded": "Disculpe, pero el tiempo para editar el comentario expiró.",
            "errorEmpty": "Parece que estás intentando publicar un comentario vacío.",
            "errorExpired": "La sesión ha expirado, por favor actualizá la página.",
            "errorFlagNotSelected": "Por favor seleccione el motivo del reporte.",
            "errorGuestLiked": "Disculpe, solo los usuarios registrados pueden sumar su \"Me gusta\".",
            "errorInsufficientPermissions": "No posee los permisos suficientes.",
            "errorInvalidChar": "Parece que hay un caractér inválido. Por favor revise el texto.",
            "errorLikeOwnComment": " No es posible poner \"Me gusta\" en un comentario propio.",
            "errorMalformed": "Parece que hay un error en el contenido del comentario. Por favor revíselo.",
            "errorMaxChars": "Disculpe, su comentario es muy largo. Por favor edítelo y vuelva a intentarlo.",
            "errorMediaNotAvailable": "Este contenido ya no se encuentra visible.",
            "errorShowMore": "Hubo un error en la carga de nuevos comentarios.",
            "MultipleMediaNotAllowedError": "Sólo puede adjuntar un contenido por comentario.",
            "menuShareTitle": "Compartir",
            "toggleCollapse": "Expandir / Contraer",
            "mentionFacebookConnect": "Facebook",
            "mentionFacebookFetching": "Cargando Contactos",
            "mentionTwitterConnect": "Twitter",
            "mentionTwitterFetching": "Cargando Contactos"

        };

        LiveFyre.convConfig = {
            siteId: '356483',
            articleId: dataLiveFyre.getAttribute("data-entrada"),
            el: 'livefyre',
            collectionMeta: dataLiveFyre.getAttribute("data-id"),
            "datetimeFormat": {
                minutesUntilAbsoluteTime: 4,
                absoluteFormat: 'HH:mm dd/MM/y'
            },
            editorCss: {
                background: '#ccc',
                color: 'red',
                font: '30px "Helvetica Neue", Helvetica, Arial, Geneva, sans-serif'
            }
        };

        LiveFyre.convConfig.initialNumVisible = '10';

        LiveFyre.attachmentDelegate = function (embedObj) {
            var providersToBlock = ['slideshare', 'scribd', 'facebook', 'photobucket', 'twitter', 'imgur', 'tinypic', 'fbcdn', 'cloudfront', 'flickr', '4.bp.blogspot', '1.bp.blogspot', 'orig00.deviantart', 'tira-la-kadena.tumblr', '41.media.tumblr', 'i.ytimg.', 'grand-hotel-calafate.tumblr', 'orig11.deviantart', 'orig07.deviantart', 'orig00.deviantart', 'orig10.deviantart', 'encrypted-tbn1', 'encrypted-tbn2'];
            for (var i = 0, len = providersToBlock.length; i < len; i++) {
                if (embedObj.provider_url.indexOf(providersToBlock[i]) > -1) {
                    return false;
                }
            }
            return true;
        };
        LiveFyre.networkConfig["attachmentDelegate"] = LiveFyre.attachmentDelegate;
        LiveFyre.networkConfig["strings"] = LiveFyre.customStrings;
        LiveFyre.convConfig.postToButtons = ['tw', 'fb'];

        Livefyre.require(['fyre.conv#3', 'auth'], function (Conv, auth) {

            var isUserLoggedIn = function isUserLoggedIn() {
                if (tokencookie != '' && logincookie != '') {
                    return true;
                } else {
                    document.getElementById("comentarios").setAttribute("class", "no-logueado");
                    return false;
                }
            };

            if (isUserLoggedIn()) {
                if (!LiveFyre.autenticado) {
                    auth.authenticate({ livefyre: tokencookie });
                    LiveFyre.autenticado = true;
                    LiveFyre.logueoUsuario = true;
                }
            }

            new Conv(LiveFyre.networkConfig, [LiveFyre.convConfig], function (widget) {
                widget.on('commentPosted', function (data) {
                    // console.log('GA: CommentPosted');
                    //ga('send', 'event', 'livefyre', 'commentPosted');
                });
                widget.on('commentFlagged', function (data) {
                    // console.log('GA: CommentFlagged');
                    //ga('send', 'event', 'livefyre', 'commentFlagged');
                });
                widget.on('commentLiked', function (data) {
                    // console.log('GA: CommentLiked');
                    //ga('send', 'event', 'livefyre', 'commentLiked');
                });
                widget.on('commentShared', function (data) {
                    // console.log('GA: CommentShared');
                    //ga('send', 'event', 'livefyre', 'commentShared');
                });
                widget.on('socialMention', function (data) {
                    //  console.log('GA: SocialMention');
                    //ga('send', 'event', 'livefyre', 'socialMention');
                });
                widget.on('showMore', function (data) {
                    // console.log('GA: ShowMore');
                    //ga('send', 'event', 'livefyre', 'verMas', 'verMas');
                });
                widget.on('initialRenderComplete', function (data) {

                    if (isUserLoggedIn()) {
                        if (!LiveFyre.autenticado) {
                            auth.authenticate({ livefyre: tokencookie });
                            LiveFyre.autenticado = true;
                            LiveFyre.logueoUsuario = true;
                        }
                    } else {
                        fyre.conv.logout();
                    }
                });
            });

            auth.delegate({
                login: function login(cb) {
                    logincb();
                    cb(null, {
                        livefyre: tokencookie
                    });
                },
                logout: function logout(finishLogout) {
                    finishLogout(null);
                },
                viewProfile: function viewProfile(author) {
                    var url,
                        authorId = author.id.match("[0-9]+");
                    if (author.profileUrl != null && authorId.length > 0) {
                        url = author.profileUrl;
                        var win = window.open(url, '_blank');
                        win.focus();
                    }
                }
            });
        });
        var link = document.createElement("link");
        link.id = "miCSS";
        link.rel = "stylesheet";
        // set the type attribute
        link.type = "text/css";
        // make the script element load file
        link.src = "~/livefyre.css";
        // finally insert the element to the body element in order to load the script
        //script.onload = function() {
        //}
        document.getElementsByTagName("head")[0].appendChild(link);
    }
};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


!function (e) {
  var n = e.Livefyre || (e.Livefyre = {});if (n.pending_REQUIRE = n.pending_REQUIRE || [], n.pending_ON = n.pending_ON || [], !n.initialized) {
    n.require = function (e, i) {
      n.pending_REQUIRE.push(arguments);
    }, n.on = function () {
      n.pending_ON.push(arguments);
    }, Livefyre.require.amd = !0, n.fulfillPending = function (i) {
      for (var t, r = e.Livefyre, o = n["pending_" + i.toUpperCase()] || []; t = o.shift();) {
        r[i].apply(r, t);
      }
    };var i = e.location.protocol;0 !== i.indexOf("http") && (i = "https:");var t = i + "//cdn.livefyre.com/libs/Livefyre/v1.1.4/builds/1507243659742/Livefyre.min.js",
        r = ["on", "require"];!function (e, n) {
      var i = document.getElementsByTagName("head")[0] || document.documentElement,
          t = document.createElement("script"),
          r = !1;t.src = e, t.onload = t.onreadystatechange = function () {
        r || this.readyState && "loaded" !== this.readyState && "complete" !== this.readyState || (r = !0, n(), t.onload = t.onreadystatechange = null, i && t.parentNode && i.removeChild(t));
      }, i.insertBefore(t, i.firstChild);
    }(t, function () {
      for (var e = r.length - 1; e >= 0; e--) {
        n.fulfillPending(r[e]);
      }
    }), n.initialized = !0;
  }
}(window);

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getAllGalerias = exports.getGaleria = exports.insertSliderFunctionality = undefined;

var _ajax = __webpack_require__(1);

var Ajax = _interopRequireWildcard(_ajax);

var _bucket = __webpack_require__(2);

var BucketTools = _interopRequireWildcard(_bucket);

var _inodo = __webpack_require__(84);

var INodoTools = _interopRequireWildcard(_inodo);

var _functions = __webpack_require__(17);

var Functions = _interopRequireWildcard(_functions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var urlGaleria = window.config.Statics.GaleriaUrl;
var urlBacket = window.config.Statics.BucketUrl;
var html = "";

var insertSliderFunctionality = exports.insertSliderFunctionality = function insertSliderFunctionality(galeriaId) {
    var nodoSlider = $("#sliderContainer[data-id='" + galeriaId + "']").parent();
    var nodoChildLi = $("#sliderContainer[data-id='" + galeriaId + "'] ul li");
    if (nodoChildLi.length > 1) {

        //Crea la navegacion // VER ESTO QUE NO PEGA LO QUE CREA    
        var nav = function nav() {
            for (var i = 0; i < slides; i++) {
                nodoSlider.find('.navegacion').append('<span data-slide="slide' + i + '" class="slide-' + i + '"></span>');
            }
        };

        // Activa las flechas


        var flechas = function flechas() {
            var galeriaPrev = nodoSlider.find('.prev');
            var galeriaNext = nodoSlider.find('.next');
            if (pos !== 1) {
                galeriaPrev.addClass("activo");
                galeriaPrev.removeClass('primero');
            } else {
                galeriaPrev.removeClass('activo');
                galeriaPrev.addClass('primero');
            }
            if (pos !== slides) {
                galeriaNext.addClass('activo');
                galeriaNext.removeClass('ultimo');
            } else {
                galeriaNext.removeClass('activo');
                galeriaNext.addClass('ultimo');
            }
        };

        //Activa la slide seleccionada

        var slideActiva = function slideActiva() {
            $('#sliderContainer ul li').removeClass('activo');
            $('#sliderContainer ul li').addClass('off');
            $('#sliderContainer ul li').removeClass('previo');
            $('#sliderContainer ul li').eq(pos - 2).addClass('previo');
            $('#sliderContainer ul li').eq(pos).removeClass('previo');
            $('#sliderContainer ul li').eq(pos - 1).toggleClass('off activo');
            if (pos == 1) {
                $('#sliderContainer ul li').removeClass('previo');
            } else {}
        };

        //Toma el texto de cada imagen y lo replica


        var epigrafe = function epigrafe() {
            var epigrafe = $("#sliderContainer[data-id='" + galeriaId + "'] ul li.activo img").attr('alt');
            $('#epigrafe[data-id="' + galeriaId + '"]').html(epigrafe);
        };

        // Crea el total y el actual numero de slides


        var total = function total() {
            var total = pos + ' de ' + slides;
            $('#total[data-id="' + galeriaId + '"]').html(total);
        };
        //Pregunta si es la primera


        var moveLeft = function moveLeft() {
            reloadSrc();
            if (pos === 1) {
                pos = slides;
            } else {
                pos = pos - 1;
            }
            slideActiva();
            total();
            flechas();
        };

        //Pregunta si es la ultima
        var moveRight = function moveRight() {
            reloadSrc();
            if (pos == slides) {
                pos = 1;
            } else {
                pos = pos + 1;
            }
            slideActiva();
            total();
            flechas();
        };

        /*stopea el video que se esta reproduciendo y si tiene autoplay se lo quita*/
        var reloadSrc = function reloadSrc() {
            var sliderIframe = $('#sliderContainer[data-id="' + galeriaId + '"] ul li.activo iframe');
            if (sliderIframe.length) {
                var strReload = sliderIframe.attr('src');
                var strReloadNew = strReload.replace('autoplay=1', 'autoplay=0');
                sliderIframe.attr('src', strReloadNew);
            }
        };

        /*agrega autoplay al video que esta en el elemento visible*/
        var addAutoplay = function addAutoplay() {
            var sliderIframe = $('#sliderContainer[data-id="' + galeriaId + '"] ul li.activo iframe');
            if (sliderIframe.length) {
                var str = sliderIframe.attr('src');
                var strNew = str.replace('autoplay=0', 'autoplay=1');
                sliderIframe.attr('src', strNew);
            }
        };

        var botonActivo = function botonActivo() {
            nodoSlider.find('.navegacion span').removeClass('activo');
            nodoSlider.find('.navegacion span').eq(pos - 1).addClass('activo');
        };

        var timeOut;
        //Cuento la cantidad de slides
        var slides = nodoChildLi.length;
        //Creo la navegacion
        nav();
        //Activo la primera
        var pos = 1;
        nodoSlider.find('.navegacion span').eq(pos - 1).addClass('activo');

        // Funciones a realizar cuando inicia
        slideActiva();
        total();
        epigrafe();

        //Altura flechas
        var alturaContenedor = nodoSlider.height();
        var galeriaButton = nodoSlider.find('button');
        if ($(window).width() < 768) {
            galeriaButton.height(alturaContenedor);
        }
        galeriaButton.css('top', alturaContenedor / 2 - 23);
        flechas();;;;;

        ;

        /*los botones ejecutan las funciones anteriores*/
        $('.prev').click(function () {
            moveLeft();
            botonActivo();
            addAutoplay();
            total();
            epigrafe();
            flechas();
        });

        $('.next').click(function () {
            moveRight();
            botonActivo();
            addAutoplay();
            total();
            epigrafe();
            flechas();
        });

        //Activa el slide segun la posicion del menu
        $('.navegacion span').click(function () {
            reloadSrc();
            pos = $(this).attr('data-slide');
            pos = parseInt(pos);
            botonActivo();
            slideActiva();
            addAutoplay();
            total();
            epigrafe();
            flechas();
        });

        //Swipe
        $('#sliderContainer ul li').first().addClass('primero');
        $('#sliderContainer ul li').last().addClass('ultimo');

        $("#sliderContainer[data-id='" + galeriaId + "']").swiperight(function () {
            if ($('.activo.primero').length) {} else {
                moveLeft();
            }
        });
        $("#sliderContainer[data-id='" + galeriaId + "']").swipeleft(function () {
            if ($('.activo.ultimo').length) {} else {
                moveRight();
            }
        });

        Functions.functions();
    }
};

var getHtml = function getHtml(ajaxData, galeriaId, classGaleria) {
    var imagesArr = ajaxData.imagenes;
    //let liClassAttr = "foto-1 on";
    if (imagesArr && imagesArr.length > 0) {
        var liClassAttr = "";

        html = //'<input id="titulo" type="hidden" value="' + ajaxData.titulo + '>' +
        '<div class="galeria conModal vertical">' + '<div id="sliderContainer" class="f-imagenRelacionada" data-id="' + galeriaId + '">' + '<span title="Ampliar imagen" class="icon-ampliar"></span><span title="Cerrar modal" class="icon-cerrar"></span>';
        html += "<ul>";

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = Array.from(imagesArr)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var img = _step.value;

                html += "<li><img src=\"" + BucketTools.urlBucketBalance(urlBacket, img.id, BucketTools.getImageSrcPath(img, "galeria", classGaleria), "", img.extension) + "\" id=\"imagen\" itemprop=\"\" alt=\"" + INodoTools.getHtml(img.epigrafe) + "\"/>\n                     </li>";
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        html += "</ul>" + '</div>' + '<div class="navegacion"></div>' + '<button href="#" id="prev" class="prev icon-izquierda"></button>' + '<button href="#" id="next" class="next icon-derecha"></button>' + '<div class="borde"></div>' + '</div>' + '<figcaption class="epigrafe floatFix" id="epigrafe" data-id="' + galeriaId + '"></figcaption>' + '<div class="total" id="total" data-id="' + galeriaId + '"></div>' +
        //'<div class="epigrafe">' + INodoTools.getHtml(ajaxData.epigrafe) + '</div>' + 
        //'<div class="total">Foto <div id="numberImage">1</div> de '+ imagesArr.length +'</div>' +
        //'<div class="herramientas floatFix">' +
        //    '<button id="facebookShareImage" class="icon-facebook" title="Compartir en Facebook"></button>' + 
        //    '<button id="twitterShareImage"  class="icon-twitter" title="Compartir en Twitter"></button>' +
        //'</div>'+
        '</div>';
    }
    return html;
};

var renderGaleria = function renderGaleria(ajaxData, divHolder) {
    divHolder.innerHTML = getHtml(ajaxData, ajaxData.id, divHolder.getAttribute("class"));
    insertSliderFunctionality(ajaxData.id);
};

/**
 * Returns the HTML <section> of a specific Galery with the data on it.
 * @param {Number} idGaleria - Galery Id
 * @param {Number} divHolder -  <div> where the returned HTML sections galeries will be placed. 
 * @return {String} HTML <section>
 */
var getGaleria = exports.getGaleria = function getGaleria(idGaleria, divHolder) {
    Ajax.get(urlGaleria + idGaleria).then(function (result) {
        return renderGaleria(JSON.parse(result), divHolder);
    }, function (status) {
        return console.log("Error Ajax call: ", status);
    });
};

/**
 * Returns a collection of <section> with their data on it.
 * @param {HTMLDivElement} divElements - One or more <div>s where the returned HTML galery sections will be placed.
 * @param {Number} divId - If null, will be extracted from 'data-id' attr of each divElement.
 * @return {HTMLStrings} Collection of HTML <section>s galeries.
 */
var getAllGalerias = exports.getAllGalerias = function getAllGalerias(divElements, divId) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = Array.from(divElements)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var div = _step2.value;

            getGaleria(divId || div.getAttribute("data-id"), div);
            html = "";
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


$(document).ready(function () {
    if (document.querySelector('#item-nota[data-template="historia"]') != null) {
        var onScroll = function onScroll(event) {
            var scrollPos = $(document).scrollTop();

            //Sticky nav
            if (tope <= scrollPos) {
                notaNav.addClass("abs");
                notaNav.css({ top: finNota - midNav });
            } else {
                notaNav.removeClass("abs");
                notaNav.css({ top: window.innerHeight / 2 - notaNav.outerHeight() / 2 });
            }

            //cambio de header
            if ($('#nota .encabezado').outerHeight() / 3 <= scrollPos) {
                $('#cabezal').removeClass("transparente");
            } else {
                $('#cabezal').addClass("transparente");
            }

            //ancla de la navegaci�n
            $('#nota nav div a').each(function () {
                var currLink = $(this);
                var refElement = $(currLink.attr("href"));
                if (refElement.position().top - midVentana <= scrollPos && notaCuerpo.position().top + notaCuerpo.height() - midVentana > scrollPos) {
                    $('#nota nav div a').removeClass("active");
                    currLink.addClass("active");
                } else {
                    currLink.removeClass("active");
                }
            });
        };

        //navegacion storytelling
        $(window).scroll(function () {
            var limite = $('.encabezado').height();

            var navTop = $('#nota nav div').offset().top;
            if (navTop > limite) {
                $('#nota nav div').addClass('active');
            } else {
                $('#nota nav div').removeClass('active');
            }

            $('.link-story').each(function () {
                var linkBottom = $(this).offset().top + $(this).height();
                if (linkBottom > limite) {
                    $(this).addClass('positivo');
                } else {
                    $(this).removeClass('positivo');
                }
            });
        });

        //START: SCROLL storytelling-nav
        $(document).on("scroll", onScroll);

        var margen = $('#cabezal').outerHeight() + 20;

        $('#nota nav div a[href^="#"]').on('click', function (e) {
            e.preventDefault();
            $(document).off("scroll");

            $('#nota nav div a').each(function () {
                $(this).removeClass('active');
            });
            $(this).addClass('active');

            var target = this.hash;
            var $target = $(target);

            $('html, body').stop().animate({
                'scrollTop': $target.offset().top - margen
            }, 500, 'swing', function () {
                //window.location.hash = target - margen;
                $(document).on("scroll", onScroll);
            });
        });
        //END: SCROLL storytelling-nav   

        var notaCuerpo = $('#cuerpo');
        var midVentana = window.innerHeight / 2;
        var midNav = $('#nota nav div').height() / 2;
        var notaNav = $('.storytelling #nota nav');
        var finNota = notaCuerpo.position().top + notaCuerpo.height(); //no cambia
        var topNav = notaNav.position().top;
        var altoNav = notaNav.outerHeight(); //no cambia
        var tope = finNota - altoNav - topNav;
        notaNav.css({ top: window.innerHeight / 2 - notaNav.outerHeight() / 2 });
    }
});

/***/ }),
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var MakeCustomDimension = exports.MakeCustomDimension = function MakeCustomDimension() {

    var date = new Date();
    var mesActual = ("0" + (date.getMonth() + 1)).slice(-2);
    var mesNotasLeidas = localStorage.getItem("mesNotasLeidas");
    if (mesNotasLeidas !== null) {
        if (mesActual === mesNotasLeidas) {
            addNotaRead();
        } else {
            localStorage.removeItem("mesNotasLeidas");
            localStorage.removeItem("CDnotasLeidas");
            localStorage.setItem("mesNotasLeidas", mesActual);
            addNotaRead();
        }
    } else {
        localStorage.setItem("mesNotasLeidas", mesActual);
        addNotaRead();
    }
};

var addNotaRead = function addNotaRead() {
    var lSnotasLeidas = localStorage.getItem("CDnotasLeidas");

    lSnotasLeidas = lSnotasLeidas ? lSnotasLeidas : 0;

    lSnotasLeidas = parseInt(lSnotasLeidas) + 1;
    localStorage.setItem("CDnotasLeidas", lSnotasLeidas);
};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.notasAdemas = exports.notasMasComentadas = undefined;

var _ajax = __webpack_require__(1);

var _bucket = __webpack_require__(2);

var BucketTools = _interopRequireWildcard(_bucket);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var urlBucket = window.config.Statics.BucketUrl;
var liveFireUrlApi = window.config.Statics.ApiLiveFireUrl;
var siteIdLF = window.config.Statics.SiteIdLF;
var urlAcuTema = window.config.Statics.ApiContenidoUrlRoot + window.config.Statics.ApiAcumuladoTemaUrl;
var sitioId = window.config.Sitio.Id;

var getMasComentadas = function getMasComentadas(data) {
    var masComentadas = document.querySelector('aside[data-id="masComentadas"]');
    if (masComentadas !== null) {
        if (data !== null && data.data !== null && data.data.length > 0) {
            var html = "<div class=\"techo floatFix\">\n                        <h4>M\xE1s <b>comentadas</b></h4>\n                    </div>\n                    <ol>";
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = data.data.slice(0, 5)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var nota = _step.value;

                    var parts = nota.url.split('/');
                    var url = parts.pop();
                    //<img src="http://bucket1.glanacion.com/anexos/fotos/16/tecnologia-2086816w122h82.jpg " />
                    html += "<li>\n                    <article title=\"\" class=\"nota floatFix\">\n                        <a class=\"figure\">                        \n                        </a>\n                        <h2>\n                            <a href=\"/" + url + "\">" + nota.title + "</a>\n                        </h2>\n                    </article>\n                    </li>";
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            html += "</ol>";
            masComentadas.innerHTML = html;
        }
    }
};

var notasMasComentadas = exports.notasMasComentadas = function notasMasComentadas() {
    var masComentadas = document.querySelector('aside[data-id="masComentadas"]');
    if (masComentadas !== null && masComentadas.length > 0) {
        liveFireUrlApi = liveFireUrlApi.replace("{livefyre-domainName}", "la-nacion");
        liveFireUrlApi = liveFireUrlApi.replace("{SiteId_Livefyre}", siteIdLF);
        liveFireUrlApi = liveFireUrlApi.replace("{cantidad de notas}", 10);

        (0, _ajax.get)(liveFireUrlApi).then(function (rs) {
            return JSON.parse(rs);
        }).then(getMasComentadas);
    }
};

var renderNotasAdemas = function renderNotasAdemas(data) {
    var nodoAdemas = document.querySelector('#listadoAdemas');
    if (data.items !== null && data.items.length > 1 && nodoAdemas !== null && nodoAdemas !== undefined) {

        var notaId = document.querySelector('div[data-notaid]').getAttribute("data-notaid");
        data.items.filter(function (item) {
            item.id == notaId ? data.items.splice(data.items.indexOf(item), 1) : null;
        });

        if (data.items.length === 3) {
            data.items.pop();
        } else if (data.items.length < 2) {
            //nodoAdemas.remove();
            nodoAdemas.parentNode.removeChild(nodoAdemas);
            return false;
        }

        var html = "<div class=\"techo\"> ADEM\xC1S </div><div>";
        //<!-- pueden venir hasta 2 articles-->
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = data.items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var nota = _step2.value;

                var imageHtml = nota.imagenes != null && nota.imagenes.length > 0 ? "<a class=\"figure\" href=\"/" + nota.url + "\">       \n                                <img src=\"" + BucketTools.urlBucketBalance(urlBucket, nota.imagenes[0].src, "82", "122") + "\"/>                   \n                              </a>" : "<a class=\"figure\"><img src=\"\"/></a>";

                html += "<article title=\"\" class=\"nota foto floatFix\">\n                " + imageHtml + "\n                <h2>\n                    <a href=\"/" + nota.url + "\">\n                        " + nota.titulo + "\n                    </a>\n                </h2>\n                </article>";
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        html += "</div>";
        nodoAdemas.innerHTML = html;
    } else {
        if (nodoAdemas !== null && nodoAdemas !== undefined) {
            nodoAdemas.remove();
        }
    }
};

var notasAdemas = exports.notasAdemas = function notasAdemas() {
    if (document.querySelector('div[data-tagPrioridad]')) {
        var cantNotas = 3;
        var fechaHoy = 1;
        var tagId = document.querySelector('div[data-tagPrioridad]').getAttribute('data-tagPrioridad');
        if (tagId == "" || tagId == null) return;

        var url = urlAcuTema + tagId + "?&c=" + cantNotas + "&s=" + sitioId + "&h=" + fechaHoy;

        (0, _ajax.get)(url).then(function (rs) {
            return JSON.parse(rs);
        }).then(renderNotasAdemas);
    }
};

/***/ }),
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(73);


/***/ })
],[110]);


// WEBPACK FOOTER //
// js/nota.f4f71d0.min.js